// @ts-nocheck
// Anonymous funnel UI on top of the Liquid-rendered planner (sections/meal-planner.liquid).
// Navigation is a history stack of positions ({ screen, slot }); "back" pops it.
// Liking is one mixed deck: right = like, left = skip (a weak signal, not a permanent hide).
// state.likes is the likes document ({ v, items }) — the future server session copy, with no body data.
// "Plan erstellen" opens the week preview: the week they will eat (this week, from Friday next week) with one
// open day (tomorrow, or Monday of next week) and day totals for the rest; the other days' recipes stay hidden.
// Lunch and dinner are two mains. Portion scale stays 0.5×–2× and no meal takes more than 40% of the calorie target.
// Macros screen (donut + presets): only from Ziele. The setup uses the recommended split. Split is percents that sum to 100.
// Setup: goal → body (sex/age/size/weight/activity + live kcal and protein) → exclusions (+ cook time) → swipe → building → preview.
// Occasions default to breakfast, lunch, dinner, snack (lunch/dinner = two mains). No setup slot picker.
// Paid Einstellungen → Mahlzeiten: kcal split per meal (ring), any meal can be dropped (2 stay, one of them a main).
// Paid week: lock, swap sheet, day/week remix, shopping list (JS merge of zutat rows).
// Paid Rezepte tab: hub (search, Favoriten/Eigene, "Neu für dich", category tiles) → set grid → vertical reel.
// The horizontal like/skip deck is only the setup funnel (the sitewide overlay is a separate asset).
// Meal cards open a cook sheet (Section Rendering API) scaled to that day's portion.
// Paywall: selling-plan picker + consent, then Shopify checkout creates the customer. No signup screen. Since
// 2026-10-19 the checkout takes guests (no login): they sign in after paying (docs/GUEST_CHECKOUT.md).
(() => {
  'use strict';

  const planner = window.vhpPlanner;
  const funnel = document.querySelector('[data-vhp-funnel]');
  const likesApi = window.vhpPlannerLikes;
  if (!planner || !funnel || !likesApi) return;

  // Document key, version and shared labels live in assets/vhp-planner-likes.js.
  const { STORAGE_KEY, STATE_VERSION, LIKES_VERSION, LIKE_READY, LIKE_VARIETY, SLOT_ORDER, SLOT_LABEL, GOAL_LABEL } = likesApi;
  const tr = window.vhpT; // snippets/vhp-i18n.liquid
  const LOCALE = document.documentElement.lang || 'de';
  const PREFETCH = 3;
  const MOTION_MS = 280;
  const CUBE_MS = 520; // story chapter turn (assets/vhp-planner-story.css)
  const FADE_SCREENS = new Set(['building', 'waiting', 'monday', 'soeren']);
  const APP_TABS = new Set(['week', 'shop', 'settings', 'recipes']);
  const SCREEN_MOTION_CLS = [
    'is-enter',
    'is-leave',
    'is-enter-active',
    'is-leave-active',
    'is-dir-forward',
    'is-dir-back',
    'is-dir-fade',
    'is-dir-cube',
    'is-cube-back',
  ];
  const motionOk = () =>
    !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  const AGE_MIN = 18;
  const AGE_MAX = 80;
  const HEIGHT_MIN = 120;
  const HEIGHT_MAX = 220;
  const WEIGHT_MIN = 40;
  const WEIGHT_MAX = 200;
  const KCAL_MIN = 1200;
  const KCAL_MAX = 5000;
  const PLAN_SLOTS = ['breakfast', 'main', 'snack'];
  const normalizePlanSlots = (slots) => {
    if (!Array.isArray(slots) || !slots.length) return PLAN_SLOTS.slice();
    const next = ['main'];
    if (slots.includes('breakfast')) next.unshift('breakfast');
    if (slots.includes('snack')) next.push('snack');
    return next;
  };
  const PAID_WAIT_KEY = 'vhp_paid_wait';
  const PAID_WAIT_MAX = 8;
  const PAID_WAIT_WINDOW_MS = 2 * 3600000;
  // The order mail's "Meinen Plan öffnen" link (docs/GUEST_CHECKOUT.md): /pages/meal-planner?paid=1[&week=<token>].
  const PAID_LINK = new URLSearchParams(location.search).get('paid') === '1';
  const SLOT_ICON = {
    breakfast: 'slot-breakfast',
    lunch: 'slot-lunch',
    dinner: 'slot-dinner',
    snack: 'slot-snack',
    dessert: 'slot-dessert',
    main: 'slot-main',
    Frühstück: 'slot-breakfast',
    Mittagessen: 'slot-lunch',
    Abendessen: 'slot-dinner',
    Snack: 'slot-snack',
    Hauptgericht: 'slot-main',
    Dessert: 'slot-dessert',
    Breakfast: 'slot-breakfast',
    Lunch: 'slot-lunch',
    Dinner: 'slot-dinner',
    Main: 'slot-main',
  };
  const WEEK_LEN = 7;
  const DAY_LABEL = tr.list('common.days_short');
  const PREVIEW_DAYS = tr.list('common.days_long');
  const MONTH_SHORT = tr.list('date.months_short');
  const MONTH_LONG = tr.list('date.months_long');
  // "12. Okt" / "Oct 12"
  const dayMonth = (date, months = MONTH_SHORT) => tr('date.day_month', { d: String(date.getDate()), month: months[date.getMonth()] });
  // "14." / "14"
  const dayNum = (date) => (LOCALE === 'de' ? `${date.getDate()}.` : String(date.getDate()));
  const weekMonday = (from = new Date()) => {
    const date = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    const weekday = date.getDay();
    date.setDate(date.getDate() + (weekday === 0 ? -6 : 1 - weekday));
    return date;
  };
  const addDays = (date, days) => new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
  const sameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  const formatWeekRange = (monday) => {
    const sunday = addDays(monday, 6);
    return `${dayMonth(monday)} – ${dayMonth(sunday)}`;
  };
  const formatDayLong = (date, today) => {
    const weekday = (date.getDay() + 6) % 7;
    const label = tr('date.weekday_day_month', { weekday: PREVIEW_DAYS[weekday], d: String(date.getDate()), month: MONTH_LONG[date.getMonth()] });
    return sameDay(date, today) ? tr('planner.with_today', { label }) : label;
  };
  const weekHasPlan = (week) =>
    Array.isArray(week) && week.some((day) => Array.isArray(day?.meals) && day.meals.length > 0);
  // Weeks are keyed by their Monday (local date, YYYY-MM-DD).
  const ISO_DAY_RE = /^\d{4}-\d{2}-\d{2}$/;
  const isoOf = (date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  const dateOfIso = (iso) => {
    const [y, m, d] = String(iso).split('-').map(Number);
    return new Date(y, m - 1, d);
  };
  const mondayIso = (weeks = 0) => isoOf(addDays(weekMonday(), weeks * 7));
  // Week the preview plans: the one they will eat. Mon–Tue this week, from Wednesday next week (later in the week
  // "Ganze Woche freischalten" would unlock only 2–3 days, and there's little left to shop and cook for). The open
  // day is the next one coming: tomorrow, or Monday of next week.
  const previewWeekAhead = (now = new Date()) => [3, 4, 5, 6, 0].includes(now.getDay());
  // Theme setting "Kostenlose Vorschau: freier Tag immer morgen" (docs/PLANNER_PAGE_FUNNEL.md, "Free day = tomorrow"):
  // the free day is always tomorrow, its week is planned as before, and the locked days are the PREVIEW_SPAN days after
  // it, into next week when this one ends (that week is planned too, with its own seed, and handed over after checkout).
  const previewTomorrow = () => planner.config.previewTomorrow === true && !planner.config.paid;
  const PREVIEW_SPAN = 6;
  const tomorrowDate = () => addDays(new Date(), 1);
  const previewStartIso = () =>
    previewTomorrow() ? isoOf(weekMonday(tomorrowDate())) : mondayIso(previewWeekAhead() ? 1 : 0);
  const previewOpenIndex = () =>
    previewTomorrow()
      ? (tomorrowDate().getDay() + 6) % 7
      : previewWeekAhead() ? 0 : (new Date().getDay() + 6) % 7 + 1;
  // Days of next week the locked tiles need (0 when the free day's week still has PREVIEW_SPAN days after it).
  const previewNextDays = (open) => (previewTomorrow() ? Math.max(0, PREVIEW_SPAN - (WEEK_LEN - 1 - open)) : 0);

  const emptyWeekDay = () => ({ meals: [] });
  const SEX_LABEL = { female: tr('planner.sex_female'), male: tr('planner.sex_male') };
  const ACTIVITY_KEYS = ['sedentary', 'light', 'active', 'very'];
  const ACTIVITY_LABEL = Object.fromEntries(ACTIVITY_KEYS.map((key) => [key, tr(`planner.act_${key}`)]));
  const EX_LABEL = Object.fromEntries(
    ['nuts', 'peanuts', 'soy', 'gluten', 'sesame', 'mushrooms', 'spicy'].map((key) => [key, tr(`filters.avoid_${key}`)])
  );
  const PAL = { sedentary: 1.2, light: 1.375, active: 1.55, very: 1.725 };
  // lose: the deficit follows the body (LOSE, computeKcal), not a flat delta.
  const GOAL_DELTA = { lose: 0, maintain: 0, gain: 300 };
  // Abnehmen (2026-10-19, was a flat −500, which put small or lightly active people under their basal rate): ~0.5 %
  // of body weight a week (5.5 kcal × kg a day), at most 20 % of the burn and 500 kcal, never under the basal rate
  // (Mifflin). BMI under 18.5: no deficit ('hold'); under 22: at most 10 % ('soft'). Keep in sync with
  // assets/vhp-plan-goal.js dayOf.
  const LOSE = { perKg: 5.5, share: 0.2, softShare: 0.1, max: 500, bmiHold: 18.5, bmiSoft: 22 };
  const MACRO_KEYS = ['protein', 'carbs', 'fat'];
  const MACRO_KCAL = { protein: 4, carbs: 4, fat: 9 };
  const MACRO_MIN = 10;
  const MACRO_MAX = 80;
  const MACRO_R = 88;
  const MACRO_CX = 200;
  const MACRO_C = 2 * Math.PI * MACRO_R;
  const MACRO_PRESETS = {
    recommended: { protein: 30, carbs: 45, fat: 25 },
    protein: { protein: 40, carbs: 35, fat: 25 },
    balanced: { protein: 25, carbs: 50, fat: 25 },
    lowcarb: { protein: 35, carbs: 25, fat: 40 },
  };
  const recommendedMacros = () => ({ ...MACRO_PRESETS.recommended });
  const sameSplit = (a, b) => MACRO_KEYS.every((key) => Number(a?.[key]) === Number(b?.[key]));
  const validSplit = (split) =>
    Boolean(split) &&
    MACRO_KEYS.every((key) => {
      const n = Number(split[key]);
      return Number.isInteger(n) && n >= MACRO_MIN && n <= MACRO_MAX;
    }) &&
    MACRO_KEYS.reduce((sum, key) => sum + Number(split[key]), 0) === 100;
  const normalizeSplit = (raw) =>
    validSplit(raw) ? { protein: raw.protein, carbs: raw.carbs, fat: raw.fat } : recommendedMacros();
  const presetIdFor = (split, saved) => {
    if (saved && MACRO_PRESETS[saved] && sameSplit(split, MACRO_PRESETS[saved])) return saved;
    const found = Object.keys(MACRO_PRESETS).find((id) => sameSplit(split, MACRO_PRESETS[id]));
    return found || (validSplit(split) ? 'custom' : 'recommended');
  };
  const macroGrams = (kcal, split) => {
    const k = Number(kcal) || 0;
    const s = split || recommendedMacros();
    return {
      protein: Math.round((k * s.protein) / 100 / MACRO_KCAL.protein),
      carbs: Math.round((k * s.carbs) / 100 / MACRO_KCAL.carbs),
      fat: Math.round((k * s.fat) / 100 / MACRO_KCAL.fat),
    };
  };
  const macroPoint = (pct, rad) => {
    const a = (pct * 3.6 * Math.PI) / 180;
    return [MACRO_CX + rad * Math.sin(a), MACRO_CX - rad * Math.cos(a)];
  };
  const FLOW = ['goal', 'body', 'macros', 'exclusions', 'meals'];
  const STAGE_SCREENS = {
    0: ['goal', 'body', 'macros', 'meals', 'exclusions', 'sex', 'activity', 'numbers', 'dishes', 'pain', 'answer'],
    1: ['grid', 'swipe', 'empty'],
    2: ['preview', 'building', 'subscribe', 'gift', 'proof'],
  };
  // Story setup (vhp-planner docs/story-setup.md, assets/vhp-planner-story.js): the screens in the story frame by
  // chapter, the obstacle answers, which paywall lines lead for each, and the slides that move on by themselves (ms).
  const STORY_CHAPTERS = [
    ['goal', 'why', 'sex', 'body', 'activity', 'numbers', 'dishes', 'pain', 'answer', 'exclusions'],
    ['grid', 'swipe', 'empty'],
    ['building', 'gift'],
    ['proof'],
  ];
  // The discount gift comes with the paywall tap, so it's "Von mir" (the second-day gift stays in "Deine Woche").
  const storyChapter = (screen) =>
    screen === 'gift' && giftIsReward() ? 3 : STORY_CHAPTERS.findIndex((list) => list.includes(screen));
  const STORY_SCREENS = new Set(STORY_CHAPTERS.flat());
  const PAINS = ['count', 'cook', 'time', 'taste', 'family'];
  // 1.4 takes several obstacles; more than three made the 1.5 thread too long for the screen.
  const PAIN_MAX = 3;
  // Story v2 (docs/story-setup-v2.md), 1.1b "Dein Warum": the reasons offered per goal, in this order.
  const WHY_BY_GOAL = {
    lose: ['comfort', 'energy', 'event', 'stick', 'healthy'],
    gain: ['muscle', 'strength', 'protein', 'energy'],
    maintain: ['healthy', 'calm', 'balanced', 'fit'],
  };
  const WHYS = [...new Set(Object.values(WHY_BY_GOAL).flat())];
  // Their first name (1.2b, optional): letters, spaces, hyphen, apostrophe, 20 at most. Only on this device.
  const cleanName = (raw) => {
    const name = String(raw || '')
      .replace(/[^\p{L}\p{M}' -]/gu, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 20);
    return name ? name.charAt(0).toLocaleUpperCase() + name.slice(1) : '';
  };
  const PAIN_PERKS = {
    count: ['goal', 'list', 'swap'],
    cook: ['week', 'goal', 'list'],
    time: ['list', 'goal', 'swap'],
    taste: ['swap', 'goal', 'list'],
    family: ['family', 'goal', 'list'],
  };
  // Paywall opened from a locked control (docs/PREVIEW_PAYWALL.md round 6): the perk that answers it leads the list,
  // and `pain` names the obstacle whose promise would say the same thing (the DM's second bubble then says another).
  const PW_CTX = {
    swap: { perk: 'swap', pain: 'taste' },
    regen: { perk: 'swap', pain: 'taste' },
    day: { perk: 'week', pain: 'cook' },
    shop: { perk: 'list', pain: 'time' },
    own: { perk: 'own' },
    exclusive: { perk: 'exclusive' },
    lock: { perk: 'hold' },
    move: { perk: 'hold' },
    prep: { perk: 'prep' },
    fav: { perk: 'fav' },
    // The preview meal sheet's "Im Abo" rows (round 7).
    copy: { perk: 'hold' },
    family: { perk: 'family', pain: 'family' },
    pick: { perk: 'swap', pain: 'taste' },
    away: { perk: 'goal' },
    // Sörens Woche's "Nächste Woche" row (docs/SOEREN_WEEK.md 3).
    next: { perk: 'week', pain: 'cook' },
  };
  const PERKS_MAX = 4;
  let pwCtx = null; // { key, day } while the paywall answers a tap; cleared by a context-free open
  const pwCtxLine = ({ key, day }) => {
    if (key === 'day') return day ? tr('planner.pw_ctx_day', { day }) : tr('planner.pw_ctx_day_any');
    if (key === 'own') return planner.config.labs?.aiImport ? tr('planner.pw_ctx_own_ai') : tr('planner.pw_ctx_own');
    return tr(`planner.pw_ctx_${key}`);
  };
  // Question slides that get a blurred dish photo behind them while they have no Story-Slide block.
  const AMBIENT_SCREENS = ['why', 'sex', 'body', 'activity', 'pain', 'exclusions'];
  // dishes: per dish (one story step each, on one bar).
  const STORY_PASSIVE = { numbers: 6500, dishes: 1500, answer: 8000, proof: 8000 };
  // Setup screens; `macros` is only reached from Ziele (subscribers), the setup goes body → exclusions.
  const FLOW_FILL = { goal: 33, body: 66, exclusions: 100 };
  const ACTIVITY_DESC = Object.fromEntries(ACTIVITY_KEYS.map((key) => [key, tr(`planner.act_desc_${key}`)]));
  const TIME_LABEL = { 15: tr('planner.time_15'), 30: tr('planner.time_30') };

  // Product id digits, or `c<id>` for a subscriber's custom recipe (assets/vhp-planner-recipes.js).
  const productId = (id) => {
    const match = String(id ?? '').match(/(c?\d+)$/);
    return match ? match[1] : '';
  };
  const isCustomId = (id) => /^c\d+$/.test(String(id ?? ''));
  const hubRules = window.vhpPlannerHubRules || null;
  // Shopping list aisles / merge keys / Vorrat (assets/vhp-planner-shop-rules.js, paid only).
  const shopRules = window.vhpPlannerShopRules || null;
  const plannerCore = window.vhpPlannerCore || null;
  // Paid only; null in the funnel/preview, so custom recipes never reach onboarding.
  const customRecipes = () => (planner.config.paid ? window.vhpPlannerRecipes || null : null);
  const customCards = (slot, opts) => customRecipes()?.cardsForSlot(slot, opts) || [];

  const blankLikes = () => ({ v: LIKES_VERSION, items: [] });
  const blankSkips = () => ({ v: LIKES_VERSION, items: [] });

  const normalizeLikeItem = (item) => {
    if (!item || typeof item !== 'object') return null;
    const id = productId(item.id);
    if (!id || !SLOT_ORDER.includes(item.slot)) return null;
    return {
      id,
      handle: typeof item.handle === 'string' ? item.handle : '',
      title: typeof item.title === 'string' ? item.title : '',
      image: typeof item.image === 'string' ? item.image : '',
      slot: item.slot,
      kcal: item.kcal ?? null,
      protein: item.protein ?? null,
      carbs: item.carbs ?? null,
      fat: item.fat ?? null,
      time: item.time ?? null,
      at: typeof item.at === 'string' ? item.at : null,
    };
  };

  const normalizeLikes = (raw) => {
    const items = [];
    const seen = new Set();
    (Array.isArray(raw?.items) ? raw.items : []).forEach((item) => {
      const next = normalizeLikeItem(item);
      if (!next || seen.has(next.id)) return;
      seen.add(next.id);
      items.push(next);
    });
    return { v: LIKES_VERSION, items };
  };

  const normalizeSkips = (raw) => {
    const items = [];
    const seen = new Set();
    (Array.isArray(raw?.items) ? raw.items : []).forEach((item) => {
      const id = productId(item?.id);
      if (!id || !SLOT_ORDER.includes(item?.slot) || seen.has(id)) return;
      seen.add(id);
      items.push({ id, slot: item.slot, at: typeof item.at === 'string' ? item.at : null });
    });
    return { v: LIKES_VERSION, items };
  };

  // Skips from two devices: union by id (newer `at` wins), minus anything liked, newest SKIPS_MAX kept.
  // Missing `at` (legacy) sorts oldest.
  const SKIPS_MAX = 100;
  const mergeSkips = (saved, local, likedIds) => {
    const byId = new Map();
    [...(Array.isArray(saved) ? saved : []), ...(local || [])].forEach((raw) => {
      const item = normalizeSkips({ items: [raw] }).items[0];
      if (!item || likedIds.has(item.id)) return;
      const prev = byId.get(item.id);
      if (!prev || (item.at || '') >= (prev.at || '')) byId.set(item.id, item);
    });
    return [...byId.values()].sort((a, b) => (a.at || '').localeCompare(b.at || '')).slice(-SKIPS_MAX);
  };

  const likesFromLegacy = (picks, skipped) => {
    const likes = blankLikes();
    if (picks && typeof picks === 'object' && !Array.isArray(picks.items)) {
      SLOT_ORDER.forEach((slot) => {
        const raw = picks[slot];
        const item = normalizeLikeItem(raw ? { ...raw, slot: raw.slot || slot } : null);
        if (item && !likes.items.some((row) => row.id === item.id)) likes.items.push(item);
      });
    }
    const skips = blankSkips();
    if (skipped && typeof skipped === 'object' && !Array.isArray(skipped.items)) {
      SLOT_ORDER.forEach((slot) => {
        (Array.isArray(skipped[slot]) ? skipped[slot] : []).forEach((id) => {
          const next = productId(id);
          if (!next || skips.items.some((row) => row.id === next)) return;
          skips.items.push({ id: next, slot, at: null });
        });
      });
    }
    return { likes, skips };
  };

  const EXCLUSIONS = {
    nuts: {
      re: /(nuss|nüsse|mandel|cashew|pekan|macadamia|pistazie)/i,
      skip: /(erdnuss|muskatnuss|kokosnuss)/i,
    },
    peanuts: { re: /(erdnuss|peanut)/i },
    soy: { re: /(soja|soy|tofu|edamame|tempeh|miso)/i },
    gluten: { re: /(gluten|weizen|dinkel|gerste|roggen|seitan|mehl|nudel|pasta|spaghetti|brot|brötchen|couscous|bulgur|panko)/i,
      skip: /(reismehl|kichererbsenmehl|maismehl|mandelmehl|buchweizen|glutenfrei)/i },
    sesame: { re: /(sesam|tahini|tahin)/i },
    mushrooms: { re: /(pilz|champignon|shiitake|kräuterseitling|pfifferling)/i },
    spicy: { re: /(scharf|chili|cayenne|jalape[nñ]o|sriracha|harissa|gochujang|sambal)/i },
  };

  const defaultState = () => ({
    v: STATE_VERSION,
    sex: 'female',
    age: 28,
    height: 168,
    weight: 64,
    activity: 'light',
    goal: null,
    kcal: null,
    kcalManual: false,
    macros: { protein: 30, carbs: 45, fat: 25 },
    macrosPreset: 'recommended',
    slots: PLAN_SLOTS.slice(),
    weekApplied: null,
    exclusions: [],
    maxTime: null,
    likes: blankLikes(),
    skips: blankSkips(),
    seen: [],
    undo: null,
    pin: null,
    swipeHintSeen: false,
    screen: 'goal',
    slot: null,
    history: [],
    swap: null,
    consentPlanner: false,
    consentMarketing: false,
    consentAt: null,
    pendingFlush: false,
    profileSaved: false,
    subscribePlanId: null,
    // Reviews screen seen (it sits before the paywall once; later paywall taps go straight to the plans).
    // Story setup (docs/story-setup.md): the obstacle answer, the gift scratched free.
    // pains: up to PAIN_MAX obstacles in pick order; pain is the first (background clip, paywall promise, quote).
    pain: null,
    pains: [],
    // Story v2: the reason behind the goal (WHYS), their first name (device only, never sent).
    why: null,
    name: '',
    scratched: false,
    // The discount scratched free on the gift slide ({ at: ISO }); the offer runs from there (REWARD_CFG.hours).
    reward: null,
    week: null,
    // Monday of state.week. The planner keeps two weeks: this one and next; state.week is the one on screen,
    // weekAlt the other ({ start, week, pending }). prevWeek ({ start, week }) is last week, kept for
    // "Letzte Woche wiederholen" and for variety.
    weekStart: null,
    weekAlt: null,
    prevWeek: null,
    weekDay: 0,
    pendingWeekFlush: false,
    preview: null,
    seedKey: null,
    planNonce: 0,
    awaitingPaid: false,
    // When the buy tap sent them to Shopify (ISO): after PAID_WAIT_WINDOW_MS a waiting flag counts as a left checkout.
    awaitingPaidAt: null,
    // Sex and measures came from the recipe calculator (assets/vhp-plan-goal.js): the story skips the body slide.
    bodyPreset: false,
    // The calculator's flow asked her activity too (since 2026-10-30): the story skips the activity slide as well.
    activityPreset: false,
    // The planner landers' first screen (docs/FIRST_SCREEN.md 9.8): this setup started on it (no Warum, Hürde, Antwort).
    mondayDoor: false,
    // Sörens Woche (docs/SOEREN_WEEK.md): this setup started on the one-question screen; soerenCalc = "Kurz ausrechnen"
    // open on it; soerenKcal = the number she typed (null while the calculator or a known target fills the field).
    soerenDoor: false,
    soerenCalc: false,
    soerenKcal: null,
    // The calculator's goal tap alone (its typical-visitor body, 2026-10-26): the express path, with the body slide
    // asked first (those values filled in, the sex still to tap).
    calcEntry: false,
    editFrom: null,
    favMix: 'balanced',
    favFreq: {},
    hidden: { items: [] },
    household: { n: 1, shared: ['dinner'] },
    pantry: { have: [], buy: [] },
    // Reste einplanen (paid, Einstellungen): each dinner also covers the lunch of the next leftoverDays days (1 or 2).
    leftovers: false,
    leftoverDays: 1,
    // Portionsgröße per meal (old Einstellungen): { [occasion id]: 's' | 'l' }. Only read while mealShares is null.
    mealSizes: {},
    // Mahlzeiten screen: percent of the day's kcal per meal, 0 = not in the plan (see normalizeMealShares).
    mealShares: null,
    // Feste Mahlzeiten (paid): see normalizeRepeat. awayRepeat: Freie Mahlzeiten every week ({ occasion, days }).
    repeat: [],
    awayRepeat: [],
  });

  const FAV_MIXES = ['more', 'balanced', 'new'];
  const HIDDEN_MAX = 200;
  const FREQ_MAX = 100;
  // Per-favorite frequency: only "often" / "pause" are stored (normal = absent).
  const normalizeFreq = (raw) => {
    const out = {};
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return out;
    Object.entries(raw).forEach(([id, value]) => {
      const sid = /^\d+$/.test(String(id)) ? String(id) : null;
      if (sid && (value === 'often' || value === 'pause') && Object.keys(out).length < FREQ_MAX) out[sid] = value;
    });
    return out;
  };
  // Hidden recipes keep a display snapshot locally; the account stores only { id, slot }.
  const normalizeHidden = (raw) => {
    const list = Array.isArray(raw?.items) ? raw.items : Array.isArray(raw) ? raw : [];
    const seen = new Set();
    const items = [];
    list.forEach((row) => {
      const id = /^\d+$/.test(String(row?.id || '')) ? String(row.id) : null;
      if (!id || seen.has(id) || !['breakfast', 'main', 'snack', 'dessert'].includes(row.slot)) return;
      seen.add(id);
      items.push({
        id,
        slot: row.slot,
        title: typeof row.title === 'string' ? row.title : '',
        image: typeof row.image === 'string' ? row.image : '',
        kcal: row.kcal == null ? null : Number(row.kcal) || 0,
        protein: row.protein == null ? null : Number(row.protein) || 0,
        at: typeof row.at === 'string' ? row.at : null,
      });
    });
    return { items: items.slice(-HIDDEN_MAX) };
  };

  // Feste Mahlzeiten (paid): per occasion one recipe + portion + weekdays (0 = Mo) that every newly generated
  // week gets, locked. Set from the week's copy sheet ("Jede Woche"). The account stores { occasion, id, scale,
  // days }; pick is this browser's display snapshot (title/image for Ziele).
  const REPEAT_OCCASIONS = ['breakfast', 'lunch', 'dinner', 'snack'];
  const normalizeRepeat = (raw, prev) => {
    const out = [];
    (Array.isArray(raw) ? raw : []).forEach((rule) => {
      const id = productId(rule?.id);
      const scale = Number(rule?.scale);
      const days = [...new Set((Array.isArray(rule?.days) ? rule.days : []).map(Number))]
        .filter((day) => Number.isInteger(day) && day >= 0 && day < 7)
        .sort((a, b) => a - b);
      if (!id || !REPEAT_OCCASIONS.includes(rule.occasion) || out.some((row) => row.occasion === rule.occasion)) return;
      if (!(scale >= 0.5 && scale <= 2) || Math.round(scale * 4) / 4 !== scale || !days.length) return;
      const pick = rule.pick && typeof rule.pick === 'object'
        ? rule.pick
        : (Array.isArray(prev) ? prev : []).find((row) => row?.occasion === rule.occasion && productId(row?.id) === id)?.pick;
      out.push({ occasion: rule.occasion, id, scale, days, ...(pick ? { pick } : {}) });
    });
    return out;
  };

  // Freie Mahlzeiten every week: per occasion the weekdays (0 = Mo). The account stores the same.
  const normalizeAwayRepeat = (raw) => {
    const out = [];
    (Array.isArray(raw) ? raw : []).forEach((rule) => {
      const days = [...new Set((Array.isArray(rule?.days) ? rule.days : []).map(Number))]
        .filter((day) => Number.isInteger(day) && day >= 0 && day < 7)
        .sort((a, b) => a - b);
      if (!REPEAT_OCCASIONS.includes(rule?.occasion) || out.some((row) => row.occasion === rule.occasion) || !days.length) return;
      out.push({ occasion: rule.occasion, days });
    });
    return out;
  };

  const SEED_RE = /^[a-z0-9]{8,40}$/;

  // Cooking for more people (Einstellungen → Ich koche für): everyone else gets one portion of the shared meals,
  // scaled by size (Etwas weniger / Normal / Etwas mehr).
  // Only the amounts to buy and cook change; the customer's own portion, kcal and macros stay as planned.
  const HOUSEHOLD_MAX = 6;
  const HOUSEHOLD_MEALS = ['breakfast', 'lunch', 'dinner', 'snack'];
  // Portion of each other person (Kleiner / Normal / Größer), the customer's own portion stays as planned.
  const HOUSEHOLD_SIZES = [0.75, 1, 1.25];
  // Shopping list Vorrat overrides on top of the default staples: keys = shop-rules canonical names.
  const PANTRY_MAX = 150;
  const normalizePantry = (raw) => {
    const keys = (list) => [...new Set((Array.isArray(list) ? list : []).filter((key) => typeof key === 'string' && key && key.length <= 60))].slice(-PANTRY_MAX);
    return { have: keys(raw?.have), buy: keys(raw?.buy) };
  };

  const MEAL_SIZE_IDS = ['breakfast', 'lunch', 'dinner', 'snack'];
  const normalizeMealSizes = (raw) => {
    const out = {};
    MEAL_SIZE_IDS.forEach((id) => {
      if (raw?.[id] === 's' || raw?.[id] === 'l') out[id] = raw[id];
    });
    return out;
  };

  // Mahlzeiten (Einstellungen): whole percent of the day's kcal per meal, 0 = not in the plan. At least 5 % per
  // meal and two meals, lunch or dinner among them. null = not set yet: slots + old sizes decide.
  const MEAL_IDS = ['breakfast', 'lunch', 'dinner', 'snack'];
  const MEAL_MIN = 5;
  const MEAL_PRESETS = {
    balanced: { breakfast: 25, lunch: 35, dinner: 30, snack: 10 },
    small_breakfast: { breakfast: 15, lunch: 40, dinner: 35, snack: 10 },
    big_breakfast: { breakfast: 35, lunch: 30, dinner: 25, snack: 10 },
    big_dinner: { breakfast: 20, lunch: 30, dinner: 40, snack: 10 },
  };
  const normalizeMealShares = (raw) => {
    if (!raw || typeof raw !== 'object') return null;
    const out = {};
    for (const id of MEAL_IDS) {
      const value = Number(raw[id] ?? 0);
      if (!Number.isInteger(value) || value < 0 || value > 100 || (value > 0 && value < MEAL_MIN)) return null;
      out[id] = value;
    }
    const on = MEAL_IDS.filter((id) => out[id] > 0);
    const sum = on.reduce((total, id) => total + out[id], 0);
    if (sum !== 100 || on.length < 2 || !(out.lunch > 0 || out.dinner > 0)) return null;
    return out;
  };

  const normalizeHousehold = (raw) => {
    const n = Math.min(HOUSEHOLD_MAX, Math.max(1, Math.round(Number(raw?.n) || 1)));
    const shared = Array.isArray(raw?.shared) ? HOUSEHOLD_MEALS.filter((id) => raw.shared.includes(id)) : [];
    const size = HOUSEHOLD_SIZES.includes(Number(raw?.size)) ? Number(raw.size) : 1;
    return { n, shared: shared.length ? shared : ['dinner'], size };
  };

  const normalizePreview = (raw) => {
    const meals = raw?.day?.meals;
    const days = raw?.days;
    if (!Array.isArray(meals) || !Array.isArray(days) || days.length !== WEEK_LEN) return null;
    // Previews from before the open day (always Monday of this week, `monday`) rebuild once.
    const open = Number(raw.open);
    if (!ISO_DAY_RE.test(String(raw.start || '')) || !Number.isInteger(open) || open < 0 || open >= WEEK_LEN) return null;
    if (meals.some((meal) => typeof meal?.generated !== 'boolean')) return null;
    // Previews from before per-day macros / the kept week rebuild once.
    if (days.some((day) => typeof day?.protein !== 'number')) return null;
    if (!Array.isArray(raw.week) || raw.week.length !== WEEK_LEN) return null;
    return {
      key: typeof raw.key === 'string' ? raw.key : '',
      basis: typeof raw.basis === 'string' ? raw.basis : '',
      target: Number(raw.target) || null,
      start: raw.start,
      open,
      // Free swaps / the free day reroll used (docs/PREVIEW_PAYWALL.md, P2 additions): a reload keeps the counts.
      swapsUsed: Number(raw.swapsUsed) || 0,
      rollsUsed: Number(raw.rollsUsed) || 0,
      // Sörens Woche (docs/SOEREN_WEEK.md): the collection handle this week came from; the week keeps its rules.
      soeren: typeof raw.soeren === 'string' && raw.soeren ? raw.soeren : undefined,
      day: {
        meals: meals.map((meal) => ({
          id: typeof meal?.id === 'string' ? meal.id : '',
          label: typeof meal?.label === 'string' ? meal.label : '',
          title: typeof meal?.title === 'string' ? meal.title : '',
          image: typeof meal?.image === 'string' ? meal.image : '',
          handle: typeof meal?.handle === 'string' ? meal.handle : '',
          scale: Number(meal?.scale) || 1,
          kcal: Number(meal?.kcal) || 0,
          protein: Number(meal?.protein) || 0,
          carbs: meal?.carbs == null ? null : Number(meal.carbs),
          fat: meal?.fat == null ? null : Number(meal.fat),
          time: meal?.time == null ? null : Number(meal.time),
          generated: meal.generated === true,
          over: Boolean(meal?.over),
        })),
        totals: {
          kcal: Number(raw.day.totals?.kcal) || 0,
          protein: Number(raw.day.totals?.protein) || 0,
          carbs: Number(raw.day.totals?.carbs) || 0,
          fat: Number(raw.day.totals?.fat) || 0,
        },
      },
      days: days.map((day, index) => ({
        label: PREVIEW_DAYS[index],
        kcal: Number(day?.kcal) || 0,
        protein: Number(day?.protein) || 0,
        carbs: Number(day?.carbs) || 0,
        fat: Number(day?.fat) || 0,
      })),
      week:
        Array.isArray(raw.week) && raw.week.length === WEEK_LEN && raw.week.every((day) => Array.isArray(day?.meals))
          ? raw.week.map((day) => ({ meals: day.meals.filter((meal) => meal && typeof meal.id === 'string' && meal.pick) }))
          : null,
      // The week after it (free day = tomorrow, late in the week).
      next:
        raw.next &&
        ISO_DAY_RE.test(String(raw.next.start || '')) &&
        Array.isArray(raw.next.week) &&
        raw.next.week.length === WEEK_LEN &&
        raw.next.week.every((day) => Array.isArray(day?.meals))
          ? {
              start: raw.next.start,
              week: raw.next.week.map((day) => ({ meals: day.meals.filter((meal) => meal && typeof meal.id === 'string' && meal.pick) })),
            }
          : null,
    };
  };

  const loadState = () => {
    try {
      const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!raw || raw.v < 1) return defaultState();
      const next = { ...defaultState(), ...raw, v: STATE_VERSION };
      if (!Array.isArray(next.history)) next.history = [];
      next.history = next.history
        .filter((pos) => pos && pos.screen && pos.screen !== 'slot-done' && pos.screen !== 'picks' && pos.screen !== 'signup' && pos.screen !== 'slots')
        .map((pos) => {
          if (pos.screen === 'day') return { ...pos, screen: 'preview' };
          if (pos.screen === 'about' || pos.screen === 'activity' || pos.screen === 'result') return { ...pos, screen: 'body' };
          if (pos.screen === 'building') return { ...pos, screen: 'swipe' };
          return pos;
        });
      const legacy = !raw.likes || !Array.isArray(raw.likes.items);
      if (raw.editFrom !== 'settings') next.history = next.history.filter((pos) => pos.screen !== 'macros' && pos.screen !== 'meals');
      const migrated = legacy ? likesFromLegacy(raw.picks, raw.skipped) : null;
      next.likes = normalizeLikes(legacy ? migrated.likes : raw.likes);
      next.skips = normalizeSkips(legacy ? migrated.skips : raw.skips);
      const likedIds = new Set(next.likes.items.map((item) => item.id));
      next.skips.items = next.skips.items.filter((item) => !likedIds.has(item.id));
      if (next.screen === 'day') next.screen = 'preview';
      if (next.screen === 'signup') next.screen = 'subscribe';
      // The reviews screen is gone (chapter "Von mir" of the story took its place).
      if (next.screen === 'reviews' || next.screen === 'voices') next.screen = 'subscribe';
      next.history = next.history.filter((pos) => pos.screen !== 'reviews');
      // Left from the story A/B test (2026-10-14).
      delete next.arm;
      delete next.armForced;
      delete next.reviewsSeen;
      if (next.screen === 'slots') next.screen = 'exclusions';
      // The macro screen left the setup: a visitor saved on it continues with the exclusions.
      if ((next.screen === 'macros' || next.screen === 'meals') && next.editFrom !== 'settings') next.screen = 'exclusions';
      if (next.screen === 'about' || next.screen === 'activity' || next.screen === 'result') next.screen = 'body';
      if (next.screen === 'building') next.screen = 'swipe';
      if (next.screen === 'slot-done' || next.screen === 'picks') {
        next.screen = 'swipe';
        next.slot = null;
      }
      if (next.screen === 'swipe' && !(next.swap && next.swap.from === 'week')) next.slot = null;
      if (!next.swap || next.swap.from !== 'week') next.swap = null;
      if (next.undo?.action === 'like') {
        const item = normalizeLikeItem(next.undo.item);
        next.undo = item ? { action: 'like', item } : null;
      } else if (next.undo?.action === 'skip') {
        const id = productId(next.undo.item?.id);
        next.undo = id && SLOT_ORDER.includes(next.undo.item?.slot)
          ? { action: 'skip', item: { id, slot: next.undo.item.slot, at: next.undo.item.at || null } }
          : null;
      } else {
        next.undo = null;
      }
      next.pin = productId(next.pin) || null;
      next.swipeHintSeen = Boolean(next.swipeHintSeen);
      delete next.picks;
      delete next.skipped;
      delete next.example;
      delete next.afterAuth;
      next.slots = normalizePlanSlots(raw.slots);
      if (raw.weekApplied && typeof raw.weekApplied === 'object') {
        next.weekApplied = {
          exclusions: Array.isArray(raw.weekApplied.exclusions) ? raw.weekApplied.exclusions.slice() : [],
          maxTime: raw.weekApplied.maxTime === 15 || raw.weekApplied.maxTime === 30 ? raw.weekApplied.maxTime : null,
          leftovers: raw.weekApplied.leftovers === true,
          leftoverDays: raw.weekApplied.leftoverDays === 2 ? 2 : 1,
          slots: normalizePlanSlots(raw.weekApplied.slots),
        };
      } else if (weekHasPlan(next.week)) {
        next.weekApplied = {
          exclusions: Array.isArray(next.exclusions) ? next.exclusions.slice() : [],
          maxTime: next.maxTime === 15 || next.maxTime === 30 ? next.maxTime : null,
          slots: next.slots.slice(),
        };
      } else {
        next.weekApplied = null;
      }
      next.preview = normalizePreview(next.preview);
      next.weekStart = ISO_DAY_RE.test(String(raw.weekStart || '')) ? raw.weekStart : null;
      next.weekAlt =
        raw.weekAlt && ISO_DAY_RE.test(String(raw.weekAlt.start || '')) && weekHasPlan(raw.weekAlt.week)
          ? { start: raw.weekAlt.start, week: raw.weekAlt.week, pending: Boolean(raw.weekAlt.pending) }
          : null;
      next.prevWeek =
        raw.prevWeek && ISO_DAY_RE.test(String(raw.prevWeek.start || '')) && weekHasPlan(raw.prevWeek.week)
          ? { start: raw.prevWeek.start, week: raw.prevWeek.week }
          : null;
      next.seedKey = typeof raw.seedKey === 'string' && SEED_RE.test(raw.seedKey) ? raw.seedKey : null;
      next.planNonce = Number.isInteger(raw.planNonce) && raw.planNonce >= 0 ? raw.planNonce : 0;
      next.favMix = FAV_MIXES.includes(raw.favMix) ? raw.favMix : 'balanced';
      next.favFreq = normalizeFreq(raw.favFreq);
      next.hidden = normalizeHidden(raw.hidden);
      next.household = normalizeHousehold(raw.household);
      next.pantry = normalizePantry(raw.pantry);
      next.leftovers = raw.leftovers === true;
      next.leftoverDays = raw.leftoverDays === 2 ? 2 : 1;
      next.mealSizes = normalizeMealSizes(raw.mealSizes);
      next.mealShares = normalizeMealShares(raw.mealShares);
      next.repeat = normalizeRepeat(raw.repeat);
      next.awayRepeat = normalizeAwayRepeat(raw.awayRepeat);
      next.macros = normalizeSplit(next.macros);
      next.macrosPreset = presetIdFor(next.macros, next.macrosPreset);
      next.editFrom = next.editFrom === 'settings' ? 'settings' : null;
      next.pains = Array.isArray(raw.pains)
        ? [...new Set(raw.pains.filter((key) => PAINS.includes(key)))].slice(0, PAIN_MAX)
        : PAINS.includes(raw.pain)
          ? [raw.pain]
          : [];
      next.pain = next.pains[0] || null;
      next.why = WHYS.includes(raw.why) ? raw.why : null;
      next.name = cleanName(raw.name);
      next.scratched = raw.scratched === true;
      next.pwFirst = raw.pwFirst === true;
      next.reward = raw.reward && Number.isFinite(Date.parse(raw.reward.at)) ? { at: raw.reward.at } : null;
      // Hub v1 kept a browse flag on the swipe screen. The Rezepte tab is its own screen now.
      if (raw.browse && (next.screen === 'swipe' || next.screen === 'empty')) next.screen = 'recipes';
      delete next.browse;
      next.seen = hubRules ? hubRules.addSeen([], raw.seen) : [];
      next.maxTime = next.maxTime === 15 || next.maxTime === 30 ? next.maxTime : null;
      const eckdatenBlank =
        raw.sex == null && raw.height == null && raw.weight == null && raw.activity == null;
      if (eckdatenBlank) {
        next.sex = 'female';
        next.height = 168;
        next.weight = 64;
        next.activity = 'light';
        if (raw.age == null) next.age = 28;
      }
      return next;
    } catch (e) {
      return defaultState();
    }
  };

  let state = loadState();
  // How long the first slide stood (docs/CR_AUDIT.md 2): from planner_new to the goal tap (answered_*) or to the page
  // being hidden while still unanswered (left_*), bucketed lt3 / 3_10 / 10p. Once per page view.
  let goalShownAt = 0;
  let goalDwellSent = false;
  const goalDwell = (how) => {
    if (!goalShownAt || goalDwellSent) return;
    goalDwellSent = true;
    const s = (performance.now() - goalShownAt) / 1000;
    step('goal_dwell', `${how}_${s < 3 ? 'lt3' : s < 10 ? '3_10' : '10p'}`);
  };
  // Slide 1 drop diagnostics (2026-10-22): the first touch on slide 1 before the goal, or none when the page is left
  // untouched. With boot_vis (at planner_new) it tells a visitor who doesn't tap from a load nobody saw. Since
  // 2026-10-26 by zone (2 in 3 touched "other"): sent when the finger lifts, "scroll" when the browser takes the
  // gesture over (pointercancel), the zone on leaving when it never lifted.
  let goalTouched = false;
  let goalTouchZone = null;
  const goalZone = (t) => {
    if (!t?.closest) return 'other';
    if (t.closest('[data-vhp-set^="goal:"]')) return 'tile';
    if (t.closest('[data-vhp-story-close]')) return 'close';
    const half = t.closest('[data-vhp-story-tap]')?.dataset.vhpStoryTap;
    if (half) return half === 'back' ? 'tap_back' : 'tap_next';
    if (t.closest('a[href]')) return 'link';
    if (t.closest('.vhp-poll, .vhp-choices')) return 'card';
    if (t.closest('.vhp-story__head')) return 'head';
    return 'other';
  };
  const goalTouchSend = (zone) => {
    if (!goalTouchZone) return;
    goalTouchZone = null;
    step('goal_touch', zone);
  };
  document.addEventListener(
    'pointerdown',
    (e) => {
      if (goalTouched || !goalShownAt || goalDwellSent || state.screen !== 'goal' || state.goal) return;
      goalTouched = true;
      goalTouchZone = goalZone(e.target);
    },
    { capture: true, passive: true }
  );
  document.addEventListener('pointerup', () => goalTouchSend(goalTouchZone), { capture: true, passive: true });
  document.addEventListener('pointercancel', () => goalTouchSend('scroll'), { capture: true, passive: true });
  const goalDwellLeave = () => {
    if (state.screen !== 'goal' || state.goal || planner.config.paid) return;
    goalTouchSend(goalTouchZone);
    if (goalShownAt && !goalDwellSent && !goalTouched) step('goal_touch', 'none');
    goalDwell('left');
    window.vhpPlannerEvents?.flush?.();
  };
  window.addEventListener('pagehide', goalDwellLeave);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') goalDwellLeave();
  });
  // Random per browser, never sent anywhere. Kept when the visitor becomes a customer (same localStorage doc),
  // so remixes stay consistent across checkout.
  if (!state.seedKey) {
    try {
      state.seedKey = Array.from(crypto.getRandomValues(new Uint8Array(12)), (b) => b.toString(36).padStart(2, '0')).join('');
    } catch (e) {
      state.seedKey = `s${Date.now().toString(36)}${Math.floor(Math.random() * 1e9).toString(36)}`;
    }
  }
  let deferId = null;
  let swapPassed = [];

  // The goal as she named it: 'easy' ("Einfach gut essen", planned as maintain) or state.goal (PERSONA_ATTACK_PLAN.md 1.4).
  const goalWord = () => (state.goal === 'maintain' && state.goalEasy ? 'easy' : state.goal);
  // Numbers in the background for her (PERSONA_ATTACK_PLAN.md 2.8): every goal but Muskelaufbau and the protein link
  // gets the preview without rings; subscribers keep their planner as it is.
  const calmGoal = () => !planner.config.paid && Boolean(state.goal) && state.goal !== 'gain' && !proteinSrc;

  const persist = () => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      /* private mode: state lives for this page view only */
    }
  };

  const parseJson = (value) => {
    if (value == null || value === '') return null;
    if (typeof value === 'object') return value;
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  };

  const hydrateFromSaved = () => {
    const saved = planner.config.saved;
    if (!planner.config.customerId || !saved) return;

    // The account's seed wins (plans and remixes match across devices). Without one, the next profile flush
    // stores this browser's seed — right after checkout that is the anonymous one.
    if (typeof saved.seed === 'string' && SEED_RE.test(saved.seed)) state.seedKey = saved.seed;
    else if (state.seedKey) state.pendingFlush = true;

    // Seen ids merge both ways (another device may have seen more); the next profile flush writes the union.
    if (hubRules && Array.isArray(saved.seen) && saved.seen.length) {
      const merged = hubRules.addSeen(saved.seen, state.seen);
      if (merged.length !== saved.seen.length) state.pendingFlush = true;
      state.seen = merged;
    }

    // A browser with its own setup keeps it: likes plus the consent from the checkout dialog mean the funnel ran
    // here, and right after checkout its answers are newer than the account's. Until 2026-10-19 likes alone
    // counted, so a subscriber who had only swiped in this browser (before buying, or bought elsewhere) kept goal
    // and kcal empty and no consent: Einstellungen showed "—" and canSaveProfile let no change reach the account.
    // Such a browser now takes the account's profile and preferences; its likes stay and the favorites only add.
    // Once this browser's setup has reached the account (profileSaved), the account wins too: goal, kcal and
    // preferences may have been changed on another device since (until 2026-10-21 each device kept its own).
    const hadLikes = likeItems().length > 0;
    const profile = parseJson(saved.profile);
    if (hadLikes && state.consentPlanner && !state.profileSaved) {
      if (profile && profile.consent?.planner === true) {
        if (!state.goal && profile.goal) state.goal = profile.goal;
        if (state.kcal == null && profile.kcal != null) state.kcal = Number(profile.kcal);
      }
    } else {
      if (profile && profile.consent?.planner === true) {
        if (profile.goal) state.goal = profile.goal;
        if (profile.kcal != null) state.kcal = Number(profile.kcal);
        state.macros = normalizeSplit(profile.macros);
        state.macrosPreset = presetIdFor(state.macros, profile.macros ? 'custom' : 'recommended');
        state.consentPlanner = true;
        state.consentAt = profile.consent.at || new Date().toISOString();
        state.profileSaved = true;

        const prefs = parseJson(saved.preferences);
        if (prefs) {
          if (Array.isArray(prefs.slots)) state.slots = normalizePlanSlots(prefs.slots);
          if (Array.isArray(prefs.exclusions)) state.exclusions = prefs.exclusions;
          if (prefs.maxTime === 15 || prefs.maxTime === 30) state.maxTime = prefs.maxTime;
          else if (prefs.maxTime === null) state.maxTime = null;
          state.favMix = FAV_MIXES.includes(prefs.mix) ? prefs.mix : 'balanced';
          state.favFreq = normalizeFreq(prefs.freq);
          state.hidden = normalizeHidden(prefs.hidden);
          state.household = normalizeHousehold(prefs.household);
          state.pantry = normalizePantry(prefs.pantry);
          state.leftovers = prefs.leftovers === true;
          state.leftoverDays = prefs.leftoverDays === 2 ? 2 : 1;
          state.mealSizes = normalizeMealSizes(prefs.sizes);
          state.mealShares = normalizeMealShares(prefs.shares);
          state.repeat = normalizeRepeat(prefs.repeat, state.repeat);
          state.awayRepeat = normalizeAwayRepeat(prefs.away);
        }

        const favs = saved.favorites || {};
        SLOT_ORDER.forEach((slot) => {
          const meals = Array.isArray(favs[slot]) ? favs[slot] : [];
          meals.forEach((meal) => {
            const item = normalizeLikeItem(meal ? { ...meal, slot: meal.slot || slot } : null);
            if (!item || state.likes.items.some((row) => row.id === item.id)) return;
            state.likes.items.push(item);
          });
        });

        if (!hadLikes && state.likes.items.length) state.screen = 'preview';
      }
    }

    // Skips merge both ways like seen; the next profile flush writes the merged list when it changed.
    if (Array.isArray(saved.skips) || state.skips.items.length) {
      const likedIds = new Set(likeItems().map((item) => item.id));
      const merged = mergeSkips(saved.skips, state.skips.items, likedIds);
      const key = (list) => (Array.isArray(list) ? list : []).map((item) => `${item?.id}|${item?.at}`).join();
      if (merged.length && key(merged) !== key(saved.skips)) state.pendingFlush = true;
      state.skips.items = merged;
    }

    if (planner.config.paid) {
      // Both saved slots (this week + next week). A plan saved before weeks had dates counts as this week.
      // The account's copy wins (the week may have been changed on another device); a browser copy with unsaved
      // edits (pending) stays and is saved by the next flush.
      const favoriteIds = new Set(state.likes.items.map((item) => item.id));
      const fromAccount = [saved.week, saved.weekNext]
        .map((raw) => ({
          start: ISO_DAY_RE.test(String(raw?.weekStart || '')) ? raw.weekStart : mondayIso(0),
          week: weekFromSaved(raw, favoriteIds),
        }))
        .filter((row) => row.week);
      rollWeeks(fromAccount);
    }
    if (planner.config.paid && weekHasPlan(state.week)) {
      state.screen = 'week';
      if (!state.weekApplied) {
        state.weekApplied = {
          exclusions: state.exclusions.slice(),
          maxTime: state.maxTime || null,
          slots: normalizePlanSlots(state.slots),
        };
      }
    }
    persist();
  };

  // A saved week (Liquid JSON: product lists per day + scales JSON) as funnel days, or null.
  const weekFromSaved = (week, favoriteIds) => {
    const scales = parseJson(week?.scales) || {};
    if (!week || !Array.isArray(week.days) || week.days.length !== WEEK_LEN) return null;
    const days = week.days.map((day, index) => {
      const plan = scales[String(index + 1)]?.meals;
      if (!Array.isArray(plan)) return { meals: [] };
      const meals = plan.map((row) => {
        if (row.away === true) {
          return {
            id: row.occasion,
            label: EXAMPLE_OCCASIONS.find((item) => item.id === row.occasion)?.label || row.occasion,
            catalog: row.slot,
            scale: 1,
            locked: false,
            away: true,
            pick: null,
            kcal: Number(row.kcal) || 0,
            protein: Number(row.protein) || 0,
            carbs: Number(row.carbs) || 0,
            fat: Number(row.fat) || 0,
            generated: false,
          };
        }
        const list = Array.isArray(day?.[row.slot]) ? day[row.slot] : day?.[row.slot]?.id ? [day[row.slot]] : [];
        // Custom recipes are not in the product lists; refreshCustomMeals() fills them in.
        const found = isCustomId(row.id)
          ? { id: row.id, handle: '', title: tr('planner.own_dish'), kcal: 0, protein: 0, carbs: 0, fat: 0, image: '', ingredients: [] }
          : list.find((item) => productId(item?.id) === String(row.id));
        if (!found) return null;
        const scale = Number(row.scale) || 1;
        const pick = {
          id: productId(found.id),
          handle: found.handle,
          title: found.title,
          image: found.image || '',
          slot: row.slot,
          kcal: found.kcal,
          protein: found.protein,
          carbs: found.carbs,
          fat: found.fat,
          time: found.time,
          portions: Number(found.portions) > 0 ? Number(found.portions) : 1,
          ingredients: Array.isArray(found.ingredients) ? found.ingredients : [],
        };
        return {
          id: row.occasion,
          label: EXAMPLE_OCCASIONS.find((item) => item.id === row.occasion)?.label || row.occasion,
          catalog: row.slot,
          scale,
          locked: Boolean(row.locked),
          pick,
          kcal: Math.round((Number(pick.kcal) || 0) * scale),
          protein: Math.round((Number(pick.protein) || 0) * scale),
          carbs: pick.carbs == null ? null : Math.round(Number(pick.carbs) * scale),
          fat: pick.fat == null ? null : Math.round(Number(pick.fat) * scale),
          generated: !row.leftover && !Number.isInteger(row.cook) && !favoriteIds.has(pick.id) && !isCustomId(pick.id),
          ...(row.leftover === true || row.leftover === 2 ? { leftover: row.leftover } : {}),
          ...(row.prepped === true ? { prepped: true } : {}),
          ...(Number.isInteger(row.cook) && row.cook >= -1 && row.cook <= 6 ? { cook: row.cook } : {}),
        };
      }).filter(Boolean);
      return { meals: orderMeals(meals) };
    });
    return weekHasPlan(days) ? days : null;
  };

  // Puts every known week where it belongs today: this week on screen (state.week), next week in weekAlt,
  // last week in prevWeek; older weeks are dropped. A browser week without a date (older state) is this week.
  // extra: weeks from the account ({ start, week }); they replace this browser's copy unless it has unsaved edits.
  // Always leaves this week on screen. Returns true when the calendar week changed since the last call.
  let weekRolledFor = '';
  const rollWeeks = (extra = []) => {
    const thisWeek = mondayIso(0);
    weekRolledFor = thisWeek;
    const entries = new Map();
    const add = (start, week, pending) => {
      if (!start || !weekHasPlan(week) || entries.has(start)) return;
      entries.set(start, { week, pending: Boolean(pending) });
    };
    const local = [
      [state.weekStart || (weekHasPlan(state.week) ? thisWeek : null), state.week, state.pendingWeekFlush],
      [state.weekAlt?.start, state.weekAlt?.week, state.weekAlt?.pending],
      [state.prevWeek?.start, state.prevWeek?.week, false],
    ];
    // Unsaved edits in this browser win; otherwise the account's copy does (another device may have changed it).
    local.filter((row) => row[2]).forEach((row) => add(...row));
    extra.forEach((row) => add(row.start, row.week, false));
    local.filter((row) => !row[2]).forEach((row) => add(...row));
    const rolled = Boolean(state.weekStart) && state.weekStart !== thisWeek && state.weekStart !== mondayIso(1);
    const current = entries.get(thisWeek);
    const next = entries.get(mondayIso(1));
    const last = entries.get(mondayIso(-1));
    state.week = current ? current.week : null;
    state.weekStart = thisWeek;
    state.pendingWeekFlush = Boolean(current?.pending);
    state.weekAlt = next ? { start: mondayIso(1), week: next.week, pending: next.pending } : null;
    state.prevWeek = last ? { start: mondayIso(-1), week: last.week } : null;
    if (rolled) state.weekDay = (new Date().getDay() + 6) % 7;
    return rolled;
  };

  const membershipPlans = () => planner.config.plans || [];

  const money = (cents) =>
    (Number(cents) / 100).toLocaleString(LOCALE, {
      style: 'currency',
      currency: planner.config.currency || 'EUR',
    });

  // Price offers. Display only: checkout charges the selling plan price minus the Shopify discount code
  // startCheckout passes along (only for a plan the offer covers). Outside its window an offer is gone and the
  // screens show the selling plan prices.
  //
  // Early access (waitlist): half price on both plans, kept for as long as the subscription runs, gone on cancel.
  // Only for visitors who redeemed one of the section's early-access codes (earlyAccessCode()), until 11.10., 18:00.
  const EARLY_ACCESS = {
    id: 'early',
    from: null,
    until: new Date('2026-10-11T18:00:00+02:00'),
    untilLabel: tr('planner.early_until'),
    off: 50,
    tag: 'Early Access',
    prices: {
      // Checkout: 12,99 € and 79,50 € (yearly plan) minus PLANNER50, rounded up by Shopify.
      month: { now: 650, was: 1299 },
      year: { now: 3975, was: 7950 },
    },
  };

  // Sale from Theme settings > Angebot (window.vhpOffer, snippets/app-offer-init.liquid; also drives the top-bar
  // badge and the feed planner card): percent off the covered plans, first payment only or for as long as the
  // subscription runs. Its ?offer_test= switch moves this clock too and hides redeemed early-access codes.
  const SALE = (() => {
    const o = window.vhpOffer;
    if (!o || !o.until || !(o.percent > 0) || !o.code) return null;
    return {
      id: 'sale',
      code: o.code,
      from: o.from ? new Date(o.from) : null,
      until: new Date(o.until),
      untilLabel: o.untilLabel,
      off: o.percent,
      tag: o.label,
      plans: o.plans,
      firstPaymentOnly: Boolean(o.firstPayment),
    };
  })();

  // Story reward (docs/story-setup.md, section "Story-Setup"): the discount scratched free on the gift slide. Lives
  // from the reveal (state.reward.at) for the set hours (0 = no end, no countdown), then it's gone for good in this
  // browser: the deadline is real, never reset. Checkout gets its code like any offer.
  const REWARD_CFG = (() => {
    const r = planner.config.story?.reward;
    if (!r || !r.code || !(Number(r.percent) > 0)) return null;
    return {
      code: String(r.code),
      off: Number(r.percent),
      plans: r.plans === 'year' || r.plans === 'month' ? [r.plans] : ['year', 'month'],
      firstPaymentOnly: r.firstPayment !== false,
      hours: Math.max(0, Number(r.hours) || 0),
    };
  })();
  const rewardOffer = () => {
    const at = Date.parse(state.reward?.at || '');
    if (!REWARD_CFG || !Number.isFinite(at)) return null;
    return {
      id: 'reward',
      code: REWARD_CFG.code,
      from: null,
      until: new Date(REWARD_CFG.hours ? at + REWARD_CFG.hours * 3600000 : at + 365 * 86400000),
      timer: REWARD_CFG.hours > 0,
      off: REWARD_CFG.off,
      tag: tr('planner.story_reward_tag'),
      plans: REWARD_CFG.plans,
      firstPaymentOnly: REWARD_CFG.firstPaymentOnly,
    };
  };

  const offerNow = () => (window.vhpOffer ? window.vhpOffer.now() : Date.now());

  const offerLive = (offer) => {
    const now = offerNow();
    return (!offer.from || now >= offer.from.getTime()) && now <= offer.until.getTime();
  };

  // The early-access code this visitor redeemed: the gate snippet (snippets/vhp-planner-early-access.liquid,
  // only rendered while the gate is on), the cart (Liquid), or this browser's earlier unlock.
  const earlyAccessCode = () => {
    if (window.vhpOffer?.test) return '';
    const codes = (planner.config.earlyAccessCodes || []).map((c) => String(c));
    const match = (value) => codes.find((c) => c.toLowerCase() === String(value || '').trim().toLowerCase()) || '';
    let stored = '';
    try {
      stored = localStorage.getItem('vhp_early_access');
    } catch (e) {
      /* private mode */
    }
    return match(window.VHP_EARLY_ACCESS?.code) || match(planner.config.earlyAccessRedeemed) || match(stored);
  };

  // The offer this visitor sees right now, or null. Subscribers never see one.
  const activeOffer = () => {
    if (planner.config.paid) return null;
    if (offerLive(EARLY_ACCESS) && earlyAccessCode()) return EARLY_ACCESS;
    // One code per checkout: the story reward or the sale, whichever takes more off.
    const reward = rewardOffer();
    const sale = SALE && offerLive(SALE) ? SALE : null;
    const gift = reward && Date.now() <= reward.until.getTime() ? reward : null;
    if (gift && (!sale || gift.off >= sale.off)) return gift;
    return sale;
  };

  const offerCode = (offer) => (offer === EARLY_ACCESS ? earlyAccessCode() : offer?.code || '');

  // Countdown to the offer's real end ("1 Tag 08:12:44", under a day "08:12:44"). One interval ticks every
  // [data-vhp-offer-timer]; when the offer ends the timers go and the screens re-render at regular prices.
  const formatLeft = (ms) => {
    const sec = Math.max(0, Math.floor(ms / 1000));
    const days = Math.floor(sec / 86400);
    const hms = [Math.floor((sec % 86400) / 3600), Math.floor((sec % 3600) / 60), sec % 60]
      .map((n) => String(n).padStart(2, '0'))
      .join(':');
    return days ? `${days} ${days === 1 ? 'Tag' : 'Tage'} ${hms}` : hms;
  };

  let offerTick = null;
  const tickOfferTimers = () => {
    const timers = $$('[data-vhp-offer-timer]');
    const deal = activeOffer();
    if (!deal) {
      clearInterval(offerTick);
      offerTick = null;
      if (timers.length) {
        timers.forEach((el) => el.remove());
        render();
      }
      return;
    }
    const left = formatLeft(deal.until.getTime() - offerNow());
    timers.forEach((el) => {
      if (el.textContent !== left) el.textContent = left;
    });
  };

  const offerTimer = () => {
    const el = document.createElement('span');
    el.className = 'vhp-offer-timer';
    el.dataset.vhpOfferTimer = '';
    el.setAttribute('role', 'timer');
    if (!offerTick) offerTick = setInterval(tickOfferTimers, 1000);
    const deal = activeOffer();
    // An offer without an end (story reward with 0 hours) shows no countdown.
    if (deal?.timer === false) el.hidden = true;
    if (deal) el.textContent = formatLeft(deal.until.getTime() - offerNow());
    return el;
  };

  // { now, was, offer } in cents; was and offer only when the active offer covers this plan.
  const planPrice = (plan) => {
    const offer = activeOffer();
    const regular = Number(plan?.price) || 0;
    if (offer === EARLY_ACCESS) {
      const deal = offer.prices[plan?.interval];
      if (deal) return { now: deal.now, was: deal.was, offer };
    } else if (offer && regular > 0 && offer.plans.includes(plan?.interval)) {
      return { now: Math.round((regular * (100 - offer.off)) / 100), was: regular, offer };
    }
    return { now: regular, was: 0, offer: null };
  };

  // Paywall plan cards: the big price per month (yearly / 12), in cents.
  const monthlyShown = (plan) => {
    const { now, was } = planPrice(plan);
    const months = plan?.interval === 'year' ? 12 : 1;
    return { now: now / months, was: was / months };
  };

  // "im 1. Jahr" / "im 1. Monat" when the offer is on the first payment only, else ''.
  const firstPaymentLabel = (offer, plan) =>
    offer?.firstPaymentOnly ? (plan?.interval === 'year' ? tr('planner.first_year') : tr('planner.first_month')) : '';

  // Paywall chip: what the offer is, then the live countdown.
  const fillOfferHeadline = (el, offer, withTimer = true) => {
    const which = offer.plans?.length === 1 ? (offer.plans[0] === 'year' ? tr('planner.plan_year') : tr('planner.plan_month')) : tr('planner.plan_any');
    const what = offer === EARLY_ACCESS ? `Early Access −${offer.off} %` : `${offer.tag}: ${which} −${offer.off} %`;
    if (withTimer && offer.timer !== false) el.replaceChildren(tr('planner.offer_left', { what }), offerTimer());
    else el.textContent = what;
  };

  // Lowest monthly price over all plans, for the preview bar ("ab 3,29 € im Monat").
  const lowestMonthly = () => {
    const per = membershipPlans()
      .map((plan) => {
        const { now } = planPrice(plan);
        if (plan.interval === 'year') return now / 12;
        if (plan.interval === 'month') return now;
        return 0;
      })
      .filter((v) => v > 0);
    return per.length ? Math.min(...per) : 0;
  };

  const planLabel = (plan) => {
    if (plan.interval === 'year') return tr('planner.yearly');
    if (plan.interval === 'month') return tr('planner.monthly');
    return plan.name;
  };

  // Monthly first and preselected, yearly next to it (docs/OFFER_DECISION.md 2, 2026-10-20): the honest entry at
  // 12,99 € instead of 77,94 € at once; the yearly plan wins on its badge.
  const sortedPlans = () =>
    membershipPlans().slice().sort((a, b) => {
      if (a.interval === b.interval) return 0;
      if (a.interval === 'month') return -1;
      if (b.interval === 'month') return 1;
      return 0;
    });

  const planKey = (plan) => `${plan.variantId}|${plan.id}`;

  const defaultSubscribePlanId = () => {
    const plans = sortedPlans();
    const monthly = plans.find((p) => p.interval === 'month');
    const pick = monthly || plans[0];
    return pick ? planKey(pick) : null;
  };

  const selectedSubscribePlan = () => {
    const id = String(state.subscribePlanId || '');
    return membershipPlans().find((p) => planKey(p) === id) || null;
  };

  // ---------- calculation ----------

  // Mifflin-St Jeor: the basal rate (Grundumsatz), the floor of an Abnehmen target.
  const basalKcal = () => {
    if (!state.sex || !state.height || !state.weight) return null;
    return 10 * state.weight + 6.25 * state.height - 5 * state.age + (state.sex === 'male' ? 5 : -161);
  };

  // Basal rate × activity: what they burn a day (Erhaltungsbedarf), before the goal.
  const maintenanceKcal = () => {
    const bmr = basalKcal();
    if (bmr == null || !state.activity) return null;
    return Math.round((bmr * PAL[state.activity]) / 10) * 10;
  };

  // How much of a deficit their body gets (LOSE): 'hold' none, 'soft' at most 10 %, 'lose' the full rule.
  const loseMode = () => {
    const bmi = state.weight / (state.height / 100) ** 2;
    return bmi < LOSE.bmiHold ? 'hold' : bmi < LOSE.bmiSoft ? 'soft' : 'lose';
  };

  const computeKcal = () => {
    const need = maintenanceKcal();
    if (need == null || !state.goal) return null;
    let kcal = Math.round((need + GOAL_DELTA[state.goal]) / 10) * 10;
    if (state.goal === 'lose') {
      const mode = loseMode();
      const deficit = mode === 'hold' ? 0 : Math.min(LOSE.perKg * state.weight, (mode === 'soft' ? LOSE.softShare : LOSE.share) * need, LOSE.max);
      kcal = Math.max(Math.round((need - deficit) / 10) * 10, Math.ceil(basalKcal() / 10) * 10);
    }
    return Math.min(KCAL_MAX, Math.max(KCAL_MIN, kcal));
  };

  const currentSplit = () => normalizeSplit(state.macros);

  const applyMacroPreset = (id) => {
    if (!MACRO_PRESETS[id]) return;
    state.macrosPreset = id;
    state.macros = { ...MACRO_PRESETS[id] };
    macroRot = 0;
  };

  let macroDrag = null;
  // Visual-only ring rotation (in %): where protein starts. Lets the fat|protein knob follow the finger
  // like the other two instead of being pinned at 12 o'clock. Presets bring the ring back to the top.
  let macroRot = 0;

  // Every knob h moves only the boundary between segment h and the next (fat wraps to protein):
  // those two trade share, the third segment stays where it is.
  const applyRingDrag = (h, x) => {
    const split = currentSplit();
    const p = [split.protein, split.carbs, split.fat];
    const next = (h + 1) % 3;
    const start = macroRot + p.slice(0, h).reduce((a, b) => a + b, 0);
    const pool = p[h] + p[next];
    let v = (((x - start) % 100) + 100) % 100;
    // Finger beyond the pool (over the third segment): snap to whichever end it's closer to.
    if (v > pool) v = v > pool + (100 - pool) / 2 ? MACRO_MIN : pool - MACRO_MIN;
    v = Math.round(Math.max(MACRO_MIN, Math.min(pool - MACRO_MIN, v)));
    p[h] = v;
    p[next] = pool - v;
    // Kept in (-50, 50] so a preset swings the ring back the short way.
    if (h === 2) macroRot = ((start + v + 50) % 100) - 50;
    state.macros = { protein: p[0], carbs: p[1], fat: p[2] };
    state.macrosPreset = presetIdFor(state.macros, 'custom');
  };

  const bodyValid = () =>
    state.height >= HEIGHT_MIN && state.height <= HEIGHT_MAX && state.weight >= WEIGHT_MIN && state.weight <= WEIGHT_MAX;

  const eckdatenValid = () => Boolean(state.sex && state.activity && bodyValid());

  const syncKcal = () => {
    if (state.kcalManual) return;
    const next = computeKcal();
    if (next != null) state.kcal = next;
  };

  // ---------- recipe pools ----------

  const selectedSlots = () => PLAN_SLOTS;
  const planSlots = () => normalizePlanSlots(state.slots);

  const ingredientName = (row) => (typeof row === 'string' ? row : row?.n || '');

  // Recipes hidden in the Favoriten sheet ("Nicht mehr vorschlagen"): out of decks, pools and plans.
  let hiddenCache = { list: null, ids: new Set() };
  const hiddenIds = () => {
    const list = state.hidden?.items;
    if (hiddenCache.list !== list) hiddenCache = { list, ids: new Set((list || []).map((item) => item.id)) };
    return hiddenCache.ids;
  };

  // Allergies outrank completeness: with any exclusion set, a recipe without ingredient names is out.
  const isExcluded = (card) =>
    (hiddenIds().size > 0 && hiddenIds().has(productId(card?.id))) ||
    (state.exclusions.length > 0 && !(card.ingredients || []).some((row) => ingredientName(row))) ||
    state.exclusions.some((key) => {
      const rule = EXCLUSIONS[key];
      return (
        rule &&
        (card.ingredients || []).some((row) => {
          const name = ingredientName(row);
          return name && rule.re.test(name) && !(rule.skip && rule.skip.test(name));
        })
      );
    });

  const withinTime = (card) => {
    if (!state.maxTime) return true;
    const t = Number(card?.time);
    if (!Number.isFinite(t) || t <= 0) return true;
    return t <= state.maxTime;
  };

  const poolFor = (slot) => planner.cards(slot).filter((c) => !isExcluded(c));
  const deckPoolFor = (slot) => poolFor(slot).filter(withinTime);

  const likeItems = () => (Array.isArray(state.likes?.items) ? state.likes.items : []);
  const likesForSlot = (slot) => likeItems().filter((item) => item.slot === slot);
  const likeCount = () => likeItems().length;
  const hasLikedMain = () => likeItems().some((item) => item.slot === 'main');
  const MAINS_FIRST = 5; // Mo–Fr pills
  const planReady = () => likeCount() >= LIKE_READY && hasLikedMain();

  const planButtonLabel = () => {
    if (exampleBuilding || weekGenerating) return tr('planner.building');
    if (!hasLikedMain()) return tr('week.btn_need_main');
    if (likeCount() < LIKE_READY) return tr('week.btn_left', { n: LIKE_READY - likeCount() });
    return tr('common.create_plan');
  };

  const patternFor = (slots) => {
    const has = (slot) => slots.includes(slot);
    const seq = [];
    if (has('main')) seq.push('main');
    if (has('breakfast')) seq.push('breakfast');
    else if (has('snack')) seq.push('snack');
    if (has('main')) seq.push('main');
    if (has('snack') && has('breakfast')) seq.push('snack');
    if (has('dessert')) seq.push('dessert');
    return seq.length ? seq : slots.slice();
  };

  const deal = (groups, slots) => {
    const seq = patternFor(slots);
    const cursors = {};
    seq.forEach((slot) => {
      cursors[slot] = 0;
    });
    const out = [];
    let moved = true;
    while (moved) {
      moved = false;
      seq.forEach((slot) => {
        const list = groups[slot] || [];
        const index = cursors[slot] || 0;
        if (index < list.length) {
          out.push(list[index]);
          cursors[slot] = index + 1;
          moved = true;
        }
      });
    }
    return out;
  };

  const placePin = (cards) => {
    if (!state.pin) return cards;
    const index = cards.findIndex((card) => productId(card.id) === state.pin);
    if (index > 0) {
      const [card] = cards.splice(index, 1);
      cards.unshift(card);
    }
    return cards;
  };

  // ---------- setup deck order ----------
  // The whole slot from the index, ordered once per browser by core.deckOrder (popularity + freshness + seeded
  // jitter; 20 % of browsers get a plain shuffle) instead of newest-first. Only a loaded prefix is shown: the deck
  // stops at the first recipe whose card isn't loaded yet, so later pages never push a card in front of the one
  // on screen. ensureDeck loads the pages of the next few cards. No index (or no position) → pool order as before.
  const DECK_INDEX_WAIT_MS = 4000;
  let deckMode = null; // null (deciding) | 'index' | 'pool'
  const deckIndex = {};
  const deckOrderCache = {};
  const deckDead = new Set(); // ids whose page failed to load: skipped so the deck can't get stuck
  let deckWaitTimer = 0;

  const settleDeckMode = (mode) => {
    if (deckMode) return;
    deckMode = mode;
    window.clearTimeout(deckWaitTimer);
    if (state.screen === 'swipe' || state.screen === 'empty') render();
  };

  const startDeckIndex = () => {
    if (deckMode || deckWaitTimer) return;
    if (!planner.index || !planner.loadPage || !plannerCore) {
      deckMode = 'pool';
      return;
    }
    deckWaitTimer = window.setTimeout(() => settleDeckMode('pool'), DECK_INDEX_WAIT_MS);
    Promise.all(
      selectedSlots().map((slot) =>
        planner.index(slot).then((items) => {
          deckIndex[slot] = items;
        })
      )
    )
      .then(() => {
        const positioned = selectedSlots().every((slot) => (deckIndex[slot] || []).every((item) => Number.isFinite(item.pos)));
        settleDeckMode(positioned ? 'index' : 'pool');
      })
      .catch(() => settleDeckMode('pool'));
  };

  // With the likes, skips and goal so far (core.deckOrder opts.taste); the likes are looked up in every slot's index.
  const deckOrderFor = (slot) => {
    if (!deckOrderCache[slot]) {
      const taste = {
        likes: likeItems().map((item) => item.id),
        skips: (state.skips?.items || []).map((item) => item.id),
        goal: state.goal,
        cards: selectedSlots().flatMap((s) => deckIndex[s] || []),
      };
      deckOrderCache[slot] = plannerCore.deckOrder(
        { stats: planner.config.recipeStats },
        { cards: deckIndex[slot] || [], seed: plannerCore.seed(state.seedKey || 'anon', 'deck'), now: Date.now(), kind: hubRules?.mainIngredient, taste }
      ).cards;
    }
    return deckOrderCache[slot];
  };

  // Index items of a slot in deck order that pass the deck filters (exclusions, cook time) and keep(id).
  const deckItems = (slot, keep) =>
    deckOrderFor(slot).filter((item) => {
      const id = productId(item.id);
      return id && !deckDead.has(id) && keep(id) && !isExcluded(item) && withinTime(item);
    });

  // One fixed sequence for the page view: every slot's order dealt into the meal pattern once. Swipes, undo and
  // newly loaded pages only filter it, never re-deal it, so the card peeking behind is always the real next card.
  // Until the Mo–Fr strip holds MAINS_FIRST liked mains the deck is mains only, so every right swipe fills a pill;
  // breakfast and snack cards are dealt in afterwards.
  let deckSequence = null;
  let mainSequence = null;
  // Taste: after TASTE_AT swipes of this page view (then every TASTE_EVERY) the deck is ranked and dealt again with
  // the likes and skips since. The cards already lined up (top + the two behind) stay in front (deckFront).
  const TASTE_AT = 5;
  const TASTE_EVERY = 10;
  let deckSwipes = 0;
  let deckFront = [];
  const withFront = (seq) => {
    if (!deckFront.length) return seq;
    const at = new Map(deckFront.map((id, i) => [id, i]));
    const pos = (item) => at.get(productId(item.id));
    const head = seq.filter((item) => pos(item) != null).sort((a, b) => pos(a) - pos(b));
    return [...head, ...seq.filter((item) => pos(item) == null)];
  };
  const retasteDeck = () => {
    deckSwipes += 1;
    if (deckMode !== 'index' || deckSwipes < TASTE_AT || (deckSwipes - TASTE_AT) % TASTE_EVERY) return;
    deckFront = deckCards().slice(0, 3).map((card) => productId(card.id));
    Object.keys(deckOrderCache).forEach((slot) => delete deckOrderCache[slot]);
    deckSequence = null;
    mainSequence = null;
  };
  const mainsPending = () =>
    !state.swap && selectedSlots().includes('main') && likeItems().filter((item) => item.slot === 'main').length < MAINS_FIRST;
  // Mains-only dealing while mains are pending and unseen mains remain; out of those, all slots (unseen first).
  const deckMainsOnly = () => {
    if (!mainsPending()) return false;
    const liked = new Set(likeItems().map((item) => item.id));
    const skipped = new Set((state.skips?.items || []).map((item) => item.id));
    return deckItems('main', (id) => !liked.has(id) && !skipped.has(id)).length > 0;
  };
  const dealtDeck = (mainsOnly) => {
    if (mainsOnly) {
      if (!mainSequence) mainSequence = withFront(deal({ main: deckOrderFor('main') }, ['main']));
      return mainSequence;
    }
    if (!deckSequence) {
      const groups = {};
      selectedSlots().forEach((slot) => {
        groups[slot] = deckOrderFor(slot);
      });
      deckSequence = withFront(deal(groups, selectedSlots()));
    }
    return deckSequence;
  };

  // Loaded cards of the sequence that pass keep(id) and the deck filters, up to the first one not loaded yet.
  const orderedDeck = (keep, mainsOnly) => {
    const loaded = new Map();
    selectedSlots().forEach((slot) => deckPoolFor(slot).forEach((card) => loaded.set(productId(card.id), card)));
    const out = [];
    for (const item of dealtDeck(mainsOnly)) {
      const id = productId(item.id);
      if (!id || deckDead.has(id) || !keep(id) || isExcluded(item) || !withinTime(item)) continue;
      const card = loaded.get(id);
      if (!card) break;
      out.push(card);
    }
    return out;
  };

  const deckCards = () => {
    if (state.swap) {
      const passed = new Set(swapPassed);
      let cards = deckPoolFor(state.swap.slot).filter((card) => !passed.has(productId(card.id)));
      if (!cards.length && passed.size) {
        const last = swapPassed[swapPassed.length - 1];
        swapPassed = last ? [last] : [];
        cards = deckPoolFor(state.swap.slot).filter((card) => productId(card.id) !== last);
        if (!cards.length) cards = deckPoolFor(state.swap.slot).slice();
      }
      return placePin(cards);
    }
    const liked = new Set(likeItems().map((item) => item.id));
    const skipped = new Set((state.skips?.items || []).map((item) => item.id));
    const slots = selectedSlots();
    const fresh = {};
    const later = {};
    if (!deckMode) return [];
    if (deckMode === 'index') {
      // An empty loaded prefix while unseen cards remain means "next page still loading", not "deck done":
      // skipped cards come back only once no unseen card is left (else they repeat after a few swipes).
      const unseen = (id) => !liked.has(id) && !skipped.has(id);
      const unseenLeft = (inSlots) => inSlots.some((slot) => deckItems(slot, unseen).length);
      const mainsOnly = deckMainsOnly();
      let cards = orderedDeck(unseen, mainsOnly);
      if (!cards.length && !unseenLeft(slots)) {
        cards = orderedDeck((id) => !liked.has(id) && skipped.has(id), mainsOnly);
        if (!cards.length && mainsOnly) cards = orderedDeck((id) => !liked.has(id) && skipped.has(id));
      }
      if (deferId && cards.length > 1 && productId(cards[0].id) === deferId) cards.push(cards.shift());
      return placePin(cards);
    }
    slots.forEach((slot) => {
      fresh[slot] = [];
      later[slot] = [];
      deckPoolFor(slot).forEach((card) => {
        const id = productId(card.id);
        if (!id || liked.has(id)) return;
        (skipped.has(id) ? later : fresh)[slot].push(card);
      });
    });
    // Skipped cards only once no more pages can bring unseen ones (render shows loading meanwhile).
    const moreComing = (inSlots) => inSlots.some((slot) => planner.hasMore(slot) && !failed.has(slot));
    const poolSlots = mainsPending() ? ['main'] : slots;
    let cards = deal(fresh, poolSlots);
    if (!cards.length && poolSlots !== slots && !moreComing(poolSlots)) cards = deal(fresh, slots);
    if (!cards.length && !moreComing(slots)) {
      cards = deal(later, poolSlots);
      if (!cards.length && poolSlots !== slots) cards = deal(later, slots);
    }
    if (deferId && cards.length > 1 && productId(cards[0].id) === deferId) cards.push(cards.shift());
    return placePin(cards);
  };

  const slotsToFill = () => {
    if (state.swap) return [state.swap.slot];
    return selectedSlots();
  };

  // Unseen (not liked, not skipped) loaded cards: skipped ones don't count, or loading stops and the skips repeat.
  const unlikedCount = (slot) => {
    const liked = new Set(likeItems().map((item) => item.id));
    const skipped = state.swap ? new Set() : new Set((state.skips?.items || []).map((item) => item.id));
    return deckPoolFor(slot).filter((card) => !liked.has(productId(card.id)) && !skipped.has(productId(card.id))).length;
  };

  const fetching = new Set();
  const failed = new Set();

  // Index mode: the pages holding the next not-yet-loaded cards of the deck sequence (the next DECK_AHEAD cards).
  const DECK_AHEAD = PREFETCH * 3;
  const ensureOrderedDeck = async () => {
    const liked = new Set(likeItems().map((item) => item.id));
    const loaded = (slot) => new Set(deckPoolFor(slot).map((card) => productId(card.id)));
    const have = {};
    selectedSlots().forEach((slot) => {
      have[slot] = loaded(slot);
    });
    const wanted = new Map(); // "slot|page" → items on it
    dealtDeck(deckMainsOnly())
      .filter((item) => {
        const id = productId(item.id);
        return id && !deckDead.has(id) && !liked.has(id) && !isExcluded(item) && withinTime(item);
      })
      .slice(0, DECK_AHEAD)
      .filter((item) => !have[item.slot]?.has(productId(item.id)))
      .forEach((item) => {
        const key = `${item.slot}|${Math.floor(item.pos / (planner.pageSize || 12)) + 1}`;
        wanted.set(key, (wanted.get(key) || []).concat(item));
      });
    if (!wanted.size) return;
    let added = 0;
    await Promise.all(
      [...wanted].map(async ([key, items]) => {
        const [slot, page] = key.split('|');
        try {
          added += await planner.loadPage(slot, Number(page));
        } catch (e) {
          added += 1;
          items.forEach((item) => deckDead.add(productId(item.id)));
        }
        // A card that is still missing after its page loaded (e.g. drafted since the index) is skipped.
        const have = loaded(slot);
        items.forEach((item) => {
          if (!have.has(productId(item.id))) deckDead.add(productId(item.id));
        });
      })
    );
    if (added && (state.screen === 'swipe' || state.screen === 'empty')) {
      if (state.screen === 'empty' && deckCards().length) {
        state.screen = 'swipe';
        persist();
      }
      render();
    }
  };

  const ensureDeck = async () => {
    if (!state.swap && !deckMode) return; // deciding: render() calls again once the mode is set
    if (!state.swap && deckMode === 'index') {
      await ensureOrderedDeck();
      return;
    }
    const slots = slotsToFill().filter((slot) => !fetching.has(slot) && !failed.has(slot) && planner.hasMore(slot));
    if (!slots.length) return;
    let fetched = false;
    await Promise.all(slots.map(async (slot) => {
      const enough = () => unlikedCount(slot) >= PREFETCH;
      if (enough()) return;
      fetching.add(slot);
      fetched = true;
      try {
        while (!enough() && planner.hasMore(slot)) {
          const added = await planner.loadMore(slot);
          if (added === null) {
            failed.add(slot);
            break;
          }
          if (!added) break;
        }
      } finally {
        fetching.delete(slot);
      }
    }));
    if (fetched && (state.screen === 'swipe' || state.screen === 'empty')) {
      if (state.screen === 'empty' && deckCards().length) {
        state.screen = 'swipe';
        persist();
      }
      render();
    }
  };

  const snapshot = (card) => ({
    id: card.id,
    handle: card.handle,
    title: card.title,
    image: card.image,
    slot: card.slot,
    kcal: card.kcal,
    protein: card.protein,
    carbs: card.carbs,
    fat: card.fat,
    time: card.time,
    ...(Number(card.views) > 0 ? { views: Number(card.views) } : {}),
  });

  // ---------- navigation ----------

  const position = () => ({ screen: state.screen, slot: state.slot });

  let visibleScreen = null;
  let screenMotion = null;

  const clearScreenMotionClasses = (el) => {
    if (!el) return;
    SCREEN_MOTION_CLS.forEach((cls) => el.classList.remove(cls));
  };

  const snapScreens = (to) => {
    const host = funnel.querySelector('[data-vhp-screens]');
    host?.classList.remove('is-motion');
    funnel.querySelectorAll('[data-vhp-screen]').forEach((el) => {
      clearScreenMotionClasses(el);
      el.hidden = el.dataset.vhpScreen !== to;
    });
    visibleScreen = to;
    screenMotion = null;
  };

  const finishScreenMotion = () => {
    if (!screenMotion) return;
    window.clearTimeout(screenMotion.timer);
    screenMotion.toEl?.removeEventListener('transitionend', screenMotion.onDone);
    snapScreens(screenMotion.to);
  };

  const inferDir = (from, to, requested) => {
    if (!motionOk() || !from || from === to) return null;
    // Story: a new chapter turns like the next account's stories on IG (cube), slides within one fade.
    if (storyOn(from) && storyOn(to)) {
      const a = storyChapter(from);
      const b = storyChapter(to);
      if (a !== b) return requested === 'back' || b < a ? 'cube-back' : 'cube';
      return 'fade';
    }
    if (FADE_SCREENS.has(from) || FADE_SCREENS.has(to)) return 'fade';
    if (storyOn(from) || storyOn(to)) return 'fade';
    if ((from === 'swipe' && to === 'empty') || (from === 'empty' && to === 'swipe')) return 'fade';
    if (requested) return requested;
    if (
      (APP_TABS.has(from) || from === 'swipe' || from === 'empty') &&
      (APP_TABS.has(to) || to === 'swipe' || to === 'empty')
    ) {
      return 'fade';
    }
    return null;
  };

  const startScreenMotion = (from, to, dir) => {
    const host = funnel.querySelector('[data-vhp-screens]');
    const fromEl = funnel.querySelector(`[data-vhp-screen="${from}"]`);
    const toEl = funnel.querySelector(`[data-vhp-screen="${to}"]`);
    if (!host || !fromEl || !toEl) {
      snapScreens(to);
      return;
    }
    finishScreenMotion();
    funnel.querySelectorAll('[data-vhp-screen]').forEach((el) => {
      clearScreenMotionClasses(el);
      const id = el.dataset.vhpScreen;
      el.hidden = id !== to && id !== from;
    });
    host.classList.add('is-motion');
    fromEl.hidden = true;
    toEl.hidden = false;
    // cube-back = the cube class turning the other way.
    const dirCls = dir === 'cube-back' ? ['is-dir-cube', 'is-cube-back'] : [`is-dir-${dir}`];
    fromEl.classList.add('is-leave', ...dirCls);
    toEl.classList.add('is-enter', ...dirCls);
    void toEl.offsetWidth;
    fromEl.classList.add('is-leave-active');
    toEl.classList.add('is-enter-active');
    const onDone = (event) => {
      if (event && event.target !== toEl && event.target !== fromEl) return;
      if (event && event.propertyName && event.propertyName !== 'transform' && event.propertyName !== 'opacity') {
        return;
      }
      finishScreenMotion();
    };
    screenMotion = {
      from,
      to,
      dir,
      fromEl,
      toEl,
      onDone,
      timer: window.setTimeout(finishScreenMotion, (String(dir).startsWith('cube') ? CUBE_MS : MOTION_MS) + 80),
    };
    toEl.addEventListener('transitionend', onDone);
    visibleScreen = to;
  };

  const applyScreens = (to, from, requested) => {
    if (screenMotion && screenMotion.to === to) return;
    const dir = inferDir(from, to, requested);
    if (!dir) {
      finishScreenMotion();
      snapScreens(to);
      return;
    }
    startScreenMotion(from, to, dir);
  };

  // Anonymous funnel step counters (vhp-planner-events.js, consent-gated). Unpaid setup flow only.
  const step = (name, value) => {
    if (!planner.config.paid) window.vhpPlannerEvents?.step?.(name, value);
  };
  // Error counters count for everyone (paid weeks fail too); once per page load and kind like every step.
  const reportError = (kind) => window.vhpPlannerEvents?.step?.('planner_error', kind);

  // Paid-feature counters: once per page load and feature, paid users only (no ids, no per-user data).
  const usage = (name) => {
    if (planner.config.paid) window.vhpPlannerEvents?.step?.(name);
  };
  // Story setup (docs/story-setup.md): the setup for everyone who isn't a subscriber. Subscribers change their goals in
  // Ziele on the plain screens. The player (assets/vhp-planner-story.js) is created at boot.
  const storyActive = () => !planner.config.paid && state.editFrom !== 'settings';
  const storyOn = (screen) => storyActive() && STORY_SCREENS.has(screen);
  // Came from Sören's story (links with ?src=story / ?src=ig): the hook greets them as such.
  const storySrc = ['story', 'ig'].includes(new URLSearchParams(location.search).get('src') || '');
  // Came from the recipe CTA (theme setting recipe_planner_hook, snippets/vhp-recipe-body.liquid) for a number:
  // ?src=protein "Mein Proteinziel berechnen" (1.3 leads with protein) or ?src=portion "Meine Portion berechnen" (1.3
  // shows their portion of that dish). The hook says the number comes first; 1.3b and the paywall speak to it.
  const srcParam = new URLSearchParams(location.search).get('src') || '';
  // The collection door (docs/CR_AUDIT.md, per door; snippets/vhp-plan-tile.liquid): ?src=collection&theme=prep | fast |
  // protein | breakfast. The hook speaks to the theme, and a new setup takes it as a preset (boot): prep = Meal-Prep on
  // (leftovers, two days; a paid feature, so it shows after checkout), fast = recipes up to 30 min, protein = the
  // protein-first numbers slide like ?src=protein, breakfast = copy only.
  const COLL_THEMES = new Set(['prep', 'fast', 'protein', 'breakfast']);
  const themeParam = new URLSearchParams(location.search).get('theme') || '';
  const collTheme = srcParam === 'collection' && COLL_THEMES.has(themeParam) ? themeParam : '';
  const proteinSrc = srcParam === 'protein' || collTheme === 'protein';
  const portionSrc = srcParam === 'portion';
  // Express path for recipe calculator entries (docs/CR_AUDIT.md per door, recipe pages; RECIPE_FUNNEL.md Batch 1):
  // goal and body come from the calculator, the dish is the like. Activity → Deine Zahlen → Ausschlüsse → the week;
  // no Warum, no montage, no obstacle poll, no deck (createPlan with skip: the planner fills the rest).
  const expressPath = () => portionSrc && Boolean(state.bodyPreset || state.calcEntry) && !planner.config.paid && storyActive();
  // Short setup for every door (theme setting "Story: kurzes Setup", docs/CR_AUDIT.md 3): Ziel → Körper → Aktivität →
  // Zahlen → Ausschlüsse → deck → week; no Warum, montage, obstacle poll or answer. The deck stays (the dish grid is
  // a later build). Off by default: the nine slides as before.
  const shortSetup = () => Boolean(planner.config.storyShort) && !planner.config.paid && storyActive();
  // Likes that already make a plan (3 incl. a main, saved in the feed): the short setup whatever the door (theme setting
  // "Story: kurzes Setup, wenn die Likes schon reichen", docs/FEED_REEL.md). She has picked her dishes; Warum, Hürde
  // and Antwort would only stand between her and the week. After Ausschlüsse the plan is built from the likes (exclusions
  // case: planReady → createPlan).
  const likesDoor = () => planner.config.storyShortLikes !== false && !planner.config.paid && storyActive() && planReady();
  // Dish grid instead of the deck (theme setting "Story: Gerichte-Raster statt Deck", docs/CR_AUDIT.md 3): nine mains
  // to tap on one slide (renderGrid); the swipe deck stays for the swap and for the feed.
  const gridSetup = () => planner.config.storyGrid !== false && !planner.config.paid && storyActive();
  // Her Monday first (theme setting "Planer-Landings: erste Folie ist ihr Tag", docs/FIRST_SCREEN.md 9): a visit that
  // starts on the planner page opens on the planned day for the typical visitor instead of the goal question. Not for
  // links that came for a number or a theme (portion, protein, collection, the recipe doors): their slide stays. The
  // section's early paint applies the same rule before the scripts.
  const mondayFirst = () =>
    planner.config.mondayFirst !== false && !planner.config.paid && storyActive() && !portionSrc && !proteinSrc && srcParam !== 'collection' && !RECIPE_HOOKS.has(srcParam);
  // Sörens Woche (docs/SOEREN_WEEK.md): the one-question door instead of the Monday screen. Theme setting
  // planner_soeren_week: off | landers (visits that start on the planner page) | all. Links that came for a number or a
  // theme keep their slide, as for mondayFirst(). The same rule paints the screen early in sections/meal-planner.liquid.
  const soerenMode = () => {
    let mode = String(planner.config.soerenWeek || 'off');
    // Review themes only (never the live theme): ?soeren=all | landers | off, kept for the session, to walk the door
    // without a settings change (the CLI cannot write settings_data.json of a development theme).
    if (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') {
      try {
        const override = new URLSearchParams(location.search).get('soeren') || sessionStorage.getItem('vhp_soeren');
        if (override) {
          sessionStorage.setItem('vhp_soeren', override);
          mode = override;
        }
      } catch (e) {
        /* storage blocked: the setting stands */
      }
    }
    return mode;
  };
  // "recipes" adds every visit that started on a recipe page or brings a recipe's dish along (11-03, Maxim: the recipe
  // door converts nothing as it is). The portion calculator joins: her number is in, so the question is skipped and the
  // week builds at once (soerenSkip at boot).
  const soerenOn = () => {
    const mode = soerenMode();
    if (mode === 'off' || planner.config.paid || !storyActive() || proteinSrc || srcParam === 'collection' || !hasScreen('soeren')) return false;
    // Her own picks win (11-03): a visit from the homepage, Explore or Likes that already saved enough for a plan of her
    // own (3 incl. a main) gets that week, not his. Planner landers and recipe visits keep his week.
    if (planReady() && !plannerLander() && visitLanding() !== 'recipe') return false;
    if (mode === 'all' || plannerLander()) return true;
    return mode === 'recipes' && (visitLanding() === 'recipe' || recipeDoor() || portionSrc);
  };
  // The recipe page's other doors (theme docs/RECIPE_FUNNEL.md 3): cook mode's "Fertig" (cooked), "Und morgen?" after
  // the method (next), the shopping-list line under the ingredients (list). Only the hook on the Ziel slide changes.
  const RECIPE_HOOKS = new Set(['cooked', 'next', 'list']);
  // Recipe fast path (docs/RECIPE_PAGE_REBUILD.md 6, 2026-11-02): a door on a recipe page that brought its dish along
  // (the PICK_KEY pick below): those hooks, or the planner line under the dish (assets/vhp-plan-goal.js sets
  // vhp_recipe_door, 30 min). Ziel → Körper → Aktivität → Zahlen → Ausschlüsse → the week: no Warum, Hürde, Antwort,
  // no dish grid and no summary; the dish is the like, the planner picks the rest (as the express path). Body data
  // stays (D3, Maxim: no assumed portions). Read from storage here, not introPick: the story asks before that exists.
  const recipeDoor = () => {
    if (planner.config.paid || !storyActive()) return false;
    try {
      if (!JSON.parse(sessionStorage.getItem('vhp_planner_pick') || 'null')?.id) return false;
      if (RECIPE_HOOKS.has(srcParam)) return true;
      const door = JSON.parse(sessionStorage.getItem('vhp_recipe_door') || 'null');
      return Boolean(door && Date.now() - Number(door.at || 0) < 30 * 60 * 1000);
    } catch (e) {
      return false;
    }
  };
  // The slides both paths leave out (and the Monday door: its setup is Ausschlüsse → dishes → the week).
  const trimmedStory = () => expressPath() || shortSetup() || likesDoor() || Boolean(state.mondayDoor) || recipeDoor();
  // Instagram links to the planner page (docs/PLANNER_PAGE_FUNNEL.md 1.3): ?src=bio (the bio link) and ?src=dm (a DM
  // link) get their own greeting on the Ziel slide; the bio one also offers the recipes and answers "die Rezepte sind
  // doch kostenlos" on the paywall.
  const LANDER_HOOKS = new Set(['bio', 'dm']);
  let storyPlayer = null;
  let giftFoil = null;

  const kcalBand = (kcal) => String(Math.min(4000, Math.max(1000, Math.floor((Number(kcal) || 0) / 200) * 200)));

  // Theme setting "Kostenlose Wochenvorschau ausschalten": no preview screen; every way to it (plan ready, a waiting
  // preview, resume) lands on the paywall instead, with the discount gift first like a paywall tap. The week is still
  // built (paywall week card, handover after checkout). No paywall_opened: selling_plan_shown is the arrival.
  const gated = () => !planner.config.paid && planner.config.freePreview === false && membershipPlans().length > 0;
  const show = (screen, slot = state.slot, dir) => {
    if (screen === 'preview' && gated()) {
      if (!state.subscribePlanId) state.subscribePlanId = defaultSubscribePlanId();
      grantGift();
      screen = 'subscribe';
    }
    const from = state.screen;
    if (screen !== from) {
      if (screen === 'preview') step('preview_viewed');
      else if (screen === 'subscribe') step('selling_plan_shown');
      // Paywall first (docs/PLANNER_PAGE_FUNNEL.md 3.1): the free preview opened from the plans (its link or back).
      if (screen === 'preview' && from === 'subscribe' && state.pwFirst) step('pw_first', 'preview');
    }
    state.screen = screen;
    state.slot = slot;
    if (screen === 'grid' || screen === 'swipe' || screen === 'empty') state.sawRecipes = true;
    persist();
    render({ from, dir });
  };

  const forward = (screen, slot = null) => {
    if (state.screen !== 'building') state.history.push(position());
    const fade = FADE_SCREENS.has(state.screen) || FADE_SCREENS.has(screen);
    show(screen, slot, fade ? 'fade' : 'forward');
  };

  // The Eckdaten are complete (the activity slide's Weiter, or all of them from the recipe calculator).
  const finishEckdaten = () => {
    if (!state.kcalManual) state.kcal = computeKcal();
    if (!validSplit(state.macros)) {
      state.macros = recommendedMacros();
      state.macrosPreset = 'recommended';
    }
    step('eckdaten_done', kcalBand(state.kcal));
  };
  // The story's next Eckdaten slide after Ziel / Warum: what the recipe calculator answered is not asked again.
  const eckdatenNext = () => {
    if (!state.bodyPreset) return 'body';
    if (!state.activityPreset) return 'activity';
    finishEckdaten();
    return 'numbers';
  };

  const SCALE_GLYPH = { 0.25: '¼', 0.5: '½', 0.75: '¾' };

  // "1¾": quarters as glyphs, no unit.
  const fmtQty = (scale) => {
    const whole = Math.floor(scale + 1e-9);
    const frac = Math.round((scale - whole) * 4) / 4;
    let label = whole ? String(whole) : '';
    if (frac) label += SCALE_GLYPH[frac] || String(frac);
    return label || '0';
  };

  // "½ Portion", "1 Portion", "1½ Portionen": singular up to one.
  const fmtScale = (scale) => `${fmtQty(scale)} ${tr(scale <= 1 ? 'planner.portions_one' : 'planner.portions_other')}`;

  const SVG_NS = 'http://www.w3.org/2000/svg';
  const spriteIcon = (name, className) => {
    if (!name) return null;
    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.classList.add('vhp-ico');
    if (className) String(className).split(/\s+/).filter(Boolean).forEach((cls) => svg.classList.add(cls));
    const use = document.createElementNS(SVG_NS, 'use');
    use.setAttribute('href', `#vhp-ico-${name}`);
    use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', `#vhp-ico-${name}`);
    svg.append(use);
    return svg;
  };
  const slotIconName = (key) => SLOT_ICON[key] || null;
  const fillSlotLabel = (el, text, iconKey) => {
    if (!el) return;
    el.replaceChildren();
    const ico = spriteIcon(slotIconName(iconKey), 'vhp-ico--sm');
    if (ico) el.append(ico);
    if (text) el.append(document.createTextNode(text));
  };
  const strokeIcon = (draw) => {
    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('vhp-pick__icon');
    draw(svg);
    return svg;
  };
  const addStroke = (parent, tag, attrs) => {
    const el = document.createElementNS(SVG_NS, tag);
    el.setAttribute('stroke', 'currentColor');
    el.setAttribute('stroke-width', '1.8');
    el.setAttribute('stroke-linecap', 'round');
    el.setAttribute('stroke-linejoin', 'round');
    Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
    parent.append(el);
  };
  const lockIcon = (locked) =>
    strokeIcon((svg) => {
      addStroke(svg, 'path', { d: locked ? 'M8 11V8a4 4 0 1 1 8 0v3' : 'M8 11V8a4 4 0 0 1 7.9-.8' });
      addStroke(svg, 'rect', { x: '5', y: '11', width: '14', height: '10', rx: '2' });
    });
  const dotsIcon = () =>
    strokeIcon((svg) => {
      ['5', '12', '19'].forEach((cx) => addStroke(svg, 'circle', { cx, cy: '12', r: '1', 'stroke-width': '2.6' }));
    });
  const diceIcon = () =>
    strokeIcon((svg) => {
      addStroke(svg, 'rect', { x: '4', y: '4', width: '16', height: '16', rx: '4' });
      addStroke(svg, 'path', { d: 'M9 9h.01M15 15h.01M15 9h.01M9 15h.01', 'stroke-width': '2.6' });
    });
  const rewindIcon = () =>
    strokeIcon((svg) => {
      addStroke(svg, 'path', { d: 'M4 12a8 8 0 1 0 2.4-5.7' });
      addStroke(svg, 'path', { d: 'M4 4v4h4' });
    });
  const bookIcon = () =>
    strokeIcon((svg) => {
      addStroke(svg, 'path', { d: 'M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3z' });
      addStroke(svg, 'path', { d: 'M5 17a3 3 0 0 1 3-3h11' });
    });
  // Unterwegs: a car.
  const awayIcon = () =>
    strokeIcon((svg) => {
      addStroke(svg, 'path', { d: 'M5 16V11l2-5h10l2 5v5' });
      addStroke(svg, 'path', { d: 'M3 16h18v2H3z' });
      addStroke(svg, 'path', { d: 'M5 11h14' });
      addStroke(svg, 'path', { d: 'M7 18v2M17 18v2' });
    });
  const copyIcon = () =>
    strokeIcon((svg) => {
      addStroke(svg, 'rect', { x: '9', y: '9', width: '12', height: '12', rx: '2' });
      addStroke(svg, 'path', { d: 'M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1' });
    });
  // Eigenes Gericht: a pencil (same as Eigene on the Rezepte hub).
  const penIcon = () =>
    strokeIcon((svg) => {
      addStroke(svg, 'path', { d: 'M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16v4Z' });
    });
  // Every week: a calendar with a loop.
  const repeatIcon = () =>
    strokeIcon((svg) => {
      addStroke(svg, 'rect', { x: '4', y: '5', width: '16', height: '15', rx: '3' });
      addStroke(svg, 'path', { d: 'M4 10h16M9 3v4M15 3v4' });
      addStroke(svg, 'path', { d: 'M15 15.5a3 3 0 1 1-1-2.2M15 12.5v1.6h-1.6' });
    });
  const peopleIcon = () =>
    strokeIcon((svg) => {
      addStroke(svg, 'circle', { cx: '9', cy: '8', r: '3.2' });
      addStroke(svg, 'path', { d: 'M3.5 19a5.5 5.5 0 0 1 11 0' });
      addStroke(svg, 'circle', { cx: '17', cy: '9', r: '2.6' });
      addStroke(svg, 'path', { d: 'M15.5 14.2A4.5 4.5 0 0 1 21 18.5' });
    });
  const swapIcon = () =>
    strokeIcon((svg) => {
      addStroke(svg, 'path', { d: 'M8 3 4 7l4 4' });
      addStroke(svg, 'path', { d: 'M4 7h16' });
      addStroke(svg, 'path', { d: 'M16 21l4-4-4-4' });
      addStroke(svg, 'path', { d: 'M20 17H4' });
    });
  const heartIcon = (on) =>
    strokeIcon((svg) => {
      addStroke(svg, 'path', {
        d: 'M20.8 4.6c-1.8-1.8-4.8-1.8-6.6 0L12 6.8l-2.2-2.2c-1.8-1.8-4.8-1.8-6.6 0-1.8 1.8-1.8 4.8 0 6.6L12 20l8.8-8.8c1.8-1.8 1.8-4.8 0-6.6z',
        fill: on ? 'currentColor' : 'none',
        'stroke-width': on ? '0' : '1.8',
      });
    });
  const pickAction = ({ tag = 'button', label, icon, on, href, dataset }) => {
    const el = document.createElement(tag);
    if (tag === 'button') el.type = 'button';
    el.className = 'vhp-pick__action';
    if (on) el.classList.add('is-on');
    el.setAttribute('aria-label', label);
    el.title = label;
    if (href) {
      el.href = href;
      el.target = '_blank';
      el.rel = 'noopener';
    }
    if (dataset) {
      Object.entries(dataset).forEach(([key, value]) => {
        el.dataset[key] = value;
      });
    }
    el.append(icon);
    return el;
  };
  const fmtScaleShort = (scale) => {
    const n = Number(scale);
    if (!Number.isFinite(n) || n <= 0) return '';
    return `×${n.toLocaleString(LOCALE, { minimumFractionDigits: n % 1 ? 1 : 0, maximumFractionDigits: 1 })}`;
  };
  const mealMetaLine = ({ scale, kcal, protein, time }) => {
    const parts = [];
    const kcalNum = Number(kcal);
    if (Number.isFinite(kcalNum) && kcalNum > 0) parts.push(`${Math.round(kcalNum).toLocaleString(LOCALE)} kcal`);
    const proteinNum = Number(protein);
    if (Number.isFinite(proteinNum) && proteinNum > 0) parts.push(tr('common.protein', { n: Math.round(proteinNum) }));
    const timeNum = Number(time);
    if (Number.isFinite(timeNum) && timeNum > 0) parts.push(tr('common.min', { n: Math.round(timeNum) }));
    if (!parts.length) return fmtScale(scale);
    return parts.join(' · ');
  };
  // Week + preview: the day from morning to evening, all meals in one box. Each meal's name ("FRÜHSTÜCK", plus
  // "Gesperrt" or a leftover note) sits inside its row above the title. The row keeps its own classes; the
  // wrapper mirrors is-locked (remix motion skips locked meals).
  // railAction: optional small button in the row's action column (week: the meal's ⋯ sheet).
  const mealOnRail = (row, { label, locked, liked, note, railAction }) => {
    const wrap = document.createElement('div');
    wrap.className = 'vhp-meal';
    wrap.classList.toggle('is-locked', Boolean(locked));
    const when = document.createElement('p');
    when.className = 'vhp-meal__when';
    const name = document.createElement('span');
    name.className = 'vhp-meal__name';
    name.textContent = label || '';
    when.append(name);
    if (locked) {
      const tag = document.createElement('span');
      tag.className = 'vhp-meal__state vhp-meal__state--locked';
      tag.append(lockIcon(true), document.createTextNode(tr('planner.locked')));
      when.append(tag);
    }
    if (liked) {
      const tag = document.createElement('span');
      tag.className = 'vhp-meal__state vhp-meal__state--liked';
      tag.textContent = `♥ ${tr('planner.liked_tag')}`;
      when.append(tag);
    }
    if (note) {
      const tag = document.createElement('span');
      tag.className = 'vhp-meal__state';
      tag.textContent = note;
      when.append(tag);
    }
    const info = row.querySelector('.vhp-pick__info');
    if (info) info.prepend(when);
    else row.prepend(when);
    if (railAction) {
      let actions = row.querySelector('.vhp-pick__actions');
      if (!actions) {
        actions = document.createElement('div');
        actions.className = 'vhp-pick__actions';
        row.append(actions);
      }
      actions.append(railAction);
    }
    wrap.append(row);
    return wrap;
  };

  // Reste einplanen notes inside the card: the lunch only gets reheated; the dinner is cooked for tomorrow too.
  const leftoverNote = (text) => {
    const note = document.createElement('p');
    note.className = 'vhp-preview__auto vhp-pick__lo';
    const ico = strokeIcon((svg) => {
      addStroke(svg, 'path', { d: 'M4 12a8 8 0 1 0 2.4-5.7' });
      addStroke(svg, 'path', { d: 'M4 4v4h4' });
    });
    note.append(ico, document.createTextNode(text));
    return note;
  };
  // Vorrat (copy sheet "Schon vorgekocht"): already cooked, so it is only reheated and never bought.
  const preppedNote = () => {
    const note = document.createElement('p');
    note.className = 'vhp-preview__auto vhp-pick__lo';
    const ico = strokeIcon((svg) => {
      addStroke(svg, 'rect', { x: '3', y: '4', width: '18', height: '5', rx: '1' });
      addStroke(svg, 'path', { d: 'M5 9v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9' });
      addStroke(svg, 'path', { d: 'M10 13h4' });
    });
    note.append(ico, document.createTextNode(tr('planner.from_pantry_reheat')));
    return note;
  };

  // The invisible button over a whole meal card that opens its recipe (own dish or shop recipe).
  const pickHit = ({ customId, handle, scale, title, occasion }) => {
    if (!customId && !handle) return null;
    const hit = document.createElement('button');
    hit.type = 'button';
    hit.className = 'vhp-pick__hit';
    if (customId) hit.dataset.vhpCustomOpen = customId;
    else {
      hit.dataset.vhpRecipeOpen = handle;
      hit.dataset.vhpRecipeTitle = title || '';
    }
    hit.dataset.vhpRecipeScale = String(scale ?? 1);
    if (occasion) hit.dataset.vhpRecipeOccasion = occasion;
    hit.setAttribute('aria-label', tr('planner.view_recipe_of', { title: title || (customId ? tr('planner.own_dish') : tr('common.recipe')) }));
    return hit;
  };

  // ▶ on a meal card (Maxim 2026-10-20: the card's crop hides the dish): the day's dishes full screen in the reel
  // viewer from this one, as video where the recipe has one, else the photo (the disc then shows ⤢); "Rezept" there
  // opens the sheet in the card's portion. openDayReel reads the day from the cards' discs.
  const PLAY_ICON = '<svg class="vhp-mcard__play-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13a1 1 0 0 0 1.5.9l10.4-6.5a1 1 0 0 0 0-1.8L9.5 4.6A1 1 0 0 0 8 5.5z" fill="currentColor"/></svg>';
  const EXPAND_ICON = '<svg class="vhp-mcard__photo-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 4h6v6M10 20H4v-6M20 4l-7 7M4 20l7-7"/></svg>';
  const mealPlayBtn = ({ handle, title, image, scale, protein, occasion }) => {
    if (!handle) return null;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vhp-mcard__play';
    btn.dataset.vhpMealPlay = handle;
    btn.dataset.title = title || '';
    btn.dataset.image = image || '';
    btn.dataset.scale = String(scale ?? 1);
    btn.dataset.protein = String(Math.round(Number(protein) || 0));
    btn.dataset.occasion = occasion || '';
    btn.setAttribute('aria-label', tr('planner.watch_dish', { title: title || tr('common.recipe') }));
    btn.innerHTML = PLAY_ICON + EXPAND_ICON;
    window.vhpReelViewer?.prefetch?.(handle)?.then((m) => {
      if (m?.ok && !m.src) btn.classList.add('is-photo');
    }, () => {});
    return btn;
  };

  // The meal's dish first, then (Maxim 2026-10-20) the other dishes for that meal below it, ranked like the swap
  // sheet (coreSwapRows) in their portion: a swipe up shows the next one. Week: "Hier einsetzen" swaps it in
  // (applySwapPick). Preview: the same reel, its button locked ("Im Abo tauschen" opens the paywall).
  const DAY_REEL_ALTS = 20;
  const dayReelAlts = async (occasion, preview) => {
    if (!plannerCore || !occasion) return [];
    let ctx = null;
    let pool = [];
    if (preview) {
      const open = Number(state.preview?.open) || 0;
      const day = state.preview?.week?.[open];
      const meal = day?.meals?.find((row) => row.id === occasion);
      if (!meal) return [];
      let catalog = null;
      try {
        catalog = await plannerCatalog(false);
      } catch (e) {
        catalog = null;
      }
      pool = (catalog?.[meal.catalog] || allCatalogCards().filter((card) => card.slot === meal.catalog)).filter(hasPlannableMacros);
      ctx = {
        day,
        meal,
        dayIndex: open,
        excludeId: productId(meal.pick?.id),
        core: plannerContext({}),
        days: (state.preview.week || []).map((d) => (d?.meals || []).map(coreFixedMeal)),
      };
    } else {
      ctx = swapContext(occasion);
      if (!ctx || ctx.meal.locked || ctx.meal.away) return [];
      try {
        await fillRemixPools();
      } catch (e) {
        // the pools as they are
      }
      pool = allCatalogCards().filter((card) => card.slot === ctx.meal.catalog && !isExcluded(card));
    }
    const today = new Set((ctx.day.meals || []).filter((meal) => meal.id !== occasion).map(mealProductId).filter(Boolean));
    return coreSwapRows(ctx, pool)
      .filter((row) => !row.blocked && !today.has(productId(row.card.id)))
      .slice(0, DAY_REEL_ALTS);
  };

  let dayReelBusy = false;
  const openDayReel = async (btn) => {
    const viewer = window.vhpReelViewer;
    if (!viewer || dayReelBusy) return;
    const preview = Boolean(btn.closest('[data-vhp-preview-meals]'));
    const occasion = btn.dataset.occasion;
    // The reel's close steps back in history: our back entry has to be under it, or that step leaves the planner
    // (a reloaded preview has none until a tap).
    if (storyActive()) pushStoryBack();
    dayReelBusy = true;
    btn.classList.add('is-busy');
    let rows = [];
    try {
      rows = await dayReelAlts(occasion, preview);
    } catch (e) {
      rows = [];
    } finally {
      dayReelBusy = false;
      btn.classList.remove('is-busy');
    }
    if (!btn.isConnected) return;
    const scale = Number(btn.dataset.scale) || 1;
    const protein = Number(btn.dataset.protein) || 0;
    const current = {
      handle: btn.dataset.vhpMealPlay,
      title: btn.dataset.title,
      image: btn.dataset.image ? hubThumb(btn.dataset.image, 900) : '',
      chips: [fmtScale(scale)].concat(protein > 0 ? [tr('common.protein', { n: protein })] : []),
      note: rows.length ? tr('planner.reel_current') : '',
      primary: false,
      scale,
      occasion,
      disc: btn,
    };
    let after = null;
    const alts = rows.map((row) => ({
      id: productId(row.card.id),
      handle: row.card.handle || '',
      title: dishName(row.card.title || ''),
      image: row.card.image ? hubThumb(row.card.image, 900) : '',
      chips: [fmtScale(row.scale), `${fmt(row.kcal)} kcal`, tr('common.protein', { n: fmt(row.protein) })],
      primaryLabel: preview ? tr('planner.swap_locked') : '',
      scale: row.scale,
      occasion,
      row,
    }));
    viewer.open({
      items: [current, ...alts],
      start: 0,
      label: tr('planner.swap_title', { label: btn.closest('.vhp-meal')?.querySelector('.vhp-mcard__meal')?.textContent || tr('planner.meal') }),
      source: preview ? 'planner_preview_day' : 'planner_day',
      host: funnel,
      primary: alts.length
        ? {
            label: tr('planner.place_here'),
            onClick: (item) => {
              if (!item.row) return;
              // Closing steps back in history: the paywall opens once that is through (onClose), or the back
              // would undo it.
              if (preview) after = () => continueToSubscribe('swap');
              closeReel();
              if (!preview) applySwapPick(item.id, item.scale, item.occasion);
            },
          }
        : null,
      onClose: () => {
        const go = after;
        after = null;
        if (go) window.setTimeout(go, 0);
      },
      onRecipe: (item) => openRecipeSheet({ handle: item.handle, scale: item.scale, title: item.title, occasion: item.occasion }),
      originFor: (item) => (item.disc?.isConnected ? item.disc.closest('.vhp-mcard') : null),
    });
  };

  const mealPickRow = ({
    rail,
    leftoverFrom,
    feedsNext,
    image,
    title,
    label,
    scale,
    generated,
    handle,
    extraActions,
    kcal,
    protein,
    time,
    occasion,
    locked,
    fading,
    customId,
    archived,
    railAction,
    prepped,
    away,
    liked,
    cue,
  }) => {
    const row = document.createElement('div');
    row.className = 'vhp-pick';
    if (away) row.classList.add('is-away');
    if (locked) row.classList.add('is-locked');
    if (fading) row.classList.add('is-fading');

    const hit = pickHit({ customId, handle, scale, title, occasion });
    if (hit) row.append(hit);

    const media = document.createElement('div');
    media.className = 'vhp-pick__media';
    const img = document.createElement(image ? 'img' : 'div');
    img.className = 'vhp-pick__img';
    if (image) {
      img.src = image;
      img.alt = '';
    }
    if (away) img.append(awayIcon());
    media.append(img);
    const badge = away ? '' : fmtScaleShort(scale);
    if (badge) {
      const mark = document.createElement('span');
      mark.className = 'vhp-pick__portion';
      mark.textContent = badge;
      media.append(mark);
    }

    const info = document.createElement('div');
    info.className = 'vhp-pick__info';
    const titleEl = document.createElement('p');
    titleEl.className = 'vhp-pick__title';
    titleEl.textContent = title || '';
    const meta = document.createElement('p');
    meta.className = 'vhp-pick__meta';
    const proteinNum = Number(protein);
    if (rail && !away && Number.isFinite(proteinNum) && proteinNum > 0) {
      // Day view: protein leads in green (the number this planner is about), kcal and time follow quietly.
      const lead = document.createElement('strong');
      lead.className = 'vhp-pick__protein';
      lead.textContent = tr('common.protein', { n: Math.round(proteinNum) });
      const rest = mealMetaLine({ scale, kcal, time });
      meta.append(lead);
      if (rest && rest !== fmtScale(scale)) meta.append(document.createTextNode(` · ${rest}`));
    } else {
      meta.textContent = away
        ? Number(kcal) > 0
          ? tr('planner.still_free', { meta: mealMetaLine({ scale, kcal, protein }) })
          : tr('planner.day_full')
        : mealMetaLine({ scale, kcal, protein, time });
    }
    // On the rail the meal name is above the card; elsewhere it stays the small kicker.
    if (!rail) {
      const slotEl = document.createElement('p');
      slotEl.className = 'vhp-pick__slot';
      const slotLabel = locked && label ? tr('planner.label_locked', { label }) : label || '';
      fillSlotLabel(slotEl, slotLabel, occasion || label);
      info.append(slotEl);
    }
    info.append(titleEl, meta);
    if (customId) {
      const own = document.createElement('p');
      own.className = 'vhp-preview__auto vhp-pick__own';
      own.textContent = archived ? tr('planner.own_recipe_archived') : tr('planner.own_recipe');
      info.append(own);
    } else if (generated && !rail) info.append(autoFilledNote());
    if (prepped) info.append(preppedNote());
    else if (leftoverFrom) info.append(leftoverNote(tr('planner.reheat_only')));
    else if (feedsNext) info.append(leftoverNote(tr('planner.cooks_for_lunch', { day: feedsNext })));
    // Preview: what a tap on the dish opens (the whole row is the button, vhp-pick__hit, and had no sign of it).
    if (cue && hit) {
      const go = document.createElement('p');
      go.className = 'vhp-pick__cue';
      go.setAttribute('aria-hidden', 'true');
      go.textContent = `${tr('planner.recipe_cue')} ›`;
      info.append(go);
    }

    row.append(media, info);
    const actions = document.createElement('div');
    actions.className = 'vhp-pick__actions';
    (extraActions || []).forEach((el) => {
      if (el) actions.append(el);
    });
    if (actions.childElementCount) row.append(actions);
    return rail
      ? mealOnRail(row, { label, occasion, locked, liked, note: leftoverFrom ? tr('planner.leftovers_from', { day: leftoverFrom }) : '', railAction })
      : row;
  };
  const sparkleIcon = () => {
    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('vhp-preview__sparkle');
    const path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('fill-rule', 'evenodd');
    path.setAttribute('clip-rule', 'evenodd');
    path.setAttribute(
      'd',
      'M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5ZM18 1.5a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.625 2.625 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.625 2.625 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5ZM16.5 15a.75.75 0 0 1 .712.558l.194.597a1.5 1.5 0 0 0 .95.95l.597.194a.75.75 0 0 1 0 1.402l-.597.194a1.5 1.5 0 0 0-.95.95l-.194.597a.75.75 0 0 1-1.402 0l-.194-.597a1.5 1.5 0 0 0-.95-.95l-.597-.194a.75.75 0 0 1 0-1.402l.597-.194a1.5 1.5 0 0 0 .95-.95l.194-.597A.75.75 0 0 1 16.5 15Z'
    );
    svg.append(path);
    return svg;
  };
  const autoFilledNote = () => {
    const auto = document.createElement('p');
    auto.className = 'vhp-preview__auto';
    auto.append(sparkleIcon(), document.createTextNode(tr('planner.auto_filled')));
    return auto;
  };

  const EXAMPLE_OCCASIONS = [
    { id: 'breakfast', catalog: 'breakfast', label: tr('common.slot_breakfast'), share: 0.25 },
    { id: 'lunch', catalog: 'main', label: tr('common.lunch'), share: 0.35 },
    { id: 'dinner', catalog: 'main', label: tr('common.dinner'), share: 0.3 },
    { id: 'snack', catalog: 'snack', label: tr('common.slot_snack'), share: 0.1 },
  ];
  // Meal name for display. Saved weeks keep the label they were planned with (German before the EN store),
  // so the occasion id wins.
  const occLabel = (meal) => EXAMPLE_OCCASIONS.find((row) => row.id === meal?.id)?.label || meal?.label || '';

  const activeOccasions = () => {
    const shares = state.mealShares;
    if (shares) {
      return EXAMPLE_OCCASIONS.filter((row) => shares[row.id] > 0).map((row) => ({ ...row, share: shares[row.id] / 100 }));
    }
    const slots = planSlots();
    const kept = EXAMPLE_OCCASIONS.filter((row) => slots.includes(row.catalog));
    if (plannerCore) return plannerCore.mealShares(kept, state.mealSizes);
    const total = kept.reduce((sum, row) => sum + row.share, 0) || 1;
    return kept.map((row) => ({ ...row, share: row.share / total }));
  };
  const capForOccasions = (occasions) =>
    plannerCore ? plannerCore.shareCapFor(occasions) : Math.max(0, ...(occasions || []).map((row) => Number(row.share) || 0)) > 0.4 + 1e-9 ? 0.55 : 0.4;
  const shareCap = () => capForOccasions(activeOccasions());
  const shareLimitKcal = () => Math.floor((Number(state.kcal) || 0) * shareCap());
  // Steps a portion down (¼, floor ½) while one meal would exceed the day's share cap.
  const capToShare = (card, scale) => {
    const limit = shareLimitKcal();
    let next = Number(scale) || 1;
    while (next > 0.5 && limit > 0 && Number(card?.kcal) * next > limit) next -= 0.25;
    return next;
  };
  const markWeekApplied = () => {
    state.weekApplied = {
      exclusions: (state.exclusions || []).slice(),
      maxTime: state.maxTime || null,
      slots: planSlots(),
      leftovers: Boolean(state.leftovers),
      leftoverDays: state.leftoverDays === 2 ? 2 : 1,
    };
  };
  const settingsDirty = () => {
    const applied = state.weekApplied;
    if (!applied) return false;
    const slotsNow = planSlots().join();
    const slotsThen = normalizePlanSlots(applied.slots).join();
    const exNow = (state.exclusions || []).slice().sort().join();
    const exThen = (applied.exclusions || []).slice().sort().join();
    return (
      slotsNow !== slotsThen ||
      exNow !== exThen ||
      (state.maxTime || null) !== (applied.maxTime || null) ||
      Boolean(state.leftovers) !== Boolean(applied.leftovers) ||
      (state.leftovers && (state.leftoverDays === 2) !== (applied.leftoverDays === 2)) ||
      weekNeedsFill()
    );
  };

  const fitPortion = (kcal, ideal, target, cap = 0.4) => {
    const shareLimit = Math.floor(Number(target) * (Number(cap) > 0 ? Number(cap) : 0.4));
    let best = null;
    let bestDiff = Infinity;
    for (let step = 0; step <= 6; step += 1) {
      const scale = (2 + step) / 4;
      const shown = Math.round(Number(kcal) * scale);
      if (shown > shareLimit) continue;
      const diff = Math.abs(shown - ideal);
      if (diff < bestDiff) {
        bestDiff = diff;
        best = scale;
      }
    }
    return best;
  };

  // Includes the previewed week and its open day: a preview from an earlier day rebuilds (same seed, same week).
  const exampleKey = () =>
    JSON.stringify({
      start: previewStartIso(),
      open: previewOpenIndex(),
      next: previewNextDays(previewOpenIndex()),
      kcal: state.kcal,
      exclusions: state.exclusions.slice().sort(),
      maxTime: state.maxTime || null,
      macros: currentSplit(),
      slots: planSlots(),
      likes: likeItems().map((item) => `${item.slot}:${item.id}`),
      skips: (state.skips.items || []).map((item) => `${item.slot}:${item.id}`),
    });

  // What the planned week depends on besides likes/skips. A preview is handed over after checkout only while
  // this still matches (exclusions decide allergy safety). Likes/skips are left out: merging the account's
  // skips can reorder them without changing what the customer saw.
  const planBasisKey = () =>
    JSON.stringify({
      kcal: state.kcal,
      exclusions: state.exclusions.slice().sort(),
      maxTime: state.maxTime || null,
      macros: currentSplit(),
      slots: planSlots(),
    });

  // The preview component's input: the open day's meals, every day's totals (the other days' recipes are not shown).
  const weekPreviewFromPlan = (planned, target, favoriteIds, open) => {
    const openPlan = planned[open];
    const meals = (openPlan?.meals || []).map((meal) => ({
      id: meal.id,
      label: meal.label,
      title: meal.pick?.title || '',
      image: meal.pick?.image || '',
      handle: meal.pick?.handle || '',
      scale: meal.scale,
      kcal: meal.kcal,
      protein: meal.protein,
      carbs: meal.carbs,
      fat: meal.fat,
      time: meal.pick?.time ?? null,
      generated: !favoriteIds.has(productId(meal.pick?.id)),
      over: Boolean(meal.overShare),
    }));
    return {
      target,
      open,
      day: {
        meals,
        totals: {
          kcal: openPlan?.totals?.kcal || 0,
          protein: openPlan?.totals?.protein || 0,
          carbs: openPlan?.totals?.carbs || 0,
          fat: openPlan?.totals?.fat || 0,
        },
      },
      // Day totals for every day (locked days show only these; their meals stay blurred placeholders).
      days: PREVIEW_DAYS.map((label, index) => ({
        label,
        kcal: planned[index]?.totals?.kcal || 0,
        protein: planned[index]?.totals?.protein || 0,
        carbs: planned[index]?.totals?.carbs || 0,
        fat: planned[index]?.totals?.fat || 0,
      })),
    };
  };

  // ---------- planner core (assets/vhp-planner-core.js) ----------
  const PLAN_CATALOG_SLOTS = ['breakfast', 'main', 'snack'];
  const isoDate = (date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  // Same user + week + nonce → same plan (a reload is stable, every device builds the same new week);
  // "neu generieren" bumps the nonce. The week is the one on screen (this or next); unpaid, the previewed week.
  const planSeed = (nonce, start) =>
    plannerCore.seed(
      state.seedKey || planner.config.customerId || 'anon',
      start || (planner.config.paid && state.weekStart ? state.weekStart : previewStartIso()),
      nonce ?? state.planNonce ?? 0
    );
  // Mains of the week next to the one on screen (last week, or this week while next week is open):
  // the core holds them back softly so two weeks in a row don't look the same.
  const recentMains = () => {
    if (!planner.config.paid) return [];
    const other = state.weekStart === mondayIso(1) ? state.weekAlt?.week : state.prevWeek?.week;
    return [...new Set((other || []).flatMap((day) => day?.meals || [])
      .filter((meal) => meal.catalog === 'main')
      .map((meal) => productId(meal.pick?.id))
      .filter(Boolean))];
  };
  const mainIngredient = (card) => (hubRules?.mainIngredient ? hubRules.mainIngredient(card || {}) : null);

  // Starts the index fetch early (page idle) so planning rarely waits on it.
  const warmPlannerIndex = () =>
    PLAN_CATALOG_SLOTS.forEach((slot) => {
      planner.index?.(slot).catch(() => {});
    });

  // Every plannable recipe per slot: the JSON index (all pages), or the full card pool if the index fails.
  // Exclusions apply to catalog recipes (likes included). withCustom (paid): active custom recipes with
  // use_in_autofill join the slots in their meal_types, never filtered.
  const plannerCatalog = async (withCustom) => {
    const out = {};
    await Promise.all(
      PLAN_CATALOG_SLOTS.map(async (slot) => {
        let cards = null;
        try {
          cards = planner.index ? await planner.index(slot) : null;
        } catch (e) {
          cards = null;
        }
        if (!cards) {
          await fillPool(slot, Infinity);
          cards = planner.cards(slot);
        }
        const own = withCustom ? customCards(slot, { autofill: true }) : [];
        // Paused favorites stay in the swap sheet and Rezepte, but the generator never plans them.
        const paused = pausedIds();
        out[slot] = [...own, ...cards.filter((card) => !isExcluded(card) && !paused.has(productId(card.id)))].map((card) => ({
          ...card,
          mi: mainIngredient(card),
        }));
      })
    );
    return out;
  };

  const plannerContext = (catalog) => {
    const occasions = activeOccasions();
    return plannerCore.context({
      target: { kcal: Number(state.kcal) || 0, ...macroGrams(state.kcal, currentSplit()) },
      occasions,
      shareCap: capForOccasions(occasions),
      maxTime: state.maxTime,
      catalog,
      likes: likeItems().map((item) => item.id).filter((id) => favFreqOf(id) !== 'pause'),
      skips: (state.skips?.items || []).map((item) => item.id),
      stats: planner.config.recipeStats,
      mix: state.favMix,
      freq: state.favFreq,
      recent: recentMains(),
      // Meal-Prep recipes reheat well: preferred for dinners that are also tomorrow's lunch.
      prep: hubRules
        ? Object.values(catalog || {}).flat().filter((card) => hubRules.isMealPrep(card)).map((card) => card.id)
        : [],
    });
  };

  // Reste einplanen is a paid planning setting; the preview always plans every meal fresh.
  const leftoversOn = () => Boolean(planner.config.paid && state.leftovers);
  const LEFTOVER_FROM = 'dinner';
  const LEFTOVER_TO = 'lunch';

  // A locked funnel meal as the core sees it (already scaled).
  const coreFixedMeal = (meal) => ({
    occasion: meal.id,
    slot: meal.catalog || meal.pick?.slot,
    id: productId(meal.pick?.id),
    scale: meal.scale,
    kcal: Number(meal.kcal) || 0,
    protein: Number(meal.protein) || 0,
    carbs: Number(meal.carbs) || 0,
    fat: Number(meal.fat) || 0,
    mi: mainIngredient(meal.pick),
    // Reste: lets the core see a batch that started the day before (leftoverSource).
    ...(meal.leftover ? { leftover: meal.leftover === 2 ? 2 : true } : {}),
  });

  // A planned core meal as a funnel choice (pick snapshot incl. ingredients, scaled macros, overShare).
  const choiceFromCoreMeal = (meal) => {
    const row = EXAMPLE_OCCASIONS.find((occasion) => occasion.id === meal.occasion) || {
      id: meal.occasion,
      label: '',
      catalog: meal.slot,
    };
    const next = mealFromRemix({ id: row.id, label: row.label, catalog: row.catalog }, meal.card, meal.scale, false);
    return { ...next, overShare: meal.overShare, leftover: meal.leftover === 2 ? 2 : Boolean(meal.leftover) };
  };

  // Preview, first paid week, "Woche neu generieren". Resolves to 7 × { meals, totals }; meals are
  // { id (occasion), label, catalog, scale, overShare, pick, kcal, protein, carbs, fat } for the open slots
  // (locked ones stay with the caller). fixed: locked funnel meals per day; forbid: per day { occasion: id }.
  // start: plan another week than the one on screen (the preview's next week, previewNextDays), with that week's seed.
  const planWeek = async ({ withCustom, fixed, forbid, nonce, start } = {}) => {
    if (!plannerCore) throw new Error('planner core missing');
    const ctx = plannerContext(await plannerCatalog(withCustom));
    const steps = plannerCore.planWeekSteps(ctx, {
      seed: planSeed(nonce, start),
      fixed: (fixed || []).map((day) => (day || []).map(coreFixedMeal)),
      forbid,
      leftovers: leftoverSetting(),
    });
    const planned = [];
    for (const day of steps) {
      planned.push({
        totals: day.totals,
        meals: day.meals.filter((meal) => !meal.locked).map(choiceFromCoreMeal),
      });
      // One day per task: keeps the page responsive on slow phones.
      await new Promise((resolve) => window.setTimeout(resolve, 0));
    }
    // A fresh, unlocked week that misses the target is a planner failure worth counting: average kcal off by more than
    // 10 % or average protein under 90 % of target (the benchmark hits +-5 % kcal and >= 95 % protein in 99 % of weeks).
    // Weeks with locked meals are skipped: locks can legitimately prevent hitting the target.
    if (!(fixed || []).some((day) => day && day.length)) {
      const target = { kcal: Number(state.kcal) || 0, protein: macroGrams(state.kcal, currentSplit()).protein };
      const days = planned.filter((day) => day.totals?.kcal > 0);
      if (target.kcal && days.length) {
        const mean = (key) => days.reduce((sum, day) => sum + (Number(day.totals[key]) || 0), 0) / days.length;
        if (Math.abs(mean('kcal') - target.kcal) > target.kcal * 0.1 || (target.protein && mean('protein') < target.protein * 0.9)) {
          reportError('macro_miss');
        }
      }
    }
    return planned;
  };

  const orderMeals = (meals) => {
    const rank = new Map(EXAMPLE_OCCASIONS.map((row, index) => [row.id, index]));
    return meals.slice().sort((a, b) => (rank.get(a.id) ?? 9) - (rank.get(b.id) ?? 9));
  };

  const mealFromChoice = (choice, favoriteIds) => ({
    id: choice.id,
    label: choice.label,
    catalog: choice.pick?.slot || 'main',
    scale: choice.scale,
    locked: false,
    pick: choice.pick,
    kcal: choice.kcal,
    protein: choice.protein,
    carbs: choice.carbs,
    fat: choice.fat,
    // A leftover lunch is a decision made with its dinner, never "Automatisch ergänzt".
    generated: !choice.leftover && !favoriteIds.has(productId(choice.pick?.id)) && !isCustomId(choice.pick?.id),
    ...(choice.leftover ? { leftover: choice.leftover === 2 ? 2 : true } : {}),
  });

  // Up to two liked mains for the free day (2026-10-17: the walk had 1 of 3 likes on it, the planner spreads likes
  // thin). Portioned to their meal's share like a swap (fitPortion), then the core plans the rest of that day around
  // them as fixed meals, so the day still adds up. Most recent like first; only what passes their exclusions and cook
  // time; never two with the same main ingredient (the walk had two "Crispy Chili Peanut" dishes on one day). Cards
  // from the planner's own catalog (all pages; the deck pools may only hold the first one at this point).
  // first: the dish they came from (introPick) goes first, so it is on the free day even when the week planner did not
  // pick it anywhere (docs/PERSONA_ATTACK_PLAN.md 2.6: two walks came from a recipe and never saw it again).
  const likedForOpenDay = async (first = '') => {
    const occasions = activeOccasions().filter((row) => row.catalog === 'main');
    const pool = ((await plannerCatalog())?.main || []).filter(withinTime);
    const kcal = Number(state.kcal) || 0;
    const out = [];
    const used = new Set();
    const ids = likeItems()
      .filter((item) => item.slot === 'main')
      .map((item) => item.id)
      .reverse();
    const lead = first ? ids.findIndex((id) => productId(id) === productId(first)) : -1;
    if (lead > 0) ids.unshift(...ids.splice(lead, 1));
    ids.forEach((id) => {
        if (out.length >= Math.min(2, occasions.length) || !kcal) return;
        const card = pool.find((row) => productId(row.id) === id);
        if (!card || !(Number(card.kcal) > 0)) return;
        const mi = mainIngredient(card);
        if (mi && used.has(mi)) return;
        const occasion = occasions[out.length];
        const scale = fitPortion(Number(card.kcal), Math.round(kcal * occasion.share), kcal, shareCap());
        if (!scale) return;
        if (mi) used.add(mi);
        out.push({ ...mealFromRemix(occasion, card, scale, false), locked: true });
      });
    return out;
  };

  // The preview generates the whole week and keeps it (state.preview.week); the screen opens one day only.
  const buildPreview = async () => {
    const key = exampleKey();
    const start = previewStartIso();
    const open = previewOpenIndex();
    const keep = !leftoversOn() ? await likedForOpenDay(introPick) : [];
    const fixed = Array.from({ length: WEEK_LEN }, (_, index) => (index === open ? keep : []));
    const planned = await planWeek(keep.length ? { fixed } : {});
    // planWeek leaves fixed meals with the caller; the day's totals already count them.
    if (keep.length && planned[open]) {
      planned[open].meals = orderMeals(planned[open].meals.concat(keep.map((meal) => ({ ...meal, locked: false }))));
    }
    // The dish they tapped "Einplanen" on (introPick) onto the open day: its whole day changes places with the open
    // one (each day is planned to target on its own). Not with leftovers, which tie a day to the next.
    if (introPick && !leftoversOn()) {
      const has = (day) => day?.meals?.some((meal) => productId(meal.pick?.id) === productId(introPick));
      const at = planned.findIndex((day, index) => index > open && has(day));
      if (at > open && !has(planned[open])) [planned[open], planned[at]] = [planned[at], planned[open]];
    }
    const favoriteIds = new Set(likeItems().map((item) => item.id));
    // No liked main fits the free day: the day with the most of their likes is the free one. Same whole-day swap.
    if (!introPick && !leftoversOn() && !keep.length) {
      const likesOn = (day) => (day?.meals || []).filter((meal) => favoriteIds.has(productId(meal.pick?.id))).length;
      let best = open;
      planned.forEach((day, index) => {
        if (index > open && likesOn(day) > likesOn(planned[best])) best = index;
      });
      if (best !== open) [planned[open], planned[best]] = [planned[best], planned[open]];
    }
    // Free day = tomorrow late in the week: the locked tiles continue into next week, planned like the paid planner
    // would plan it (same seed), so the days they saw are the days they get.
    let next = null;
    if (previewNextDays(open) > 0) {
      const nextStart = isoOf(addDays(dateOfIso(start), WEEK_LEN));
      const nextPlanned = await planWeek({ start: nextStart });
      next = {
        start: nextStart,
        week: nextPlanned.map((day) => ({ meals: orderMeals(day.meals.map((meal) => mealFromChoice(meal, favoriteIds))) })),
      };
    }
    if (key !== exampleKey()) return; // answers changed while this ran (summary edit): a newer build follows
    state.preview = {
      key,
      basis: planBasisKey(),
      start,
      ...weekPreviewFromPlan(planned, state.kcal, favoriteIds, open),
      week: planned.map((day) => ({ meals: orderMeals(day.meals.map((meal) => mealFromChoice(meal, favoriteIds))) })),
      next,
    };
  };

  const fillPool = async (slot, need) => {
    // Whole slot wanted (hub, swap sheet, remix): fetch the remaining pages in parallel.
    if (planner.loadAll && need >= (planner.counts(slot)?.total || Infinity) && planner.hasMore(slot)) {
      await planner.loadAll(slot);
    }
    while (poolFor(slot).length < need && planner.hasMore(slot)) {
      const added = await planner.loadMore(slot);
      if (!added) break;
    }
  };

  const SHOP_CHECKS_KEY = 'vhp_shop_checked';
  // Rounding and quantity glyphs are the site's one set (assets/vhp-amounts.js, loaded by layout/theme.liquid before this
  // script): the free recipe page shows her portion's amounts with the same rules (docs/PORTION_FIRST.md batch 1).
  const shopNorm = window.vhpAmounts.norm;
  const shopUnitKind = window.vhpAmounts.kindOf;

  // Recipe units are German data (EL, TL, Stück); shown in the page language.
  const SHOP_UNIT_KEY = { el: 'el', esslöffel: 'el', tl: 'tl', teelöffel: 'tl', stück: 'stueck', stk: 'stueck', prise: 'prise' };
  const shopUnitLabel = (unit) => {
    const key = SHOP_UNIT_KEY[shopNorm(unit).replace(/\./g, '')];
    return key ? tr(`planner.unit_${key}`) : unit;
  };

  const shopMergeKey = (name, unit) => `${shopNorm(name)}|${shopNorm(unit).replace(/\./g, '')}`;

  const shopRound = window.vhpAmounts.round;
  const shopFmtQty = window.vhpAmounts.fmtQty;

  const shopLineText = (item) => {
    if (item.kind === 'taste') return item.name;
    const amount =
      item.kind === 'metric' ? `${shopFmtQty(item.qty)}${item.unit}` : `${shopFmtQty(item.qty)} ${shopUnitLabel(item.unit)}`.trim();
    return `${amount}${item.hint ? tr('planner.to_taste') : ''} ${item.name}`;
  };

  const normalizeShopIngs = (raw) => {
    if (!Array.isArray(raw)) return [];
    return raw
      .map((row) => {
        if (typeof row === 'string') return { n: row, a: 0, u: '' };
        const n = String(row?.n || '').trim();
        if (!n) return null;
        return { n, a: Number(row.a) || 0, u: String(row.u || '') };
      })
      .filter(Boolean);
  };

  const recipeFromSource = (obj) => {
    if (!obj || (obj.ingredients == null && obj.portions == null)) return null;
    return {
      portions: Number(obj.portions) > 0 ? Number(obj.portions) : 1,
      ingredients: normalizeShopIngs(obj.ingredients),
    };
  };

  const findRecipe = (id, slot) => {
    const sid = productId(id);
    if (!sid) return null;
    const order = slot
      ? [slot, ...PLAN_SLOTS.filter((key) => key !== slot), 'dessert']
      : [...PLAN_SLOTS, 'dessert'];
    for (let i = 0; i < order.length; i += 1) {
      const card = planner.cards(order[i]).find((row) => productId(row.id) === sid);
      if (card) return recipeFromSource(card);
    }
    const saved = planner.config.saved;
    const lists = [];
    (saved?.week?.days || []).forEach((day) => {
      SLOT_ORDER.forEach((key) => {
        if (Array.isArray(day?.[key])) lists.push(day[key]);
      });
    });
    SLOT_ORDER.forEach((key) => {
      if (Array.isArray(saved?.favorites?.[key])) lists.push(saved.favorites[key]);
    });
    for (let i = 0; i < lists.length; i += 1) {
      const found = lists[i].find((item) => productId(item?.id) === sid);
      if (found && (found.ingredients != null || found.portions != null)) return recipeFromSource(found);
    }
    return null;
  };

  const weekMeals = () =>
    (state.week || []).flatMap((day) => day?.meals || []).filter((meal) => productId(meal?.pick?.id));

  const ensureShopRecipes = async () => {
    // Custom recipes carry their own ingredients on the pick; never page the catalog for them.
    const missing = weekMeals().filter(
      (meal) => !isCustomId(meal.pick.id) && !findRecipe(meal.pick.id, meal.catalog || meal.pick.slot)
    );
    const bySlot = {};
    missing.forEach((meal) => {
      const slot = meal.catalog || meal.pick.slot;
      if (!slot) return;
      bySlot[slot] = bySlot[slot] || new Set();
      bySlot[slot].add(productId(meal.pick.id));
    });
    await Promise.all(
      Object.keys(bySlot).map(async (slot) => {
        const want = bySlot[slot];
        while (want.size && planner.hasMore(slot)) {
          const added = await planner.loadMore(slot);
          if (!added) break;
          [...want].forEach((id) => {
            if (findRecipe(id, slot)) want.delete(id);
          });
        }
      })
    );
  };

  // Week shown in the shop (this or next), and the days the customer shops for (stored per week).
  const SHOP_DAYS_KEY = 'vhp_shop_days';
  const shopWeekIso = () => (planner.config.paid && state.weekStart ? state.weekStart : mondayIso(0));
  // This week: from today on (past meals are eaten). Next week: all days.
  const defaultShopDays = () => {
    const from = viewingNextWeek() ? 0 : (new Date().getDay() + 6) % 7;
    return Array.from({ length: WEEK_LEN - from }, (_, index) => from + index);
  };
  const readShopDays = () => {
    try {
      const raw = JSON.parse(localStorage.getItem(`${SHOP_DAYS_KEY}:${shopWeekIso()}`) || 'null');
      const days = Array.isArray(raw) ? [...new Set(raw.map(Number))].filter((day) => day >= 0 && day < WEEK_LEN).sort() : [];
      return days.length ? days : defaultShopDays();
    } catch (e) {
      return defaultShopDays();
    }
  };
  const writeShopDays = (days) => {
    try {
      localStorage.setItem(`${SHOP_DAYS_KEY}:${shopWeekIso()}`, JSON.stringify(days));
      const keep = new Set([0, 1].map((n) => `${SHOP_DAYS_KEY}:${mondayIso(n)}`));
      Object.keys(localStorage)
        .filter((key) => key.startsWith(`${SHOP_DAYS_KEY}:`) && !keep.has(key))
        .forEach((key) => localStorage.removeItem(key));
    } catch (e) { /* ignore */ }
  };
  // "Mo–Mi", "Mo, Mi, Fr", "ganze Woche".
  const shopDaysLabel = (days) => {
    if (days.length === WEEK_LEN) return tr('planner.whole_week');
    const runs = [];
    days.forEach((day) => {
      const last = runs[runs.length - 1];
      if (last && day === last[1] + 1) last[1] = day;
      else runs.push([day, day]);
    });
    return runs
      .map(([a, b]) => (a === b ? DAY_LABEL[a] : b === a + 1 ? `${DAY_LABEL[a]}, ${DAY_LABEL[b]}` : `${DAY_LABEL[a]}–${DAY_LABEL[b]}`))
      .join(', ');
  };

  const shopKeyOf = (name) => (shopRules ? shopRules.canonical(name) : shopNorm(name));
  const shopAisleOf = (name, unit) => (shopRules ? shopRules.aisleOf(name, unit) : 'other');
  const shopInPantry = (name, unit) => (shopRules ? shopRules.inPantry(name, unit, state.pantry) : false);

  // Meals merged by ingredient (spelling variants count as one) + unit, with the aisle on each line. Staples (Vorrat)
  // are split off; plain water and ice are never listed. The week's list (buildShoppingList) and the preview's free
  // day (renderPreviewDayList) both come from here.
  const mergeShopMeals = (meals) => {
    const merged = new Map();
    const missing = [];
    const seenMissing = new Set();
    const markMissing = (meal) => {
      const id = productId(meal.pick.id);
      if (seenMissing.has(id)) return;
      seenMissing.add(id);
      missing.push({ title: meal.pick.title || tr('common.recipe'), handle: meal.pick.handle || '' });
    };
    meals.forEach((meal) => {
      const recipe =
        (meal.pick?.ingredients != null ? recipeFromSource(meal.pick) : null) ||
        findRecipe(meal.pick.id, meal.catalog || meal.pick.slot);
      if (!recipe || !recipe.ingredients.length) {
        // A custom recipe without ingredients is the user's choice, not missing data.
        if (!isCustomId(meal.pick.id)) markMissing(meal);
        return;
      }
      const scale = cookPortions(meal);
      const portions = recipe.portions || 1;
      recipe.ingredients.forEach((ing) => {
        if (shopRules?.isDropped(ing.n)) return;
        const key = `${shopKeyOf(ing.n)}|${shopNorm(ing.u).replace(/\./g, '')}`;
        const qty = (Number(ing.a) || 0) * (scale / portions);
        const prev = merged.get(key);
        if (prev) prev.raw += qty;
        else merged.set(key, { key, name: ing.n, unit: ing.u, raw: qty });
      });
    });
    // Same ingredient in several units (Spinat g + EL, Salz Prise + TL) becomes one line.
    const folded = shopRules ? shopRules.foldUnits([...merged.values()]) : [...merged.values()];
    const items = [];
    const pantry = [];
    folded.forEach((row) => {
      const rounded = shopRound(row.raw, row.unit);
      const item = rounded.kind === 'taste'
        ? { key: row.key, name: row.name, unit: row.unit, kind: 'taste' }
        : { key: row.key, name: row.name, unit: row.unit, kind: rounded.kind, qty: rounded.qty, hint: Boolean(rounded.hint) };
      item.aisle = shopAisleOf(row.name, row.unit);
      (shopInPantry(row.name, row.unit) ? pantry : items).push(item);
    });
    const byName = (a, b) => a.name.localeCompare(b.name, 'de');
    items.sort(byName);
    pantry.sort(byName);
    return { items, pantry, missing };
  };

  // Meals of the chosen days of the week on screen.
  const buildShoppingList = () => {
    const days = readShopDays();
    const week = state.week || [];
    // Vorrat meals are already cooked: nothing to buy, the list only says how many there are.
    // A Reste lunch of a Vorrat dinner is from the same batch.
    const isPrepped = (meal, index) =>
      Boolean(meal.prepped) ||
      Boolean(meal.leftover && findMeal(week, index - leftoverBackOf(meal), LEFTOVER_FROM)?.prepped);
    const planned = week
      .flatMap((day, index) => (days.includes(index) ? (day?.meals || []).map((meal) => ({ meal, index })) : []))
      .filter(({ meal }) => productId(meal?.pick?.id));
    const prepped = planned.filter(({ meal, index }) => isPrepped(meal, index)).length;
    const meals = planned.filter(({ meal, index }) => !isPrepped(meal, index)).map(({ meal }) => meal);
    return { ...mergeShopMeals(meals), days, prepped };
  };

  // The preview's free day as a shopping list (2026-10-17): the week's merge and rounding for that one day, by aisle,
  // tickable for the visit. Proof of the feature on the day they can cook; the week's list stays locked further down.
  // Since 2026-10-19 one closed row ("25 Zutaten …") that opens the list: open it pushed the locked week down and gave
  // a paid feature away to everyone. Opens count as preview_use list_more; if few open it, the row can go.
  let dayListOpen = false;
  const renderPreviewDayList = (preview) => {
    const box = $('[data-vhp-preview-daylist]');
    if (!box) return;
    const open = Number(preview?.open) || 0;
    const meals = (preview?.week?.[open]?.meals || []).filter((meal) => productId(meal?.pick?.id));
    const merged = meals.length ? mergeShopMeals(meals) : null;
    const items = merged ? merged.items : [];
    box.hidden = !items.length;
    if (!items.length) return;
    const key = `${preview.key}|${open}|${dayListOpen ? 1 : 0}`;
    if (box.dataset.key === key) return;
    box.dataset.key = key;
    const groups = box.querySelector('[data-vhp-daylist-groups]');
    const aisles = shopRules ? shopRules.AISLES : [{ id: 'other', label: '' }];
    const ordered = aisles.flatMap((aisle) => items.filter((item) => !shopRules || item.aisle === aisle.id).map((item) => ({ item, aisle })));
    const shown = dayListOpen ? ordered : [];
    const toggle = box.querySelector('[data-vhp-daylist-more]');
    if (toggle) toggle.setAttribute('aria-expanded', dayListOpen ? 'true' : 'false');
    box.classList.toggle('is-open', dayListOpen);
    const count = box.querySelector('[data-vhp-daylist-count]');
    if (count) count.textContent = tr('planner.daylist_count', { n: String(ordered.length) });
    const nodes = [];
    let ul = null;
    let lastAisle = null;
    shown.forEach(({ item, aisle }) => {
      if (aisle !== lastAisle) {
        lastAisle = aisle;
        if (aisle.label) {
          const head = document.createElement('p');
          head.className = 'vhp-pv-daylist__aisle';
          head.textContent = aisle.label;
          nodes.push(head);
        }
        ul = document.createElement('ul');
        ul.className = 'vhp-pv-daylist__items';
        nodes.push(ul);
      }
      const li = document.createElement('li');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vhp-pv-daylist__item';
      btn.dataset.vhpDaylistItem = '';
      btn.setAttribute('aria-pressed', 'false');
      const tick = document.createElement('span');
      tick.className = 'vhp-pv-daylist__tick';
      tick.setAttribute('aria-hidden', 'true');
      btn.append(tick, document.createTextNode(shopLineText(item)));
      li.append(btn);
      ul.append(li);
    });
    groups?.replaceChildren(...nodes);
    const pantryEl = box.querySelector('[data-vhp-daylist-pantry]');
    if (pantryEl) {
      const names = (merged?.pantry || []).map((item) => item.name);
      pantryEl.hidden = !dayListOpen || !names.length;
      pantryEl.textContent = names.length ? tr('planner.daylist_pantry', { names: names.slice(0, 6).join(', ') }) : '';
    }
  };

  // Ticked items per week, in localStorage: they survive closing the tab mid-shop (Instagram's browser).
  const shopChecksKey = () => `${SHOP_CHECKS_KEY}:${planner.config.paid && state.weekStart ? state.weekStart : mondayIso(0)}`;

  // Extra people eating this meal with the customer (0 = cooking for one).
  const householdExtra = (occasion) =>
    planner.config.paid && state.household?.n > 1 && state.household.shared.includes(occasion) ? state.household.n - 1 : 0;
  // Portions the extra people eat (their portion size times their number).
  const householdPortions = (occasion) => householdExtra(occasion) * (Number(state.household?.size) || 1);
  // Portions to cook: the customer's own (scale) + the household's.
  const cookPortions = (meal) => (Number(meal?.scale) || 1) + householdPortions(meal?.id);
  const householdLabel = () => {
    const h = state.household;
    if (!h || h.n <= 1) return tr('planner.household_one');
    const names = h.shared.length === HOUSEHOLD_MEALS.length
      ? tr('planner.household_all')
      : h.shared.map((id) => EXAMPLE_OCCASIONS.find((row) => row.id === id)?.label || id).join(' & ');
    return tr('planner.household_n', { names, n: h.n });
  };

  let householdTimer = 0;
  const saveHousehold = () => {
    persist();
    render();
    if (!planner.config.paid) return;
    window.clearTimeout(householdTimer);
    householdTimer = window.setTimeout(() => {
      state.pendingFlush = true;
      flushProfile();
    }, 1200);
  };

  const readShopChecks = () => {
    try {
      const raw = JSON.parse(localStorage.getItem(shopChecksKey()) || '[]');
      return new Set(Array.isArray(raw) ? raw.map(String) : []);
    } catch (e) {
      return new Set();
    }
  };

  const writeShopChecks = (set) => {
    try {
      localStorage.setItem(shopChecksKey(), JSON.stringify([...set]));
      // Only this week and next week are kept.
      const keep = new Set([0, 1].map((n) => `${SHOP_CHECKS_KEY}:${mondayIso(n)}`));
      Object.keys(localStorage)
        .filter((key) => key.startsWith(`${SHOP_CHECKS_KEY}:`) && !keep.has(key))
        .forEach((key) => localStorage.removeItem(key));
    } catch (e) { /* ignore */ }
  };

  // avoidCurrent (default with keepLocks): unlocked meals never come back in the same slot. The Favoriten
  // sheet turns it off: with "Mehr Favoriten" a favorite may well stay where it is.
  // Feste Mahlzeiten join the locked meals of a generated week (same recipe and portion, locked).
  // A meal the caller already keeps for that day and occasion wins; a recipe that is gone is skipped.
  const withRepeatMeals = async (locked) => {
    const fixed = Array.from({ length: WEEK_LEN }, (_, index) => (locked[index] || []).slice());
    const active = new Set(activeOccasions().map((row) => row.id));
    // Freie Mahlzeiten every week (awayRepeat): a budget, no recipe.
    (planner.config.paid ? state.awayRepeat || [] : []).forEach((rule) => {
      const occasion = EXAMPLE_OCCASIONS.find((row) => row.id === rule.occasion);
      if (!occasion || !active.has(rule.occasion)) return;
      rule.days.forEach((dayIndex) => {
        if (fixed[dayIndex].some((meal) => meal.id === rule.occasion)) return;
        fixed[dayIndex].push(awayPlaceholder(occasion));
      });
    });
    const rules = planner.config.paid ? state.repeat || [] : [];
    if (!rules.length) return fixed;
    let catalog = {};
    try {
      catalog = await plannerCatalog(true);
    } catch (e) {
      /* findCatalogCard / the rule's snapshot below */
    }
    const cards = Object.values(catalog).flat();
    rules.forEach((rule) => {
      const occasion = EXAMPLE_OCCASIONS.find((row) => row.id === rule.occasion);
      const card = cards.find((row) => productId(row.id) === rule.id) || findCatalogCard(rule.id) || rule.pick;
      if (!occasion || !active.has(rule.occasion) || !hasPlannableMacros(card)) return;
      rule.days.forEach((dayIndex) => {
        if (fixed[dayIndex].some((meal) => meal.id === rule.occasion)) return;
        const meal = mealFromRemix(occasion, card, rule.scale, false);
        meal.locked = true;
        fixed[dayIndex].push(meal);
      });
    });
    return fixed;
  };

  const generateWeek = async ({ keepLocks, avoidCurrent = keepLocks } = {}) => {
    const locked = await withRepeatMeals(keepLocks
      ? (state.week || []).map((day) => (day?.meals || []).filter(keepsMeal))
      : []);
    const forbid = keepLocks && avoidCurrent
      ? (state.week || []).map((day) =>
          Object.fromEntries(
            (day?.meals || []).filter((meal) => !meal.locked && mealProductId(meal)).map((meal) => [meal.id, mealProductId(meal)])
          )
        )
      : undefined;
    if (keepLocks) state.planNonce = (Number(state.planNonce) || 0) + 1;
    const planned = await planWeek({ withCustom: true, fixed: locked, forbid });
    const favoriteIds = new Set(likeItems().map((item) => item.id));
    state.week = planned.map((day, index) => {
      const meals = (day.meals || []).map((meal) => mealFromChoice(meal, favoriteIds));
      (locked[index] || []).forEach((kept) => {
        const at = meals.findIndex((meal) => meal.id === kept.id);
        if (at >= 0) meals[at] = kept;
        else meals.push(kept);
      });
      return { meals: orderMeals(meals) };
    });
    state.week.forEach((day) => trackPlanned(day.meals, 'week'));
    markWeekApplied();
  };

  // First paid week = the 7 days the preview already planned (state.preview.week), unchanged, in the slot of the
  // week it planned: this week (state.week) or next week (state.weekAlt). Only when the plan basis still matches
  // and that slot is empty; a browser without a preview (other device) generates instead. Used once: the preview
  // is cleared so it can't be handed over again. Returns 'this', 'next' or false.
  const takePreviewWeek = () => {
    const preview = state.preview;
    const week = preview?.week;
    if (!Array.isArray(week) || week.length !== WEEK_LEN || !weekHasPlan(week)) return false;
    if (!preview.basis || preview.basis !== planBasisKey()) return false;
    if (viewingNextWeek()) return false;
    let slot = false;
    if (preview.start === mondayIso(0) && !weekHasPlan(state.week)) slot = 'this';
    else if (preview.start === mondayIso(1) && !weekHasPlan(state.weekAlt?.week)) slot = 'next';
    if (!slot) return false;
    const favoriteIds = new Set(likeItems().map((item) => item.id));
    const taken = week.map((day) => ({
      meals: orderMeals(
        (day.meals || []).map((meal) => ({
          ...cloneJson(meal),
          locked: false,
          generated: !favoriteIds.has(productId(meal.pick?.id)) && !isCustomId(meal.pick?.id),
        }))
      ),
    }));
    // Free day = tomorrow, late in the week: the next week they saw as locked tiles comes along into its slot.
    const nextWeek = preview.next?.week;
    const takenNext =
      slot === 'this' && preview.next?.start === mondayIso(1) && Array.isArray(nextWeek) && weekHasPlan(nextWeek) &&
      !weekHasPlan(state.weekAlt?.week)
        ? nextWeek.map((day) => ({
            meals: orderMeals(
              (day.meals || []).map((meal) => ({
                ...cloneJson(meal),
                locked: false,
                generated: !favoriteIds.has(productId(meal.pick?.id)) && !isCustomId(meal.pick?.id),
              }))
            ),
          }))
        : null;
    state.preview = null;
    taken.forEach((day) => trackPlanned(day.meals, 'week'));
    if (slot === 'this') {
      state.week = taken;
      markWeekApplied();
      if (takenNext) {
        takenNext.forEach((day) => trackPlanned(day.meals, 'week'));
        state.weekAlt = { start: mondayIso(1), week: takenNext, pending: true };
      }
    } else {
      state.weekAlt = { start: mondayIso(1), week: taken, pending: true };
    }
    return slot;
  };

  const REGEN_TOAST_MS = 6000;

  const cloneJson = (value) => JSON.parse(JSON.stringify(value));
  const mealProductId = (meal) => productId(meal?.pick?.id);

  // Anonymous recipe counters (assets/vhp-planner-events.js). A failure there never reaches the planner.
  const plannerEvents = (method, ...args) => {
    try {
      window.vhpPlannerEvents?.[method]?.(...args);
    } catch (err) {
      /* counters are optional */
    }
  };
  // Custom recipes are never counted.
  const recipeEvent = (e, pick, slot, src) => plannerEvents('track', e, { id: pick?.id, slot: pick?.slot || slot, src });
  // Auto-filled meals that just entered the week (the denominator for swapped_out).
  const trackPlanned = (meals, src) =>
    (meals || []).forEach((meal) => {
      if (meal && !meal.locked && meal.generated) recipeEvent('recipe_planned', meal.pick, meal.catalog, src);
    });
  // A meal replaced by a hand-picked recipe: out only counts when the old one was auto-filled.
  const trackReplaced = (oldMeal, newPick, src) => {
    if (oldMeal?.generated) recipeEvent('recipe_swapped_out', oldMeal.pick, oldMeal.catalog, src);
    recipeEvent('recipe_swapped_in', newPick, oldMeal?.catalog, src);
  };
  // Meals remix and "Woche neu" leave where they are: locked ones and Unterwegs.
  const keepsMeal = (meal) => Boolean(meal?.locked || meal?.away);
  // Unterwegs: no recipe, only a budget for buying something on the road. Not locked, so the swap sheet can
  // still put a recipe or an own product there. The budget is set by syncAwayBudgets.
  const awayMeal = (meal) => {
    const occasion = activeOccasions().find((row) => row.id === meal.id);
    return {
      id: meal.id,
      label: meal.label || occasion?.label || '',
      catalog: meal.catalog || occasion?.catalog || 'main',
      scale: 1,
      locked: false,
      away: true,
      pick: null,
      kcal: 0,
      protein: 0,
      carbs: 0,
      fat: 0,
      generated: false,
    };
  };
  // An Unterwegs budget is what the day has left once its other meals are counted (several Unterwegs meals
  // split it by their occasions' shares), so the day always lands on its targets. Runs on every week render,
  // so budgets follow any change to the other meals. Never below 0: a day already full shows "schon voll".
  const syncAwayBudgets = (week) => {
    const target = { kcal: Number(state.kcal) || 0, ...macroGrams(state.kcal, currentSplit()) };
    const shares = new Map(activeOccasions().map((row) => [row.id, row.share]));
    (week || []).forEach((day) => {
      const away = (day?.meals || []).filter((meal) => meal.away);
      if (!away.length) return;
      const left = { ...target };
      day.meals.filter((meal) => !meal.away).forEach((meal) => {
        MACRO_TOTAL_KEYS.forEach((key) => {
          left[key] -= Number(meal[key]) || 0;
        });
      });
      const total = away.reduce((sum, meal) => sum + (shares.get(meal.id) || 0.25), 0);
      away.forEach((meal) => {
        const part = (shares.get(meal.id) || 0.25) / total;
        MACRO_TOTAL_KEYS.forEach((key) => {
          meal[key] = Math.max(0, Math.round(left[key] * part));
        });
      });
    });
  };
  const MACRO_TOTAL_KEYS = ['kcal', 'protein', 'carbs', 'fat'];
  const dayHasUnlocked = (day) => (day?.meals || []).some((meal) => !keepsMeal(meal));
  const weekHasUnlocked = (week) => (week || []).some(dayHasUnlocked);

  const hasPlannableMacros = (card) =>
    Number(card?.kcal) > 0 &&
    card?.protein != null &&
    card?.carbs != null &&
    card?.fat != null &&
    Number.isFinite(Number(card.protein)) &&
    Number.isFinite(Number(card.carbs)) &&
    Number.isFinite(Number(card.fat));

  const mealFromRemix = (meal, card, scale, generated) => {
    const pick = snapshot(card);
    if (card.ingredients != null) pick.ingredients = card.ingredients;
    if (card.portions != null) pick.portions = card.portions;
    if (card.instructions) pick.instructions = card.instructions;
    if (card.notes) pick.notes = card.notes;
    if (card.source_url) pick.source_url = card.source_url;
    if (card.archived) pick.archived = true;
    return {
      id: meal.id,
      label: meal.label,
      catalog: card.slot || meal.catalog,
      scale,
      locked: false,
      pick,
      kcal: Math.round((Number(card.kcal) || 0) * scale),
      protein: Math.round((Number(card.protein) || 0) * scale),
      carbs: card.carbs == null ? null : Math.round(Number(card.carbs) * scale),
      fat: card.fat == null ? null : Math.round(Number(card.fat) * scale),
      generated: Boolean(generated),
    };
  };

  // Recipes shown in each slot during recent remixes, per day + occasion (memory only: a reload resets it).
  // All of them are forbidden on the next remix; the core allows the oldest again only when the pool runs out.
  const remixHistory = new Map();
  const remixForbid = (dayIndex, day) => {
    const forbid = {};
    (day?.meals || []).forEach((meal) => {
      const id = mealProductId(meal);
      if (meal.locked || !id) return;
      const key = `${dayIndex}|${meal.id}`;
      const list = plannerCore.rememberShown(remixHistory.get(key), id);
      remixHistory.set(key, list);
      forbid[meal.id] = list;
    });
    return forbid;
  };

  // Tag neu mischen (one day) / Ganze Woche neu (all days): unlocked meals re-planned by the core around the
  // locked ones, seeded with a fresh nonce and sampled among the best day options.
  const remixDays = async (dayIndexes, scope) => {
    if (!plannerCore) throw new Error('planner core missing');
    const ctx = plannerContext(await plannerCatalog(true));
    const favoriteIds = new Set(likeItems().map((item) => item.id));
    state.planNonce = (Number(state.planNonce) || 0) + 1;
    const seed = planSeed();
    // Whole week: days not yet remixed only count with their locked meals (the rest is about to change).
    const week = (state.week || []).slice();
    const known = week.map((day) =>
      (day?.meals || []).filter((meal) => scope === 'day' || keepsMeal(meal)).map(coreFixedMeal)
    );
    for (const dayIndex of dayIndexes) {
      const day = week[dayIndex];
      const locked = (day?.meals || []).filter(keepsMeal);
      // A leftover lunch stays leftovers (the setting, or a pair the customer made by hand).
      const lunch = (day?.meals || []).find((meal) => meal.id === LEFTOVER_TO);
      const span = Math.max(leftoverSetting(), leftoverBackOf(lunch));
      const source = span && lunch && !keepsMeal(lunch)
        ? plannerCore.leftoverSource(ctx, known, dayIndex, locked.map(coreFixedMeal), span)
        : null;
      const planned = plannerCore.planDay(ctx, {
        seed: plannerCore.seed(seed, 'remix', dayIndex),
        dayIndex,
        days: known,
        fixed: locked.map(coreFixedMeal),
        forbid: remixForbid(dayIndex, day),
        pick: plannerCore.REMIX_PICK,
        pin: source ? { [LEFTOVER_TO]: source.id } : undefined,
        cookAhead: leftoverSetting() && dayIndex < WEEK_LEN - 1 && plannerCore.cooksAhead(span, source) ? [LEFTOVER_FROM] : undefined,
      });
      const meals = planned.meals
        .filter((meal) => !meal.locked)
        .map((meal) =>
          source && meal.occasion === LEFTOVER_TO && meal.id === source.id ? { ...meal, leftover: source.back === 2 ? 2 : true } : meal
        )
        .map((meal) => mealFromChoice(choiceFromCoreMeal(meal), favoriteIds));
      week[dayIndex] = { meals: orderMeals([...locked, ...meals]) };
      known[dayIndex] = week[dayIndex].meals.map(coreFixedMeal);
      if (dayIndexes.length > 1) await new Promise((resolve) => window.setTimeout(resolve, 0));
    }
    // All days or none: a failure halfway leaves the week as it was.
    state.week = week;
    syncLeftovers();
  };

  // A leftover lunch is the dinner one or two days before it (leftover true / 2). When that dinner changes (swap,
  // remix, Einplanen, undo) the lunch follows with a re-solved portion; a locked lunch keeps its recipe and just
  // stops being leftovers, so does one whose dinner is gone. Returns the day indexes whose lunch changed.
  const syncLeftovers = () => {
    const week = state.week || [];
    const changed = [];
    week.forEach((day, index) => {
      const lunch = day?.meals?.find((meal) => meal.id === LEFTOVER_TO);
      const back = leftoverBackOf(lunch);
      if (!back) return;
      const dinner = findMeal(week, index - back, LEFTOVER_FROM);
      if (dinner?.pick && productId(dinner.pick.id) === productId(lunch.pick?.id)) return;
      if (!dinner?.pick || lunch.locked) {
        delete lunch.leftover;
        return;
      }
      setLeftoverLunch(week, index, index - back);
      changed.push(index);
    });
    return changed;
  };

  // ---------- Reste (meal prep): one dinner, the lunch of the next one or two days ----------
  // The lunch knows its dinner: leftover true = yesterday's, 2 = the one two days ago. The setting (Einstellungen)
  // pairs the lunches of a whole week; the dinner's ⋯ sheet sets them for one dinner.
  const leftoverBackOf = (meal) => (meal?.leftover === 2 ? 2 : meal?.leftover ? 1 : 0);
  // 0 = Aus, 1 = one lunch per dinner (twice from one cook), 2 = two lunches (three times).
  const leftoverSetting = () => (leftoversOn() ? (state.leftoverDays === 2 ? 2 : 1) : 0);
  const findMeal = (week, index, occasion) => week?.[index]?.meals?.find((meal) => meal.id === occasion) || null;
  // First day of a week that may still change: this week from today on, a later week whole, an earlier one never.
  const firstOpenDay = (start) => {
    const now = mondayIso(0);
    if (!start || start === now) return weekdayToday();
    return start > now ? 0 : WEEK_LEN;
  };
  // slotScale, coreWeekDays and the surprise picker read the week on screen; the other week borrows its place.
  const onWeek = (week, fn) => {
    const shown = state.week;
    state.week = week;
    try {
      return fn();
    } finally {
      state.week = shown;
    }
  };

  // Day indexes whose lunch is made from the dinner of dayIndex.
  const leftoverLunchDays = (week, dayIndex) => {
    const dinner = findMeal(week, dayIndex, LEFTOVER_FROM);
    const id = productId(dinner?.pick?.id);
    if (!id || dinner.away) return [];
    return [1, 2]
      .filter((back) => {
        const lunch = findMeal(week, dayIndex + back, LEFTOVER_TO);
        return leftoverBackOf(lunch) === back && productId(lunch.pick?.id) === id;
      })
      .map((back) => dayIndex + back);
  };

  // A lunch can turn into leftovers unless it is locked, a Freie Mahlzeit, from the Vorrat, or the recipe is
  // already on that day. Returns why not (under the day in the Meal-Prep sheet), or null when it can.
  const leftoverBlocker = (week, index, id) => {
    const lunch = findMeal(week, index, LEFTOVER_TO);
    if (!lunch) return tr('planner.no_lunch');
    if (lunch.locked) return tr('planner.locked_unlock_first');
    if (lunch.away) return tr('planner.away_planned');
    if (lunch.prepped) return tr('planner.from_pantry_already');
    if ((week[index].meals || []).some((meal) => meal.id !== LEFTOVER_TO && productId(meal.pick?.id) === id)) {
      return tr('planner.recipe_already_that_day');
    }
    return null;
  };
  const lunchTakesLeftovers = (week, index, id) => !leftoverBlocker(week, index, id);

  // The lunch of `index` becomes the dinner of `from` (1 or 2 days before), with its own portion.
  const setLeftoverLunch = (week, index, from) => {
    const dinner = findMeal(week, from, LEFTOVER_FROM);
    const lunch = findMeal(week, index, LEFTOVER_TO);
    if (!dinner?.pick || !lunch) return;
    const day = week[index];
    const next = onWeek(week, () => mealFromRemix(lunch, dinner.pick, slotScale(dinner.pick, day, LEFTOVER_TO), false));
    next.leftover = index - from === 2 ? 2 : true;
    day.meals = orderMeals(day.meals.filter((meal) => meal.id !== LEFTOVER_TO).concat(next));
  };

  // Setting on: from day `from` on, every free lunch becomes the leftovers of the dinner before it (span 2: the
  // same dinner feeds two lunches, then the next batch starts). Returns how many lunches changed.
  const pairLeftovers = (week, from, span) => {
    const occasions = { occasions: activeOccasions() };
    let changed = 0;
    for (let index = Math.max(1, from); index < WEEK_LEN; index += 1) {
      const lunch = findMeal(week, index, LEFTOVER_TO);
      if (!lunch || lunch.locked || lunch.away || lunch.prepped) continue;
      const days = week.map((day) => (day?.meals || []).map(coreFixedMeal));
      const source = plannerCore.leftoverSource(occasions, days, index, [], span);
      if (!source) continue;
      if (productId(lunch.pick?.id) === source.id && leftoverBackOf(lunch) === source.back) continue;
      if (!lunchTakesLeftovers(week, index, source.id)) continue;
      setLeftoverLunch(week, index, index - source.back);
      changed += 1;
    }
    return changed;
  };

  // Meals that stop being leftovers (or leave a Meal-Prep batch) get a new recipe (same picker as "Überrasch
  // mich"). slots: [{ day, occasion }]. Uses the planner index (JSON), not the card pools. Resolves to false when
  // the catalog didn't load (nothing changed then).
  const freshMeals = async (week, slots) => {
    if (!slots.length) return true;
    let catalog;
    try {
      catalog = await plannerCatalog(true);
    } catch (e) {
      return false;
    }
    if (week !== state.week && week !== state.weekAlt?.week) return false;
    const liked = new Set(likeItems().map((item) => item.id));
    onWeek(week, () => {
      slots.forEach(({ day: index, occasion }) => {
        const meal = findMeal(week, index, occasion);
        if (!meal) return;
        const pool = (catalog[meal.catalog || 'main'] || []).filter(hasPlannableMacros);
        swipeNonce += 1;
        const pick = plannerCore.surprise(plannerContext({}), {
          days: coreWeekDays(),
          dayIndex: index,
          occasionId: occasion,
          pool,
          tried: new Set([productId(meal.pick?.id)]),
          seed: plannerCore.seed(planSeed(), 'fresh', index, swipeNonce),
        });
        // Nothing else fits: same recipe, cooked fresh.
        if (!pick) {
          delete meal.leftover;
          if (cookOf(meal) != null) meal.locked = false;
          delete meal.cook;
          return;
        }
        const card = hydrateSwapCard(pick.card);
        const next = mealFromRemix(meal, card, slotScale(card, week[index], occasion), !liked.has(productId(card.id)));
        week[index].meals = orderMeals(week[index].meals.filter((row) => row.id !== occasion).concat(next));
      });
    });
    return true;
  };
  const freshLunches = (week, indexes) => freshMeals(week, indexes.map((day) => ({ day, occasion: LEFTOVER_TO })));

  const dayList = (indexes) => indexes.map((index) => DAY_LABEL[index]).join(' + ');

  // Einstellungen → Reste: applies right away to the week on screen (from today on) and the other planned week,
  // so the setting does what it says (before, it only reached the next planning). One undo for both weeks.
  const applyLeftoverSetting = async () => {
    const span = leftoverSetting();
    const weeks = [
      { week: state.week, start: state.weekStart },
      state.weekAlt ? { week: state.weekAlt.week, start: state.weekAlt.start, alt: true } : null,
    ].filter((row) => row && weekHasPlan(row.week) && firstOpenDay(row.start) < WEEK_LEN);
    if (!weeks.length) return;
    const undo = {
      scope: 'copy',
      snapshot: cloneJson(state.week),
      alt: state.weekAlt ? { start: state.weekAlt.start, week: cloneJson(state.weekAlt.week) } : null,
    };
    let changed = 0;
    for (const row of weeks) {
      const from = firstOpenDay(row.start);
      if (span) changed += pairLeftovers(row.week, from, span);
      else {
        const drop = [];
        for (let index = from; index < WEEK_LEN; index += 1) {
          if (leftoverBackOf(findMeal(row.week, index, LEFTOVER_TO))) drop.push(index);
        }
        if (!(await freshLunches(row.week, drop))) {
          showWeekToast(tr('planner.lunch_regen_failed'), { action: 'OK', ms: 3000 });
          return;
        }
        changed += drop.length;
      }
      if (row.alt && state.weekAlt?.week === row.week) state.weekAlt.pending = true;
    }
    state.weekApplied = { ...(state.weekApplied || {}), leftovers: Boolean(state.leftovers), leftoverDays: state.leftoverDays === 2 ? 2 : 1 };
    if (!changed) return;
    regenUndo = undo;
    swapUndo = null;
    favUndo = null;
    persist();
    scheduleWeekSave();
    render();
    const what = !span ? tr('planner.lunch_fresh') : span === 2 ? tr('planner.dinner_2_lunches') : tr('planner.dinner_next_lunch');
    showWeekToast(what);
  };

  // Meal-Prep for all dinners (Einstellungen and the Meal-Prep sheet): 0 = Aus, 1 = 2× essen, 2 = 3× essen. Saved,
  // then applied to the planned weeks right away (applyLeftoverSetting).
  const setLeftoverSpan = async (span) => {
    const now = state.leftovers ? (state.leftoverDays === 2 ? 2 : 1) : 0;
    if (![0, 1, 2].includes(span) || span === now || weekGenerating) return;
    state.leftovers = span > 0;
    if (span) state.leftoverDays = span;
    persist();
    if (planner.config.paid) {
      state.pendingFlush = true;
      flushProfile();
    }
    render();
    if (planner.config.paid) await applyLeftoverSetting();
  };

  // Toast text after a change that pulled a leftover lunch along.
  const withLeftoverNote = (message, changed) =>
    changed.length ? tr('planner.leftover_note', { message, day: DAY_LABEL[changed[0]] }) : message;

  // Swap sheet offer: today's lunch as yesterday's dinner.
  const leftoverOffer = (ctx) => {
    if (!planner.config.paid || ctx?.meal?.id !== LEFTOVER_TO || ctx.meal.leftover || state.weekDay < 1) return null;
    const dinner = state.week?.[state.weekDay - 1]?.meals?.find((meal) => meal.id === LEFTOVER_FROM);
    if (!dinner?.pick || productId(dinner.pick.id) === productId(ctx.meal.pick?.id)) return null;
    if ((ctx.day?.meals || []).some((meal) => meal.id !== LEFTOVER_TO && productId(meal.pick?.id) === productId(dinner.pick.id))) return null;
    return dinner;
  };

  // Meal ⋯ menu → "Unterwegs essen": this meal becomes a budget (one-step undo via the week toast).
  function applyAwayPick(occasion) {
    const ctx = swapContext(occasion);
    if (!ctx || ctx.meal.away || ctx.meal.locked) return;
    regenUndo = null;
    swapUndo = { day: state.weekDay, snapshot: cloneJson(ctx.meal) };
    ctx.day.meals = orderMeals((ctx.day.meals || []).filter((row) => row.id !== ctx.meal.id).concat(awayMeal(ctx.meal)));
    syncAwayBudgets([ctx.day]);
    const moved = syncLeftovers();
    if (swapUi) closeSwapSheet();
    persist();
    scheduleWeekSave();
    render();
    showWeekToast(withLeftoverNote(tr('planner.away_added'), moved));
  }

  // Swap sheet row or meal ⋯ menu (occasion given): today's lunch as yesterday's dinner.
  function applyLeftoverPick(occasion) {
    const ctx = swapContext(occasion);
    const dinner = leftoverOffer(ctx);
    if (!ctx || !dinner) return;
    regenUndo = null;
    swapUndo = { day: state.weekDay, snapshot: cloneJson(ctx.meal) };
    const next = mealFromRemix(ctx.meal, dinner.pick, slotScale(dinner.pick, ctx.day, LEFTOVER_TO), false);
    next.locked = false;
    next.leftover = true;
    ctx.day.meals = orderMeals((ctx.day.meals || []).filter((row) => row.id !== ctx.meal.id).concat(next));
    if (swapUi) closeSwapSheet();
    persist();
    scheduleWeekSave();
    render();
    showWeekToast(tr('planner.leftovers_added', { day: DAY_LABEL[state.weekDay - 1] }));
  }

  // ---------- Freie Mahlzeit (no recipe, only a budget) every week ----------
  // Rules { occasion, days } (meal ⋯ sheet "Jeden Mittwoch frei", listed under Feste Mahlzeiten): every newly
  // planned week gets a Freie Mahlzeit there, like a fixed recipe.
  const awayRuleFor = (occasion) => (state.awayRepeat || []).find((rule) => rule.occasion === occasion) || null;
  const awayRepeats = (occasion, dayIndex) => Boolean(awayRuleFor(occasion)?.days.includes(dayIndex));

  // A Freie Mahlzeit in a week about to be planned: its share of the day as the budget, so the planner leaves room
  // for it (syncAwayBudgets takes over once the week is on screen).
  const awayPlaceholder = (occasion) => {
    const share = activeOccasions().find((row) => row.id === occasion.id)?.share || 0.25;
    const grams = macroGrams(state.kcal, currentSplit());
    return {
      ...awayMeal(occasion),
      kcal: Math.round((Number(state.kcal) || 0) * share),
      protein: Math.round((Number(grams.protein) || 0) * share),
      carbs: Math.round((Number(grams.carbs) || 0) * share),
      fat: Math.round((Number(grams.fat) || 0) * share),
    };
  };

  // Meal ⋯ sheet switch on a Freie Mahlzeit. On: a later week that is already planned gets it too (unless that
  // meal is locked). Off: only new weeks change.
  const toggleAwayRepeat = (occasion, dayIndex) => {
    const days = new Set(awayRuleFor(occasion)?.days || []);
    const on = !days.has(dayIndex);
    if (on) days.add(dayIndex);
    else days.delete(dayIndex);
    const rest = (state.awayRepeat || []).filter((rule) => rule.occasion !== occasion);
    state.awayRepeat = days.size ? rest.concat({ occasion, days: [...days].sort((a, b) => a - b) }) : rest;
    if (on && state.weekAlt && state.weekAlt.start > state.weekStart) {
      const day = state.weekAlt.week?.[dayIndex];
      const meal = day?.meals?.find((row) => row.id === occasion);
      if (meal && !meal.locked && !meal.away) {
        day.meals = orderMeals(day.meals.filter((row) => row.id !== occasion).concat(awayMeal(meal)));
        state.weekAlt.pending = true;
        scheduleWeekSave();
      }
    }
    persist();
    state.pendingFlush = true;
    flushProfile();
    render();
  };

  const fillRemixPools = async () => {
    await Promise.all(
      PLAN_SLOTS.map((slot) => {
        const total = planner.counts?.(slot)?.total || 200;
        return fillPool(slot, Math.max(total, 24));
      })
    );
  };

  let regenUndo = null;
  let swapUndo = null;
  // Open meal ⋯ sheet: { occasion, day, start } (see openMealSheet).
  let mealSheet = null;
  let regenToastTimer = 0;

  let toastHideTimer = 0;

  const hideRegenToast = () => {
    window.clearTimeout(regenToastTimer);
    regenToastTimer = 0;
    const el = funnel.querySelector('[data-vhp-week-toast]');
    if (!el) return;
    el.classList.remove('is-on');
    window.clearTimeout(toastHideTimer);
    if (!motionOk()) {
      el.hidden = true;
      return;
    }
    toastHideTimer = window.setTimeout(() => {
      if (!el.classList.contains('is-on')) el.hidden = true;
    }, MOTION_MS + 40);
  };

  const showWeekToast = (message, { action = tr('planner.undo'), ms = REGEN_TOAST_MS } = {}) => {
    const el = funnel.querySelector('[data-vhp-week-toast]');
    const msg = funnel.querySelector('[data-vhp-week-toast-msg]');
    if (!el || !msg) return;
    msg.textContent = message;
    const undoBtn = el.querySelector('[data-vhp-week-undo]');
    if (undoBtn) undoBtn.textContent = action;
    window.clearTimeout(toastHideTimer);
    el.hidden = false;
    if (motionOk() && !el.classList.contains('is-on')) {
      void el.offsetWidth;
      requestAnimationFrame(() => el.classList.add('is-on'));
    } else {
      el.classList.add('is-on');
    }
    window.clearTimeout(regenToastTimer);
    regenToastTimer = window.setTimeout(() => {
      hideRegenToast();
      regenUndo = null;
      swapUndo = null;
      favUndo = null;
      saveRetry = null;
    }, ms);
  };

  // A failed save is told once in a while, with a retry (the toast's action button).
  let saveRetry = null;
  let saveFailedAt = 0;
  const showSaveFailed = (retry) => {
    if (Date.now() - saveFailedAt < 30000) return;
    saveFailedAt = Date.now();
    regenUndo = null;
    swapUndo = null;
    favUndo = null;
    saveRetry = retry;
    showWeekToast(tr('planner.save_failed'), { action: tr('planner.retry'), ms: 10000 });
  };

  const showRegenToast = (scope) => {
    swapUndo = null;
    favUndo = null;
    showWeekToast(scope === 'week' ? tr('planner.week_replanned') : tr('planner.day_replanned'));
  };

  const closeRegenConfirm = () => {
    const dlg = $('[data-vhp-week-confirm]');
    if (dlg?.open) dlg.close();
  };

  const openRegenConfirm = () => {
    const dlg = $('[data-vhp-week-confirm]');
    if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
  };

  const applyRegenUndo = () => {
    if (saveRetry) {
      const retry = saveRetry;
      saveRetry = null;
      saveFailedAt = 0;
      hideRegenToast();
      retry();
      return;
    }
    if (favUndo && applyFavUndo()) return;
    if (swapUndo && state.week) {
      const day = state.week[swapUndo.day];
      const snap = swapUndo.snapshot;
      if (day && snap) {
        day.meals = orderMeals((day.meals || []).filter((meal) => meal.id !== snap.id).concat(snap));
      }
      syncLeftovers();
      swapUndo = null;
      hideRegenToast();
      persist();
      scheduleWeekSave();
      render();
      return;
    }
    // Nothing to undo (a plain note, "OK"): just close the toast.
    if (!regenUndo || !state.week) {
      hideRegenToast();
      return;
    }
    if (regenUndo.scope === 'day') {
      state.week[regenUndo.day] = regenUndo.snapshot;
    } else if (regenUndo.scope === 'copy') {
      // A copy can reach both weeks: put back the one on screen and the other one.
      state.week = regenUndo.snapshot;
      const alt = regenUndo.alt;
      if (alt && state.weekAlt?.start === alt.start) {
        state.weekAlt.week = alt.week;
        state.weekAlt.pending = true;
      }
      if (regenUndo.repeat && JSON.stringify(regenUndo.repeat) !== JSON.stringify(state.repeat || [])) {
        state.repeat = regenUndo.repeat;
        state.pendingFlush = true;
        flushProfile();
      }
    } else {
      state.week = regenUndo.snapshot;
    }
    // A restored dinner takes its leftover lunch (next day) back with it.
    syncLeftovers();
    regenUndo = null;
    hideRegenToast();
    persist();
    scheduleWeekSave();
    weekReveal = 'back';
    render();
  };

  const runRemix = async (scope) => {
    if (weekGenerating) return;
    if (scope === 'day' && !dayHasUnlocked(state.week?.[state.weekDay])) return;
    if (scope === 'week' && !weekHasUnlocked(state.week)) return;
    usage(scope === 'week' ? 'use_remix_week' : 'use_remix_day');
    if (scope === 'day' && !state.week?.[state.weekDay]) return;
    rollTap($('.vhp-day-regen .vhp-own-row__ico'));
    weekGenerating = true;
    weekError = false;
    closeRegenConfirm();
    render();
    try {
      const before = (state.week || []).map((day) => new Map((day?.meals || []).map((meal) => [meal.id, mealProductId(meal)])));
      if (scope === 'day') {
        const dayIndex = state.weekDay;
        regenUndo = { scope: 'day', day: dayIndex, snapshot: cloneJson(state.week[dayIndex]) };
        await remixDays([dayIndex], 'day');
        showRegenToast('day');
      } else {
        regenUndo = { scope: 'week', snapshot: cloneJson(state.week) };
        await remixDays((state.week || []).map((_, index) => index), 'week');
        showRegenToast('week');
      }
      (state.week || []).forEach((day, index) =>
        trackPlanned((day?.meals || []).filter((meal) => before[index]?.get(meal.id) !== mealProductId(meal)), 'week')
      );
      markWeekApplied();
      persist();
      scheduleWeekSave();
      weekReveal = 'in';
    } catch (e) {
      console.error('[vhp-planner] remix failed', e);
      weekError = true;
      regenUndo = null;
      hideRegenToast();
    } finally {
      weekGenerating = false;
      render();
    }
  };

  // ---------- meal ⋯ sheet (week card): the occasional actions ----------
  // Austauschen stays on the card; everything else lives in a bottom sheet, grouped by intent:
  // view · keep (Sperren as a switch, Kopieren) · replace (Überrasch mich, Reste, Unterwegs).

  const mealSheetEl = () => funnel.querySelector('[data-vhp-meal-sheet]');
  const mealSheetMeal = () =>
    mealSheet ? state.week?.[mealSheet.day]?.meals?.find((row) => row.id === mealSheet.occasion) || null : null;

  const mealSheetItem = ({ act, label, note, icon, on }) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vhp-meal-sheet__item';
    btn.dataset.vhpMealAct = act;
    const svg = icon?.();
    if (svg) btn.append(svg);
    const copy = document.createElement('span');
    copy.className = 'vhp-meal-sheet__label';
    copy.append(document.createTextNode(label));
    if (note) {
      const small = document.createElement('small');
      small.textContent = note;
      copy.append(small);
    }
    btn.append(copy);
    if (on != null) {
      btn.setAttribute('role', 'switch');
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      const sw = document.createElement('span');
      sw.className = 'vhp-switch';
      sw.classList.toggle('is-on', Boolean(on));
      sw.setAttribute('aria-hidden', 'true');
      btn.append(sw);
    }
    return btn;
  };

  const mealSheetGroups = (meal) => {
    const view = [];
    const keep = [];
    const replace = [];
    if (meal.pick?.handle || isCustomId(meal.pick?.id)) view.push({ act: 'view', label: tr('common.view_recipe'), icon: bookIcon });
    if (meal.away) {
      keep.push({
        act: 'away-repeat',
        label: tr('planner.away_every', { day: PREVIEW_DAYS[mealSheet.day] }),
        note: tr('planner.away_every_note'),
        icon: repeatIcon,
        on: awayRepeats(meal.id, mealSheet.day),
      });
      replace.push({ act: 'surprise', label: tr('planner.plan_recipe_anyway'), icon: diceIcon });
      return [view, keep, replace];
    }
    keep.push({
      act: 'lock',
      label: tr('planner.lock'),
      note: tr('planner.lock_note'),
      icon: () => lockIcon(meal.locked),
      on: Boolean(meal.locked),
    });
    if (meal.pick?.id) keep.push({ act: 'copy', label: tr('planner.copy_days'), icon: copyIcon });
    if (!meal.locked) {
      replace.push({ act: 'surprise', label: tr('planner.surprise'), icon: diceIcon });
      if (customRecipes()) replace.push({ act: 'own', label: tr('planner.own_here'), note: tr('planner.own_here_note'), icon: penIcon });
      const dinner = leftoverOffer(swapContext(meal.id));
      if (dinner) {
        replace.push({ act: 'leftover', label: tr('planner.leftovers_from', { day: DAY_LABEL[mealSheet.day - 1] }), note: dinner.pick.title, icon: rewindIcon });
      }
      replace.push({ act: 'away', label: tr('planner.away'), note: tr('planner.away_note'), icon: awayIcon });
    }
    return [view, keep, replace];
  };

  // ---------- portions (meal ⋯ sheet) ----------
  // The stepper changes this meal only. The day line below shows where that leaves the day; when it is off the
  // goal, one explicit action evens out the rest of the day (never automatic: the other meals are the user's too).
  const PORTION_MIN = 0.5;
  const PORTION_MAX = 3;
  const PORTION_STEP = 0.25;
  const AUTO_MIN = 0.5;
  const AUTO_MAX = 2;

  // Exact quarters here (×1,25), unlike the rounded badge on the card: the stepper moves in quarter steps.
  const fmtPortion = (scale) => `×${Number(scale).toLocaleString(LOCALE, { maximumFractionDigits: 2 })}`;

  const scaleMeal = (meal, scale) => {
    const pick = meal.pick || {};
    meal.scale = scale;
    meal.kcal = Math.round((Number(pick.kcal) || 0) * scale);
    meal.protein = Math.round((Number(pick.protein) || 0) * scale);
    meal.carbs = pick.carbs == null ? null : Math.round(Number(pick.carbs) * scale);
    meal.fat = pick.fat == null ? null : Math.round(Number(pick.fat) * scale);
  };

  const dayKcal = (meals) => meals.reduce((sum, meal) => sum + (Number(meal.kcal) || 0), 0);

  // Meals the rebalance may touch: open (not locked, not Unterwegs, not already cooked) with kcal to scale.
  const rebalanceable = (meal, except) =>
    meal.id !== except && !meal.locked && !meal.away && !meal.prepped && Number(meal.pick?.kcal) > 0;

  // New scales for the other open meals so the day lands on the goal: proportional first, quarter steps within
  // ½–2× (the planner's own range), then single-step nudges while they bring the day closer.
  const rebalancePlan = (day, except) => {
    const target = Number(state.kcal) || 0;
    const meals = day?.meals || [];
    const open = meals.filter((meal) => rebalanceable(meal, except));
    if (!target || !open.length) return null;
    const fixed = dayKcal(meals.filter((meal) => !open.includes(meal)));
    const openKcal = dayKcal(open);
    if (!(openKcal > 0)) return null;
    const factor = (target - fixed) / openKcal;
    const quarter = (n) => Math.round(n / PORTION_STEP) * PORTION_STEP;
    const clamp = (n) => Math.min(AUTO_MAX, Math.max(AUTO_MIN, n));
    const next = new Map(open.map((meal) => [meal, clamp(quarter((Number(meal.scale) || 1) * factor))]));
    const total = () => fixed + open.reduce((sum, meal) => sum + Number(meal.pick.kcal) * next.get(meal), 0);
    for (let guard = 0; guard < 24; guard += 1) {
      const diff = total() - target;
      let best = null;
      open.forEach((meal) => {
        const step = diff > 0 ? -PORTION_STEP : PORTION_STEP;
        const scale = next.get(meal) + step;
        if (scale < AUTO_MIN || scale > AUTO_MAX) return;
        const after = Math.abs(diff + Number(meal.pick.kcal) * step);
        if (after < Math.abs(diff) && (!best || after < best.after)) best = { meal, scale, after };
      });
      if (!best) break;
      next.set(best.meal, best.scale);
    }
    const changes = open
      .filter((meal) => next.get(meal) !== (Number(meal.scale) || 1))
      .map((meal) => ({ id: meal.id, label: occLabel(meal), from: Number(meal.scale) || 1, to: next.get(meal) }));
    const before = Math.abs(dayKcal(meals) - target);
    const after = Math.abs(total() - target);
    // Only worth offering when it gets the day noticeably closer.
    if (!changes.length || before - after < Math.max(40, target * 0.02)) return null;
    return { changes, kcal: Math.round(total()) };
  };

  const dayStatusText = (kcal, target) => {
    const diff = Math.round(kcal - target);
    if (!target) return tr('planner.day_kcal', { kcal: deInt(kcal) });
    const head = tr('planner.day_kcal_of', { kcal: deInt(kcal), target: deInt(target) });
    if (Math.abs(diff) <= target * DAY_TOL) return tr('planner.on_target', { head });
    return `${head} · ${diff > 0 ? '+' : '−'}${deInt(Math.abs(diff))} kcal`;
  };

  const sheetEl = (tag, cls, text) => {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text != null) el.textContent = text;
    return el;
  };

  const paintMealPortion = (box, meal) => {
    const day = state.week?.[mealSheet.day];
    box.hidden = Boolean(meal.away || !meal.pick);
    if (box.hidden || !day) {
      box.replaceChildren();
      return;
    }
    const scale = Number(meal.scale) || 1;
    const card = sheetEl('div', 'vhp-meal-sheet__portion');
    const copy = sheetEl('div', 'vhp-meal-sheet__portion-copy');
    copy.append(sheetEl('strong', null, tr('planner.your_portion')), sheetEl('small', null, mealMetaLine({ kcal: meal.kcal, protein: meal.protein })));
    const stepper = sheetEl('div', 'vhp-stepper');
    stepper.setAttribute('role', 'group');
    stepper.setAttribute('aria-label', tr('planner.portions_label'));
    const btn = (act, label, glyph, disabled) => {
      const b = sheetEl('button', 'vhp-stepper__btn', glyph);
      b.type = 'button';
      b.dataset.vhpMealAct = act;
      b.setAttribute('aria-label', label);
      b.disabled = disabled || weekGenerating;
      return b;
    };
    const value = sheetEl('output', 'vhp-stepper__value', fmtPortion(scale));
    value.setAttribute('aria-live', 'polite');
    stepper.append(
      btn('less', tr('planner.smaller'), '−', scale <= PORTION_MIN),
      value,
      btn('more', tr('planner.bigger'), '+', scale >= PORTION_MAX)
    );
    card.append(copy, stepper);
    // Who else eats along (Einstellungen → Ich koche für): the portion above stays the customer's own.
    const people = sheetEl('button', 'vhp-meal-sheet__people');
    people.type = 'button';
    people.dataset.vhpMealAct = 'household';
    const extra = householdExtra(meal.id);
    const peopleText = sheetEl('span', 'vhp-meal-sheet__label');
    if (extra) {
      const size = Number(state.household?.size) || 1;
      const sizeNote = size < 1 ? tr('planner.size_smaller') : size > 1 ? tr('planner.size_bigger') : '';
      peopleText.append(
        tr('planner.cooked_for', { n: extra + 1 }),
        sheetEl('small', null, tr('planner.cooked_more', { n: extra, size: sizeNote }))
      );
    } else {
      peopleText.append(tr('planner.eats_with'), sheetEl('small', null, tr('planner.eats_with_note')));
    }
    people.append(peopleIcon(), peopleText, sheetEl('span', 'vhp-meal-sheet__people-go', extra ? tr('planner.change') : tr('planner.add')));
    card.append(people);

    const target = Number(state.kcal) || 0;
    const line = sheetEl('p', 'vhp-meal-sheet__day', dayStatusText(dayKcal(day.meals || []), target));
    const nodes = [card, line];
    if (mealSheet.rebalanced) {
      const done = sheetEl('p', 'vhp-meal-sheet__done', tr('planner.adjusted', { text: mealSheet.rebalanced.text }));
      const undo = sheetEl('button', 'vhp-meal-sheet__undo', tr('planner.undo'));
      undo.type = 'button';
      undo.dataset.vhpMealAct = 'unbalance';
      done.append(undo);
      nodes.push(done);
    } else {
      const plan = rebalancePlan(day, meal.id);
      if (plan) {
        const go = sheetEl('button', 'vhp-meal-sheet__balance');
        go.type = 'button';
        go.dataset.vhpMealAct = 'rebalance';
        go.disabled = weekGenerating;
        const text = sheetEl('span', 'vhp-meal-sheet__label');
        text.append(
          tr('planner.rebalance'),
          sheetEl('small', null, plan.changes.map((c) => `${c.label} ${fmtPortion(c.from)} → ${fmtPortion(c.to)}`).join(' · '))
        );
        go.append(text, sheetEl('span', 'vhp-meal-sheet__balance-kcal', `≈ ${deInt(plan.kcal)} kcal`));
        nodes.push(go);
      }
    }
    const prepRow = mealPrepRow(meal);
    if (prepRow) nodes.push(prepRow);
    box.replaceChildren(...nodes);
  };

  // ---------- Meal-Prep: one recipe cooked once (the cook day), eaten at several meals of the week ----------
  // meal.cook = the day the batch is cooked (0–6, -1 = the Sunday before the week). Every meal of the week with the
  // same recipe and the same cook day eats from that batch; batch meals are locked, so re-planning keeps them. A
  // dinner with leftover lunches (meal.leftover, from the Einstellungen setting) reads as a batch too and is
  // rewritten as one when it is edited here. A swap gives the meal a fresh object, so it leaves the batch by itself.
  const COOK_BEFORE = -1;
  // Cooked food keeps about 3 days in the fridge; later meals get a freezer tip.
  const FRIDGE_DAYS = 3;
  const cookOf = (meal) =>
    Number.isInteger(meal?.cook) && meal.cook >= COOK_BEFORE && meal.cook < WEEK_LEN ? meal.cook : null;
  const prepKey = (day, occasion) => `${day}|${occasion}`;
  const prepSlot = (key) => {
    const [day, occasion] = key.split('|');
    return { day: Number(day), occasion };
  };
  const cookDayName = (day) => (day === COOK_BEFORE ? tr('planner.sunday_before') : PREVIEW_DAYS[day]);
  const occasionShort = (id) =>
    id === 'lunch' ? tr('planner.lunch_short') : id === 'dinner' ? tr('planner.dinner_short') : EXAMPLE_OCCASIONS.find((row) => row.id === id)?.label || id;
  const slotName = ({ day, occasion }) => `${DAY_LABEL[day]} ${occasionShort(occasion)}`;
  const slotOrder = (a, b) =>
    a.day - b.day || EXAMPLE_OCCASIONS.findIndex((row) => row.id === a.occasion) - EXAMPLE_OCCASIONS.findIndex((row) => row.id === b.occasion);
  const dateOfDay = (day) => addDays(shownMonday(), day);
  const isPastDay = (day) => {
    const today = new Date();
    const date = dateOfDay(day);
    return date < today && !sameDay(date, today);
  };

  // The batch a meal belongs to: { id, cook, slots: [{ day, occasion }], legacy } (a single meal = a batch of one).
  const batchOf = (week, dayIndex, occasion) => {
    const meal = findMeal(week, dayIndex, occasion);
    const id = mealProductId(meal);
    if (!id || meal.away) return null;
    const cook = cookOf(meal);
    if (cook != null) {
      const slots = [];
      (week || []).forEach((day, index) => {
        (day?.meals || []).forEach((row) => {
          if (!row.away && mealProductId(row) === id && cookOf(row) === cook) slots.push({ day: index, occasion: row.id });
        });
      });
      return { id, cook, slots: slots.sort(slotOrder), legacy: false };
    }
    const from = occasion === LEFTOVER_FROM ? dayIndex : occasion === LEFTOVER_TO && leftoverBackOf(meal) ? dayIndex - leftoverBackOf(meal) : -1;
    const fed = from >= 0 ? leftoverLunchDays(week, from) : [];
    if (fed.length && (occasion === LEFTOVER_FROM || fed.includes(dayIndex))) {
      const slots = [{ day: from, occasion: LEFTOVER_FROM }, ...fed.map((day) => ({ day, occasion: LEFTOVER_TO }))];
      return { id, cook: from, slots, legacy: true };
    }
    return { id, cook: dayIndex, slots: [{ day: dayIndex, occasion }], legacy: false };
  };

  const batchPortions = (week, slots) =>
    slots.reduce((sum, slot) => sum + cookPortions(findMeal(week, slot.day, slot.occasion)), 0);
  const fmtPortions = (n) => {
    const value = Math.round(n * 4) / 4;
    return `${value.toLocaleString(LOCALE, { maximumFractionDigits: 2 })} ${tr(value === 1 ? 'planner.portions_one' : 'planner.portions_other')}`;
  };

  // Note for a planned meal of a batch: reheated (cooked earlier) or cooked for more meals. '' = no batch.
  const prepMealNote = (week, dayIndex, meal) => {
    const cook = cookOf(meal);
    if (cook == null || !meal?.pick) return '';
    const batch = batchOf(week, dayIndex, meal.id);
    if (!batch || batch.slots.length < 2) return '';
    if (cook !== dayIndex) return cook >= 0 && cook === dayIndex - 1 ? tr('planner.leftovers_from', { day: DAY_LABEL[cook] }) : tr('planner.cooked_on', { day: cook === COOK_BEFORE ? tr('planner.sun_short') : DAY_LABEL[cook] });
    return tr('planner.batch_for', { n: String(batch.slots.length - 1), slots: batch.slots.filter((slot) => slot.day !== dayIndex || slot.occasion !== meal.id).map(slotName).join(', ') });
  };

  const potIcon = () =>
    strokeIcon((svg) => {
      addStroke(svg, 'path', { d: 'M4 10h16v5a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5z' });
      addStroke(svg, 'path', { d: 'M2 10h2M20 10h2M9 6.5c0-1 1-1.5 1-2.5M14 6.5c0-1 1-1.5 1-2.5' });
    });
  const chevronIcon = () =>
    strokeIcon((svg) => {
      addStroke(svg, 'path', { d: 'm9 6 6 6-6 6' });
    });

  // Meals that can be meal-prepped: paid, a recipe, on a day that may still change.
  const prepEligible = (dayIndex, meal) =>
    Boolean(planner.config.paid && meal?.pick?.id && !meal.away && dayIndex >= firstOpenDay(state.weekStart));

  // The Meal-Prep row in the meal ⋯ sheet, or null.
  const mealPrepRow = (meal) => {
    const dayIndex = mealSheet.day;
    if (!prepEligible(dayIndex, meal)) return null;
    const batch = batchOf(state.week, dayIndex, meal.id);
    let note = tr('planner.prep_note');
    if (batch?.slots.length > 1) note = tr('planner.prep_note_batch', { when: prepWhen(batch.cook), n: String(batch.slots.length) });
    const btn = mealSheetItem({ act: 'prep', label: tr('planner.meal_prep'), note, icon: potIcon });
    btn.classList.add('vhp-meal-sheet__prep-row');
    btn.append(chevronIcon());
    btn.disabled = weekGenerating;
    const group = sheetEl('div', 'vhp-meal-sheet__group vhp-meal-sheet__prep');
    group.append(btn);
    return group;
  };

  // ---------- Meal-Prep sheet: a draft of one batch, applied with "Übernehmen" ----------
  // { start, day, occasion, id, pick, catalog, cook, cook0, chosen, chosen0, prepped, prepped0, hint }
  let prep = null;
  const prepSheetEl = () => funnel.querySelector('[data-vhp-prep-sheet]');
  const prepIsToday = (dayIndex) => state.weekStart === mondayIso(0) && dayIndex === weekdayToday();
  const prepWhen = (cook) => (cook === COOK_BEFORE ? tr('planner.prep_on_sunday_before') : prepIsToday(cook) ? tr('planner.prep_today') : tr('planner.prep_on_day', { day: PREVIEW_DAYS[cook] }));

  function openPrepSheet(dayIndex, occasion) {
    const sheet = prepSheetEl();
    const meal = findMeal(state.week, dayIndex, occasion);
    if (!sheet || weekGenerating || !prepEligible(dayIndex, meal)) return;
    const batch = batchOf(state.week, dayIndex, occasion);
    if (!batch) return;
    const chosen = new Set(batch.slots.map((slot) => prepKey(slot.day, slot.occasion)));
    const prepped = batch.slots.every((slot) => findMeal(state.week, slot.day, slot.occasion)?.prepped);
    prep = {
      start: state.weekStart,
      day: dayIndex,
      occasion,
      id: batch.id,
      pick: meal.pick,
      catalog: meal.catalog,
      cook: batch.cook,
      cook0: batch.slots.length > 1 ? batch.cook : null,
      chosen,
      chosen0: new Set(chosen),
      prepped,
      prepped0: prepped,
      hint: '',
    };
    paintPrepSheet();
    setDialogOpen(sheet, true);
    sheet.querySelector('#vhp-prep-title')?.focus({ preventScroll: true });
  }

  function closePrepSheet() {
    const sheet = prepSheetEl();
    prep = null;
    if (sheet?.open) setDialogOpen(sheet, false);
  }

  // Occasions the batch can be eaten at: the ones planned with the same kind of recipe (main: Mittag + Abend).
  const prepOccasions = () => activeOccasions().filter((row) => row.catalog === prep.catalog);

  // Why a meal can't eat from the batch ('' = it can). Meals of the batch itself always can.
  const prepBlock = (day, occasion) => {
    if (prep.chosen0.has(prepKey(day, occasion))) return '';
    const meal = findMeal(state.week, day, occasion);
    if (!meal) return tr('planner.not_planned');
    if (meal.away) return tr('planner.away_planned');
    if (mealProductId(meal) === prep.id) return '';
    if (meal.locked) return tr('planner.locked_unlock_first');
    if (meal.prepped) return tr('planner.from_pantry_already');
    return '';
  };

  // First day the batch can be eaten: the cook day (or Monday for "Sonntag davor"), never a day that is over.
  const prepFirstDay = () => Math.max(0, prep.cook, firstOpenDay(state.weekStart));

  // Portions of a slot as it would be after applying: as planned when it is the recipe already, else fitted.
  const prepSlotPortions = (slot) => {
    const meal = findMeal(state.week, slot.day, slot.occasion);
    if (mealProductId(meal) === prep.id) return cookPortions(meal);
    return slotScale(prep.pick, state.week[slot.day], slot.occasion) + householdPortions(slot.occasion);
  };

  const prepDirty = () =>
    prep.prepped !== prep.prepped0 ||
    (prep.chosen.size > 1 && prep.cook !== prep.cook0) ||
    prep.chosen.size !== prep.chosen0.size ||
    [...prep.chosen].some((key) => !prep.chosen0.has(key));

  const prepSection = (label) => sheetEl('p', 'vhp-plan-pick__label', label);

  function paintPrepSheet() {
    const sheet = prepSheetEl();
    if (!sheet || !prep) return;
    // Another week on screen (or a re-plan under it): the draft belongs to a week that is gone.
    if (prep.start !== state.weekStart || !findMeal(state.week, prep.day, prep.occasion)) {
      closePrepSheet();
      return;
    }
    const busy = weekGenerating || prepApplying;
    const recipe = sheet.querySelector('[data-vhp-prep-recipe]');
    if (recipe) recipe.textContent = prep.pick.title || tr('common.recipe');
    const body = sheet.querySelector('[data-vhp-prep-body]');
    if (!body) return;
    const focused = body.contains(document.activeElement) ? document.activeElement.dataset?.vhpPrepKey : null;
    const nodes = [];

    // 1. Kochen am: today or later (the current cook day stays even when it is over).
    nodes.push(prepSection(tr('planner.cook_on')));
    const cookRow = sheetEl('div', 'vhp-prep__cookdays');
    cookRow.setAttribute('role', 'radiogroup');
    cookRow.setAttribute('aria-label', tr('planner.cook_on'));
    for (let day = COOK_BEFORE; day < WEEK_LEN; day += 1) {
      const on = day === prep.cook;
      if (!on && isPastDay(day)) continue;
      const date = dateOfDay(day);
      const btn = sheetEl('button', 'vhp-prep__cookday');
      btn.type = 'button';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      btn.setAttribute('aria-label', `${cookDayName(day)}, ${dayMonth(date)}`);
      btn.classList.toggle('is-on', on);
      btn.dataset.vhpPrepCook = String(day);
      btn.dataset.vhpPrepKey = `cook-${day}`;
      btn.disabled = busy;
      btn.append(sheetEl('span', 'vhp-prep__cookday-name', day === COOK_BEFORE ? tr('planner.sun_short') : DAY_LABEL[day]), sheetEl('span', 'vhp-prep__cookday-date', dayNum(date)));
      cookRow.append(btn);
    }
    nodes.push(cookRow);

    // 2. Essen am: one row per day from the cook day on, a chip per meal.
    nodes.push(prepSection(tr('planner.eat_on')));
    const grid = sheetEl('div', 'vhp-copy__opts vhp-prep__grid');
    const occasions = prepOccasions();
    for (let day = prepFirstDay(); day < WEEK_LEN; day += 1) {
      const planned = occasions.filter((row) => findMeal(state.week, day, row.id));
      if (!planned.length) continue;
      const row = sheetEl('div', 'vhp-prep__row');
      const date = dateOfDay(day);
      const name = sheetEl('span', 'vhp-prep__row-day');
      name.append(sheetEl('strong', null, PREVIEW_DAYS[day]), sheetEl('small', null, dayMonth(date)));
      const chips = sheetEl('div', 'vhp-prep__chips');
      planned.forEach(({ id: occasion }) => {
        const key = prepKey(day, occasion);
        const on = prep.chosen.has(key);
        const why = on ? '' : prepBlock(day, occasion);
        const chip = sheetEl('button', 'vhp-prep__chip', occasionShort(occasion));
        chip.type = 'button';
        chip.setAttribute('role', 'checkbox');
        chip.setAttribute('aria-checked', on ? 'true' : 'false');
        chip.setAttribute('aria-label', `${PREVIEW_DAYS[day]} ${occasionShort(occasion)}${why ? `: ${why}` : ''}`);
        chip.classList.toggle('is-on', on);
        chip.classList.toggle('is-blocked', Boolean(why));
        chip.dataset.vhpPrepSlot = key;
        chip.dataset.vhpPrepKey = `slot-${key}`;
        if (why) chip.dataset.vhpPrepWhy = `${PREVIEW_DAYS[day]} ${occasionShort(occasion)}: ${why}`;
        chip.disabled = busy;
        chips.append(chip);
      });
      row.append(name, chips);
      grid.append(row);
    }
    if (grid.childElementCount) nodes.push(grid);
    else nodes.push(sheetEl('p', 'vhp-prep__hint', tr('planner.nothing_after')));

    const slots = [...prep.chosen].map(prepSlot).sort(slotOrder);
    const late = slots.filter((slot) => slot.day - prep.cook > FRIDGE_DAYS);
    const hint = prep.hint
      ? prep.hint
      : late.length
        ? tr('planner.too_late', { slots: late.map(slotName).join(', '), days: FRIDGE_DAYS })
        : tr('planner.fridge_days', { days: FRIDGE_DAYS });
    const hintEl = sheetEl('p', `vhp-prep__hint${prep.hint || late.length ? ' is-strong' : ''}`, hint);
    hintEl.setAttribute('aria-live', 'polite');
    nodes.push(hintEl);
    prep.hint = '';

    // 3. What that means: total portions at the stove, per meal, what gets replaced.
    if (slots.length) {
      const cook = sheetEl('div', 'vhp-prep__cook');
      const total = slots.reduce((sum, slot) => sum + prepSlotPortions(slot), 0);
      cook.append(sheetEl('p', 'vhp-prep__cook-when', `${prepWhen(prep.cook)} kochen`), sheetEl('p', 'vhp-prep__cook-total', fmtPortions(total)));
      const parts = sheetEl('ul', 'vhp-prep__cook-parts');
      slots.forEach((slot) => {
        const li = sheetEl('li', null);
        li.append(sheetEl('span', null, `${PREVIEW_DAYS[slot.day]} ${occasionShort(slot.occasion)}`), sheetEl('span', null, fmtPortions(prepSlotPortions(slot))));
        parts.append(li);
      });
      cook.append(parts);
      const replaced = slots.filter((slot) => mealProductId(findMeal(state.week, slot.day, slot.occasion)) !== prep.id).length;
      const notes = [];
      if (replaced) notes.push(tr('planner.replaces', { n: replaced }));
      notes.push(prep.prepped ? tr('planner.already_cooked_note') : tr('planner.list_counts_all'));
      cook.append(sheetEl('p', 'vhp-prep__cook-note', notes.join(' ')));
      nodes.push(cook);
    }

    // 4. Already cooked (fridge, freezer): nothing to buy.
    const opts = sheetEl('div', 'vhp-copy__opts vhp-prep__opts');
    const opt = sheetEl('div', 'vhp-copy__opt');
    const optCopy = sheetEl('div', 'vhp-copy__opt-copy');
    optCopy.append(
      sheetEl('p', 'vhp-copy__opt-title', tr('planner.prepped_title')),
      sheetEl('p', 'vhp-copy__opt-note', tr('planner.prepped_note'))
    );
    const sw = sheetEl('button', 'vhp-switch');
    sw.type = 'button';
    sw.setAttribute('role', 'switch');
    sw.setAttribute('aria-label', tr('planner.prepped_title'));
    sw.setAttribute('aria-checked', prep.prepped ? 'true' : 'false');
    sw.classList.toggle('is-on', prep.prepped);
    sw.dataset.vhpPrepPrepped = '';
    sw.dataset.vhpPrepKey = 'prepped';
    sw.disabled = busy;
    opt.append(optCopy, sw);
    opts.append(opt);
    nodes.push(opts);

    body.replaceChildren(...nodes);
    const confirm = sheet.querySelector('[data-vhp-prep-apply]');
    if (confirm) {
      confirm.disabled = busy || !prep.chosen.size || !prepDirty();
      confirm.textContent = prepApplying ? tr('planner.saving') : tr('planner.apply');
    }
    if (focused) body.querySelector(`[data-vhp-prep-key="${CSS.escape(focused)}"]`)?.focus({ preventScroll: true });
  }

  const pickPrepCook = (day) => {
    if (!prep || day === prep.cook) return;
    prep.cook = day;
    // Nothing is eaten before it is cooked.
    [...prep.chosen].forEach((key) => {
      if (prepSlot(key).day < Math.max(0, day)) prep.chosen.delete(key);
    });
    paintPrepSheet();
  };

  const togglePrepSlot = (key, why) => {
    if (!prep) return;
    if (why) prep.hint = why;
    else if (prep.chosen.has(key)) prep.chosen.delete(key);
    else prep.chosen.add(key);
    paintPrepSheet();
  };

  const togglePrepPrepped = () => {
    if (!prep) return;
    prep.prepped = !prep.prepped;
    paintPrepSheet();
  };

  // Writes the draft into the week: chosen meals become the recipe (own portion each), locked, with the cook day;
  // meals that left the batch get a fresh recipe. One undo.
  let prepApplying = false;
  const applyPrep = async () => {
    if (!prep || prepApplying || weekGenerating || !prep.chosen.size || !prepDirty()) return;
    const week = state.week;
    const draft = prep;
    const undo = { scope: 'week', snapshot: cloneJson(week) };
    const slots = [...draft.chosen].map(prepSlot).sort(slotOrder);
    const dropped = [...draft.chosen0].filter((key) => !draft.chosen.has(key)).map(prepSlot);
    prepApplying = true;
    paintPrepSheet();
    const fresh = await freshMeals(week, dropped);
    prepApplying = false;
    if (!fresh) {
      paintPrepSheet();
      showWeekToast(tr('planner.meals_regen_failed'), { action: 'OK', ms: 3000 });
      return;
    }
    if (week !== state.week) return;
    // One meal cooked the day it is eaten is no batch: it stays a normal meal.
    const single = slots.length === 1 && slots[0].day === draft.cook;
    slots.forEach(({ day, occasion }) => {
      const target = findMeal(week, day, occasion);
      if (!target) return;
      let next = target;
      if (mealProductId(target) !== draft.id) {
        next = onWeek(week, () => mealFromRemix(target, draft.pick, slotScale(draft.pick, week[day], occasion), false));
        week[day].meals = orderMeals(week[day].meals.filter((meal) => meal.id !== occasion).concat(next));
      }
      delete next.leftover;
      if (single) {
        // Locked only for the batch it was in.
        if (cookOf(next) != null) next.locked = false;
        delete next.cook;
      } else Object.assign(next, { cook: draft.cook, locked: true, generated: false });
      if (draft.prepped) next.prepped = true;
      else delete next.prepped;
    });
    // A legacy dinner whose lunches left it: those lunches are no leftovers any more.
    syncLeftovers();
    regenUndo = undo;
    swapUndo = null;
    favUndo = null;
    persist();
    scheduleWeekSave();
    closePrepSheet();
    render();
    const when = draft.cook === COOK_BEFORE ? tr('planner.prep_on_sunday_before') : tr('planner.prep_on_day', { day: PREVIEW_DAYS[draft.cook] });
    showWeekToast(single ? tr('planner.prep_removed') : tr('planner.prep_set', { when, n: String(slots.length) }));
  };

  // ---------- Vorkochen card on the cook day (above the meals) ----------
  // Batches cooked on the day on screen that are eaten on another day too; on Sunday also next week's "Sonntag
  // davor" batches. Tap: the Meal-Prep sheet (this week) · Rezept: the recipe for all portions.
  const cookDayBatches = (dayIndex) => {
    const rows = [];
    const collect = (week, cook, ownWeek) => {
      const seen = new Set();
      (week || []).forEach((day, index) => {
        (day?.meals || []).forEach((meal) => {
          if (meal.away || cookOf(meal) !== cook) return;
          const key = mealProductId(meal);
          if (!key || seen.has(key)) return;
          seen.add(key);
          const batch = batchOf(week, index, meal.id);
          if (!batch || !batch.slots.some((slot) => slot.day !== dayIndex || !ownWeek)) return;
          rows.push({ week, batch, meal, ownWeek });
        });
      });
    };
    collect(state.week, dayIndex, true);
    const next = state.weekAlt?.start === mondayIso(1) && state.weekStart === mondayIso(0) ? state.weekAlt.week : null;
    if (dayIndex === WEEK_LEN - 1 && next) collect(next, COOK_BEFORE, false);
    return rows;
  };

  let prepTodayRows = [];
  const renderPrepToday = (empty) => {
    const box = $('[data-vhp-prep-today]');
    if (!box) return;
    prepTodayRows = empty || !planner.config.paid ? [] : cookDayBatches(state.weekDay);
    box.hidden = !prepTodayRows.length;
    box.replaceChildren(...prepTodayRows.map(({ week, batch, meal, ownWeek }, index) => {
      const card = sheetEl('div', 'vhp-prep-today__card');
      const open = sheetEl('button', 'vhp-prep-today__open');
      open.type = 'button';
      if (ownWeek) open.dataset.vhpPrepTodayOpen = String(index);
      else open.disabled = true;
      const ico = sheetEl('span', 'vhp-prep-today__ico');
      ico.append(potIcon());
      const copy = sheetEl('span', 'vhp-prep-today__copy');
      const kicker = prepIsToday(state.weekDay) && ownWeek ? tr('planner.prep_today_kicker') : ownWeek ? tr('planner.prep_day_kicker', { day: PREVIEW_DAYS[state.weekDay] }) : tr('planner.prep_next_week');
      const eaten = batch.slots.map((slot) => (ownWeek ? slotName(slot) : `${DAY_LABEL[slot.day]} ${occasionShort(slot.occasion)}`)).join(', ');
      copy.append(
        sheetEl('small', null, kicker),
        sheetEl('strong', null, meal.pick?.title || tr('common.recipe')),
        sheetEl('span', null, tr('planner.portions_for', { portions: fmtPortions(batchPortions(week, batch.slots)), slots: eaten }))
      );
      open.append(ico, copy);
      card.append(open);
      if (meal.pick?.handle || isCustomId(meal.pick?.id)) {
        const recipeBtn = sheetEl('button', 'vhp-prep-today__recipe', tr('common.recipe'));
        recipeBtn.type = 'button';
        recipeBtn.dataset.vhpPrepTodayRecipe = String(index);
        card.append(recipeBtn);
      }
      return card;
    }));
  };

  // The recipe for the whole batch (no own meal context: the amounts are for every portion).
  const openPrepTodayRecipe = (index) => {
    const row = prepTodayRows[index];
    if (!row) return;
    const total = batchPortions(row.week, row.batch.slots);
    const pick = row.meal.pick;
    if (isCustomId(pick.id)) openCustomRecipeSheet({ id: pick.id, scale: total });
    else openRecipeSheet({ handle: pick.handle, scale: total, title: pick.title });
  };

  const openPrepToday = (index) => {
    const row = prepTodayRows[index];
    if (!row?.ownWeek) return;
    const slot = row.batch.slots.find((item) => item.day >= firstOpenDay(state.weekStart));
    if (slot) openPrepSheet(slot.day, slot.occasion);
  };

  const commitMealSheetChange = () => {
    persist();
    scheduleWeekSave();
    render();
  };

  // Next quarter on the grid, also from an off-grid portion (×1,3 → ×1,5 / ×1,25).
  const portionStep = (scale, dir) => {
    const q = (Number(scale) || 1) / PORTION_STEP;
    const grid = (dir > 0 ? Math.floor(q + 1e-9) + 1 : Math.ceil(q - 1e-9) - 1) * PORTION_STEP;
    return Math.min(PORTION_MAX, Math.max(PORTION_MIN, grid));
  };

  const stepPortion = (dir) => {
    const meal = mealSheetMeal();
    if (!meal || meal.away || !meal.pick) return;
    const scale = portionStep(meal.scale, dir);
    if (scale === meal.scale) return;
    scaleMeal(meal, scale);
    mealSheet.rebalanced = null;
    commitMealSheetChange();
  };

  const rebalanceDay = () => {
    const day = state.week?.[mealSheet?.day];
    const meal = mealSheetMeal();
    const plan = day && meal ? rebalancePlan(day, meal.id) : null;
    if (!plan) return;
    const snapshot = new Map((day.meals || []).map((row) => [row.id, row.scale]));
    plan.changes.forEach((change) => {
      const row = day.meals.find((m) => m.id === change.id);
      if (row) scaleMeal(row, change.to);
    });
    mealSheet.rebalanced = {
      snapshot,
      text: plan.changes.map((c) => `${c.label} ${fmtPortion(c.to)}`).join(', '),
    };
    commitMealSheetChange();
  };

  const undoRebalance = () => {
    const day = state.week?.[mealSheet?.day];
    const snap = mealSheet?.rebalanced?.snapshot;
    if (!day || !snap) return;
    (day.meals || []).forEach((row) => {
      if (snap.has(row.id) && snap.get(row.id) !== row.scale && row.pick) scaleMeal(row, snap.get(row.id));
    });
    mealSheet.rebalanced = null;
    commitMealSheetChange();
  };

  function paintMealSheet() {
    const sheet = mealSheetEl();
    const meal = mealSheetMeal();
    if (!sheet || !mealSheet) return;
    // The meal is gone (another day, week or a re-plan under it): nothing left to act on.
    if (!meal || mealSheet.start !== state.weekStart) {
      closeMealSheet();
      return;
    }
    const thumb = sheet.querySelector('[data-vhp-meal-sheet-thumb]');
    if (thumb) {
      const src = meal.away ? '' : meal.pick?.image || '';
      if (thumb.dataset.src !== src) {
        thumb.dataset.src = src;
        thumb.replaceChildren();
        if (src) {
          const img = document.createElement('img');
          img.src = swapThumbUrl(src, SWAP_CARD);
          img.alt = '';
          thumb.append(img);
        } else if (meal.away) thumb.append(awayIcon());
      }
    }
    const title = sheet.querySelector('[data-vhp-meal-sheet-title]');
    if (title) title.textContent = meal.away ? tr('planner.away') : (meal.pick?.title && dishName(meal.pick.title)) || occLabel(meal) || tr('planner.meal');
    const when = sheet.querySelector('[data-vhp-meal-sheet-when]');
    if (when) {
      const date = addDays(shownMonday(), mealSheet.day);
      when.textContent = tr('planner.meal_when', { label: occLabel(meal) || tr('planner.meal'), weekday: PREVIEW_DAYS[mealSheet.day], date: dayMonth(date) });
    }
    // Keep keyboard focus on the stepper / action that was used (the block is rebuilt on every change).
    const focused = sheet.contains(document.activeElement) ? document.activeElement.dataset?.vhpMealAct : null;
    const portion = sheet.querySelector('[data-vhp-meal-sheet-portion]');
    if (portion) paintMealPortion(portion, meal);
    const box = sheet.querySelector('[data-vhp-meal-sheet-groups]');
    if (!box) return;
    box.replaceChildren(
      ...mealSheetGroups(meal)
        .filter((items) => items.length)
        .map((items) => {
          const group = document.createElement('div');
          group.className = 'vhp-meal-sheet__group';
          group.append(...items.map(mealSheetItem));
          return group;
        })
    );
    box.querySelectorAll('[data-vhp-meal-act]').forEach((btn) => {
      btn.disabled = weekGenerating;
    });
    if (focused) {
      const again = sheet.querySelector(`[data-vhp-meal-act="${focused}"]:not(:disabled)`) || sheet.querySelector('[data-vhp-meal-act="less"]:not(:disabled), [data-vhp-meal-act="more"]:not(:disabled)');
      again?.focus({ preventScroll: true });
    }
  }

  function openMealSheet(occasion) {
    const sheet = mealSheetEl();
    const meal = state.week?.[state.weekDay]?.meals?.find((row) => row.id === occasion);
    if (!sheet || !meal || weekGenerating) return;
    mealSheet = { occasion, day: state.weekDay, start: state.weekStart };
    paintMealSheet();
    setDialogOpen(sheet, true);
    sheet.querySelector('[data-vhp-meal-sheet-title]')?.focus({ preventScroll: true });
  }

  function closeMealSheet() {
    const sheet = mealSheetEl();
    const occasion = mealSheet?.occasion;
    mealSheet = null;
    if (sheet?.open) setDialogOpen(sheet, false);
    if (occasion) {
      funnel.querySelector(`[data-vhp-week-meals] [data-vhp-meal-more="${occasion}"]`)?.focus({ preventScroll: true });
    }
  }

  // Runs once the meal sheet has slid away (two sheets never animate at once).
  const afterMealSheet = (fn) => {
    const sheet = mealSheetEl();
    if (sheet?.open) sheet.addEventListener('close', fn, { once: true });
    else fn();
  };

  const runMealAct = (act) => {
    const occasion = mealSheet?.occasion;
    if (!occasion || weekGenerating) return;
    // Sperren is a switch: it flips in place and the sheet stays open. So do portions and the rebalance.
    if (act === 'lock') {
      toggleWeekLock(occasion);
      paintMealSheet();
      return;
    }
    if (act === 'less' || act === 'more') {
      stepPortion(act === 'more' ? 1 : -1);
      return;
    }
    if (act === 'rebalance') {
      rebalanceDay();
      return;
    }
    if (act === 'unbalance') {
      undoRebalance();
      return;
    }
    // "Jeden Mittwoch frei" changes in place too; the sheet shows the new state.
    if (act === 'away-repeat') {
      toggleAwayRepeat(occasion, mealSheet.day);
      return;
    }
    const day = mealSheet.day;
    closeMealSheet();
    afterMealSheet(() => {
      if (act === 'prep') openPrepSheet(day, occasion);
      else if (act === 'surprise') swipeReplace(occasion);
      else if (act === 'copy') openCopySheet(occasion);
      else if (act === 'leftover') applyLeftoverPick(occasion);
      else if (act === 'household') openSettingsAt('[data-vhp-household]');
      else if (act === 'away') applyAwayPick(occasion);
      else if (act === 'own') openOwnForm(day, occasion);
      else if (act === 'view') {
        funnel.querySelector(`[data-vhp-week-meals] .vhp-pick__hit[data-vhp-recipe-occasion="${occasion}"]`)?.click();
      }
    });
  };

  const endSwap = ({ restore }) => {
    const swap = state.swap;
    const dayIndex = swap?.day ?? state.weekDay;
    state.swap = null;
    swapPassed = [];
    state.undo = null;
    state.pin = null;
    const day = state.week?.[dayIndex];
    if (restore && swap?.meal && day) {
      const meals = (day.meals || []).filter((meal) => meal.id !== swap.meal.id);
      day.meals = orderMeals(meals.concat(swap.meal));
    }
    show('week', null, 'fade');
  };

  const goBack = () => {
    if (state.editFrom === 'summary' && state.screen !== 'building') {
      returnToSummary();
      return;
    }
    if (state.screen === 'building') {
      clearBuildTimers();
      exampleBuilding = false;
      buildHolding = false;
      buildRelease = null;
      show('swipe', null, 'fade');
      return;
    }
    if (state.swap && (state.screen === 'swipe' || state.screen === 'empty')) {
      endSwap({ restore: true });
      return;
    }
    // Story setup: the preview ends it. Back leaves the planner (to where they came from, else the feed) instead of
    // stepping into the story slides, which came back empty after a reload (walk 2026-10-17, S47).
    const storyEnd = storyActive() && !planner.config.paid && state.editFrom !== 'settings';
    if (storyEnd && state.screen === 'preview') {
      step('preview_use', 'back');
      leavePlanner();
      return;
    }
    let prev = state.history.pop();
    while (prev && (prev.screen === 'building' || (prev.screen === 'preview' && gated()))) prev = state.history.pop();
    // Back from the plans skips the gift / Sören's clip: their × leads on to the plans, so they would loop.
    if (state.screen === 'subscribe') {
      while (prev && (prev.screen === 'proof' || prev.screen === 'gift')) prev = state.history.pop();
      // ... and lands on the free day, or out of the planner when there is none (preview off).
      if (storyEnd && prev?.screen !== 'preview') {
        if (state.preview?.day?.meals?.length && !gated()) prev = { screen: 'preview', slot: null };
        else {
          leavePlanner();
          return;
        }
      }
    }
    if (state.editFrom === 'settings' && (!prev || !FLOW.includes(prev.screen))) {
      closeSettingsEdit();
      returnToPlanSheet(prev?.screen);
      return;
    }
    if (!prev) {
      show(state.soerenDoor && !planner.config.paid && hasScreen('soeren') ? 'soeren' : state.mondayDoor && !planner.config.paid ? 'monday' : 'goal', null, 'back');
      return;
    }
    const fade = FADE_SCREENS.has(state.screen) || FADE_SCREENS.has(prev.screen);
    show(prev.screen, prev.slot, fade ? 'fade' : 'back');
  };

  let goalAdvance = 0; // pending auto-advance after a goal tile tap (click handler)

  // The exclusions also go into the feed's standing filters (assets/vhp-filters.js, "Ohne": same keys), added to
  // what is there and never removed, so the feed does not ask again. Cook time stays in the planner: it is the
  // weekday time, the feed is for browsing.
  const shareExclusions = () => {
    const api = window.vhpFilters;
    if (!api || !state.exclusions.length) return;
    const avoid = api.get().avoid;
    const add = state.exclusions.filter((key) => !avoid.includes(key));
    if (add.length) api.set({ avoid: avoid.concat(add) });
  };

  const goNext = () => {
    // Opened from a 3.1 summary row: that answer, then straight back to the summary (no setup walk again).
    if (state.editFrom === 'summary') {
      switch (state.screen) {
        case 'goal':
          if (!state.goal) return;
          if (!state.kcalManual) state.kcal = computeKcal();
          // Another goal has other reasons (the tile tap already cleared a reason that doesn't fit): its Warum
          // slide, then back.
          if (!state.why || !(WHY_BY_GOAL[state.goal] || []).includes(state.why)) {
            state.why = null;
            show('why', null, 'fade');
            return;
          }
          returnToSummary();
          return;
        case 'why':
          if (!state.why) return;
          returnToSummary();
          return;
        case 'activity':
          if (!eckdatenValid()) return;
          if (!state.kcalManual) state.kcal = computeKcal();
          if (!validSplit(state.macros)) {
            state.macros = recommendedMacros();
            state.macrosPreset = 'recommended';
          }
          returnToSummary();
          return;
        case 'exclusions':
          shareExclusions();
          returnToSummary();
          return;
        default:
          break; // body goes on to activity as usual
      }
    }
    if (state.editFrom === 'settings') {
      switch (state.screen) {
        case 'goal':
          if (!state.goal) return;
          if (!state.kcalManual) state.kcal = computeKcal();
          finishSettingsEdit();
          break;
        case 'body':
          if (!eckdatenValid()) return;
          if (!state.kcalManual) state.kcal = computeKcal();
          finishSettingsEdit();
          break;
        case 'macros':
        case 'meals':
          finishSettingsEdit();
          break;
        case 'exclusions':
          shareExclusions();
          finishSettingsEdit();
          break;
        default:
          break;
      }
      return;
    }
    switch (state.screen) {
      case 'goal':
        if (!state.goal) return;
        if (!state.kcalManual) state.kcal = computeKcal();
        step('goal_selected', state.goal);
        goalDwell('answered');
              // The first screen's door (docs/FIRST_SCREEN.md 9.8) runs the short setup: no Warum.
        forward(storyActive() ? (shortSetup() || state.mondayDoor || likesDoor() || recipeDoor() ? eckdatenNext() : 'why') : 'body');
        break;
      // Story: Eckdaten as two slides since 2026-10-17 (sex + measures, then activity; Geschlecht as its own slide
      // lost the most in-app visitors of the setup, CONVERSION_PLAN.md 2.3); eckdaten_done after the last one.
      // Measures from the recipe calculator skip straight to activity, measures and activity straight to Deine Zahlen.
      case 'why':
        if (!state.why) return;
        forward(eckdatenNext());
        break;
      // A sex slide saved before the merge.
      case 'sex':
        forward('body');
        break;
      case 'body':
        if (storyActive()) {
          if (!bodyValid()) return;
          // The default sex isn't an answer until it's tapped on this slide.
          if (!storyVoted.has('sex')) {
            const tags = $('[data-vhp-sex-tags]');
            if (tags) {
              tags.classList.remove('is-nudged');
              void tags.offsetWidth;
              tags.classList.add('is-nudged');
            }
            // The shake alone went unseen: Weiter looked broken (docs/PERSONA_ATTACK_PLAN.md 2.10).
            storyPlayer?.say(tr('planner.story_sex_hint'), 2600);
            return;
          }
          forward('activity');
          break;
        }
      // falls through: the classic screen holds all of it
      case 'activity':
        if (!eckdatenValid()) return;
        // Sörens Woche's "Anpassen" (docs/SOEREN_WEEK.md 2): her own body wins over the typed number; back to the question.
        if (state.soerenDoor && !planner.config.paid) {
          state.kcalManual = false;
          state.soerenKcal = null;
        }
        finishEckdaten();
        forward(state.soerenDoor && !planner.config.paid && hasScreen('soeren') ? 'soeren' : storyActive() ? 'numbers' : 'exclusions');
        break;
      case 'numbers':
        if (trimmedStory()) {
          forward('exclusions');
          break;
        }
        forward(storyDishes().length && !montageSkipped() ? 'dishes' : 'pain');
        break;
      case 'dishes':
        forward('pain');
        break;
      case 'pain':
        if (!state.pain) return;
        forward('answer');
        break;
      case 'answer':
        forward('exclusions');
        break;
      case 'exclusions':
        deferId = null;
        if (state.exclusions.length) state.exclusions.forEach((key) => step('exclusions_done', key));
        else step('exclusions_done', 'none');
        shareExclusions();
        step('deck_started');
        // Likes from the webapp already make a plan: straight to the preview (back from it leads to the deck).
        if (!planner.config.paid && planReady()) {
          createPlan();
          break;
        }
        // Express path and recipe fast path: the dish from the recipe is the like, the planner picks the rest (deck_skipped).
        if (expressPath() || recipeDoor()) {
          createPlan({ skip: true });
          break;
        }
        if (gridSetup() && $('[data-vhp-screen="grid"]')) {
          forward('grid', null);
          break;
        }
        forward('swipe', null);
        break;
      default:
        break;
    }
  };

  // Frequencies only for current favorites (a removed favorite drops its setting).
  const favFreqForSave = () => {
    const liked = new Set(likeItems().map((item) => item.id));
    return Object.fromEntries(Object.entries(state.favFreq || {}).filter(([id]) => liked.has(id)).slice(0, FREQ_MAX));
  };
  const favFreqOf = (id) => state.favFreq?.[productId(id)] || 'normal';
  const pausedIds = () =>
    new Set(Object.entries(state.favFreq || {}).filter(([, value]) => value === 'pause').map(([id]) => id));

  const pendingProfile = () => {
    const favorites = {};
    selectedSlots().forEach((slot) => {
      const ids = likesForSlot(slot).map((item) => item.id).slice(-20);
      if (ids.length) favorites[slot] = ids;
    });
    return {
      profile: {
        goal: state.goal,
        kcal: state.kcal,
        macros: currentSplit(),
        consent: { planner: true, at: state.consentAt, version: 1 },
      },
      preferences: {
        slots: planSlots(),
        exclusions: state.exclusions,
        maxTime: state.maxTime || null,
        // Favoriten sheet. Needs the planner API that accepts mix / freq / hidden (deploy it first).
        mix: state.favMix || 'balanced',
        freq: favFreqForSave(),
        hidden: (state.hidden?.items || []).slice(-HIDDEN_MAX).map((item) => ({ id: item.id, slot: item.slot })),
        // Needs the planner API that accepts household (deploy it first).
        // size: needs the planner API that accepts household.size (deploy it first).
        ...(state.household?.n > 1
          ? {
              household: {
                n: state.household.n,
                shared: state.household.shared.slice(),
                ...(state.household.size && state.household.size !== 1 ? { size: state.household.size } : {}),
              },
            }
          : {}),
        // Needs the planner API that accepts leftovers / pantry (deploy it first).
        ...(state.leftovers ? { leftovers: true, ...(state.leftoverDays === 2 ? { leftoverDays: 2 } : {}) } : {}),
        // Needs the planner API that accepts shares (deploy it first). Shares replace the old sizes.
        ...(state.mealShares
          ? { shares: { ...state.mealShares } }
          : Object.keys(state.mealSizes || {}).length
            ? { sizes: { ...state.mealSizes } }
            : {}),
        // Needs the planner API that accepts repeat (deploy it first).
        ...(state.repeat?.length
          ? { repeat: state.repeat.map(({ occasion, id, scale, days }) => ({ occasion, id, scale, days: days.slice() })) }
          : {}),
        // Needs the planner API that accepts away (deploy it first).
        ...(state.awayRepeat?.length ? { away: state.awayRepeat.map(({ occasion, days }) => ({ occasion, days: days.slice() })) } : {}),
        ...(state.pantry?.have?.length || state.pantry?.buy?.length
          ? { pantry: { have: state.pantry.have.slice(), buy: state.pantry.buy.slice() } }
          : {}),
      },
      favorites,
      // Rezepte reel. Paid only; needs the planner API that accepts `seen` (deploy it first).
      ...(planner.config.paid && state.seen?.length ? { seen: state.seen.slice(-1000) } : {}),
      // Needs the planner API that accepts `skips` (deploy it first).
      ...(state.skips?.items?.length ? { skips: state.skips.items.slice(-SKIPS_MAX) } : {}),
      // Only until the account has one (hydrateFromSaved adopts a saved seed). Needs the planner API with `seed`.
      ...(state.seedKey && state.seedKey !== planner.config.saved?.seed ? { seed: state.seedKey } : {}),
      // E-mail opt-in moved to Shopify checkout: only an old in-planner yes is sent, never a no that could
      // overwrite the checkout choice.
      ...(state.consentMarketing ? { marketing: true } : {}),
    };
  };

  const canSaveProfile = () =>
    state.consentPlanner && Boolean(state.goal) && state.kcal != null && selectedSlots().length > 0;

  const flushProfile = async () => {
    if (!state.pendingFlush) return;
    const { config, saveProfile } = planner;
    if (!config.customerId || !config.token || !state.consentPlanner || !state.consentAt || !saveProfile) return;
    if (!canSaveProfile()) return;
    try {
      const res = await saveProfile(pendingProfile());
      if (!res.ok) throw new Error(String(res.status));
      state.pendingFlush = false;
      state.profileSaved = true;
      persist();
    } catch (e) {
      console.error('[vhp-planner] profile save failed', e);
      step('planner_error', 'api_profile');
      showSaveFailed(() => {
        state.pendingFlush = true;
        flushProfile();
      });
    }
  };

  const pendingWeek = (week = state.week, start = state.weekStart) => (syncAwayBudgets(week), {
    weekStart: start || mondayIso(0),
    days: Array.from({ length: WEEK_LEN }, (_, index) => ({
      meals: (week?.[index]?.meals || []).map((meal) => (meal.away ? {
        // Needs the planner API that accepts away meals (deploy it first).
        occasion: meal.id,
        slot: meal.catalog,
        away: true,
        kcal: Math.round(Number(meal.kcal) || 0),
        protein: Math.round(Number(meal.protein) || 0),
        carbs: Math.round(Number(meal.carbs) || 0),
        fat: Math.round(Number(meal.fat) || 0),
        locked: false,
      } : {
        occasion: meal.id,
        slot: meal.catalog,
        id: productId(meal.pick?.id),
        scale: meal.scale,
        locked: Boolean(meal.locked),
        // leftover 2 (two days back): needs the planner API that accepts it (deploy it first).
        ...(meal.leftover ? { leftover: meal.leftover === 2 ? 2 : true } : {}),
        // Needs the planner API that accepts prepped (deploy it first).
        ...(meal.prepped ? { prepped: true } : {}),
        // Meal-Prep cook day: needs the planner API that accepts cook (deploy it first).
        ...(Number.isInteger(meal.cook) ? { cook: meal.cook } : {}),
      })).filter((meal) => meal.away || meal.id),
    })),
  });

  let weekSaving = false;
  let weekGenerating = false;
  let weekReveal = null;
  let weekDayDir = 0;
  let weekStripDir = 0;
  let mealsMotion = null;
  // Day change (planner skin v3): the old day steps aside and fades (200 ms), the new one glides in a short way
  // behind it (vhp-planner.css), like a native day switch rather than cards flying across the screen.
  const MEALS_ROW_MS = 200;
  const MEALS_STAGGER = 30;
  const MEALS_OVERLAP_MS = 90;
  // Neu würfeln / neu planen: the unlocked cards fold away and deal back in one after another (vhp-ui-story.css).
  const MEALS_ROLL_STAGGER = 60;
  const MEALS_ROLL_OVERLAP_MS = 170;
  let weekError = false;
  let shopLoading = false;
  let shopCopied = false;
  let shopList = { items: [], pantry: [], missing: [], days: [] };
  // Shop UI (memory only): Vorrat section open, "Anpassen" mode (move items between list and Vorrat).
  let shopPantryOpen = false;
  let shopEdit = false;
  let weekTimer = 0;

  // Edits bump this; a save only clears "pending" when nothing changed while it was in flight.
  let weekEdits = 0;
  let weekFlushAgain = false;

  // Saves every week with unsaved changes (the one on screen and the other one), one request each.
  const flushWeek = async () => {
    if (!planner.config.paid || !planner.saveWeek) return;
    if (!planner.config.customerId || !planner.config.token) return;
    if (weekSaving) {
      weekFlushAgain = true;
      return;
    }
    const holders = [];
    if (state.pendingWeekFlush && weekHasPlan(state.week)) holders.push(state.weekStart || mondayIso(0));
    if (state.weekAlt?.pending && weekHasPlan(state.weekAlt.week)) holders.push(state.weekAlt.start);
    if (!holders.length) return;
    weekSaving = true;
    let rolled = false;
    try {
      for (const start of holders) {
        const week = start === (state.weekStart || mondayIso(0)) ? state.week : state.weekAlt?.week;
        if (!week) continue;
        const edits = weekEdits;
        const res = await planner.saveWeek(pendingWeek(week, start));
        // 409: the server's week has moved on (tab left open over Sunday night). That plan is last week now.
        if (res.status === 409) {
          rolled = true;
          continue;
        }
        if (!res.ok) throw new Error(String(res.status));
        if (edits === weekEdits) {
          if (state.weekStart === start) state.pendingWeekFlush = false;
          else if (state.weekAlt?.start === start) state.weekAlt.pending = false;
        }
      }
      weekError = false;
      persist();
    } catch (e) {
      console.error('[vhp-planner] week save failed', e);
      reportError('api_week');
      weekError = true;
      showSaveFailed(flushWeek);
    } finally {
      weekSaving = false;
      const err = funnel.querySelector('[data-vhp-week-error]');
      if (err) err.hidden = !weekError;
    }
    if (rolled) checkWeekRollover();
    if (weekFlushAgain) {
      weekFlushAgain = false;
      flushWeek();
    }
  };

  const scheduleWeekSave = () => {
    if (!planner.config.paid || !planner.config.customerId || !planner.config.token) return;
    weekEdits += 1;
    state.pendingWeekFlush = true;
    persist();
    window.clearTimeout(weekTimer);
    weekTimer = window.setTimeout(() => {
      flushWeek();
    }, 2000);
  };

  const inRecipes = () => Boolean(planner.config.paid && state.screen === 'recipes');

  const inPaidApp = () =>
    state.screen === 'week' ||
    state.screen === 'shop' ||
    state.screen === 'settings' ||
    state.editFrom === 'settings' ||
    inRecipes();

  const closeSettingsEdit = () => {
    if (state.editFrom !== 'settings') return;
    if (!state.kcalManual) {
      const next = computeKcal();
      if (next != null && next !== state.kcal) {
        state.kcal = next;
        rescaleWeekToKcal(next);
        scheduleWeekSave();
      } else if (next != null) {
        state.kcal = next;
      }
    }
    applyMealsToWeek();
    state.editFrom = null;
    state.pendingFlush = true;
    persist();
    while (state.history.length) {
      const top = state.history[state.history.length - 1];
      if (top.screen === 'week' || top.screen === 'shop' || top.screen === 'settings') break;
      state.history.pop();
    }
    flushProfile();
  };

  // Settings live in the Dein Plan sheet; its Ziel / Körperdaten / Makros rows open the setup screens
  // (editFrom = 'settings'). Done or back: the app screen underneath, with the sheet open again.
  const returnToPlanSheet = (screen) => {
    show(screen === 'shop' ? 'shop' : 'week', null, 'fade');
    window.requestAnimationFrame(() => openFavSheet('settings'));
  };

  const finishSettingsEdit = () => {
    closeSettingsEdit();
    const top = state.history[state.history.length - 1];
    if (top && !FLOW.includes(top.screen)) state.history.pop();
    returnToPlanSheet(top?.screen);
  };

  const startSettingsEdit = (screen) => {
    if (!FLOW.includes(screen)) return;
    closeFavSheet();
    state.editFrom = 'settings';
    if (state.screen !== 'building') state.history.push(position());
    show(screen, null, 'fade');
  };

  // Einstellungen = the Dein Plan sheet on its first tab, over the Wochenplan (or the Einkaufsliste).
  const openSettings = () => {
    if (!planner.config.paid || !favSheet()) return;
    closeSwapSheet();
    if (state.editFrom === 'settings' || !(state.screen === 'week' || state.screen === 'shop')) {
      closeSettingsEdit();
      openWeek();
    }
    openFavSheet('settings');
  };

  // Settings scrolled to one card, which flashes once (meal ⋯ sheet, shop pill).
  const openSettingsAt = (sel) => {
    openSettings();
    window.requestAnimationFrame(() => {
      const card = favSheet()?.querySelector(sel);
      const scroll = $('[data-vhp-fav-scroll]');
      if (!card || !scroll) return;
      // Only the list scrolls (scrollIntoView would also shift the sheet panel under its header).
      const top = card.getBoundingClientRect().top - scroll.getBoundingClientRect().top + scroll.scrollTop - 24;
      scroll.scrollTo({ top: Math.max(0, top), behavior: motionOk() ? 'smooth' : 'auto' });
      card.classList.remove('is-flash');
      void card.offsetWidth;
      card.classList.add('is-flash');
      card.addEventListener('animationend', () => card.classList.remove('is-flash'), { once: true });
    });
  };

  // Rezepte tab (paid). Hub → set grid → reel. In memory only; a reload opens the week.
  // set: { kind: 'category' | 'likes' | 'own' | 'search', id, title }.
  const hub = { set: null, query: '', hubTop: 0 };
  let hubGridKey = '';
  let hubSearchTimer = 0;
  let hubCatalogLoad = null;
  let hubCatalogReady = false;

  // Loads every breakfast/main/snack page once (the swap sheet does the same),
  // so counts, categories and "Neu für dich" cover the whole catalog.
  const loadHubCatalog = () => {
    if (hubCatalogReady) return Promise.resolve();
    if (!hubCatalogLoad) {
      hubCatalogLoad = fillRemixPools()
        .catch((e) => console.error('[vhp-planner] recipe catalog load failed', e))
        .then(() => {
          hubCatalogReady = true;
          hubCatalogLoad = null;
          hubGridKey = '';
          if (inRecipes()) render();
        });
    }
    return hubCatalogLoad;
  };

  const openRecipes = () => {
    if (!planner.config.paid) return;
    if (!funnel.querySelector('[data-vhp-screen="recipes"]')) return;
    closeSwapSheet();
    closeSettingsEdit();
    state.swap = null;
    swapPassed = [];
    state.slot = null;
    if (state.screen === 'recipes') {
      // Dock tap on the open tab goes back to the hub top.
      closeReel();
      hub.set = null;
      hub.query = '';
      hub.hubTop = 0;
      hubGridKey = '';
      const scroller = $('[data-vhp-rx-scroll]');
      if (scroller) scroller.scrollTop = 0;
      render();
    } else if (inPaidApp()) show('recipes', null, 'fade');
    else forward('recipes', null);
    loadHubCatalog();
  };

  // ---------- Favoriten sheet (paid) ----------
  // Manages likes: mix (how much the plan leans on favorites), per-favorite frequency (Oft / Normal / Pause),
  // remove (swipe or ⋯), hide ("Nicht mehr vorschlagen") and restore. Changes only mark the sheet dirty;
  // "Woche neu mischen" re-plans the unlocked meals with them.
  // Menu label · note on the row (only when it differs from normal).
  const FAV_FREQ_LABEL = { often: tr('planner.freq_often'), normal: tr('planner.freq_normal'), pause: tr('planner.freq_pause') };
  const FAV_FREQ_NOTE = { often: tr('planner.freq_note_often'), pause: tr('planner.freq_note_pause') };
  // Long meal types show this many rows, then "Alle N anzeigen".
  const FAV_GROUP_PEEK = 3;
  const FAV_SLOTS = ['breakfast', 'main', 'snack', 'dessert'];
  const FAV_SWIPE_OPEN = 96;
  const FAV_SWIPE_SNAP = 44;
  // tab: the Dein Plan sheet's open tab ('settings' | 'fav'), kept for the page visit.
  const fav = { dirty: false, hiddenOpen: false, menu: null, openRow: null, drag: null, query: '', expanded: new Set(), tab: 'settings' };
  let favUndo = null;
  let favFlushTimer = 0;

  const favSheet = () => funnel.querySelector('[data-vhp-fav-sheet]');
  const favoriteItems = () => likeItems().filter((item) => !isCustomId(item.id));
  const favPlannedDays = (id) =>
    (state.week || [])
      .map((day, index) => ((day?.meals || []).some((meal) => mealProductId(meal) === id) ? index : -1))
      .filter((index) => index >= 0);

  // Profile writes are debounced: a few taps in a row are one request.
  const scheduleFavSave = () => {
    state.pendingFlush = true;
    persist();
    window.clearTimeout(favFlushTimer);
    favFlushTimer = window.setTimeout(() => flushProfile(), 1500);
  };
  const markFavDirty = () => {
    fav.dirty = true;
    scheduleFavSave();
  };

  const favButton = (className, text, data) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = className;
    if (text) btn.textContent = text;
    Object.entries(data || {}).forEach(([key, value]) => {
      btn.dataset[key] = value;
    });
    return btn;
  };

  const favThumb = (image) => {
    const thumb = document.createElement(image ? 'img' : 'div');
    thumb.className = 'vhp-fav-row__thumb';
    if (image) {
      thumb.src = image;
      thumb.alt = '';
      thumb.loading = 'lazy';
    }
    return thumb;
  };

  const favMeta = (item) =>
    [
      item.kcal != null ? `${Math.round(item.kcal)} kcal` : '',
      item.protein != null ? tr('common.protein', { n: Math.round(item.protein) }) : '',
    ]
      .filter(Boolean)
      .join(' · ');

  // One row in the meal type's list: thumb, title, kcal · protein (+ "öfter" / "pausiert"), and on the right the
  // days it is planned this week or "+ Einplanen". Tapping the row opens its menu (frequency, view, remove);
  // swiping it left removes it.
  const favRow = (item) => {
    const freq = favFreqOf(item.id);
    const row = document.createElement('div');
    row.className = 'vhp-fav-row';
    row.dataset.vhpFavRow = item.id;
    row.classList.toggle('is-paused', freq === 'pause');

    const remove = favButton('vhp-fav-row__remove', '', { vhpFavRemove: item.id });
    remove.tabIndex = -1;
    remove.setAttribute('aria-label', tr('planner.fav_remove_label', { title: item.title || tr('common.recipe') }));
    const removeLabel = document.createElement('span');
    removeLabel.className = 'vhp-fav-row__remove-label';
    const trash = spriteIcon('trash', 'vhp-ico--sm');
    if (trash) removeLabel.append(trash);
    removeLabel.append(document.createTextNode(tr('planner.remove')));
    remove.append(removeLabel);

    const card = document.createElement('div');
    card.className = 'vhp-fav-row__card';
    card.dataset.vhpFavCard = item.id;

    const open = favButton('vhp-fav-row__open', '', { vhpFavMore: item.id });
    open.setAttribute('aria-haspopup', 'menu');
    open.setAttribute('aria-expanded', 'false');
    const body = document.createElement('span');
    body.className = 'vhp-fav-row__body';
    const title = document.createElement('span');
    title.className = 'vhp-fav-row__title';
    title.textContent = item.title || tr('common.recipe');
    const meta = document.createElement('span');
    meta.className = 'vhp-fav-row__meta';
    meta.textContent = favMeta(item);
    if (FAV_FREQ_NOTE[freq]) {
      const note = document.createElement('span');
      note.className = `vhp-fav-row__freq is-${freq}`;
      note.textContent = FAV_FREQ_NOTE[freq];
      if (meta.textContent) meta.append(' · ');
      meta.append(note);
    }
    body.append(title, meta);
    open.append(favThumb(item.image), body);
    open.setAttribute(
      'aria-label',
      tr('planner.fav_more', { title: item.title || tr('common.recipe'), note: FAV_FREQ_NOTE[freq] ? `, ${FAV_FREQ_NOTE[freq]}` : '' })
    );
    card.append(open);

    if (freq !== 'pause') {
      const days = favPlannedDays(item.id);
      if (days.length) {
        const week = document.createElement('span');
        week.className = 'vhp-fav-row__week';
        week.textContent = days.map((index) => DAY_LABEL[index]).join(' · ');
        week.setAttribute('aria-label', `${viewingNextWeek() ? tr('planner.next_week') : tr('planner.this_week')}: ${days.map((index) => PREVIEW_DAYS[index]).join(', ')}`);
        card.append(week);
      } else if (weekHasPlan(state.week)) {
        const plan = favButton('vhp-fav-row__plan', tr('planner.plan_add'), { vhpFavPlan: item.id });
        plan.setAttribute('aria-label', tr('planner.plan_of', { title: item.title || tr('common.recipe') }));
        card.append(plan);
      }
    }
    row.append(remove, card);
    return row;
  };

  const favMatches = (item, needle) => !needle || foldSearch(item.title || '').includes(needle);

  const renderFavHidden = () => {
    const box = $('[data-vhp-fav-hidden]');
    const list = $('[data-vhp-fav-hidden-list]');
    const label = $('[data-vhp-fav-hidden-label]');
    const toggle = $('[data-vhp-fav-hidden-toggle]');
    const items = (state.hidden?.items || []).slice().reverse();
    if (!box || !list) return;
    box.hidden = !items.length;
    if (!items.length) fav.hiddenOpen = false;
    if (label) label.textContent = tr('planner.hidden_n', { n: items.length });
    if (toggle) toggle.setAttribute('aria-expanded', fav.hiddenOpen ? 'true' : 'false');
    box.classList.toggle('is-open', fav.hiddenOpen);
    list.hidden = !fav.hiddenOpen;
    list.replaceChildren(
      ...items.map((item) => {
        const row = document.createElement('div');
        row.className = 'vhp-fav-hrow';
        const copy = document.createElement('div');
        copy.className = 'vhp-fav-hrow__copy';
        const title = document.createElement('p');
        title.className = 'vhp-fav-row__title';
        title.textContent = item.title || tr('common.recipe');
        const meta = document.createElement('p');
        meta.className = 'vhp-fav-row__meta';
        meta.textContent = favMeta(item) || SLOT_LABEL[item.slot] || '';
        copy.append(title, meta);
        row.append(
          favThumb(item.image),
          copy,
          favButton('vhp-fav-hrow__restore', tr('planner.restore'), { vhpFavRestore: item.id })
        );
        return row;
      })
    );
  };

  const renderFavSheet = () => {
    const sheet = favSheet();
    if (!sheet) return;
    const items = favoriteItems();
    const n = $('[data-vhp-fav-n]');
    if (n) n.textContent = items.length ? String(items.length) : '';
    renderPlanTabs();
    const empty = !items.length;
    const mix = $('[data-vhp-fav-mix]');
    if (mix) mix.hidden = empty;
    $$('[data-vhp-fav-mix-opt]').forEach((btn) => {
      const on = btn.dataset.vhpFavMixOpt === (state.favMix || 'balanced');
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    const emptyEl = $('[data-vhp-fav-empty]');
    if (emptyEl) emptyEl.hidden = !empty;
    const more = $('[data-vhp-fav-more-link]');
    if (more) more.hidden = empty;
    const search = $('[data-vhp-fav-search]');
    if (search) search.hidden = items.length < 6;
    renderOwnCard();
    const needle = foldSearch(fav.query || '').trim();
    const groups = $('[data-vhp-fav-groups]');
    if (groups) {
      const sections = FAV_SLOTS.map((slot) => {
        const rows = items.filter((item) => item.slot === slot && favMatches(item, needle)).reverse();
        if (!rows.length) return null;
        const group = document.createElement('section');
        group.className = 'vhp-fav-group';
        const head = document.createElement('h3');
        head.className = 'vhp-fav-group__head';
        head.textContent = `${SLOT_LABEL[slot] || slot} · ${rows.length}`;
        const list = document.createElement('div');
        list.className = 'vhp-fav-list';
        // Long meal types collapse (not while searching): a few rows, then "Alle N anzeigen".
        const peek = !needle && !fav.expanded.has(slot) && rows.length > FAV_GROUP_PEEK + 1;
        list.append(...(peek ? rows.slice(0, FAV_GROUP_PEEK) : rows).map(favRow));
        if (peek) list.append(favButton('vhp-fav-list__all', tr('planner.show_all_n', { n: rows.length }), { vhpFavAll: slot }));
        group.append(head, list);
        return group;
      }).filter(Boolean);
      if (!sections.length && needle && !empty) {
        const none = document.createElement('p');
        none.className = 'vhp-fav-none';
        none.textContent = tr('planner.no_favs_found');
        sections.push(none);
      }
      groups.replaceChildren(...sections);
    }
    fav.openRow = null;
    renderFavHidden();
    renderPlanFoot();
  };

  // Tabs of the Dein Plan sheet: Einstellungen · Favoriten.
  const renderPlanTabs = () => {
    $$('[data-vhp-plan-tab]').forEach((btn) => {
      const on = btn.dataset.vhpPlanTab === fav.tab;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
      btn.tabIndex = on ? 0 : -1;
    });
    $$('[data-vhp-plan-pane]').forEach((pane) => {
      pane.hidden = pane.dataset.vhpPlanPane !== fav.tab;
    });
  };

  // Changed favorites, or settings only a new plan picks up (meals, Kochzeit, Ausschlüsse, Reste):
  // "Woche neu planen" slides up, on both tabs.
  const planSheetDirty = () => fav.dirty || (settingsDirty() && weekHasPlan(state.week));
  const renderPlanFoot = () => {
    const dirty = planSheetDirty();
    const foot = $('[data-vhp-fav-foot]');
    if (foot) {
      foot.classList.toggle('is-on', dirty);
      foot.setAttribute('aria-hidden', dirty ? 'false' : 'true');
      const btn = foot.querySelector('[data-vhp-fav-regen]');
      if (btn) {
        btn.tabIndex = dirty ? 0 : -1;
        btn.disabled = weekGenerating;
      }
    }
    favSheet()?.querySelector('[data-vhp-fav-panel]')?.classList.toggle('is-dirty', dirty);
  };

  const showPlanTab = (tab) => {
    if (tab !== 'settings' && tab !== 'fav') return;
    closeFavMenu();
    if (fav.openRow) closeFavRow();
    fav.tab = tab;
    renderPlanTabs();
    const scroll = $('[data-vhp-fav-scroll]');
    if (scroll) scroll.scrollTop = 0;
  };

  // The week toast sits below modals; while the sheet is open it moves inside (like the reel).
  const moveToastIntoFav = () => {
    const el = funnel.querySelector('[data-vhp-week-toast]');
    const root = favSheet();
    if (!el || !root || root.contains(el)) return;
    toastHome.parent = el.parentNode;
    toastHome.next = el.nextSibling;
    root.append(el);
  };

  function openFavSheet(tab) {
    const sheet = favSheet();
    if (!sheet || !planner.config.paid) return;
    if (tab === 'settings' || tab === 'fav') fav.tab = tab;
    // Already open (not sliding out): just the tab.
    if (sheet.open && sheet.classList.contains('is-open')) {
      showPlanTab(fav.tab);
      return;
    }
    fav.dirty = false;
    fav.hiddenOpen = false;
    fav.query = '';
    fav.expanded = new Set();
    const q = sheet.querySelector('[data-vhp-fav-q]');
    if (q) q.value = '';
    closeFavMenu();
    renderFavSheet();
    renderSettings();
    const scroll = $('[data-vhp-fav-scroll]');
    if (scroll) scroll.scrollTop = 0;
    setDialogOpen(sheet, true);
    moveToastIntoFav();
    sheet.querySelector('#vhp-fav-title')?.focus({ preventScroll: true });
  }

  function closeFavSheet() {
    const sheet = favSheet();
    closeFavMenu();
    if (sheet?.open) setDialogOpen(sheet, false);
  }

  // ---------- ⋯ / frequency menu ----------
  function closeFavMenu() {
    const menu = $('[data-vhp-fav-menu]');
    if (menu) {
      menu.hidden = true;
      menu.replaceChildren();
    }
    fav.menu?.anchor?.setAttribute('aria-expanded', 'false');
    fav.menu = null;
  }

  const openFavMenu = (anchor, kind, id) => {
    const menu = $('[data-vhp-fav-menu]');
    const panel = $('[data-vhp-fav-panel]');
    if (!menu || !panel || !anchor) return;
    if (fav.menu?.anchor === anchor) {
      closeFavMenu();
      return;
    }
    closeFavMenu();
    const item = favoriteItems().find((row) => row.id === id);
    if (!item) return;
    // How often first (the reason to tap a favorite here), then view / remove.
    const entries = [
      ...['often', 'normal', 'pause'].map((key) => ({
        label: FAV_FREQ_LABEL[key],
        data: { vhpFavFreq: key, vhpFavId: id },
        on: favFreqOf(id) === key,
        role: 'menuitemradio',
      })),
      { sep: true },
      item.handle
        ? {
            label: tr('common.view_recipe'),
            data: { vhpRecipeOpen: item.handle, vhpRecipeScale: '1', vhpRecipeTitle: item.title || '' },
          }
        : null,
      { label: tr('planner.fav_remove'), data: { vhpFavRemove: id } },
      { label: tr('planner.fav_hide'), data: { vhpFavHide: id }, danger: true },
    ].filter(Boolean);
    menu.replaceChildren(
      ...entries.map((entry) => {
        if (entry.sep) {
          const sep = document.createElement('hr');
          sep.className = 'vhp-fav-menu__sep';
          return sep;
        }
        const btn = favButton('vhp-fav-menu__item', entry.label, entry.data);
        btn.setAttribute('role', entry.role || 'menuitem');
        if (entry.role) btn.setAttribute('aria-checked', entry.on ? 'true' : 'false');
        btn.classList.toggle('is-on', Boolean(entry.on));
        btn.classList.toggle('is-danger', Boolean(entry.danger));
        return btn;
      })
    );
    menu.hidden = false;
    const p = panel.getBoundingClientRect();
    const a = anchor.getBoundingClientRect();
    menu.style.right = `${Math.max(12, p.right - a.right)}px`;
    const below = a.bottom - p.top + 6;
    const h = menu.offsetHeight;
    menu.style.top = `${below + h > p.height - 12 ? Math.max(12, a.top - p.top - h - 6) : below}px`;
    anchor.setAttribute('aria-expanded', 'true');
    fav.menu = { anchor, kind, id };
    menu.querySelector('button')?.focus({ preventScroll: true });
  };

  // ---------- actions ----------
  const setFavFreq = (id, freq) => {
    if (!['often', 'normal', 'pause'].includes(freq) || favFreqOf(id) === freq) return;
    const next = { ...(state.favFreq || {}) };
    if (freq === 'normal') delete next[id];
    else next[id] = freq;
    state.favFreq = next;
    markFavDirty();
    renderFavSheet();
  };

  const showFavToast = (message, undo) => {
    regenUndo = null;
    swapUndo = null;
    favUndo = undo;
    showWeekToast(message);
  };

  const removeFavorite = (id, { hide } = {}) => {
    const items = likeItems();
    const item = items.find((row) => row.id === id);
    if (!item) return;
    const before = {
      likes: items.slice(),
      freq: { ...(state.favFreq || {}) },
      hidden: state.hidden?.items || [],
    };
    state.likes.items = items.filter((row) => row.id !== id);
    if (state.undo?.action === 'like' && state.undo.item?.id === id) state.undo = null;
    plannerEvents('retract', 'recipe_liked', id);
    const freq = { ...(state.favFreq || {}) };
    delete freq[id];
    state.favFreq = freq;
    if (hide) {
      const snap = {
        id,
        slot: item.slot,
        title: item.title || '',
        image: item.image || '',
        kcal: item.kcal ?? null,
        protein: item.protein ?? null,
        at: new Date().toISOString(),
      };
      state.hidden = normalizeHidden({ items: [...(state.hidden?.items || []).filter((row) => row.id !== id), snap] });
    }
    markFavDirty();
    closeFavMenu();
    renderFavSheet();
    render();
    showFavToast(hide ? tr('planner.hidden') : tr('planner.fav_removed'), before);
  };

  const restoreHidden = (id) => {
    const list = state.hidden?.items || [];
    if (!list.some((item) => item.id === id)) return;
    state.hidden = { items: list.filter((item) => item.id !== id) };
    markFavDirty();
    renderFavSheet();
  };

  // Week toast "Rückgängig" after remove / hide in the sheet.
  const applyFavUndo = () => {
    const snap = favUndo;
    favUndo = null;
    if (!snap) return false;
    state.likes.items = snap.likes;
    state.favFreq = snap.freq;
    state.hidden = { items: snap.hidden };
    hideRegenToast();
    scheduleFavSave();
    renderFavSheet();
    render();
    return true;
  };

  // A free slot for a favorite: today → Sunday, then the earlier days. Prefers an auto-filled meal, then any
  // other non-favorite; never a locked meal or a day that already has this recipe.
  const favFreeSlot = (item) => {
    const today = todayIndex();
    const order = Array.from({ length: WEEK_LEN }, (_, i) => (today + i) % WEEK_LEN);
    const liked = new Set(likeItems().map((row) => row.id));
    const tiers = [(meal) => meal.generated, (meal) => !liked.has(mealProductId(meal)), () => true];
    for (const tier of tiers) {
      for (const dayIndex of order) {
        const meals = state.week?.[dayIndex]?.meals || [];
        if (meals.some((meal) => mealProductId(meal) === item.id)) continue;
        const meal = orderMeals(meals.slice()).find((row) => !row.locked && row.catalog === item.slot && tier(row));
        if (meal) return { dayIndex, occasion: meal.id, label: occLabel(meal) };
      }
    }
    return null;
  };

  const planFavorite = async (id) => {
    const item = favoriteItems().find((row) => row.id === id);
    if (!item || !weekHasPlan(state.week)) return;
    const spot = favFreeSlot(item);
    if (!spot) {
      showFavToast(tr('planner.no_free_spot'), null);
      return;
    }
    let card = hydrateSwapCard(findCatalogCard(id, item.slot));
    // Full card (ingredients for the shopping list) from the index when the pool isn't loaded.
    if (!card?.ingredients && planner.index) {
      try {
        const indexCard = (await planner.index(item.slot)).find((row) => productId(row.id) === id);
        if (indexCard) card = { ...indexCard, slot: item.slot };
      } catch (e) { /* the like snapshot still plans */ }
    }
    if (!card) return;
    favUndo = null;
    placeCardInWeek({
      dayIndex: spot.dayIndex,
      occasion: spot.occasion,
      card,
      toast: tr('planner.planned_at', { day: DAY_LABEL[spot.dayIndex], meal: spot.label || SLOT_LABEL[item.slot] || '' }),
      src: 'week',
    });
    renderFavSheet();
  };

  const runFavRegen = async () => {
    if (weekGenerating || !weekHasPlan(state.week)) return;
    weekGenerating = true;
    weekError = false;
    closeFavSheet();
    render();
    try {
      regenUndo = { scope: 'week', snapshot: cloneJson(state.week) };
      favUndo = null;
      await generateWeek({ keepLocks: true, avoidCurrent: false });
      fav.dirty = false;
      showRegenToast('week');
      persist();
      scheduleWeekSave();
      flushProfile();
      weekReveal = 'in';
    } catch (e) {
      console.error('[vhp-planner] favorites regen failed', e);
      weekError = true;
      regenUndo = null;
      hideRegenToast();
    } finally {
      weekGenerating = false;
      render();
    }
  };

  const openFavoritesInRecipes = () => {
    closeFavSheet();
    openRecipes();
    if (inRecipes()) openSet({ kind: 'likes', id: 'likes', title: tr('planner.favorites') });
  };

  // ---------- swipe left to remove ----------
  // Card follows the finger 1:1 up to the action width, then with resistance. Release: a flick or > 44 px opens
  // (96 px), past ~55 % of the row deletes right away (iOS-style full swipe), anything else closes.
  const FAV_SWIPE_FULL = 0.55;
  const FAV_FLICK = 0.35; // px/ms
  const favRowOf = (card) => card?.closest('.vhp-fav-row');
  const setFavRowX = (card, x, animate) => {
    const row = favRowOf(card);
    card.classList.toggle('is-settling', Boolean(animate));
    card.style.transform = x ? `translate3d(${x}px, 0, 0)` : '';
    if (!row) return;
    window.clearTimeout(row.vhpUnswipe);
    if (x < 0) row.classList.add('is-swiped');
    else if (animate && motionOk()) {
      // Keep the rust layer until the card has slid back over it.
      row.vhpUnswipe = window.setTimeout(() => {
        if (!card.style.transform) row.classList.remove('is-swiped');
      }, 340);
    } else row.classList.remove('is-swiped');
    // Action label fades in with the reveal; at a full swipe it slides along with the card edge.
    const width = row.offsetWidth || 1;
    row.style.setProperty('--fav-reveal', String(Math.min(1, -x / FAV_SWIPE_OPEN)));
    row.classList.toggle('is-full', -x > width * FAV_SWIPE_FULL);
  };
  const closeFavRow = () => {
    if (fav.openRow) setFavRowX(fav.openRow, 0, true);
    fav.openRow = null;
  };
  // Rubber band beyond the action width (and a little to the right when already open).
  const favDragX = (raw, width) => {
    if (raw > 0) return raw * 0.15;
    const open = -FAV_SWIPE_OPEN;
    if (raw >= open) return raw;
    const over = open - raw;
    const max = width * 0.9 - FAV_SWIPE_OPEN;
    return open - Math.min(max, over * 0.85);
  };

  // Removes with a slide-out + height collapse, then updates state (and shows the undo toast).
  const removeFavoriteAnimated = (id, opts) => {
    const row = favSheet()?.querySelector(`[data-vhp-fav-row="${CSS.escape(String(id))}"]`);
    if (!row || !motionOk() || fav.removing) {
      removeFavorite(id, opts);
      return;
    }
    fav.removing = true;
    closeFavMenu();
    const card = row.querySelector('[data-vhp-fav-card]');
    row.style.height = `${row.offsetHeight}px`;
    void row.offsetHeight;
    if (card) setFavRowX(card, -row.offsetWidth, true);
    row.classList.add('is-leaving');
    requestAnimationFrame(() => {
      row.style.height = '0px';
    });
    window.setTimeout(() => {
      fav.removing = false;
      fav.openRow = null;
      removeFavorite(id, opts);
    }, 300);
  };

  const bindFavSheet = () => {
    const sheet = favSheet();
    if (!sheet) return;

    sheet.addEventListener('pointerdown', (event) => {
      const card = event.target.closest('[data-vhp-fav-card]');
      // The row itself is a button (it opens the menu); other buttons on it never start a swipe.
      if (!card || fav.removing || event.target.closest('button:not(.vhp-fav-row__open)') || event.button > 0) return;
      if (fav.openRow && fav.openRow !== card) closeFavRow();
      const start = fav.openRow === card ? -FAV_SWIPE_OPEN : 0;
      const now = performance.now();
      fav.drag = {
        card,
        id: event.pointerId,
        x0: event.clientX,
        y0: event.clientY,
        start,
        x: start,
        on: false,
        width: favRowOf(card)?.offsetWidth || 320,
        lastX: event.clientX,
        lastT: now,
        vx: 0,
        raf: 0,
      };
    });
    sheet.addEventListener('pointermove', (event) => {
      const d = fav.drag;
      if (!d || event.pointerId !== d.id) return;
      const dx = event.clientX - d.x0;
      const dy = event.clientY - d.y0;
      if (!d.on) {
        // Decide once: vertical → let the list scroll; horizontal → this row.
        if (Math.abs(dy) > 6 && Math.abs(dy) >= Math.abs(dx)) {
          fav.drag = null;
          return;
        }
        if (Math.abs(dx) < 6) return;
        d.on = true;
        d.x0 += Math.sign(dx) * 6; // starts from the dead-zone edge: no jump, no lost movement
        favRowOf(d.card)?.classList.add('is-dragging');
        try {
          d.card.setPointerCapture(d.id);
        } catch (e) { /* ignore */ }
      }
      const now = performance.now();
      const dt = now - d.lastT;
      if (dt > 0) d.vx = 0.7 * ((event.clientX - d.lastX) / dt) + 0.3 * d.vx;
      d.lastX = event.clientX;
      d.lastT = now;
      d.x = favDragX(d.start + (event.clientX - d.x0), d.width);
      if (!d.raf) {
        d.raf = requestAnimationFrame(() => {
          d.raf = 0;
          if (fav.drag === d) setFavRowX(d.card, d.x, false);
        });
      }
    });
    const endDrag = (event) => {
      const d = fav.drag;
      if (!d || event.pointerId !== d.id) return;
      fav.drag = null;
      if (d.raf) cancelAnimationFrame(d.raf);
      if (!d.on) return;
      favRowOf(d.card)?.classList.remove('is-dragging');
      // The click that ends a drag is swallowed.
      fav.justSwiped = true;
      window.setTimeout(() => {
        fav.justSwiped = false;
      }, 60);
      const stale = performance.now() - d.lastT > 90; // finger rested before lifting → no flick
      const vx = event.type === 'pointercancel' || stale ? 0 : d.vx;
      if (-d.x > d.width * FAV_SWIPE_FULL && event.type !== 'pointercancel') {
        removeFavoriteAnimated(d.card.dataset.vhpFavCard);
        return;
      }
      const open = vx < -FAV_FLICK || (vx <= FAV_FLICK && d.x < -FAV_SWIPE_SNAP);
      setFavRowX(d.card, open ? -FAV_SWIPE_OPEN : 0, true);
      fav.openRow = open ? d.card : null;
    };
    sheet.addEventListener('pointerup', endDrag);
    sheet.addEventListener('pointercancel', endDrag);
    // Scrolling the list closes an open row.
    sheet.querySelector('[data-vhp-fav-scroll]')?.addEventListener(
      'scroll',
      () => {
        if (fav.openRow && !fav.drag) closeFavRow();
      },
      { passive: true }
    );

    sheet.addEventListener('click', (event) => {
      const t = event.target;
      if (fav.justSwiped) return;
      if (t === sheet) {
        closeFavSheet();
        return;
      }
      const menuAnchor = t.closest('[data-vhp-fav-more]');
      if (fav.menu && !t.closest('[data-vhp-fav-menu]') && menuAnchor !== fav.menu.anchor) {
        closeFavMenu();
        if (!menuAnchor) return;
      }
      if (fav.openRow && !t.closest('[data-vhp-fav-remove]')) {
        closeFavRow();
        return;
      }
      if (t.closest('[data-vhp-fav-close]')) closeFavSheet();
      else if (t.closest('[data-vhp-fav-mix-opt]')) {
        const mix = t.closest('[data-vhp-fav-mix-opt]').dataset.vhpFavMixOpt;
        if (FAV_MIXES.includes(mix) && mix !== state.favMix) {
          state.favMix = mix;
          markFavDirty();
          renderFavSheet();
        }
      } else if (t.closest('[data-vhp-fav-freq]')) {
        const btn = t.closest('[data-vhp-fav-freq]');
        closeFavMenu();
        setFavFreq(btn.dataset.vhpFavId, btn.dataset.vhpFavFreq);
      } else if (t.closest('[data-vhp-fav-all]')) {
        fav.expanded.add(t.closest('[data-vhp-fav-all]').dataset.vhpFavAll);
        renderFavSheet();
      } else if (t.closest('[data-vhp-fav-more]')) {
        const btn = t.closest('[data-vhp-fav-more]');
        openFavMenu(btn, 'more', btn.dataset.vhpFavMore);
      } else if (t.closest('[data-vhp-fav-remove]')) {
        removeFavoriteAnimated(t.closest('[data-vhp-fav-remove]').dataset.vhpFavRemove);
      } else if (t.closest('[data-vhp-fav-hide]')) {
        removeFavoriteAnimated(t.closest('[data-vhp-fav-hide]').dataset.vhpFavHide, { hide: true });
      } else if (t.closest('[data-vhp-fav-restore]')) {
        restoreHidden(t.closest('[data-vhp-fav-restore]').dataset.vhpFavRestore);
      } else if (t.closest('[data-vhp-fav-hidden-toggle]')) {
        fav.hiddenOpen = !fav.hiddenOpen;
        renderFavHidden();
      } else if (t.closest('[data-vhp-fav-plan]')) {
        planFavorite(t.closest('[data-vhp-fav-plan]').dataset.vhpFavPlan);
      } else if (t.closest('[data-vhp-plan-tab]')) {
        showPlanTab(t.closest('[data-vhp-plan-tab]').dataset.vhpPlanTab);
      } else if (t.closest('[data-vhp-fav-regen]')) {
        if (settingsDirty() && weekHasPlan(state.week)) {
          closeFavSheet();
          fav.dirty = false;
          runSettingsRegen();
        } else runFavRegen();
      } else if (t.closest('[data-vhp-tour-replay]')) {
        // assets/vhp-planner-tour.js restarts the tour on the Wochenplan.
        closeFavSheet();
      } else if (t.closest('[data-vhp-fav-find]')) {
        openFavoritesInRecipes();
      } else if (t.closest('[data-vhp-fav-discover]')) {
        closeFavSheet();
        openRecipes();
      } else if (t.closest('[data-vhp-recipe-open]')) {
        // "Rezept ansehen" from the ⋯ menu: the funnel handler opens the recipe sheet on top.
        closeFavMenu();
      }
    });

    sheet.querySelector('[role="tablist"]')?.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      showPlanTab(fav.tab === 'settings' ? 'fav' : 'settings');
      sheet.querySelector(`[data-vhp-plan-tab="${fav.tab}"]`)?.focus();
    });

    sheet.querySelector('[data-vhp-fav-q]')?.addEventListener('input', (event) => {
      fav.query = event.target.value;
      closeFavMenu();
      renderFavSheet();
    });

    sheet.addEventListener('cancel', (event) => {
      if (!fav.menu) return;
      event.preventDefault();
      const anchor = fav.menu.anchor;
      closeFavMenu();
      anchor?.focus({ preventScroll: true });
    });
    sheet.addEventListener('close', () => {
      if (sheet.open) return;
      sheet.classList.remove('is-dragging', 'is-open');
      const panel = sheet.querySelector('.vhp-sheet__panel');
      if (panel) panel.style.transform = '';
      closeFavMenu();
      fav.openRow = null;
      restoreToast();
      if (state.screen === 'week') render();
    });
    window.vhpSheet?.bindDrag(sheet, closeFavSheet);
  };

  const openWeek = async () => {
    if (!planner.config.paid) return;
    if (!funnel.querySelector('[data-vhp-screen="week"]')) return;
    closeSwapSheet();
    closeSettingsEdit();
    leaveRecipes();
    let lastWeek = null;
    // Right after checkout (same browser) the previewed week is exactly the preview, in its slot (this or next week).
    const handed = takePreviewWeek();
    // Next week stays empty until it is planned (empty state); this week is always planned.
    if (!weekHasPlan(state.week) && !viewingNextWeek()) {
      // A new calendar week is planned automatically; the toast offers last week again instead.
      if (handed !== 'this') {
        lastWeek = weekHasPlan(state.prevWeek?.week) ? repeatOf(state.prevWeek.week) : null;
        await generateWeek({ keepLocks: false });
      }
      scheduleWeekSave();
    }
    if (handed || state.pendingWeekFlush) flushWeek();
    if (state.screen === 'week') {
      persist();
      render();
    } else if (inPaidApp()) show('week', null, 'fade');
    else forward('week', null);
    // Bought from Wednesday on: they land on the week they saw (this week stays planned one tap back).
    if (handed === 'next') {
      showWeekOf(mondayIso(1), 0);
      return;
    }
    if (lastWeek) {
      swapUndo = null;
      favUndo = null;
      regenUndo = { scope: 'week', snapshot: lastWeek };
      showWeekToast(tr('planner.new_week'), { action: tr('planner.repeat_last_week'), ms: 10000 });
    }
  };

  // ---------- weeks: this week + next week ----------

  const viewingNextWeek = () => Boolean(planner.config.paid) && state.weekStart === mondayIso(1);
  // Monday of the week on screen (paid), else this week.
  const shownMonday = () =>
    planner.config.paid && ISO_DAY_RE.test(String(state.weekStart || '')) ? dateOfIso(state.weekStart) : weekMonday();

  // Another week planned again: same meals and portions, unlocked, "Automatisch ergänzt" against current likes.
  const repeatOf = (week) => {
    const favoriteIds = new Set(likeItems().map((item) => item.id));
    return cloneJson(week).map((day) => ({
      meals: orderMeals(
        (day?.meals || []).map((meal) => ({
          ...meal,
          locked: false,
          generated: !favoriteIds.has(productId(meal.pick?.id)) && !isCustomId(meal.pick?.id),
        }))
      ),
    }));
  };

  const weekdayToday = () => (new Date().getDay() + 6) % 7;
  // The › to next week nudges until next week has been opened once (per browser).
  const NEXT_SEEN_KEY = 'vhp-week-next-seen';
  const nextWeekSeen = () => {
    try {
      return localStorage.getItem(NEXT_SEEN_KEY) === '1';
    } catch (error) {
      return false;
    }
  };
  const markNextWeekSeen = () => {
    try {
      localStorage.setItem(NEXT_SEEN_KEY, '1');
    } catch (error) {
      /* private mode: keeps nudging, harmless */
    }
  };

  // Switches the week on screen (this ↔ next). The other week moves to weekAlt with its unsaved flag.
  // Undo toasts belong to the week they were made in, so they go.
  // `day` picks the day to land on (default: today in this week, Monday in the next).
  const showWeekOf = (start, day) => {
    const here = state.weekStart || mondayIso(0);
    if (start === here || weekGenerating) return;
    if (start !== mondayIso(0) && start !== mondayIso(1)) return;
    hideRegenToast();
    regenUndo = null;
    swapUndo = null;
    favUndo = null;
    const other = state.weekAlt?.start === start ? state.weekAlt : null;
    state.weekAlt = weekHasPlan(state.week) ? { start: here, week: state.week, pending: state.pendingWeekFlush } : null;
    state.week = other ? other.week : null;
    state.weekStart = start;
    state.pendingWeekFlush = Boolean(other?.pending);
    state.weekDay = day ?? (start === mondayIso(0) ? weekdayToday() : 0);
    weekDayDir = start > here ? 1 : -1;
    weekStripDir = weekDayDir;
    if (start === mondayIso(1)) markNextWeekSeen();
    shopList = { items: [], pantry: [], missing: [], days: [] };
    shopEdit = false;
    persist();
    render();
  };

  const pickWeekDay = (index) => {
    if (index === state.weekDay) return;
    weekDayDir = index > state.weekDay ? 1 : -1;
    state.weekDay = index;
    persist();
    render();
  };

  // One day forward / back; past Sunday into next week, before Monday back into this one.
  const canStepWeekDay = (dir) => {
    const index = state.weekDay + dir;
    if (index >= 0 && index < WEEK_LEN) return true;
    return planner.config.paid && (dir > 0 ? !viewingNextWeek() : viewingNextWeek());
  };
  const stepWeekDay = (dir) => {
    const index = state.weekDay + dir;
    if (index >= 0 && index < WEEK_LEN) pickWeekDay(index);
    else if (canStepWeekDay(dir)) showWeekOf(mondayIso(dir > 0 ? 1 : 0), dir > 0 ? 0 : WEEK_LEN - 1);
  };

  // Next week: plan it fresh (likes + Mix, holding back this week's mains), or repeat this week.
  const planNextWeek = async ({ repeat = false } = {}) => {
    if (weekGenerating) return;
    if (!viewingNextWeek()) showWeekOf(mondayIso(1));
    if (!viewingNextWeek() || weekHasPlan(state.week)) return;
    if (repeat) {
      if (!weekHasPlan(state.weekAlt?.week)) return;
      state.week = repeatOf(state.weekAlt.week);
      markWeekApplied();
    } else {
      weekGenerating = true;
      weekError = false;
      render();
      try {
        await generateWeek({ keepLocks: false });
      } catch (e) {
        console.error('[vhp-planner] next week failed', e);
        weekError = true;
      } finally {
        weekGenerating = false;
      }
    }
    if (!weekHasPlan(state.week)) {
      render();
      return;
    }
    weekReveal = 'forward';
    persist();
    scheduleWeekSave();
    flushWeek();
    render();
  };

  // Calendar week changed while the page was open (or the server said so): re-sort the weeks and plan
  // this week if nobody did.
  const checkWeekRollover = () => {
    if (!planner.config.paid || weekRolledFor === mondayIso(0)) return;
    rollWeeks();
    persist();
    if (!inPaidApp()) return;
    if (!weekHasPlan(state.week)) openWeek();
    else render();
  };

  const openShop = async () => {
    if (planner.config.paid && !weekHasPlan(state.week) && viewingNextWeek()) showWeekOf(mondayIso(0));
    if (!planner.config.paid || !weekHasPlan(state.week)) return;
    if (!funnel.querySelector('[data-vhp-screen="shop"]')) return;
    usage('use_shopping_list');
    closeSwapSheet();
    closeSettingsEdit();
    leaveRecipes();
    shopCopied = false;
    shopEdit = false;
    shopLoading = true;
    if (state.screen !== 'shop') {
      if (inPaidApp()) show('shop', null, 'fade');
      else forward('shop', null);
    } else render();
    try {
      await ensureShopRecipes();
      shopList = buildShoppingList();
    } catch (e) {
      console.error('[vhp-planner] shopping list failed', e);
      shopList = buildShoppingList();
    } finally {
      shopLoading = false;
      render();
    }
  };

  const BUILD_STEP_MS = 600;
  // Last step fades in for 0.4s (vhp-build__steps li), then holds briefly before the preview.
  const BUILD_MIN_MS = BUILD_STEP_MS * 3 + 400 + 700;

  let exampleBuilding = false;
  // Story v2, 3.1: the summary with "Gedrückt halten" is up (the week builds meanwhile); buildRelease starts the
  // checklist once it's held.
  let buildHolding = false;
  let buildRelease = null;
  let buildRun = 0; // a createPlan run left for a summary edit is stale once this moves on
  let buildStep = 0;
  let buildTimers = [];

  const clearBuildTimers = () => {
    buildTimers.forEach((id) => window.clearTimeout(id));
    buildTimers = [];
  };

  const openPreview = async () => {
    if (exampleBuilding) return;
    // Sörens Woche (docs/SOEREN_WEEK.md): her stored week is his; a changed basis rebuilds it the same way, never as
    // the likes-planned week.
    const key = soerenWeekOn() ? `${exampleKey()}|soeren:${soerenHandle()}` : exampleKey();
    if (state.preview?.key === key && state.preview.day?.meals?.length) {
      if (state.screen === 'preview' && !gated()) {
        persist();
        render();
        return;
      }
      forward('preview', null);
      return;
    }
    if (soerenWeekOn()) {
      await buildSoerenWeek();
      return;
    }
    if (!state.kcal) return;
    exampleBuilding = true;
    render();
    try {
      await buildPreview();
      persist();
      if (state.screen !== 'preview' || gated()) forward('preview', null);
    } catch (e) {
      console.error('[vhp-planner] week preview failed', e);
      step('planner_error', 'no_plan');
    } finally {
      exampleBuilding = false;
      render();
    }
  };

  // The day after the preview's open day (the gift slide scratches it free; then the preview shows it open too).
  const bonusDay = (preview = state.preview) => {
    const open = Number(preview?.open);
    const index = open + 1;
    if (!Number.isInteger(open) || index >= WEEK_LEN) return null;
    const meals = (preview.week?.[index]?.meals || []).filter((meal) => meal?.pick);
    return meals.length ? { index, meals, totals: preview.days?.[index] || null } : null;
  };
  // The gift is the discount when the section has one set up (and this browser never had it), else the second day.
  const giftIsReward = () => Boolean(REWARD_CFG) && (!state.scratched || Boolean(state.reward));
  const giftReady = () => storyActive() && !state.scratched && (giftIsReward() || (!gated() && Boolean(bonusDay())));
  // The second-day gift opens a day of the preview, so it comes before it; the discount comes with the paywall tap.
  // Planner landers (docs/PLANNER_PAGE_FUNNEL.md 3.1): the paywall right after the hold, with the gift on it, and the
  // free preview one tap away (its link, or back from the plans).
  // Theme setting "Abo-Screen direkt nach dem Plan": 'landers' (default, visits that start on the planner page), 'all'
  // (every non-subscriber, once the landers' read says so) or 'off' (an older page's true / false still reads right).
  const pwMode = () => {
    const raw = planner.config.paywallFirst;
    if (raw === 'all' || raw === 'off') return raw;
    return raw === false ? 'off' : 'landers';
  };
  // Who gets paywall first and its parts (the free-day link, "Noch nicht? Woche per Mail sichern").
  const pwFirstScope = () =>
    pwMode() === 'all' ? storyActive() && !planner.config.paid : pwMode() === 'landers' && plannerLander();
  const paywallFirst = () => pwFirstScope() && !gated() && membershipPlans().length > 0;
  // The fallback (3.3, setting 'off'): planner landers get the preview first, with the week on top of the free day and
  // the gift named on the bar.
  const previewWeekFirst = () => plannerLander() && pwMode() === 'off' && !gated();
  // The second-day scratch slide is off (Maxim, 2026-10-19): after the build straight to the plans or the preview.
  const afterBuild = () => (paywallFirst() ? 'subscribe' : 'preview');
  const goAfterBuild = () => {
    const next = afterBuild();
    if (next === 'subscribe') {
      if (!state.subscribePlanId) state.subscribePlanId = defaultSubscribePlanId();
      grantGift();
      state.pwFirst = true;
      step('pw_first', 'shown');
    }
    forward(next, null);
  };

  // skip: "Überspringen – ich wähle für dich aus" under the deck (setup only): plans with whatever was liked so far.
  // again: back from a summary edit (3.1 rows), the summary and the build once more even when nothing changed.
  const createPlan = async ({ skip = false, again = false } = {}) => {
    if ((!planReady() && !((skip || again) && !planner.config.paid)) || exampleBuilding || weekGenerating) return;
    if (planner.config.paid) {
      openWeek();
      return;
    }
    if (skip) step('deck_skipped');
    if (!again) step('plan_ready'); // "Plan erstellen" pressed with a plan-ready deck, or the deck skipped
    if (state.editFrom === 'summary') state.editFrom = null; // the deck's "Plan erstellen" ends a likes edit
    const key = exampleKey();
    const already = state.preview?.key === key && state.preview.day?.meals?.length;
    if (already && !again) {
      if (state.screen !== 'preview' && state.screen !== 'subscribe') goAfterBuild();
      return;
    }
    if (!state.kcal) return;
    clearBuildTimers();
    buildStep = 0;
    let started = Date.now();
    exampleBuilding = true;
    // Story v2: their summary and "Gedrückt halten" first; the week is built meanwhile, the checklist runs after.
    const hold = storyActive() && Boolean(storyPlayer) && Boolean($('[data-vhp-hold]'));
    buildHolding = hold;
    let released = !hold;
    let built = false;
    const runSteps = () => {
      started = Date.now();
      [1, 2, 3].forEach((i) => {
        buildTimers.push(window.setTimeout(() => {
          buildStep = i;
          render();
        }, BUILD_STEP_MS * i));
      });
    };
    const finishBuild = () => {
      const wait = Math.max(0, BUILD_MIN_MS - (Date.now() - started));
      buildTimers.push(window.setTimeout(() => {
        exampleBuilding = false;
        if (state.screen === 'building') goAfterBuild();
        else render();
      }, wait));
    };
    buildRelease = () => {
      if (released || state.screen !== 'building') return;
      released = true;
      buildHolding = false;
      step('story_hold_done');
      runSteps();
      render();
      if (built) finishBuild();
    };
    const run = ++buildRun;
    forward('building', null);
    if (!hold) runSteps();
    render();
    try {
      await buildPreview();
      if (run !== buildRun) return; // left for a summary edit meanwhile: the run that comes back builds anew
      persist();
    } catch (e) {
      if (run !== buildRun) return;
      console.error('[vhp-planner] week preview failed', e);
      step('planner_error', 'no_plan');
      exampleBuilding = false;
      buildHolding = false;
      clearBuildTimers();
      if (state.screen === 'building') show('swipe', null, 'fade');
      render();
      return;
    }
    built = true;
    if (released) finishBuild();
  };

  let checkingOut = false;
  let checkoutError = false;
  // 'save' (profile flush) → 'cart' → 'done' (cart ready, Shopify's checkout loading); '' when idle.
  let checkoutStage = '';

  // Only one membership in the cart: someone who went to checkout with "Jährlich", came back and picks
  // "Monatlich" would otherwise pay for both. Removes every line of a membership variant (any plan, any
  // quantity) and leaves the rest of the cart alone. Best effort: a failed read still lets the add go through.
  const dropMembershipLines = async () => {
    const variants = new Set(membershipPlans().map((plan) => String(plan.variantId)));
    if (!variants.size) return;
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      const updates = {};
      (cart.items || []).forEach((item) => {
        if (variants.has(String(item.variant_id))) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
    } catch (e) {
      console.error('[vhp-planner] cart cleanup failed', e);
    }
  };

  // The planner consent between the buy tap and Shopify (sections/meal-planner.liquid, dialog data-vhp-consent-dialog),
  // only while it isn't given (since 2026-10-18 just title, consent line and button). Its button comes back to
  // startCheckout (bridgePassed).
  let bridgePassed = false;
  const renderBridge = () => {
    const dlg = $('[data-vhp-consent-dialog]');
    if (!dlg) return;
    dlg.querySelectorAll('[data-vhp-bridge-consent]').forEach((el) => (el.hidden = state.consentPlanner));
    const ok = dlg.querySelector('[data-vhp-consent-ok]');
    if (ok && !checkingOut) {
      ok.dataset.idle = state.consentPlanner ? tr('planner.bridge_go') : tr('planner.bridge_agree');
      paintCheckoutBtn(ok, ok.dataset.idle);
    }
  };

  // The visit's context on the order (docs/PLANNER_PAGE_FUNNEL.md 0.3): cart attributes end up on the order
  // (customAttributes), so orders can be read per landing page, entry and in-app browser. Only with analytics consent
  // (vhpPlannerEvents.context is null without it); nothing about the person; never holds the checkout up over 1.5 s.
  const writeVisitAttributes = async () => {
    const ctx = window.vhpPlannerEvents?.context?.();
    if (!ctx) return;
    const attributes = {
      _vhp_land: ctx.land || '',
      _vhp_ent: ctx.ent || '',
      _vhp_iab: ctx.iab ? '1' : '0',
      _vhp_fresh: ctx.fresh ? '1' : '0',
      // The first screen of the start this order belongs to (monday / goal / preset, up to 7 days back).
      _vhp_door: ctx.door || '',
    };
    try {
      await Promise.race([
        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes }),
        }),
        new Promise((resolve) => window.setTimeout(resolve, 1500)),
      ]);
    } catch (e) {
      /* the order just goes without them */
    }
  };

  // Guest checkout (docs/GUEST_CHECKOUT.md, 2026-10-19): without an account the answers live only in this browser. The
  // buy tap stores them as a 30-day draft (the API's handoff route, purpose checkout: no address, never body data) and
  // puts its token on the order (_vhp_week), so the order mail's link sets up the account on any device. A service
  // attribute, not analytics: written without analytics consent. Never holds the checkout up over 1.5 s.
  const writeCheckoutDraft = async () => {
    if (planner.config.customerId || !planner.config.apiBase) return;
    const draft = draftFields();
    if (!GOAL_DELTA[draft.goal] || !(draft.kcal >= KCAL_MIN && draft.kcal <= KCAL_MAX) || !SEED_RE.test(String(draft.seed || ''))) return;
    const consentAt = Number.isFinite(Date.parse(state.consentAt || '')) ? new Date(state.consentAt).toISOString() : null;
    const work = (async () => {
      const res = await fetch(`${planner.config.apiBase}/api/week-draft/handoff`, {
        method: 'POST',
        credentials: 'omit',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({ draft: { ...draft, consentAt }, purpose: 'checkout' }),
      });
      if (!res.ok) return;
      const body = await res.json();
      if (!body?.token) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _vhp_week: body.token } }),
      });
    })().catch(() => {
      /* the order goes without it: on a new device the planner then starts with the setup */
    });
    await Promise.race([work, new Promise((resolve) => window.setTimeout(resolve, 1500))]);
  };

  const startCheckout = async () => {
    if (planner.config.paid || checkingOut) return;
    // The consent: the line above the button says the tap is it (docs/CR_AUDIT.md 5), so no dialog in between.
    // The dialog (renderBridge) stays wired for the classic paywall's checkbox path.
    if (!state.consentPlanner) {
      const line = $('[data-vhp-pw-consent]');
      if (line && !line.hidden) {
        bridgePassed = true;
        state.consentPlanner = true;
        state.consentAt = state.consentAt || new Date().toISOString();
        persist();
      } else if (!bridgePassed) {
        const dlg = $('[data-vhp-consent-dialog]');
        if (dlg && typeof dlg.showModal === 'function' && !dlg.open) {
          renderBridge();
          dlg.showModal();
          return;
        }
        if (!state.consentPlanner) return;
      }
    }
    if (!state.subscribePlanId) state.subscribePlanId = defaultSubscribePlanId();
    const plan = selectedSubscribePlan();
    if (!plan) return;
    checkingOut = true;
    checkoutError = false;
    const saves = Boolean(planner.config.customerId && planner.config.token);
    checkoutStage = saves ? 'save' : 'cart';
    state.consentAt = state.consentAt || new Date().toISOString();
    state.pendingFlush = true;
    state.awaitingPaid = true;
    state.awaitingPaidAt = new Date().toISOString();
    try {
      sessionStorage.removeItem(PAID_WAIT_KEY);
      sessionStorage.removeItem('vhp_paid_handover');
    } catch (e) { /* ignore */ }
    persist();
    render();
    if (saves) {
      await flushProfile();
      checkoutStage = 'cart';
      render();
    }
    try {
      await dropMembershipLines();
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: Number(plan.variantId),
              quantity: 1,
              selling_plan: Number(plan.id),
            },
          ],
        }),
      });
      if (!res.ok) throw new Error(String(res.status));
      await Promise.all([writeVisitAttributes(), writeCheckoutDraft()]);
      state.awaitingPaid = true;
      persist();
      step('checkout_clicked');
      if (plan.interval === 'year' || plan.interval === 'month') step('checkout_plan', plan.interval);
      // Only for a plan the offer covers: a yearly-only code on the monthly plan would show a "code not valid" error at checkout.
      const { offer } = planPrice(plan);
      const code = offer ? String(offerCode(offer)).trim() : '';
      // The check plays while the browser loads the checkout: no added wait.
      checkoutStage = 'done';
      render();
      location.href = code ? `/checkout?discount=${encodeURIComponent(code)}` : '/checkout';
    } catch (e) {
      console.error('[vhp-planner] checkout failed', e);
      state.awaitingPaid = false;
      state.awaitingPaidAt = null;
      checkoutError = true;
      checkingOut = false;
      checkoutStage = '';
      $('[data-vhp-consent-dialog]')?.close();
      render();
    }
  };

  // The tapped button is the progress: it fills while the plan is saved and the cart is set up, then pops a check.
  const CHECKOUT_STAGE_LABEL = { save: 'planner.checkout_saving', cart: 'planner.checkout_cart', done: 'planner.checkout_ready' };
  // stage: '' paints the idle label (the paywall button while the consent dialog over it shows the progress).
  const paintCheckoutBtn = (btn, idle, { stage = checkoutStage } = {}) => {
    if (!btn) return;
    if (!stage) {
      if (btn.classList.contains('is-busy')) {
        btn.classList.remove('is-busy');
        delete btn.dataset.stage;
        btn.removeAttribute('aria-busy');
      }
      if (btn.textContent !== idle) btn.textContent = idle;
      return;
    }
    if (btn.dataset.stage === stage) return;
    if (!btn.classList.contains('is-busy')) {
      btn.textContent = '';
      const fill = document.createElement('span');
      fill.className = 'vhp-btn__fill';
      btn.append(fill);
      void btn.offsetWidth; // start the fill from 0
      btn.classList.add('is-busy');
      btn.setAttribute('aria-busy', 'true');
    }
    btn.dataset.stage = stage;
    btn.querySelector('.vhp-btn__busy')?.remove();
    const label = document.createElement('span');
    label.className = 'vhp-btn__busy';
    if (stage === 'done') {
      label.insertAdjacentHTML(
        'afterbegin',
        '<span class="vhp-btn__check" aria-hidden="true"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 8.5l3 3 6-7"/></svg></span>',
      );
    }
    label.append(tr(CHECKOUT_STAGE_LABEL[stage]));
    btn.append(label);
  };
  // Back from the checkout via the back/forward cache: the page comes back as it was left, mid-checkout. A guest
  // (no login since 2026-10-19) whose membership is still in the cart left the checkout; an empty cart means they
  // paid: the sign-in screen (settleAfterCheckout).
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    if (state.awaitingPaid && !planner.config.customerId) {
      membershipInCart().then((left) => {
        if (!state.awaitingPaid) return;
        if (left) leaveCheckout();
        else settleAfterCheckout();
        render();
      });
    }
    if (!checkingOut) return;
    checkingOut = false;
    checkoutStage = '';
    $('[data-vhp-consent-dialog]')?.close();
    render();
  });

  // Paywall taps: straight to the plans, the discount gift already on them (grantGift). Sören's clip and the real
  // voice sit on the paywall itself, never between the tap and the price.
  const continueToSubscribe = (trigger = 'other', ctx = trigger) => {
    if (planner.config.paid || !membershipPlans().length) return;
    step('paywall_opened', trigger);
    // The locked thing they tapped: the paywall's first bubble answers it and its perk leads (docs/PREVIEW_PAYWALL.md
    // round 6). The event keeps its whitelisted value; ctx can be finer (the ... sheet's rows).
    const day = ctx === 'day' && pvView > 0 ? PREVIEW_DAYS[pvSpan(state.preview)[pvView]?.index] || '' : '';
    pwCtx = PW_CTX[ctx] ? { key: ctx, day } : null;
    if (!state.subscribePlanId) state.subscribePlanId = defaultSubscribePlanId();
    grantGift();
    toPlans();
  };
  const toPlans = () => forward('subscribe', null);

  const paidWaitTries = () => {
    try {
      return Number(sessionStorage.getItem(PAID_WAIT_KEY) || 0);
    } catch (e) {
      return 0;
    }
  };

  // Back from Shopify without a purchase: the flag goes, the plan stays (the plans, back leads to the preview).
  // Until 2026-10-17 the flag stayed for anyone who left at Shopify's login, and layout/theme.liquid sent every page
  // of the site to the paywall for good.
  const leaveCheckout = () => {
    state.awaitingPaid = false;
    state.awaitingPaidAt = null;
    try {
      sessionStorage.removeItem(PAID_WAIT_KEY);
    } catch (e) { /* ignore */ }
    paidClaim = '';
    if (state.screen === 'waiting') state.screen = state.goal ? 'subscribe' : 'goal';
    persist();
  };

  // A purchase empties the cart: a membership line still in it means the checkout was left, not paid.
  const membershipInCart = async () => {
    const variants = new Set(membershipPlans().map((plan) => String(plan.variantId)));
    if (!variants.size) return false;
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!res.ok) return false;
      const cart = await res.json();
      return (cart.items || []).some((item) => variants.has(String(item.variant_id)));
    } catch (e) {
      return false;
    }
  };

  // Guest checkout (docs/GUEST_CHECKOUT.md): paid without an account, back here signed out. 'check' = the cart is being
  // read (a membership still in it means they left the checkout), 'login' = the sign-in screen: the plan opens once
  // they sign in with the e-mail of the purchase (Shopify's code by mail), the setup in this browser goes along.
  let paidClaim = '';
  // The sign-in screen's success moment plays once per page load (a re-render doesn't replay it).
  let claimPlayed = false;
  const paintClaim = (claim) => {
    const ok = $('[data-vhp-claim-ok]');
    if (!ok) return;
    ok.hidden = !claim;
    if (!claim || claimPlayed) return;
    claimPlayed = true;
    const screen = ok.closest('.vhp-screen');
    ok.classList.remove('is-play');
    screen?.classList.remove('is-claim-in');
    void ok.offsetWidth;
    ok.classList.add('is-play');
    screen?.classList.add('is-claim-in');
    // Confetti and the buzz when the tick lands.
    window.setTimeout(() => {
      window.vhpUi?.burst(ok, { count: 34, spread: 1 });
      window.vhpUi?.buzz(18);
    }, 560);
  };
  const dropPaidParam = () => {
    const url = new URL(location.href);
    if (!url.searchParams.has('paid')) return;
    url.searchParams.delete('paid');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  };
  // Shopify's login (new customer accounts), back to this page; the order mail's ?week=<token> rides along so the
  // account gets the setup from the buy tap (restorePaidSetup).
  const claimLoginHref = (base) => {
    try {
      const url = new URL(base, location.origin);
      const week = new URLSearchParams(location.search).get('week') || '';
      url.searchParams.set('return_to', location.pathname + (/^[A-Za-z0-9_-]{24}$/.test(week) ? `?week=${week}` : ''));
      return url.toString();
    } catch (e) {
      return base;
    }
  };

  const settleAfterCheckout = () => {
    // From the order mail: bought, maybe on another device. Signed out: straight to the sign-in screen; signed in
    // before Flow tagged the account: the usual wait.
    if (PAID_LINK) {
      dropPaidParam();
      if (!planner.config.paid) {
        state.awaitingPaid = true;
        state.awaitingPaidAt = new Date().toISOString();
        if (!planner.config.customerId) {
          state.screen = 'waiting';
          paidClaim = 'login';
          persist();
          step('paid_claim', 'mail');
          return true;
        }
      }
    }
    if (!state.awaitingPaid) return false;
    if (planner.config.paid) {
      state.awaitingPaid = false;
      state.awaitingPaidAt = null;
      try {
        sessionStorage.removeItem(PAID_WAIT_KEY);
      } catch (e) { /* ignore */ }
      persist();
      return false;
    }
    // An old flag is a checkout left long ago.
    const at = Date.parse(state.awaitingPaidAt || '');
    if (!(at > Date.now() - PAID_WAIT_WINDOW_MS)) {
      leaveCheckout();
      return false;
    }
    // Signed out: a purchase empties the cart, so the sign-in screen comes once the cart has no membership left.
    if (!planner.config.customerId) {
      state.screen = 'waiting';
      if (paidClaim !== 'login') paidClaim = 'check';
      persist();
      membershipInCart().then((left) => {
        if (!state.awaitingPaid || paidClaim === 'login') return;
        if (left) leaveCheckout();
        else {
          paidClaim = 'login';
          step('paid_claim', 'checkout');
        }
        render();
      });
      return true;
    }
    state.screen = 'waiting';
    persist();
    const n = paidWaitTries();
    let reload = 0;
    membershipInCart().then((left) => {
      if (!left || !state.awaitingPaid) return;
      window.clearTimeout(reload);
      leaveCheckout();
      render();
    });
    if (n >= PAID_WAIT_MAX) return true;
    try {
      sessionStorage.setItem(PAID_WAIT_KEY, String(n + 1));
    } catch (e) { /* ignore */ }
    reload = window.setTimeout(() => location.reload(), 2000);
    return true;
  };

  // ---------- swipe ----------

  // Card on top of the setup deck (assets/vhp-swipe-deck.js, created under "rendering").
  const deckCard = () => swipeDeck?.current || null;

  const asLike = (card) =>
    normalizeLikeItem({
      ...snapshot(card),
      id: productId(card.id),
      slot: card.slot,
      at: new Date().toISOString(),
    });

  const take = () => {
    const current = deckCard();
    if (!current || state.screen !== 'swipe') return;
    state.swipeHintSeen = true;
    if (state.swap?.from === 'week') {
      const snap = snapshot(current);
      const dayIndex = state.swap.day ?? state.weekDay;
      if (!state.week) state.week = Array.from({ length: WEEK_LEN }, () => emptyWeekDay());
      const day = state.week[dayIndex] || emptyWeekDay();
      state.week[dayIndex] = day;
      const occasion =
        activeOccasions().find((row) => row.id === state.swap.occasion) ||
        EXAMPLE_OCCASIONS.find((row) => row.id === state.swap.occasion);
      const scale = fitPortion(Number(snap.kcal), Math.round((state.kcal || 0) * (occasion?.share || 0.25)), state.kcal) || 1;
      const meal = {
        id: state.swap.occasion,
        label: state.swap.label,
        catalog: state.swap.slot,
        scale,
        locked: false,
        pick: snap,
        kcal: Math.round((Number(snap.kcal) || 0) * scale),
        protein: Math.round((Number(snap.protein) || 0) * scale),
        carbs: snap.carbs == null ? null : Math.round(Number(snap.carbs) * scale),
        fat: snap.fat == null ? null : Math.round(Number(snap.fat) * scale),
        generated: !likeItems().some((item) => item.id === productId(snap.id)),
      };
      day.meals = orderMeals((day.meals || []).filter((row) => row.id !== meal.id).concat(meal));
      state.swap = null;
      swapPassed = [];
      state.undo = null;
      state.pin = null;
    show('week', null, 'fade');
    scheduleWeekSave();
      return;
    }
    const item = asLike(current);
    if (!item) return;
    state.likes.items = state.likes.items.filter((row) => row.id !== item.id);
    state.likes.items.push(item);
    state.skips.items = state.skips.items.filter((row) => row.id !== item.id);
    state.undo = { action: 'like', item };
    recipeEvent('recipe_liked', item, item.slot, 'funnel');
    storyLikeReact(current);
    state.pin = null;
    deferId = null;
    retasteDeck();
    if (planner.config.paid) {
      state.pendingFlush = true;
      flushProfile();
    }
    show('swipe', null);
  };

  const skip = () => {
    const current = deckCard();
    if (!current || state.screen !== 'swipe') return;
    const id = productId(current.id);
    if (!id) return;
    state.swipeHintSeen = true;
    state.pin = null;
    if (state.swap) {
      if (!swapPassed.includes(id)) swapPassed.push(id);
      state.undo = { action: 'swap-skip', item: { id, slot: state.swap.slot } };
      deferId = null;
      show('swipe', state.swap.slot);
      return;
    }
    const item = { id, slot: current.slot, at: new Date().toISOString() };
    state.skips.items = state.skips.items.filter((row) => row.id !== id);
    state.skips.items.push(item);
    state.undo = { action: 'skip', item };
    recipeEvent('recipe_skipped', item, item.slot, 'funnel');
    deferId = id;
    retasteDeck();
    // Rides along with the next profile save (like, settings, next visit); no request per swipe.
    if (planner.config.paid) state.pendingFlush = true;
    show('swipe', null);
  };

  const undoSwipe = () => {
    const step = state.undo;
    if (!step) return;
    state.undo = null;
    deferId = null;
    if (step.action === 'like') {
      plannerEvents('retract', 'recipe_liked', step.item.id);
      state.likes.items = state.likes.items.filter((row) => row.id !== step.item.id);
      state.pin = step.item.id;
      if (planner.config.paid) {
        state.pendingFlush = true;
        flushProfile();
      }
    } else if (step.action === 'skip') {
      plannerEvents('retract', 'recipe_skipped', step.item.id);
      state.skips.items = state.skips.items.filter((row) => row.id !== step.item.id);
      state.pin = step.item.id;
    } else if (step.action === 'swap-skip') {
      const at = swapPassed.lastIndexOf(step.item.id);
      if (at >= 0) swapPassed.splice(at, 1);
      state.pin = step.item.id;
    }
    show('swipe', state.swap ? state.swap.slot : null);
  };

  const startSwap = (occasion) => {
    closeSwapSheet();
    const day = state.week?.[state.weekDay];
    const meal = day?.meals?.find((row) => row.id === occasion);
    if (!meal) return;
    state.swap = {
      slot: meal.catalog,
      occasion: meal.id,
      label: meal.label,
      meal,
      from: 'week',
      day: state.weekDay,
    };
    swapPassed = [];
    state.undo = null;
    state.pin = null;
    deferId = null;
    failed.delete(meal.catalog);
    day.meals = day.meals.filter((row) => row.id !== occasion);
    show('swipe', meal.catalog, 'fade');
  };

  const SWAP_SEARCH_MS = 200;
  const SWAP_PAGE = 24;
  const SWAP_THUMB = 160;
  // Photo cards (swap grid, the meal sheet header, planner skin v3): sharp at two columns on a phone.
  const SWAP_CARD = 480;
  // What is left of the day's target once every other meal is counted (header "Ideal f�r diese Mahlzeit", day bar).
  const remainingForOccasion = (meals, occasionId) => {
    const target = { kcal: Number(state.kcal) || 0, ...macroGrams(state.kcal, currentSplit()) };
    return (meals || [])
      .filter((meal) => meal?.id !== occasionId)
      .reduce(
        (acc, meal) => ({
          kcal: acc.kcal - (Number(meal.kcal) || 0),
          protein: acc.protein - (Number(meal.protein) || 0),
          carbs: acc.carbs - (Number(meal.carbs) || 0),
          fat: acc.fat - (Number(meal.fat) || 0),
        }),
        target
      );
  };
  const coreWeekDays = () => (state.week || []).map((day) => (day?.meals || []).map(coreFixedMeal));
  // Own recipes may lack carbs/fat (or protein): they rank with 0 there and keep null for display.
  const rankableCard = (card) => ({
    ...card,
    protein: Number(card.protein) || 0,
    carbs: Number(card.carbs) || 0,
    fat: Number(card.fat) || 0,
    mi: mainIngredient(card),
    _src: card,
  });

  // Swap rows from the planner core: every candidate scored as "this day with that recipe in this meal"
  // (same score as planning; portion ½–2× under the share cap). No same-day repeats, never the current dish.
  function coreSwapRows(ctx, cards) {
    if (!plannerCore) return [];
    const pool = (cards || [])
      .filter((card) => Number(card?.kcal) > 0 && productId(card.id) && productId(card.id) !== ctx.excludeId)
      .map(rankableCard);
    return plannerCore
      .rankSwaps(ctx.core, { days: ctx.days, dayIndex: ctx.dayIndex, occasionId: ctx.meal.id, pool, exclude: [ctx.excludeId] })
      .map((row) => {
        const src = row.card._src || row.card;
        return { ...row, card: src, carbs: src.carbs == null ? null : row.carbs, fat: src.fat == null ? null : row.fat };
      });
  }
  let swapUi = null;
  let swapSearchTimer = 0;

  const foldSearch = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/ẞ/g, 'ss')
      .toLocaleLowerCase('de');

  const swapThumbUrl = (url, width = SWAP_THUMB) => {
    const src = String(url || '');
    if (!src) return '';
    try {
      const u = new URL(src, location.href);
      u.searchParams.set('width', String(width));
      u.searchParams.delete('height');
      u.pathname = u.pathname.replace(/_(\d+x(?:\d+)?)(?=\.[a-z0-9]+$)/i, `_${width}x`);
      return u.href;
    } catch (e) {
      return src;
    }
  };

  const swapSearchText = (card) => {
    if (!card) return '';
    if (card.searchText != null) return card.searchText;
    const parts = [card.title || ''];
    (card.ingredients || []).forEach((ing) => {
      if (ing?.n) parts.push(ing.n);
    });
    card.searchText = foldSearch(parts.join(' '));
    return card.searchText;
  };

  const cardMatchesQuery = (card, needle) => !needle || swapSearchText(card).includes(needle);

  // Algolia matches for a typed query (typo tolerant, ingredients incl. compounds like "Räuchertofu"),
  // as product id -> rank (assets/vhp-search-core.js). null until known; onReady then re-renders.
  // The local match above stays for own recipes and plan-exclusive ones, which are not in the index.
  const searchCore = window.vhpSearchCore || null;
  const algoliaPending = new Set();
  const algoliaRank = (query, onReady) => {
    const q = String(query || '').trim();
    if (!searchCore || q.length < 2) return null;
    const known = searchCore.peekIds(q);
    if (known) return known;
    if (!algoliaPending.has(q)) {
      algoliaPending.add(q);
      searchCore.ids(q).then(onReady, () => {}).finally(() => algoliaPending.delete(q));
    }
    return null;
  };
  const cardMatchesSearch = (card, needle, rank) =>
    cardMatchesQuery(card, needle) || Boolean(rank && rank.has(productId(card.id)));

  const allCatalogCards = () => {
    const seen = new Set();
    const out = [];
    SLOT_ORDER.forEach((slot) => {
      poolFor(slot).forEach((card) => {
        const id = productId(card.id);
        if (!id || seen.has(id)) return;
        seen.add(id);
        out.push(card);
      });
    });
    return out;
  };

  const findCatalogCard = (id, slot) => {
    const sid = productId(id);
    if (!sid) return null;
    if (isCustomId(sid)) return customRecipes()?.card(sid, slot) || null;
    for (let i = 0; i < SLOT_ORDER.length; i += 1) {
      const card = planner.cards(SLOT_ORDER[i]).find((row) => productId(row.id) === sid);
      if (card) return card;
    }
    return likeItems().find((item) => item.id === sid) || null;
  };

  const hydrateSwapCard = (item) => {
    if (!item) return null;
    const full = findCatalogCard(item.id);
    if (!full) return item;
    return {
      ...full,
      title: full.title || item.title,
      image: full.image || item.image,
      slot: full.slot || item.slot,
    };
  };

  function swapContext(occasion = swapUi?.occasion) {
    if (!occasion || !plannerCore) return null;
    const day = state.week?.[state.weekDay];
    const meal = day?.meals?.find((row) => row.id === occasion);
    if (!meal) return null;
    return {
      day,
      meal,
      dayIndex: state.weekDay,
      remaining: remainingForOccasion(day.meals, meal.id),
      excludeId: productId(meal.pick?.id),
      maxKcal: shareLimitKcal(),
      core: plannerContext({}),
      days: coreWeekDays(),
    };
  }

  // Shared bottom sheet (assets/vhp-sheet.js).
  function setDialogOpen(sheet, open) {
    window.vhpSheet?.setOpen(sheet, open);
  }

  function closeSwapSheet() {
    const sheet = funnel.querySelector('[data-vhp-swap-sheet]');
    if (sheet) {
      sheet.classList.remove('is-dragging');
      setDialogOpen(sheet, false);
    }
    window.clearTimeout(swapSearchTimer);
    swapSearchTimer = 0;
    swapUi = null;
    const q = funnel.querySelector('[data-vhp-swap-q]');
    if (q) q.value = '';
  }

  function fillSwapHeader(ctx) {
    if (!ctx) return;
    const title = funnel.querySelector('[data-vhp-swap-title]');
    const need = funnel.querySelector('[data-vhp-swap-need]');
    if (title) title.textContent = tr('planner.swap_title', { label: occLabel(ctx.meal) || tr('planner.meal') });
    const kicker = funnel.querySelector('[data-vhp-swap-kicker]');
    if (kicker) {
      const date = addDays(shownMonday(), state.weekDay);
      kicker.textContent = `${PREVIEW_DAYS[state.weekDay]}, ${dayMonth(date)}`;
    }
    // What is being replaced: its photo and "statt …" (planner skin v3).
    const thumb = funnel.querySelector('[data-vhp-swap-thumb]');
    if (thumb) {
      const src = ctx.meal.away ? '' : ctx.meal.pick?.image || '';
      if (thumb.dataset.src !== src) {
        thumb.dataset.src = src;
        thumb.replaceChildren();
        if (src) {
          const img = document.createElement('img');
          img.src = swapThumbUrl(src, SWAP_THUMB);
          img.alt = '';
          thumb.append(img);
        } else {
          const ico = ctx.meal.away ? awayIcon() : spriteIcon(slotIconName(ctx.meal.id), 'vhp-swap-head__ico');
          if (ico) thumb.append(ico);
        }
      }
    }
    const instead = funnel.querySelector('[data-vhp-swap-instead]');
    if (instead) {
      const was = ctx.meal.away ? tr('planner.away') : ctx.meal.pick?.title ? dishName(ctx.meal.pick.title) : '';
      instead.textContent = was ? tr('planner.swap_instead', { title: was }) : '';
      instead.hidden = !was;
    }
    if (need) {
      // `remaining` = the goal minus the other meals, i.e. the ideal size of this meal. Rounded: "≈ 342 kcal" reads
      // more precise than the ranking is. A few grams of protein are noise. Shown as "Passend" + two pills.
      const kcal = Math.round(ctx.remaining.kcal / 10) * 10;
      const protein = Math.round(ctx.remaining.protein);
      if (kcal > 0) {
        const label = document.createElement('span');
        label.className = 'vhp-swap-need__label';
        label.textContent = tr('planner.fits', { parts: '' }).replace(/[\s:]+$/, '');
        const pill = (text, cls) => {
          const el = document.createElement('span');
          el.className = cls ? `vhp-swap-need__pill ${cls}` : 'vhp-swap-need__pill';
          el.textContent = text;
          return el;
        };
        const parts = [label, pill(`≈ ${kcal.toLocaleString(LOCALE)} kcal`)];
        if (protein > 0) parts.push(pill(tr('common.protein', { n: protein }), 'is-protein'));
        need.replaceChildren(...parts);
        need.setAttribute('aria-label', tr('planner.fits', { parts: parts.slice(1).map((el) => el.textContent).join(' · ') }));
      } else {
        need.removeAttribute('aria-label');
        need.textContent = tr('planner.day_full_without');
      }
    }

    const offerEl = funnel.querySelector('[data-vhp-swap-leftover]');
    if (offerEl) {
      const dinner = leftoverOffer(ctx);
      offerEl.hidden = !dinner;
      const name = offerEl.querySelector('[data-vhp-swap-leftover-name]');
      if (name && dinner) name.textContent = dinner.pick.title || tr('common.dinner');
      const head = offerEl.querySelector('[data-vhp-swap-leftover-head]');
      if (head && dinner) head.textContent = tr('planner.leftovers_from', { day: DAY_LABEL[state.weekDay - 1] });
    }
  }

  // ---------- swap sources: Vorschläge · Favoriten · Eigene (+ "andere Mahlzeiten" at the end of Vorschläge) ----------

  // Catalog (and own recipes with kcal) for this meal; every meal type with "Alle Mahlzeiten".
  function swapBaseCards(ctx, opts) {
    const slot = ctx.meal.catalog;
    const anySlot = Boolean(opts?.anySlot || swapUi.anySlot);
    const catalog = swapCatalog().filter((card) => anySlot || card.slot === slot);
    const store = customRecipes();
    const own = store
      ? (store.cardsForSwap ? store.cardsForSwap(slot) : store.cardsForSlot(slot))
        .filter((card) => Number(card.kcal) > 0 && (anySlot || card.slot === slot))
      : [];
    return catalog.concat(own);
  }

  // One row of chips instead of two dropdowns: source and order in one choice. "Passt am besten" is the default.
  // Favoriten only when this meal has any, Eigene for subscribers, Schnell only when some recipe has a time.
  const SWAP_CHIPS = [
    { id: 'best', label: tr('planner.sort_best'), filter: 'all', sort: 'best' },
    { id: 'likes', label: tr('planner.favorites'), filter: 'likes', sort: 'best' },
    { id: 'time', label: tr('planner.sort_time'), filter: 'all', sort: 'time' },
    { id: 'protein', label: tr('planner.sort_protein'), filter: 'all', sort: 'protein' },
    { id: 'kcal', label: tr('planner.sort_kcal'), filter: 'all', sort: 'kcal' },
    { id: 'own', label: tr('planner.own'), filter: 'own', sort: 'best' },
    { id: 'any', label: tr('planner.household_all'), filter: 'all', sort: 'best', anySlot: true },
  ];

  const applySwapChip = (id) => {
    const chip = SWAP_CHIPS.find((row) => row.id === id) || SWAP_CHIPS[0];
    swapUi.chip = chip.id;
    swapUi.filter = chip.filter;
    swapUi.sort = chip.sort;
    swapUi.anySlot = Boolean(chip.anySlot);
  };

  function swapChipsShown(ctx) {
    const liked = new Set(likeItems().map((item) => item.id));
    const show = {
      likes: swapBaseCards(ctx).some((card) => liked.has(productId(card.id))),
      own: Boolean(customRecipes()),
      time: swapBaseCards(ctx).some((card) => Number(card.time) > 0),
    };
    return SWAP_CHIPS.filter((chip) => show[chip.id] !== false);
  }

  function renderSwapChips(ctx) {
    const box = funnel.querySelector('[data-vhp-swap-chips]');
    if (!box || !swapUi) return;
    const chips = swapChipsShown(ctx);
    if (!chips.some((chip) => chip.id === swapUi.chip)) applySwapChip('best');
    const key = `${chips.map((chip) => chip.id).join(',')}|${swapUi.chip}`;
    if (box.dataset.key === key) return;
    box.dataset.key = key;
    box.replaceChildren(
      ...chips.map((chip) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vhp-swap-chip';
        btn.dataset.vhpSwapChip = chip.id;
        btn.setAttribute('role', 'radio');
        const on = chip.id === swapUi.chip;
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
        btn.textContent = chip.label;
        return btn;
      })
    );
  }

  // Foto · Barcode · Text/Sprache as icons inside the search field (built once).
  const SWAP_TOOL_ICON = { photo: 'photo', barcode: 'barcode', text: 'mic' };
  function renderSwapMethods() {
    const box = funnel.querySelector('[data-vhp-swap-methods]');
    const capture = window.vhpPlannerCapture;
    if (!box || !capture || box.dataset.built) return;
    box.dataset.built = '1';
    capture.methods().forEach(({ id, label }) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vhp-swap-tool';
      btn.dataset.vhpSwapOwn = id;
      btn.setAttribute('aria-label', label);
      btn.title = label;
      const icon = capture.icon(SWAP_TOOL_ICON[id] || id);
      if (icon) btn.append(icon);
      box.append(btn);
    });
  }

  function swapEmpty(text, link, action) {
    const wrap = document.createElement('div');
    wrap.className = 'vhp-swap-empty';
    const p = document.createElement('p');
    p.textContent = text;
    wrap.append(p);
    if (link) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vhp-text-btn';
      btn.dataset[action || 'vhpSwapDiscover'] = '1';
      btn.textContent = link;
      wrap.append(btn);
    }
    return wrap;
  }

  function swapSkeleton() {
    const frag = document.createDocumentFragment();
    for (let i = 0; i < 6; i += 1) {
      const row = document.createElement('span');
      row.className = 'vhp-swap-row vhp-swap-row--skel';
      row.setAttribute('aria-hidden', 'true');
      const thumb = document.createElement('span');
      thumb.className = 'vhp-swap-row__thumb';
      const lines = document.createElement('span');
      lines.className = 'vhp-swap-row__lines';
      lines.append(document.createElement('i'), document.createElement('i'));
      row.append(thumb, lines);
      frag.append(row);
    }
    return frag;
  }

  // "Meine Rezepte" above the catalog: every active own recipe. Slot match first;
  // picking by hand is always allowed (autofill flag and 0 kcal do not hide them).
  function ownSwapRows(ctx) {
    const store = customRecipes();
    if (!plannerCore || !store) return [];
    const needle = foldSearch(swapUi.query || '').trim();
    const slot = ctx.meal.catalog;
    const excludeId = productId(ctx.excludeId);
    const cards = (store.cardsForSwap ? store.cardsForSwap(slot) : store.cardsForSlot(slot)).filter(
      (card) => cardMatchesQuery(card, needle) && productId(card.id) !== excludeId
    );
    const withKcal = cards.filter((card) => Number(card.kcal) > 0);
    const noKcal = cards.filter((card) => !(Number(card.kcal) > 0));
    const ranked = coreSwapRows(ctx, withKcal);
    const rest = noKcal.map((card) => ({
      card,
      scale: 1,
      kcal: 0,
      protein: 0,
      carbs: card.carbs == null ? null : 0,
      fat: card.fat == null ? null : 0,
      score: Infinity,
    }));
    return ranked.concat(rest).sort((a, b) => {
      const aFit = a.card.slot === slot ? 0 : 1;
      const bFit = b.card.slot === slot ? 0 : 1;
      if (aFit !== bFit) return aFit - bFit;
      return (a.score || 0) - (b.score || 0);
    });
  }

  function swapCatalog() {
    if (!swapUi) return [];
    if (!swapUi.catalog) swapUi.catalog = allCatalogCards();
    return swapUi.catalog;
  }

  function swapCandidatePool(ctx) {
    const base = swapBaseCards(ctx);
    if (swapUi.filter === 'likes') {
      const liked = new Set(likeItems().map((item) => item.id));
      return base.filter((card) => liked.has(productId(card.id)));
    }
    return base;
  }

  // Ranked rows for the active chip. "Eigene" keeps the own-recipe order (incl. ones without kcal).
  function rankedSwapRows(ctx) {
    const needle = foldSearch(swapUi.query || '').trim();
    // A search looks through every recipe (all meal types + own), whatever chip is on.
    // Dishes already in another meal of this day stay visible at the end, greyed out and not selectable.
    if (needle) {
      const typed = swapUi.query;
      const rank = algoliaRank(typed, () => {
        if (swapUi && swapUi.query === typed) renderSwapResults();
      });
      const all = swapBaseCards(ctx, { anySlot: true }).filter((card) => cardMatchesSearch(card, needle, rank));
      const today = new Set(
        (ctx.day.meals || []).filter((meal) => meal.id !== ctx.meal.id).map(mealProductId).filter(Boolean)
      );
      const blocked = all
        .filter((card) => today.has(productId(card.id)))
        .map((card) => ({
          card,
          scale: 1,
          kcal: Math.round(Number(card.kcal) || 0),
          protein: Math.round(Number(card.protein) || 0),
          carbs: card.carbs == null ? null : Math.round(Number(card.carbs)),
          fat: card.fat == null ? null : Math.round(Number(card.fat)),
          blocked: 'today',
        }));
      return coreSwapRows(ctx, all).concat(blocked);
    }
    if (swapUi.filter === 'own') return ownSwapRows(ctx);
    const cards = swapCandidatePool(ctx);
    return coreSwapRows(ctx, cards);
  }

  // Chip order: "best" keeps the planner ranking; the others re-order it (stable, so ties stay in ranking
  // order). Rows without the value go last, greyed-out same-day dishes stay at the very end.
  const swapLast = (value) => (value > 0 ? value : Infinity);
  const SWAP_SORTS = {
    protein: (a, b) => (Number(b.protein) || 0) - (Number(a.protein) || 0),
    kcal: (a, b) => swapLast(Number(a.kcal)) - swapLast(Number(b.kcal)),
    time: (a, b) => swapLast(Number(a.card.time)) - swapLast(Number(b.card.time)),
  };
  function sortSwapRows(rows, sort) {
    const by = SWAP_SORTS[sort];
    if (!by) return rows;
    return rows.filter((row) => !row.blocked).sort(by).concat(rows.filter((row) => row.blocked));
  }

  // One swap candidate as a compact row: thumb (portion badge), title, kcal · protein. The list is already what
  // fits the day, so only a dish that goes over says by how much ("+133 kcal"). Tapping the row opens the reel
  // in swap mode ("Hier einsetzen") to look first; ＋ puts it in right away. A protein bump of at least 5 g
  // turns the protein figure green.
  const SWAP_PROTEIN_BADGE = 5;
  function swapRow(row, ctx, index) {
    const card = row.card;
    const id = productId(card.id);
    const own = isCustomId(id);
    const has = Number(row.kcal) > 0;
    const blocked = row.blocked === 'today';
    const dP = Math.round(row.protein - (Number(ctx.meal.protein) || 0));
    const proteinUp = has && !ctx.meal.away && dP >= SWAP_PROTEIN_BADGE;
    const item = document.createElement('div');
    item.className = 'vhp-swap-row';
    item.setAttribute('role', 'listitem');
    if (blocked) item.classList.add('is-blocked');

    const open = document.createElement('button');
    open.type = 'button';
    open.className = 'vhp-swap-row__open';
    if (blocked) open.disabled = true;
    else open.dataset.vhpSwapCard = String(index);

    const thumb = document.createElement('span');
    thumb.className = 'vhp-swap-row__thumb';
    const src = posterUrl(card) || card.image || '';
    if (src) {
      const img = document.createElement('img');
      img.src = swapThumbUrl(src, SWAP_CARD);
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.draggable = false;
      thumb.append(img);
    }
    const badge = has ? fmtScaleShort(row.scale) : '';
    if (badge && Number(row.scale) !== 1) {
      const mark = document.createElement('span');
      mark.className = 'vhp-pick__portion';
      mark.textContent = badge;
      thumb.append(mark);
    }

    const copy = document.createElement('span');
    copy.className = 'vhp-swap-row__copy';
    const kicker = blocked
      ? tr('planner.already_today')
      : own
        ? tr('planner.own_short')
        : card.slot && card.slot !== ctx.meal.catalog
          ? SLOT_LABEL[card.slot]
          : '';
    if (kicker) {
      const k = document.createElement('span');
      k.className = 'vhp-swap-row__kicker';
      k.textContent = kicker;
      copy.append(k);
    }
    const title = document.createElement('span');
    title.className = 'vhp-swap-row__title';
    title.textContent = card.title ? dishName(card.title) : tr('common.recipe');
    copy.append(title);

    const meta = document.createElement('span');
    meta.className = 'vhp-swap-row__meta';
    let fitText = '';
    if (has) {
      const kcal = document.createElement('span');
      kcal.textContent = `${fmt(row.kcal)} kcal`;
      const protein = document.createElement('span');
      protein.textContent = tr('common.protein', { n: fmt(row.protein) });
      if (proteinUp) protein.classList.add('is-up');
      meta.append(kcal, ' · ', protein);
      const target = Number(state.kcal) || 0;
      if (!blocked && target && ctx.remaining.kcal > 0) {
        const over = Math.round(row.kcal - ctx.remaining.kcal);
        if (over > Math.max(40, target * 0.04)) {
          const fit = document.createElement('span');
          fit.className = 'vhp-swap-row__fit is-over';
          fit.textContent = `+${over.toLocaleString(LOCALE)} kcal`;
          fitText = tr('planner.over_target', { n: over });
          meta.append(fit);
        }
      }
    } else {
      meta.textContent = tr('planner.no_nutrition');
    }
    copy.append(meta);
    open.append(thumb, copy);
    open.setAttribute(
      'aria-label',
      blocked
        ? tr('planner.already_today_of', { title: card.title || tr('common.recipe') })
        : tr('planner.view_of', { title: card.title || tr('common.recipe'), facts: (has ? tr('planner.facts', { kcal: fmt(row.kcal), protein: fmt(row.protein) }) : '') + fitText })
    );
    item.append(open);

    if (!blocked) {
      const add = document.createElement('button');
      add.type = 'button';
      add.className = 'vhp-swap-row__add';
      add.dataset.vhpSwapPick = id;
      add.dataset.vhpSwapScale = String(row.scale || 1);
      add.setAttribute('aria-label', tr('planner.use_of', { title: card.title || tr('common.recipe') }));
      add.append(
        strokeIcon((svg) => {
          addStroke(svg, 'path', { d: 'M12 6v12M6 12h12' });
        })
      );
      item.append(add);
    }
    return item;
  }

  function appendSwapRows(box, ctx, rows, from, to) {
    const frag = document.createDocumentFragment();
    const offset = swapUi.top?.length || 0;
    for (let i = from; i < to && i < rows.length; i += 1) {
      frag.append(swapRow(rows[i], ctx, offset + i));
    }
    box.append(frag);
  }

  // Reel over the sheet: every ranked card of the current chip, starting at the tapped one.
  function openSwapReel(index) {
    const ctx = swapContext();
    // Greyed-out same-day dishes sit at the end of the list and never open (indexes before them are unchanged).
    const rows = (swapUi?.top || []).concat(swapUi?.rows || []).filter((row) => !row.blocked);
    if (!ctx || !rows.length) return;
    const target = Number(state.kcal) || 0;
    openReel({
      cards: rows.map((row) => row.card),
      index,
      title: tr('planner.swap_title', { label: occLabel(ctx.meal) || tr('planner.meal') }),
      swap: {
        occasion: ctx.meal.id,
        rows: rows.map((row) => ({ scale: row.scale, kcal: row.kcal, protein: row.protein, carbs: row.carbs })),
        others: Math.max(0, target - ctx.remaining.kcal),
        target,
      },
    });
  }

  function placeFromReel(session, index) {
    const card = session.cards[index];
    const fit = session.swap?.rows?.[index];
    if (!card || !fit || !swapUi || swapUi.occasion !== session.swap.occasion) return;
    closeReel();
    applySwapPick(productId(card.id), fit.scale);
  }


  function paintSwapPage() {
    const box = funnel.querySelector('[data-vhp-swap-results]');
    const ctx = swapContext();
    if (!box || !swapUi || !ctx) return;
    const rows = swapUi.rows || [];
    const from = swapUi.shown || 0;
    if (from >= rows.length) return;
    appendSwapRows(box, ctx, rows, from, Math.min(rows.length, from + SWAP_PAGE));
    swapUi.shown = Math.min(rows.length, from + SWAP_PAGE);
  }

  function onSwapResultsScroll(event) {
    if (!swapUi?.rows || (swapUi.shown || 0) >= swapUi.rows.length) return;
    const box = event.currentTarget;
    if (box.scrollHeight - box.scrollTop - box.clientHeight > 320) return;
    paintSwapPage();
  }

  function renderSwapResults() {
    const box = funnel.querySelector('[data-vhp-swap-results]');
    if (!box || !swapUi) return;
    const ctx = swapContext();
    if (!ctx) {
      closeSwapSheet();
      return;
    }
    fillSwapHeader(ctx);
    renderSwapMethods();
    renderSwapChips(ctx);
    if (swapUi.loading && !swapCatalog().length) {
      box.replaceChildren(swapSkeleton());
      return;
    }
    const rows = sortSwapRows(rankedSwapRows(ctx), swapUi.sort);
    const query = (swapUi.query || '').trim();
    swapUi.top = [];
    swapUi.rows = rows;
    swapUi.shown = 0;
    box.replaceChildren();
    // Eigene: typing one in by hand comes first (Foto / Barcode / Text are the tiles above). On the default list
    // too, as "Eigenes Gericht eintragen": the pizza evening shouldn't need the Eigene chip to be found.
    if ((swapUi.filter === 'own' || swapUi.filter === 'all') && !query && customRecipes()) {
      box.append(swapManualRow(swapUi.filter === 'all'));
    }
    if (!rows.length) {
      if (swapUi.filter === 'own' && !query) return;
      if (query) {
        box.append(swapEmpty(tr('planner.no_hits')));
      } else if (swapUi.filter === 'likes') {
        box.append(swapEmpty(tr('planner.no_favs_meal'), tr('planner.all_suggestions'), 'vhpSwapAll'));
      } else {
        box.append(swapEmpty(tr('planner.nothing_fits')));
      }
      return;
    }
    paintSwapPage();
  }

  // Eigene → "Gericht oder Produkt manuell eintragen": the plain form, as the first row of the list.
  // compact: the slimmer "Eigenes Gericht eintragen" row on top of the default list.
  function swapManualRow(compact) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = compact ? 'vhp-swap-manual vhp-swap-manual--compact' : 'vhp-swap-manual';
    btn.dataset.vhpSwapOwn = 'manual';
    const plus = document.createElement('span');
    plus.className = 'vhp-swap-manual__plus';
    plus.setAttribute('aria-hidden', 'true');
    plus.textContent = '+';
    const copy = document.createElement('span');
    copy.className = 'vhp-swap-manual__copy';
    const title = document.createElement('strong');
    title.textContent = compact ? tr('planner.own_here') : tr('planner.manual');
    const note = document.createElement('span');
    note.textContent = compact ? tr('planner.own_here_note') : tr('planner.manual_note');
    copy.append(title, note);
    btn.append(plus, copy);
    return btn;
  }

  async function openSwapSheet(occasion) {
    const day = state.week?.[state.weekDay];
    const meal = day?.meals?.find((row) => row.id === occasion);
    if (!meal || meal.locked) return;
    usage('use_swap');
    if (!plannerCore) {
      startSwap(occasion);
      return;
    }
    const sheet = funnel.querySelector('[data-vhp-swap-sheet]');
    if (!sheet) return;
    swapUi = {
      occasion: meal.id,
      chip: 'best',
      filter: 'all',
      anySlot: false,
      query: '',
      sort: 'best',
      loading: true,
    };
    const q = funnel.querySelector('[data-vhp-swap-q]');
    if (q) {
      q.value = '';
      q.readOnly = true;
    }
    const chips = funnel.querySelector('[data-vhp-swap-chips]');
    if (chips) chips.scrollLeft = 0;
    renderSwapResults();
    if (!swapUi) return;
    const scroll = funnel.querySelector('[data-vhp-swap-scroll]');
    if (scroll) scroll.scrollTop = 0;
    setDialogOpen(sheet, true);
    funnel.querySelector('[data-vhp-swap-title]')?.focus();
    try {
      await Promise.all([
        fillRemixPools(),
        fillPool('dessert', Math.max(planner.counts?.('dessert')?.total || 24, 24)),
      ]);
    } catch (e) {
      console.error('[vhp-planner] swap pool load failed', e);
    }
    if (!swapUi || swapUi.occasion !== meal.id) return;
    swapUi.catalog = allCatalogCards();
    swapUi.loading = false;
    renderSwapResults();
  }

  // occasion: the meal ▶'s reel swaps into (openDayReel), without the sheet.
  function applySwapPick(id, scale, occasion = swapUi?.occasion) {
    const ctx = swapContext(occasion);
    const card = isCustomId(productId(id))
      ? findCatalogCard(id, ctx?.meal?.catalog)
      : hydrateSwapCard(findCatalogCard(id));
    if (!ctx || !card || !(Number(scale) > 0)) return;
    // The sheet already ranks with the cap; this keeps any other caller inside it too.
    const n = capToShare(card, Number(scale));
    regenUndo = null;
    swapUndo = { day: state.weekDay, snapshot: cloneJson(ctx.meal) };
    const generated =
      !isCustomId(card.id) && !likeItems().some((item) => item.id === productId(card.id));
    const next = mealFromRemix(ctx.meal, card, n, generated);
    next.locked = false;
    trackReplaced(ctx.meal, next.pick, 'swap_sheet');
    ctx.day.meals = orderMeals((ctx.day.meals || []).filter((row) => row.id !== ctx.meal.id).concat(next));
    const moved = syncLeftovers();
    closeSwapSheet();
    persist();
    scheduleWeekSave();
    render();
    showWeekToast(withLeftoverNote(tr('planner.recipe_swapped'), moved));
  }

  // Swap sheet → "Eigenes Gericht": quick form with the slot preselected; saving fills this slot.
  // method: a vhpPlannerCapture id ('manual', 'barcode', labs 'photo' / 'text'); the form starts with it.
  function startOwnRecipe(method) {
    const ctx = swapContext();
    if (!customRecipes() || !ctx) return;
    const dayIndex = state.weekDay;
    const occasion = ctx.meal.id;
    closeSwapSheet();
    openOwnForm(dayIndex, occasion, method);
  }

  // Also from the meal ⋯ sheet ("Eigenes Gericht eintragen").
  function openOwnForm(dayIndex, occasion, method) {
    const recipes = customRecipes();
    const meal = state.week?.[dayIndex]?.meals?.find((row) => row.id === occasion);
    if (!recipes || !meal) return;
    recipes.openForm({
      quick: true,
      slot: meal.catalog,
      capture: method && method !== 'manual' ? method : null,
      onSaved: (recipe) => placeOwnRecipe(dayIndex, occasion, recipe),
    });
  }

  function placeOwnRecipe(dayIndex, occasion, recipe) {
    const meal = state.week?.[dayIndex]?.meals?.find((row) => row.id === occasion);
    const card = customRecipes()?.card(recipe?.id, meal?.catalog);
    placeCardInWeek({ dayIndex, occasion, card, toast: tr('planner.own_dish_added'), src: 'swap_sheet' });
  }

  function startDiscoverFromSheet() {
    closeSwapSheet();
    openRecipes();
  }

  // ---------- recipe sheet ----------
  // The shared recipe sheet (assets/vhp-recipe-sheet.js, content: sections/recipe-sheet.liquid) at full height, with
  // the planner's portions under the title. It lives in the funnel while open, so the clicks below still reach it.
  // Cook mode, ingredient ticks and the video are the sheet's own; "Zum Meal Plan" is off here.
  const RECIPE_SECTION_ID = 'recipe-sheet';
  let recipeSheetCustom = null;
  let recipeHead = null;

  const recipeSheet = () => window.vhpRecipeSheet || null;
  const recipeSheetOpen = () => Boolean(recipeSheet()?.isOpen());

  function pauseRecipeMedia() {
    const body = recipeSheet()?.body();
    if (!body) return;
    body.querySelectorAll('video').forEach((video) => video.pause());
  }

  // Recipe sheet open: hold the deck video and the Rezepte hero/reel.
  function pauseSwipeMedia() {
    funnel.querySelector('[data-vhp-swipe-media]')?.querySelectorAll('video').forEach((video) => video.pause());
    recipesMediaHeld = true;
    syncRecipesMedia();
  }

  function resumeSwipeMedia() {
    if (recipesMediaHeld) {
      recipesMediaHeld = false;
      syncRecipesMedia();
    }
    if (state.screen !== 'swipe') return;
    funnel.querySelector('[data-vhp-swipe-media]')?.querySelectorAll('video').forEach((video) => {
      if (video.paused && video.dataset.userPaused !== '1') void video.play().catch(() => {});
    });
  }

  function closeRecipeSheet() {
    if (recipeSheetOpen()) recipeSheet().close();
  }

  // Ingredients for `cook` portions (household), macros for the customer's own portion (scale).
  const scaleRecipeAmounts = (root, scale, cook) => {
    const portions = Number(root.dataset.portions) > 0 ? Number(root.dataset.portions) : 1;
    const n = Number(scale) > 0 ? Number(scale) : 1;
    const cookN = Number(cook) > 0 ? Number(cook) : n;
    const factor = cookN / portions;
    root.querySelectorAll('.vhp-recipe-ings__amt[data-base]').forEach((el) => {
      const base = parseFloat(el.dataset.base);
      if (!Number.isFinite(base) || base <= 0) {
        el.textContent = '';
        return;
      }
      const unit = el.dataset.unit || '';
      const rounded = shopRound(base * factor, unit);
      if (rounded.kind === 'taste') {
        el.textContent = '';
        return;
      }
      const qty = shopFmtQty(rounded.qty);
      el.textContent = rounded.kind === 'metric' ? `${qty}${unit}` : `${qty} ${shopUnitLabel(unit)}`.trim();
    });
    root.querySelectorAll('.vhp-recipe-macro[data-base]').forEach((el) => {
      const base = parseFloat(el.dataset.base);
      if (!Number.isFinite(base)) return;
      el.textContent = `${Math.round(base * n)}${el.dataset.suffix || ''}`;
    });
    root.querySelectorAll('[data-vhp-recipe-servings]').forEach((el) => {
      el.textContent = fmtScale(cookN);
    });
  };

  // Cook sheet for a planned meal that is shared: amounts for everyone (default) or only the customer's portion.
  let recipeWho = 'all';
  // Breakdown under "Mengen für …": closed on every open, toggled by tapping the headline.
  let recipeWhyOpen = false;
  // n = the customer's portion, extra = other people eating along, others = their portions, ahead = tomorrow's
  // leftover lunch (incl. its household), reheat = this meal is leftovers (day label it was cooked on).
  let recipeSheetPortions = { n: 1, extra: 0, others: 0, ahead: 0, aheadDay: '', reheat: '' };
  const recipeCookPortions = () =>
    recipeSheetPortions.n + (recipeWho === 'all' ? recipeSheetPortions.others + recipeSheetPortions.ahead : 0);
  // Week rows only (they pass the occasion): context of the meal in the shown day.
  const recipeMealContext = (occasion) => {
    const out = { ahead: 0, aheadDay: '', reheat: '' };
    if (!planner.config.paid || !occasion || !Array.isArray(state.week) || state.screen !== 'week') return out;
    const dayIndex = state.weekDay;
    // A Meal-Prep batch (or a dinner with leftover lunches): cooked on its cook day for every meal of the batch,
    // reheated on the others.
    const batch = batchOf(state.week, dayIndex, occasion);
    if (!batch || batch.slots.length < 2) return out;
    if (batch.cook !== dayIndex) {
      out.reheat = batch.cook >= 0 && (batch.cook === dayIndex - 1 || batch.legacy) ? tr('planner.leftovers_from', { day: DAY_LABEL[batch.cook] }) : tr('planner.cooked_on', { day: cookDayName(batch.cook) });
      return out;
    }
    const others = batch.slots.filter((slot) => slot.day !== dayIndex || slot.occasion !== occasion);
    out.ahead = batchPortions(state.week, others);
    out.aheadDay = others.map(slotName).join(' + ');
    return out;
  };

  // Portions line + "Für 3 Personen / Nur meine" under the sheet title (template in sections/meal-planner.liquid).
  const recipeHeadNode = () => {
    if (!recipeHead) {
      const tpl = funnel.querySelector('template[data-vhp-recipe-head]');
      recipeHead = tpl?.content?.firstElementChild?.cloneNode(true) || document.createElement('div');
    }
    return recipeHead;
  };

  const paintRecipeWho = () => {
    const head = recipeHeadNode();
    const { n, extra, others, ahead, aheadDay, reheat } = recipeSheetPortions;
    const box = head.querySelector('[data-vhp-recipe-who]');
    if (box) {
      box.hidden = !extra && !ahead;
      box.querySelectorAll('[data-vhp-recipe-who-btn]').forEach((btn) => {
        const on = btn.dataset.vhpRecipeWhoBtn === recipeWho;
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (btn.dataset.vhpRecipeWhoBtn === 'all') btn.textContent = extra ? tr('planner.for_all') : tr('planner.with_leftovers');
      });
    }
    // Headline: the one number the amounts are for. When it is more than your portion, the headline unfolds
    // (tap, not a tooltip: works on touch and does not clip in the sheet) into one row per part and why it is there.
    const scaleEl = head.querySelector('[data-vhp-recipe-scale]');
    const splitEl = head.querySelector('[data-vhp-recipe-split]');
    if (splitEl) {
      splitEl.textContent = '';
      splitEl.hidden = true;
    }
    if (!scaleEl) return;
    if (reheat) {
      scaleEl.textContent = tr('planner.reheat_scale', { scale: fmtScale(n), reheat });
      return;
    }
    const total = recipeCookPortions();
    if (!splitEl || total === n) {
      scaleEl.textContent = fmtScale(n);
      return;
    }
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'vhp-recipe-total';
    toggle.dataset.vhpRecipeWhy = '';
    toggle.setAttribute('aria-expanded', recipeWhyOpen ? 'true' : 'false');
    toggle.setAttribute('aria-controls', 'vhp-recipe-split');
    toggle.textContent = tr('planner.amounts_for', { scale: fmtScale(total) });
    const chev = document.createElement('span');
    chev.className = 'vhp-recipe-total__chev';
    chev.setAttribute('aria-hidden', 'true');
    toggle.append(chev);
    scaleEl.replaceChildren(toggle);
    splitEl.id = 'vhp-recipe-split';
    splitEl.hidden = !recipeWhyOpen;
    const size = Number(state.household?.size) || 1;
    const rows = [['target', tr('planner.why_you_label'), tr('planner.why_you'), n]];
    if (extra) {
      rows.push(['people', tr('planner.why_eaters_label', { n: extra }), size === 1 ? tr('planner.why_eaters') : tr('planner.why_eaters_size', { size: fmtQty(size) }), others]);
    }
    if (ahead) rows.push(['calendar', tr('planner.why_leftovers_label', { day: aheadDay }), tr('planner.why_leftovers'), ahead]);
    rows.forEach(([icon, label, why, qty]) => {
      const row = document.createElement('div');
      row.className = 'vhp-recipe-split__row';
      const text = document.createElement('span');
      text.className = 'vhp-recipe-split__text';
      const strong = document.createElement('strong');
      strong.textContent = label;
      const small = document.createElement('small');
      small.textContent = why;
      text.append(strong, small);
      const num = document.createElement('span');
      num.className = 'vhp-recipe-split__qty';
      num.textContent = fmtQty(qty);
      row.append(spriteIcon(icon, 'vhp-recipe-split__ico'), text, num);
      splitEl.append(row);
    });
  };

  // Shared by catalog and own recipes. Leftovers are reheated, not cooked: no cook mode for them.
  const recipeSheetOptions = (title, extra) => ({
    title,
    snap: 'full',
    head: recipeHeadNode(),
    host: funnel,
    keepUrl: true,
    plan: false,
    cook: !recipeSheetPortions.reheat,
    source: 'planner',
    onBody: (node) => {
      if (node.querySelector('.vhp-recipe-ings__amt, .vhp-recipe-macro')) scaleRecipeAmounts(node, recipeSheetPortions.n, recipeCookPortions());
    },
    onCook: () => usage('use_cook_mode'),
    onClose: () => {
      recipeSheetCustom = null;
      resumeSwipeMedia();
    },
    ...extra,
  });

  function openRecipeSheet({ handle, scale, title, occasion }) {
    if (!handle || !recipeSheet() || recipeSheetOpen()) return;
    recipeSheetCustom = null;
    recipeWhyOpen = false;
    recipeSheetPortions = {
      n: Number(scale) > 0 ? Number(scale) : 1,
      extra: householdExtra(occasion),
      others: householdPortions(occasion),
      ...recipeMealContext(occasion),
    };
    paintRecipeWho();
    pauseSwipeMedia();
    const url = new URL(`/products/${encodeURIComponent(handle)}`, location.origin);
    url.searchParams.set('section_id', RECIPE_SECTION_ID);
    recipeSheet().open(null, recipeSheetOptions(title || tr('common.recipe'), { url: url.toString() }));
  }

  // Own recipes: same sheet, body built in JS from the /api/recipes data (no product page).
  const customRecipeNode = ({ id }) => {
    const meal = weekMeals().find((row) => productId(row.pick?.id) === productId(id));
    const node = customRecipes()?.renderBody(id, meal?.pick);
    if (node) return node;
    const wrap = document.createElement('div');
    wrap.className = 'vhp-swap-empty';
    wrap.dataset.title = meal?.pick?.title || tr('planner.own_dish');
    const p = document.createElement('p');
    p.textContent = customRecipes()?.isLoaded() ? tr('planner.recipe_not_found') : tr('planner.recipe_loading');
    wrap.append(p);
    if (!customRecipes()?.isLoaded()) customRecipes()?.load?.();
    return wrap;
  };

  function paintCustomRecipeSheet(custom) {
    paintRecipeWho();
    recipeSheet()?.setBody(customRecipeNode(custom));
  }

  function openCustomRecipeSheet({ id, scale, occasion }) {
    if (!recipeSheet() || recipeSheetOpen()) return;
    recipeSheetCustom = { id, scale };
    recipeWhyOpen = false;
    recipeSheetPortions = {
      n: Number(scale) > 0 ? Number(scale) : 1,
      extra: householdExtra(occasion),
      others: householdPortions(occasion),
      ...recipeMealContext(occasion),
    };
    paintRecipeWho();
    pauseSwipeMedia();
    const node = customRecipeNode(recipeSheetCustom);
    recipeSheet().open(null, recipeSheetOptions(node.dataset.title || tr('planner.own_dish'), { node }));
  }

  // Re-applies own-recipe data (edits, archive, first load) to meals in the week.
  // Scale stays; per-serving macros × scale as for catalog recipes.
  const refreshCustomMeals = () => {
    const recipes = customRecipes();
    if (!recipes) return false;
    let dirty = false;
    [state.week, state.weekAlt?.week, state.prevWeek?.week].flat().forEach((day) => {
      (day?.meals || []).forEach((meal) => {
        if (!isCustomId(meal.pick?.id)) return;
        const card = recipes.card(meal.pick.id, meal.catalog);
        if (!card) return;
        const scale = Number(meal.scale) || 1;
        const next = {
          kcal: Math.round(card.kcal * scale),
          protein: Math.round(card.protein * scale),
          carbs: Math.round(card.carbs * scale),
          fat: Math.round(card.fat * scale),
        };
        const before = JSON.stringify([meal.pick, meal.kcal, meal.protein, meal.carbs, meal.fat]);
        meal.pick = card;
        Object.assign(meal, next);
        meal.generated = false;
        if (JSON.stringify([meal.pick, meal.kcal, meal.protein, meal.carbs, meal.fat]) !== before) dirty = true;
      });
    });
    if (dirty) persist();
    return dirty;
  };

  // ---------- rendering ----------

  const $ = (sel) => funnel.querySelector(sel);
  const $$ = (sel) => Array.from(funnel.querySelectorAll(sel));
  const deck = $('[data-vhp-swipe-deck]');
  const swipeScreen = $('[data-vhp-screen="swipe"]');
  const swipeFeed = $('[data-vhp-plan-feed]');
  const cardEl = $('[data-vhp-swipe-card]');
  const deckBusy = () => state.screen !== 'swipe' || deck.classList.contains('is-loading');
  // Same deck as the swipe feed (snippets/vhp-swipe-deck.liquid): it paints the cards and turns drags and the
  // buttons into take() / skip(); which card comes next stays here (deckCards).
  const swipeDeck =
    swipeFeed && window.vhpSwipeDeck
      ? window.vhpSwipeDeck.create(swipeFeed, {
          canDrag: () => !deckBusy(),
          canSwipe: () => Boolean(deckCard()) && !deckBusy(),
          onSwipe: (kind) => (kind === 'take' ? take() : skip()),
          dirEls: [swipeScreen, swipeFeed],
          badge: (el, card) => fillSlotLabel(el, SLOT_LABEL[card.slot], card.slot),
          poster: (card) => posterUrl(card),
        })
      : null;

  const fmt = (n) => (n == null ? '–' : String(Math.round(n)));
  const deInt = (n) => Math.max(0, Math.round(Number(n) || 0)).toLocaleString(LOCALE);
  const DAY_NUM_MS = 720;
  const dayNumEase = (t) => t * t * (3 - 2 * t);
  const dayNumTweens = new WeakMap();
  const prefersReducedMotion = () => !motionOk();

  const tweenNumber = (el, to, write) => {
    if (!el) return;
    const target = Number(to) || 0;
    const existing = dayNumTweens.get(el);
    if (existing && existing.to === target) {
      if (!existing.raf) write(target);
      return;
    }
    if (existing?.raf) cancelAnimationFrame(existing.raf);
    const from = existing && Number.isFinite(existing.value) ? existing.value : 0;
    if (prefersReducedMotion() || from === target) {
      dayNumTweens.set(el, { value: target, to: target, raf: 0 });
      write(target);
      return;
    }
    write(from);
    const start = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - start) / DAY_NUM_MS);
      const value = from + (target - from) * dayNumEase(t);
      const done = t >= 1;
      dayNumTweens.set(el, { value: done ? target : value, to: target, raf: done ? 0 : requestAnimationFrame(step) });
      write(done ? target : value);
    };
    dayNumTweens.set(el, { value: from, to: target, raf: requestAnimationFrame(step) });
  };

  const DAY_TOL = 0.03;
  const dayEl = (tag, cls, text) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  };

  // Day summary: one number (kcal of the goal), one bar, one line of macros. One status on the right says
  // what to do next. Built once, then only updated.
  const DAY_MACROS = [
    ['protein', tr('planner.protein')],
    ['carbs', tr('planner.carbs')],
    ['fat', tr('planner.fat')],
  ];
  const buildDayBody = (body) => {
    const num = dayEl('p', 'vhp-day-card__kcal-num');
    num.append(dayEl('strong', 'vhp-day-card__kcal-got'), dayEl('span', 'vhp-day-card__kcal-rest'));
    const status = dayEl('p', 'vhp-day-card__status');
    status.hidden = true;
    const top = dayEl('div', 'vhp-day-card__kcal-top');
    top.append(num, status);
    const bar = dayEl('div', 'vhp-day-card__kcal-bar');
    bar.setAttribute('aria-hidden', 'true');
    bar.append(dayEl('i'), dayEl('b'));
    const kcal = dayEl('div', 'vhp-day-card__kcal');
    kcal.append(top, bar);

    const macros = dayEl('p', 'vhp-day-card__macros');
    DAY_MACROS.forEach(([key, label]) => {
      const item = dayEl('span', `vhp-day-card__macro vhp-day-card__macro--${key}`);
      const got = dayEl('strong', 'vhp-day-card__macro-got');
      item.append(got, dayEl('span', null, ` ${label}`));
      macros.append(item);
    });
    body.replaceChildren(kcal, macros);
  };

  const fillDayMacro = (item, got) => {
    const gotEl = item.querySelector('.vhp-day-card__macro-got');
    tweenNumber(gotEl, got, (n) => {
      gotEl.textContent = `${fmt(n)} g`;
    });
  };

  const fillDayCard = ({ bodyEl, whenEl, badgeEl, totals, when, target }) => {
    const t = totals || { kcal: 0, protein: 0, carbs: 0, fat: 0 };
    const want = Number(target) || state.kcal;
    const goals = macroGrams(want, currentSplit());
    const kcal = Number(t.kcal) || 0;
    const protein = Number(t.protein) || 0;
    const proteinOk = goals.protein > 0 && protein >= goals.protein * 0.95;
    const kcalOver = want > 0 && kcal > want * (1 + DAY_TOL);
    const kcalOk = want > 0 && Math.abs(kcal - want) / want <= DAY_TOL;
    if (whenEl) whenEl.textContent = when || '';
    // The status lives inside the summary now; the old header badge stays empty.
    if (badgeEl) badgeEl.hidden = true;

    if (!bodyEl) return;
    if (!bodyEl.querySelector('.vhp-day-card__kcal')) buildDayBody(bodyEl);
    const card = bodyEl.closest('.vhp-day-card');
    if (card) card.dataset.state = proteinOk ? 'ok' : 'low';

    // One status at a time, in order of what the user can act on: protein first, then kcal.
    let text = '';
    let tone = '';
    if (!proteinOk && goals.protein > 0) {
      text = tr('planner.protein_missing', { n: fmt(Math.max(0, goals.protein - protein)) });
      tone = 'low';
    } else if (kcalOver) {
      text = tr('planner.kcal_too_much', { n: deInt(kcal - want) });
      tone = 'over';
    } else if (kcalOk) {
      text = tr('planner.on_target_check');
      tone = 'ok';
    }
    const status = bodyEl.querySelector('.vhp-day-card__status');
    status.hidden = !text;
    status.textContent = text;
    status.dataset.tone = tone;

    const gotEl = bodyEl.querySelector('.vhp-day-card__kcal-got');
    tweenNumber(gotEl, kcal, (n) => {
      gotEl.textContent = deInt(n);
    });
    bodyEl.querySelector('.vhp-day-card__kcal-rest').textContent = want > 0 ? ` / ${deInt(want)} kcal` : ' kcal';
    // Bar: forest up to the goal, rust for whatever goes past it (scale only grows when over).
    const scale = Math.max(want, kcal, 1);
    const [fill, spill] = bodyEl.querySelectorAll('.vhp-day-card__kcal-bar > *');
    const within = Math.min(kcal, want || kcal);
    fill.style.width = `${(within / scale) * 100}%`;
    spill.style.left = `${(want / scale) * 100}%`;
    spill.style.width = `${(Math.max(0, kcal - want) / scale) * 100}%`;
    bodyEl.querySelector('.vhp-day-card__kcal').classList.toggle('is-over', kcalOver);

    const items = bodyEl.querySelectorAll('.vhp-day-card__macro');
    fillDayMacro(items[0], protein);
    fillDayMacro(items[1], Number(t.carbs) || 0);
    fillDayMacro(items[2], Number(t.fat) || 0);
  };

  // Week head numbers (planner skin v2): kcal and protein side by side, each a ring that fills up to the goal (a
  // second lap in gold for kcal past it) next to its label with a status mark (✓ on target, ! too many kcal) and
  // "1.890 / 2.100". The rings fill from empty on the first paint and glide on every change.
  const SVG_RING = 'http://www.w3.org/2000/svg';
  const ringArc = (cls) => {
    const arc = document.createElementNS(SVG_RING, 'circle');
    arc.setAttribute('class', cls);
    arc.setAttribute('cx', '24');
    arc.setAttribute('cy', '24');
    arc.setAttribute('r', '20');
    arc.setAttribute('pathLength', '100');
    return arc;
  };
  const buildWeekStats = (body) => {
    const stat = (key, label) => {
      const box = dayEl('div', `vhp-wk__stat vhp-wk__stat--${key}`);
      const ring = document.createElementNS(SVG_RING, 'svg');
      ring.setAttribute('class', 'vhp-wk__ring');
      ring.setAttribute('viewBox', '0 0 48 48');
      ring.setAttribute('aria-hidden', 'true');
      ring.append(ringArc('vhp-wk__track'), ringArc('vhp-wk__arc'), ringArc('vhp-wk__spill'));
      const copy = dayEl('div', 'vhp-wk__copy');
      const top = dayEl('div', 'vhp-wk__stat-top');
      const badge = dayEl('span', 'vhp-wk__badge');
      badge.setAttribute('role', 'img');
      top.append(dayEl('span', 'vhp-wk__label', label), badge);
      const line = dayEl('p', 'vhp-wk__line');
      line.append(dayEl('strong', 'vhp-wk__num'), dayEl('span', 'vhp-wk__goal'));
      copy.append(top, line);
      box.append(ring, copy);
      return box;
    };
    const nums = dayEl('div', 'vhp-wk__nums');
    nums.append(stat('kcal', tr('planner.calories')), stat('protein', tr('planner.protein')));
    // Carbs and fat: one quiet line under the rings.
    body.replaceChildren(nums, dayEl('p', 'vhp-wk__rest'));
  };


  const checkIcon = () =>
    strokeIcon((svg) => {
      addStroke(svg, 'path', { d: 'M5 12.5l4.5 4.5L19 7.5', 'stroke-width': '3' });
    });
  // "!" for too many kcal: a heads-up, not a failure.
  const warnIcon = () =>
    strokeIcon((svg) => {
      addStroke(svg, 'path', { d: 'M12 6.5v7', 'stroke-width': '3' });
      addStroke(svg, 'path', { d: 'M12 18h.01', 'stroke-width': '3.4' });
    });

  // Badge next to a label: tone done (✓), over (!) or open (ring). The words go to screen readers and the tooltip.
  const paintWeekBadge = (el, tone, text) => {
    if (el.dataset.tone !== tone) {
      el.replaceChildren();
      if (tone === 'done') el.append(checkIcon());
      else if (tone === 'over') el.append(warnIcon());
      el.dataset.tone = tone;
    }
    el.hidden = !text;
    el.setAttribute('aria-label', text);
    el.title = text;
  };

  // Ring: its colour up to the goal; past it (kcal) a second lap in gold for the part over, up to one more lap.
  const fillWeekRing = (ring, got, want) => {
    const [, arc, spill] = ring.children;
    const share = want > 0 ? got / want : 0;
    const fill = Math.min(1, share) * 100;
    const over = Math.min(1, Math.max(0, share - 1)) * 100;
    arc.style.strokeDashoffset = String(100 - fill);
    arc.style.opacity = fill > 0.5 ? '1' : '0';
    spill.style.strokeDashoffset = String(100 - over);
    spill.style.opacity = over > 0.5 ? '1' : '0';
  };

  const fillWeekStats = (bodyEl, totals, target, key) => {
    if (!bodyEl) return;
    if (!bodyEl.querySelector('.vhp-wk__nums')) {
      buildWeekStats(bodyEl);
      // Rings start empty, so the first fill glides in.
      void bodyEl.offsetWidth;
    }
    const t = totals || {};
    const want = Number(target) || state.kcal;
    const goals = macroGrams(want, currentSplit());
    const kcal = Number(t.kcal) || 0;
    const protein = Number(t.protein) || 0;
    const [kcalBox, proteinBox] = bodyEl.querySelectorAll('.vhp-wk__stat');

    const kcalNum = kcalBox.querySelector('.vhp-wk__num');
    tweenNumber(kcalNum, kcal, (n) => {
      kcalNum.textContent = deInt(n);
    });
    // No unit after the goal: the label says Kalorien, and "/ 2.940 kcal" would not fit next to a 4-digit number.
    kcalBox.querySelector('.vhp-wk__goal').textContent = want > 0 ? `/ ${deInt(want)}` : 'kcal';
    const kcalOver = want > 0 && kcal > want * (1 + DAY_TOL);
    const kcalDone = want > 0 && !kcalOver && kcal >= want * (1 - DAY_TOL);
    // Planner skin: the same day reaching its goal after a change (a swap) gets a small celebration.
    const dayKey = key || `${state.weekStart}|${state.weekDay}`;
    if (kcalDone && bodyEl.dataset.day === dayKey && !kcalBox.classList.contains('is-done')) {
      window.setTimeout(() => {
        window.vhpUi?.burst(kcalBox.querySelector('.vhp-wk__badge'), { count: 18, spread: 0.7 });
        window.vhpUi?.buzz(14);
      }, 450);
    }
    bodyEl.dataset.day = dayKey;
    kcalBox.classList.toggle('is-over', kcalOver);
    kcalBox.classList.toggle('is-done', kcalDone);
    fillWeekRing(kcalBox.querySelector('.vhp-wk__ring'), kcal, want);
    const kcalBadge = kcalBox.querySelector('.vhp-wk__badge');
    if (!(want > 0)) paintWeekBadge(kcalBadge, 'open', '');
    else if (kcalOver) paintWeekBadge(kcalBadge, 'over', tr('planner.kcal_over_goal', { n: deInt(kcal - want) }));
    else if (kcalDone) paintWeekBadge(kcalBadge, 'done', tr('planner.kcal_goal_hit'));
    else paintWeekBadge(kcalBadge, 'open', tr('planner.kcal_to_goal', { n: deInt(want - kcal) }));

    const proteinGoal = Math.round(goals.protein || 0);
    const proteinNum = proteinBox.querySelector('.vhp-wk__num');
    tweenNumber(proteinNum, protein, (n) => {
      proteinNum.textContent = fmt(n);
    });
    proteinBox.querySelector('.vhp-wk__goal').textContent = proteinGoal > 0 ? `/ ${proteinGoal} g` : 'g';
    // More protein is never "over": the bar just fills up. Within DAY_TOL below the goal counts as hit, like kcal.
    const proteinDone = proteinGoal > 0 && protein >= proteinGoal * (1 - DAY_TOL);
    proteinBox.classList.toggle('is-done', proteinDone);
    fillWeekRing(proteinBox.querySelector('.vhp-wk__ring'), Math.min(protein, proteinGoal || protein), proteinGoal);
    const proteinBadge = proteinBox.querySelector('.vhp-wk__badge');
    if (!proteinGoal) paintWeekBadge(proteinBadge, 'open', '');
    else if (proteinDone) paintWeekBadge(proteinBadge, 'done', tr('planner.protein_goal_hit'));
    else paintWeekBadge(proteinBadge, 'open', tr('planner.protein_to_goal', { n: proteinGoal - Math.round(protein) }));
    bodyEl.querySelector('.vhp-wk__rest').textContent =
      tr('planner.carbs_fat', { carbs: fmt(Number(t.carbs) || 0), fat: fmt(Number(t.fat) || 0) });
  };

  const renderDayTab = ({ label, date, selected, locked, today, past, on }) => {
    const btn = document.createElement(on ? 'button' : 'div');
    if (on) btn.type = 'button';
    btn.className = 'vhp-week-day';
    btn.classList.toggle('is-on', Boolean(selected));
    btn.classList.toggle('is-locked', Boolean(locked));
    btn.classList.toggle('is-today', Boolean(today));
    btn.classList.toggle('is-past', Boolean(past));
    btn.setAttribute('role', 'tab');
    btn.setAttribute('aria-selected', selected ? 'true' : 'false');
    if (locked) btn.setAttribute('aria-disabled', 'true');
    const name = document.createElement('span');
    name.className = 'vhp-week-day__name';
    name.textContent = label;
    const num = document.createElement('span');
    num.className = 'vhp-week-day__date';
    num.textContent = String(date);
    const dot = document.createElement('span');
    dot.className = 'vhp-week-day__dot';
    btn.append(name, num, dot);
    return btn;
  };

  const renderMacros = () => {
    const split = currentSplit();
    const grams = macroGrams(state.kcal, split);
    const p = MACRO_KEYS.map((key) => split[key]);
    const starts = [macroRot, macroRot + p[0], macroRot + p[0] + p[1]];
    const ring = $('[data-vhp-macro-ring]');
    if (ring) ring.classList.toggle('is-dragging', macroDrag != null);

    MACRO_KEYS.forEach((key, i) => {
      const arc = $(`[data-vhp-macro-arc="${key}"]`);
      if (arc) {
        // Period of exactly one circumference, so a segment rotated across 12 o'clock wraps around.
        arc.setAttribute('stroke-dasharray', `${MACRO_C * p[i] / 100} ${MACRO_C * (100 - p[i]) / 100}`);
        arc.setAttribute('stroke-dashoffset', String(-MACRO_C * starts[i] / 100));
      }
      const mid = starts[i] + p[i] / 2;
      const [ax, ay] = macroPoint(mid, MACRO_R + 20);
      const [bx, by] = macroPoint(mid, MACRO_R + 44);
      const right = bx >= MACRO_CX;
      const cx2 = bx + (right ? 14 : -14);
      const lead = $(`[data-vhp-macro-lead="${key}"]`);
      if (lead) lead.setAttribute('points', `${ax},${ay} ${bx},${by} ${cx2},${by}`);
      const dot = $(`[data-vhp-macro-dot="${key}"]`);
      if (dot) {
        dot.setAttribute('cx', String(ax));
        dot.setAttribute('cy', String(ay));
      }
      const label = $(`[data-vhp-macro-label="${key}"]`);
      if (label) {
        label.style.left = `${(cx2 + (right ? 6 : -6)) / 4}%`;
        label.style.top = `${by / 4}%`;
        label.style.transform = right ? 'translate(0,-50%)' : 'translate(-100%,-50%)';
        label.style.textAlign = right ? 'left' : 'right';
      }
      const gEl = $(`[data-vhp-macro-g="${key}"]`);
      if (gEl) gEl.textContent = String(grams[key]);
      const pctEl = $(`[data-vhp-macro-pct="${key}"]`);
      if (pctEl) pctEl.textContent = `${Math.round(p[i])} %`;
    });

    // Knob i sits where segment i ends; that segment's round cap lies on top of the next one.
    const handleAt = MACRO_KEYS.map((key, i) => macroPoint(starts[i] + p[i], MACRO_R));
    MACRO_KEYS.forEach((key, i) => {
      const cap = $(`[data-vhp-macro-cap="${key}"]`);
      if (!cap) return;
      cap.setAttribute('cx', String(handleAt[i][0]));
      cap.setAttribute('cy', String(handleAt[i][1]));
    });
    $$('[data-vhp-macro-handle]').forEach((handle) => {
      const [hx, hy] = handleAt[Number(handle.dataset.vhpMacroHandle)] || handleAt[0];
      handle.querySelectorAll('circle').forEach((circle) => {
        circle.setAttribute('cx', String(hx));
        circle.setAttribute('cy', String(hy));
      });
    });

    const kcalEl = $('[data-vhp-macro-kcal]');
    if (kcalEl) kcalEl.textContent = state.kcal != null ? state.kcal.toLocaleString(LOCALE) : '–';

    $$('[data-vhp-macro-preset]').forEach((btn) => {
      btn.classList.toggle('is-on', btn.dataset.vhpMacroPreset === state.macrosPreset);
    });

    const recommended = MACRO_PRESETS.recommended;
    const modified = !sameSplit(split, recommended);
    const reset = $('[data-vhp-macro-reset]');
    if (reset) reset.hidden = !modified;

    const note = $('[data-vhp-macro-note]');
    if (note) {
      const lowProtein = Number(state.weight) > 0 && grams.protein / state.weight < 1.6;
      note.classList.toggle('is-warn', lowProtein);
      note.textContent = lowProtein
        ? tr('planner.low_protein')
        : modified
          ? ''
          : tr('planner.drag_points');
    }
  };

  const mediaFromCard = (card) => {
    const deferred = card.el.querySelector('deferred-media');
    const fromTemplate = deferred?.querySelector('template')?.content.cloneNode(true);
    return {
      video: fromTemplate?.querySelector('video') || deferred?.querySelector('video')?.cloneNode(true) || null,
      iframe: fromTemplate?.querySelector('iframe') || null,
    };
  };

  const posterUrl = (card) =>
    card.image ||
    card.el?.querySelector('.deferred-media__poster-image')?.currentSrc ||
    card.el?.querySelector('.card-img img')?.currentSrc ||
    '';

  const makePoster = (url) => {
    const poster = document.createElement('img');
    poster.className = 'vhp-swipe-card__poster';
    poster.src = url;
    poster.alt = '';
    poster.draggable = false;
    return poster;
  };

  const armVideo = (video, play) => {
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.controls = false;
    video.preload = 'auto';
    video.autoplay = play;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    if (play) video.setAttribute('autoplay', '');
    else video.removeAttribute('autoplay');
  };

  // ---------- Rezepte tab: hub + set grid ----------

  const HERO_MS = 6500;

  const hubThumb = (url, width = 480) => {
    const src = String(url || '');
    if (!src) return '';
    try {
      const u = new URL(src, location.href);
      u.searchParams.set('width', String(width));
      u.searchParams.delete('height');
      u.pathname = u.pathname.replace(/_(\d+x(?:\d+)?)(?=\.[a-z0-9]+$)/i, `_${width}x`);
      return u.href;
    } catch (e) {
      return src;
    }
  };

  const recipeWord = (n) => tr('common.recipes', { n });

  // Browsable catalog: breakfast / main / snack minus the user's exclusions (cook time does not hide).
  const hubCards = () => {
    const seen = new Set();
    const out = [];
    PLAN_SLOTS.forEach((slot) => {
      poolFor(slot).forEach((card) => {
        const id = productId(card.id);
        if (!id || seen.has(id)) return;
        seen.add(id);
        out.push(card);
      });
    });
    return out;
  };

  const catalogTotal = () =>
    PLAN_SLOTS.reduce((sum, slot) => sum + (planner.counts(slot)?.total || 0), 0);

  // Liked or skipped in the setup deck counts as seen too: those were on screen already.
  const seenIdSet = () =>
    new Set([
      ...(state.seen || []),
      ...likeItems().map((item) => item.id),
      ...(state.skips?.items || []).map((item) => item.id),
    ]);

  // "Neu für dich": unseen catalog recipes, interleaved by meal like the setup deck.
  const unseenCards = (cards) => {
    const seen = seenIdSet();
    const groups = {};
    PLAN_SLOTS.forEach((slot) => {
      groups[slot] = [];
    });
    cards.forEach((card) => {
      const id = productId(card.id);
      if (!id || seen.has(id) || !groups[card.slot]) return;
      groups[card.slot].push(card);
    });
    return deal(groups, PLAN_SLOTS);
  };

  let hubCatsKey = '';
  let hubCats = { meal: [], themes: [] };
  const hubCategories = (cards) => {
    if (!hubRules) return hubCats;
    const key = `${cards.length}|${cards.map((card) => productId(card.id)).join(',')}`;
    if (key !== hubCatsKey) {
      hubCatsKey = key;
      hubCats = hubRules.categories(cards);
    }
    return hubCats;
  };
  const findCategory = (cards, id) => {
    const cats = hubCategories(cards);
    return cats.meal.concat(cats.themes).find((row) => row.id === id) || null;
  };

  const hubCopy = (card, kind) => {
    const root = card?.el?.querySelector('.recipe-card');
    const category = root?.querySelector('.card-category')?.textContent?.trim() || '';
    const description = root?.querySelector('.card-description')?.textContent?.trim() || '';
    if (kind === 'own') {
      return {
        category: tr('planner.own_category', { slot: SLOT_LABEL[card.slot] || tr('common.recipe') }),
        description: '',
      };
    }
    return {
      category: category || SLOT_LABEL[card.slot] || '',
      description,
    };
  };

  const swapStat = (value, label) => {
    const stat = document.createElement('span');
    stat.className = 'vhp-swap-tile__stat';
    const strong = document.createElement('strong');
    strong.textContent = value;
    const span = document.createElement('span');
    span.textContent = label;
    stat.append(strong, span);
    return stat;
  };

  const hubBarChip = (value, label) => {
    const chip = document.createElement('span');
    chip.className = 'vhp-tile__chip';
    const strong = document.createElement('strong');
    strong.textContent = value;
    const span = document.createElement('span');
    span.textContent = label;
    chip.append(strong, span);
    return chip;
  };

  const setLikeButton = (btn, on) => {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? tr('planner.unsave') : tr('planner.save'));
    btn.replaceChildren(heartIcon(on));
  };

  // Set grid card (same look as the collection full-bleed card). Tap opens the reel at this recipe.
  const hubTile = (card, kind) => {
    const id = productId(card.id);
    const copy = hubCopy(card, kind);
    const article = document.createElement('article');
    article.className = 'vhp-tile';
    article.dataset.vhpHubId = id;

    const open = document.createElement('button');
    open.type = 'button';
    open.className = 'vhp-tile__open';
    open.dataset.vhpRxCard = id;
    open.setAttribute('aria-label', tr('planner.view_title', { title: card.title || (kind === 'own' ? tr('planner.own_dish') : tr('common.recipe')) }));

    const photo = document.createElement('span');
    photo.className = 'vhp-tile__photo';
    photo.dataset.slot = card.slot || 'main';
    const src = hubThumb(card.image);
    if (src) {
      const img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.draggable = false;
      photo.append(img);
    }

    const face = document.createElement('span');
    face.className = 'vhp-tile__face';
    const kicker = document.createElement('span');
    kicker.className = 'vhp-tile__kicker';
    kicker.textContent = copy.category;
    const title = document.createElement('span');
    title.className = 'vhp-tile__title';
    title.textContent = card.title || (kind === 'own' ? tr('planner.own_dish') : tr('common.recipe'));
    face.append(kicker, title);
    if (copy.description) {
      const desc = document.createElement('span');
      desc.className = 'vhp-tile__desc';
      desc.textContent = copy.description;
      face.append(desc);
    }
    const protein = Number(card.protein);
    const kcal = Number(card.kcal);
    const carbs = Number(card.carbs);
    const bar = document.createElement('span');
    bar.className = 'vhp-tile__bar';
    bar.append(
      hubBarChip(Number.isFinite(protein) && protein > 0 ? `${fmt(protein)}g` : '–', tr('planner.protein')),
      hubBarChip(Number.isFinite(kcal) && kcal > 0 ? fmt(kcal) : '–', 'kcal'),
      hubBarChip(Number.isFinite(carbs) && carbs > 0 ? `${fmt(carbs)}g` : '–', tr('planner.carbs'))
    );
    face.append(bar);
    open.append(photo, face);
    article.append(open);

    // Own recipes are not product favorites, so no heart.
    if (kind !== 'own') {
      const tools = document.createElement('span');
      tools.className = 'vhp-tile__tools';
      const like = document.createElement('button');
      like.type = 'button';
      like.className = 'vhp-tile__plus';
      like.dataset.vhpRxLike = id;
      setLikeButton(like, likeItems().some((item) => item.id === id));
      tools.append(like);
      article.append(tools);
    }
    return article;
  };

  const hubOwnActions = () => {
    const create = document.createElement('button');
    create.type = 'button';
    create.className = 'vhp-tile vhp-tile--action';
    create.dataset.vhpRxCreate = '1';
    create.innerHTML = tr('planner.new_recipe_html');

    const soon = document.createElement('div');
    soon.className = 'vhp-tile vhp-tile--action vhp-tile--soon';
    soon.innerHTML = tr('planner.import_soon_html');
    return [create, soon];
  };

  const hubOwnCards = (needle) => {
    const store = customRecipes();
    if (!store) return [];
    return store.all()
      .filter((recipe) => recipe?.status === 'active')
      .filter((recipe) => {
        if (!needle) return true;
        const parts = [recipe.title || ''];
        (recipe.ingredients || []).forEach((row) => {
          if (row?.name) parts.push(row.name);
        });
        return foldSearch(parts.join(' ')).includes(needle);
      })
      .map((recipe) => store.card(recipe.id, recipe.meal_types?.[0] || 'main'))
      .filter(Boolean);
  };

  const hubLikeCards = () =>
    likeItems()
      .filter((item) => !isCustomId(item.id))
      .slice()
      .reverse()
      .map((item) => hydrateSwapCard(item))
      .filter(Boolean);

  // The set on screen: a typed query wins over an opened category / Favoriten / Eigene.
  const activeSet = () => {
    const q = hub.query.trim();
    if (q) return { kind: 'search', id: 'search', title: q };
    return hub.set;
  };

  const setCards = (set, cards) => {
    if (!set) return [];
    if (set.kind === 'likes') return hubLikeCards();
    if (set.kind === 'own') return hubOwnCards('');
    if (set.kind === 'search') {
      const needle = foldSearch(hub.query).trim();
      const typed = hub.query;
      const rank = algoliaRank(typed, () => {
        if (hub.query === typed) {
          hubGridKey = '';
          renderRecipes();
        }
      });
      const found = cards.filter((card) => cardMatchesSearch(card, needle, rank));
      // Algolia's relevance first; local-only matches keep their order at the end.
      if (rank) found.sort((a, b) => (rank.get(productId(a.id)) ?? 1e9) - (rank.get(productId(b.id)) ?? 1e9));
      return found.concat(hubOwnCards(needle));
    }
    const cat = findCategory(cards, set.id);
    if (!cat) return [];
    const byId = new Map(cards.map((card) => [productId(card.id), card]));
    return cat.ids.map((id) => byId.get(id)).filter(Boolean);
  };

  const syncHubHearts = (grid) => {
    const liked = new Set(likeItems().map((item) => item.id));
    grid.querySelectorAll('[data-vhp-rx-like]').forEach((btn) => {
      const on = liked.has(btn.dataset.vhpRxLike);
      if ((btn.getAttribute('aria-pressed') === 'true') !== on) setLikeButton(btn, on);
    });
  };

  const paintSetGrid = (set, cards) => {
    const grid = $('[data-vhp-hub-grid]');
    if (!grid) return;
    const ids = cards.map((card) => `${productId(card.id)}:${card.title || ''}`).join('\u001f');
    const key = `${set.kind}|${set.id}|${hub.query}|${ids}`;
    if (key === hubGridKey && grid.childElementCount) {
      syncHubHearts(grid);
      return;
    }
    hubGridKey = key;
    const nodes = set.kind === 'own' ? hubOwnActions() : [];
    cards.forEach((card) => nodes.push(hubTile(card, isCustomId(productId(card.id)) ? 'own' : 'catalog')));
    grid.replaceChildren(...nodes);
  };

  const setEmptyCopy = (set) => {
    if (set.kind === 'likes') return tr('planner.no_favs_yet');
    if (set.kind === 'search') {
      return hubCatalogReady ? tr('planner.no_hits') : tr('planner.recipes_loading');
    }
    if (set.kind === 'own') return '';
    return hubCatalogReady ? tr('planner.nothing_now') : tr('planner.recipes_loading');
  };

  let hubTilesKey = '';

  const categoryTile = (row, image) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vhp-rx-tile';
    btn.dataset.vhpRxCat = row.id;
    btn.dataset.group = row.group;
    const photo = document.createElement('span');
    photo.className = 'vhp-rx-tile__photo';
    if (image) {
      const img = document.createElement('img');
      img.src = hubThumb(image, 360);
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.draggable = false;
      photo.append(img);
    }
    const name = document.createElement('strong');
    name.className = 'vhp-rx-tile__name';
    name.textContent = row.label;
    const count = document.createElement('span');
    count.className = 'vhp-rx-tile__count';
    count.textContent = recipeWord(row.ids.length);
    btn.append(photo, name, count);
    btn.setAttribute('aria-label', `${row.label}, ${recipeWord(row.ids.length)}`);
    return btn;
  };

  const tileSkeleton = () => {
    const el = document.createElement('span');
    el.className = 'vhp-rx-tile vhp-rx-tile--skel';
    el.setAttribute('aria-hidden', 'true');
    return el;
  };

  // Each tile shows the photo of its first recipe that no earlier tile uses yet.
  const renderTiles = (cards) => {
    const cats = hubCategories(cards);
    const key = `${hubCatalogReady}|${hubCatsKey}`;
    if (key === hubTilesKey) return;
    hubTilesKey = key;
    const byId = new Map(cards.map((card) => [productId(card.id), card]));
    const used = new Set();
    const imageFor = (row) => {
      const pick = row.ids.find((id) => byId.get(id)?.image && !used.has(id)) || row.ids.find((id) => byId.get(id)?.image);
      if (!pick) return '';
      used.add(pick);
      return byId.get(pick).image;
    };
    [['meal', cats.meal], ['themes', cats.themes]].forEach(([group, rows]) => {
      const box = $(`[data-vhp-rx-tiles="${group}"]`);
      const section = box?.closest('[data-vhp-rx-group]');
      if (!box) return;
      if (!hubCatalogReady) {
        box.replaceChildren(tileSkeleton(), tileSkeleton(), tileSkeleton());
        if (section) section.hidden = false;
        return;
      }
      box.replaceChildren(...rows.map((row) => categoryTile(row, imageFor(row))));
      if (section) section.hidden = !rows.length;
    });
  };

  // ---------- "Neu für dich" hero ----------

  const hero = { id: null, timer: 0, gen: 0 };
  let recipesMediaHeld = false;

  const heroVideo = () => $('[data-vhp-rx-hero-media]')?.querySelector('video') || null;

  const heroRunning = () =>
    inRecipes() && !activeSet() && !reelIsOpen() && !recipesMediaHeld && document.visibilityState !== 'hidden';

  function stopHero() {
    window.clearTimeout(hero.timer);
    hero.timer = 0;
    heroVideo()?.pause();
    $('[data-vhp-rx-hero]')?.classList.remove('is-timing');
  }

  const paintHero = (card) => {
    const media = $('[data-vhp-rx-hero-media]');
    const root = $('[data-vhp-rx-hero]');
    if (!media || !root) return;
    const id = productId(card.id);
    if (hero.id === id) return;
    hero.id = id;
    const gen = ++hero.gen;
    media.querySelectorAll('video').forEach((video) => video.pause());
    media.replaceChildren();
    root.classList.add('is-media-loading');
    const url = posterUrl(card);
    if (url) {
      const poster = makePoster(hubThumb(url, 800));
      poster.className = 'vhp-rx-hero__poster';
      media.append(poster);
    }
    const { video } = mediaFromCard(card);
    if (video) {
      armVideo(video, false);
      video.className = 'vhp-rx-hero__video';
      video.addEventListener('playing', () => {
        if (gen === hero.gen) root.classList.remove('is-media-loading');
      }, { once: true });
      media.append(video);
    } else {
      root.classList.remove('is-media-loading');
    }
    $('[data-vhp-rx-hero-title]').textContent = card.title || tr('common.recipe');
    const meta = [];
    if (Number(card.protein) > 0) meta.push(tr('common.protein', { n: fmt(card.protein) }));
    if (Number(card.kcal) > 0) meta.push(`${fmt(card.kcal)} kcal`);
    if (Number(card.time) > 0) meta.push(`⏱ ${tr('common.min', { n: fmt(card.time) })}`);
    $('[data-vhp-rx-hero-meta]').textContent = meta.join(' · ');
    root.dataset.vhpRxHeroId = id;
  };

  // What the hero shows, first match wins:
  // 1. unseen recipes ("Neu für dich"),
  // 2. favorites that are not in this week's plan (one tap from "In Plan einfügen"),
  // 3. a theme tile that rotates weekly, so the hero never disappears.
  const heroSource = (cards) => {
    const unseen = unseenCards(cards);
    if (unseen.length) {
      return {
        kind: 'new',
        kicker: tr('planner.new_for_you'),
        badge: hubCatalogReady ? tr('planner.n_new', { n: unseen.length }) : '',
        reelTitle: tr('planner.new_for_you'),
        cards: unseen,
      };
    }
    // Until the whole catalog is in, "nothing new" may just mean "not loaded yet".
    if (!hubCatalogReady) return null;
    const byId = new Map(cards.map((card) => [productId(card.id), card]));
    const planned = new Set(weekMeals().map((meal) => productId(meal.pick.id)));
    const favs = likeItems()
      .filter((item) => !isCustomId(item.id) && !planned.has(item.id))
      .slice()
      .reverse()
      .map((item) => byId.get(item.id))
      .filter(Boolean);
    if (favs.length) {
      return {
        kind: 'favs',
        kicker: tr('planner.not_planned_yet'),
        badge: tr('planner.favs', { n: favs.length }),
        reelTitle: tr('planner.not_planned_yet'),
        cards: favs,
      };
    }
    const themes = hubCategories(cards).themes.filter((row) => row.ids.length);
    if (!themes.length) return null;
    const week = Math.floor(weekMonday().getTime() / (7 * 24 * 60 * 60 * 1000));
    const theme = themes[week % themes.length];
    return {
      kind: 'theme',
      kicker: tr('planner.theme_of_week'),
      badge: theme.label,
      reelTitle: theme.label,
      cards: theme.ids.map((id) => byId.get(id)).filter(Boolean),
    };
  };

  const heroList = () => heroSource(hubCards())?.cards || [];

  const advanceHero = () => {
    hero.timer = 0;
    const list = heroList();
    if (!list.length) {
      render();
      return;
    }
    const at = list.findIndex((card) => productId(card.id) === hero.id);
    paintHero(list[(at + 1) % list.length]);
    syncRecipesMedia();
  };

  const runHero = () => {
    const video = heroVideo();
    if (video && video.paused) void video.play().catch(() => {});
    if (hero.timer) return;
    const root = $('[data-vhp-rx-hero]');
    if (root) {
      root.classList.remove('is-timing');
      void root.offsetWidth;
      root.classList.add('is-timing');
    }
    hero.timer = window.setTimeout(advanceHero, HERO_MS);
  };

  const renderHero = (cards) => {
    const root = $('[data-vhp-rx-hero]');
    if (!root) return;
    const source = heroSource(cards);
    const list = source?.cards || [];
    root.hidden = !list.length;
    // Skeleton while the catalog loads and there is nothing to show yet.
    const skel = $('[data-vhp-rx-hero-skel]');
    if (skel) skel.hidden = Boolean(list.length) || hubCatalogReady;
    if (!list.length) {
      stopHero();
      hero.id = null;
      return;
    }
    root.dataset.kind = source.kind;
    const kicker = $('[data-vhp-rx-hero-kicker]');
    if (kicker) kicker.textContent = source.kicker;
    const badge = $('[data-vhp-rx-hero-badge]');
    if (badge) {
      badge.hidden = !source.badge;
      badge.textContent = source.badge;
    }
    const current = list.find((card) => productId(card.id) === hero.id) || list[0];
    paintHero(current);
    root.setAttribute('aria-label', tr('planner.reel_of', { kicker: source.kicker, title: current.title || tr('common.recipe') }));
  };

  // Single place that decides which Rezepte media may play: hero on the hub, the visible reel slide.
  // Everything pauses when the tab is hidden, a sheet is open, or the user leaves the tab.
  function syncRecipesMedia() {
    if (heroRunning() && hero.id && !$('[data-vhp-rx-hero]')?.hidden) runHero();
    else stopHero();
    reelViewer()?.hold(recipesMediaHeld || document.visibilityState === 'hidden');
  }

  // ---------- render ----------

  const renderRecipes = () => {
    const screen = $('[data-vhp-screen="recipes"]');
    if (!screen) return;
    if (!inRecipes()) {
      stopHero();
      return;
    }
    const cards = hubCards();
    const set = activeSet();

    const countEl = $('[data-vhp-rx-count]');
    if (countEl) {
      const n = hubCatalogReady ? cards.length : catalogTotal();
      countEl.textContent = tr('common.recipes', { n });
    }
    const likeN = $('[data-vhp-rx-like-n]');
    if (likeN) likeN.textContent = recipeWord(likeItems().filter((item) => !isCustomId(item.id)).length);
    const ownN = $('[data-vhp-rx-own-n]');
    if (ownN) ownN.textContent = recipeWord(customRecipes()?.count?.() || 0);
    const create = $('[data-vhp-rx-create]');
    if (create) create.hidden = !customRecipes();

    const q = $('[data-vhp-rx-q]');
    if (q && document.activeElement !== q && q.value !== hub.query) q.value = hub.query;

    const browsingSet = Boolean(set && set.kind !== 'search');
    $('[data-vhp-rx-top]').hidden = browsingSet;
    $('[data-vhp-rx-home]').hidden = Boolean(set);
    const setEl = $('[data-vhp-rx-set]');
    setEl.hidden = !set;

    if (!set) {
      renderHero(cards);
      renderTiles(cards);
    } else {
      const list = setCards(set, cards);
      const head = $('[data-vhp-rx-set-head]');
      if (head) head.hidden = set.kind === 'search';
      const title = $('[data-vhp-rx-set-title]');
      if (title) title.textContent = set.title;
      const count = $('[data-vhp-rx-set-count]');
      if (count) {
        count.textContent = set.kind === 'search'
          ? tr('planner.hits', { n: list.length })
          : recipeWord(list.length);
      }
      const reelBtn = $('[data-vhp-rx-reel]');
      if (reelBtn) reelBtn.hidden = !list.length;
      paintSetGrid(set, list);
      const note = $('[data-vhp-hub-note]');
      if (note) {
        const empty = list.length ? '' : setEmptyCopy(set);
        note.hidden = !empty;
        note.textContent = empty;
      }
    }
    syncRecipesMedia();
  };

  const recipesScroller = () => $('[data-vhp-rx-scroll]');

  const openSet = (set) => {
    const scroller = recipesScroller();
    if (!hub.set && !hub.query.trim()) hub.hubTop = scroller?.scrollTop || 0;
    hub.set = set;
    hubGridKey = '';
    render();
    if (scroller) scroller.scrollTop = 0;
  };

  const closeSet = () => {
    hub.set = null;
    hubGridKey = '';
    render();
    const scroller = recipesScroller();
    if (scroller) scroller.scrollTop = hub.hubTop || 0;
  };

  function toggleRecipeLike(id) {
    if (isCustomId(productId(id))) return;
    const card = hydrateSwapCard(findCatalogCard(id));
    if (!card) return;
    const sid = productId(card.id);
    const liked = likeItems().some((item) => item.id === sid);
    if (liked) {
      state.likes.items = state.likes.items.filter((item) => item.id !== sid);
      if (state.undo?.action === 'like' && state.undo.item?.id === sid) state.undo = null;
      plannerEvents('retract', 'recipe_liked', sid);
    } else {
      const item = asLike(card);
      if (!item) return;
      state.likes.items = state.likes.items.filter((row) => row.id !== item.id);
      state.likes.items.push(item);
      state.skips.items = state.skips.items.filter((row) => row.id !== item.id);
      recipeEvent('recipe_liked', item, item.slot, 'reel');
    }
    persist();
    if (planner.config.paid) {
      state.pendingFlush = true;
      flushProfile();
    }
    render();
  }

  // Leaving the tab (dock) stops its media. Hub position is kept for the next visit.
  function leaveRecipes() {
    closeReel();
    stopHero();
  }

  // ---------- Reel: the shared vertical reel (assets/vhp-reel-viewer.js, as on Likes and Search) ----------
  // The planner hands it its cards from memory (video, own recipes) and its own like / plan / recipe actions.
  // A recipe counts as seen once it was on screen or scrolled past.

  const REEL_SEEN_FLUSH_MS = 4000;
  // session: { cards, swap } of the reel on screen. swap: { occasion, rows, others, target } from the swap sheet.
  const reel = { session: null, seenTimer: 0 };

  const reelViewer = () => window.vhpReelViewer || null;
  function reelIsOpen() {
    return Boolean(reelViewer()?.isOpen());
  }

  const flushSeen = () => {
    window.clearTimeout(reel.seenTimer);
    reel.seenTimer = 0;
    if (!planner.config.paid) return;
    state.pendingFlush = true;
    flushProfile();
  };

  // Same path as likes: localStorage now, customer metafield with the next profile flush.
  const markSeen = (ids) => {
    if (!hubRules) return;
    const have = new Set(state.seen || []);
    const fresh = ids.filter((id) => id && !isCustomId(id) && !have.has(id));
    if (!fresh.length) return;
    state.seen = hubRules.addSeen(state.seen, fresh);
    persist();
    window.clearTimeout(reel.seenTimer);
    reel.seenTimer = window.setTimeout(flushSeen, REEL_SEEN_FLUSH_MS);
  };

  // One recipe as the reel shows it. Swap mode: the portion that would go into the plan and the day after it.
  const reelItem = (card, index, swap) => {
    const id = productId(card.id);
    const own = isCustomId(id);
    const poster = card.image || (card.el ? posterUrl(card) : '');
    const item = {
      id,
      handle: own ? '' : card.handle || '',
      title: card.title || (own ? tr('planner.own_dish') : tr('common.recipe')),
      image: poster ? hubThumb(poster, 900) : '',
      protein: card.protein,
      time: card.time,
      kcal: card.kcal,
      slot: card.slot,
      card,
    };
    const fit = swap?.rows?.[index];
    if (fit) {
      item.chips = [fmtScale(fit.scale), `${fmt(fit.kcal)} kcal`];
      if (fit.protein != null) item.chips.push(tr('common.protein', { n: fmt(fit.protein) }));
      if (fit.carbs != null) item.chips.push(tr('planner.carbs_g', { n: fmt(fit.carbs) }));
      if (swap.target) {
        const after = Math.round(swap.others + fit.kcal);
        const diff = after - swap.target;
        const ok = Math.abs(diff) <= Math.max(25, swap.target * 0.03);
        item.note = `${tr('planner.day_after', { kcal: after, target: swap.target })}${ok ? ' ✓' : ''}`;
        item.noteWarn = !ok && diff > 0;
      }
    }
    return item;
  };

  // The video comes from the pool card's deferred-media template, no fetch. Own recipes: photo only, no heart.
  const reelMedia = (item) => {
    const video = item.card?.el ? mediaFromCard(item.card).video : null;
    return {
      src: video?.getAttribute('src') || video?.querySelector('source[src]')?.getAttribute('src') || '',
      poster: video?.getAttribute('poster') || '',
      plannable: true,
      likable: !isCustomId(item.id),
    };
  };

  // The week toast lives in the funnel. The reel opens inside the funnel (host), and while it is open
  // the toast node moves into it so "Eingeplant · Rückgängig" stays visible; it moves back on close.
  const toastHome = { parent: null, next: null };
  const moveToastIntoReel = (root) => {
    const el = funnel.querySelector('[data-vhp-week-toast]');
    if (!el || !root || root.contains(el)) return;
    toastHome.parent = el.parentNode;
    toastHome.next = el.nextSibling;
    root.append(el);
  };
  const restoreToast = () => {
    const el = funnel.querySelector('[data-vhp-week-toast]');
    if (el && toastHome.parent) toastHome.parent.insertBefore(el, toastHome.next);
    toastHome.parent = null;
    toastHome.next = null;
  };

  // swap: { occasion, rows, others, target } when opened from the swap sheet. rows[i] holds the scaled
  // portion for cards[i]; the main button becomes "Hier einsetzen".
  // grid: from the story's dish grid (docs/DISH_PICKER.md): zooms out of the tile, the heart is the grid pick,
  // no "Einplanen" (there is no week yet).
  function openReel({ cards, index, title, swap, grid }) {
    const viewer = reelViewer();
    const list = (cards || []).filter(Boolean);
    if (!viewer || !list.length) return;
    const session = { cards: list, swap: swap || null };
    reel.session = session;
    stopHero();
    viewer.open({
      items: list.map((card, k) => reelItem(card, k, session.swap)),
      start: index,
      label: title || tr('planner.recipes'),
      source: swap ? 'planner_swap' : grid ? 'planner_grid' : 'planner',
      host: funnel,
      media: reelMedia,
      originFor: grid ? (item) => $(`[data-vhp-grid-pick="${item.id}"]`) : null,
      isLiked: (item) => likeItems().some((row) => row.id === item.id),
      onLike: (item) => {
        if (grid) gridPick(item.id);
        else toggleRecipeLike(item.id);
        return true;
      },
      onRecipe: (item) => {
        if (isCustomId(item.id)) openCustomRecipeSheet({ id: item.id, scale: 1 });
        else openRecipeSheet({ handle: item.handle, scale: 1, title: item.title });
      },
      onPlan: swap || grid ? null : (item) => openPlanPicker(item.card),
      secondary: grid
        ? {
            label: tr('planner.grid_skip'),
            onLabel: tr('planner.grid_skip_on'),
            isOn: (item) => (state.skips?.items || []).some((row) => row.id === item.id),
            onClick: (item, k) => {
              if (gridSkip(item.id) && k < list.length - 1) viewer.next();
            },
          }
        : null,
      primary: swap ? { label: tr('planner.place_here'), onClick: (item, k) => placeFromReel(session, k) } : null,
      onActive: (item, k, prev) => {
        const from = prev < 0 ? k : Math.min(prev, k);
        const to = prev < 0 ? k : Math.max(prev, k);
        markSeen(session.cards.slice(from, to + 1).map((card) => productId(card.id)));
        plannerEvents('shown', { id: item.card.id, slot: item.card.slot, src: 'reel' });
      },
      onOpen: moveToastIntoReel,
      onClose: () => {
        if (reel.session === session) reel.session = null;
        restoreToast();
        if (copyPick.card) closeCopySheet();
        if (reel.seenTimer) flushSeen();
        if (inRecipes()) render();
        else if (grid && state.screen === 'grid') renderGrid();
      },
    });
  }

  function closeReel() {
    if (reelIsOpen()) reelViewer().close();
  }

  // ---------- portion + single placement (swap sheet, Eigenes Gericht) ----------

  // Index of today in the week on screen; next week starts on Monday.
  const todayIndex = () => (viewingNextWeek() ? 0 : (new Date().getDay() + 6) % 7);

  // Same portion rule as the swap sheet (core.bestPortion: the ½–2× step that scores best for the whole day),
  // never over the day's share cap.
  const slotScale = (card, day, occasion) => {
    if (!plannerCore || !(Number(card?.kcal) > 0)) return 1;
    const days = coreWeekDays();
    const found = (state.week || []).indexOf(day);
    const dayIndex = found >= 0 ? found : 0;
    days[dayIndex] = (day?.meals || []).map(coreFixedMeal);
    const scale = plannerCore.bestPortion(plannerContext({}), { days, dayIndex, occasionId: occasion, recipe: rankableCard(card) });
    return capToShare(card, scale);
  };

  // Shared by the reel and "Eigenes Gericht": one meal in, one-step undo via the week toast.
  function placeCardInWeek({ dayIndex, occasion, card, toast, src = 'reel' }) {
    const day = state.week?.[dayIndex];
    const meal = day?.meals?.find((row) => row.id === occasion);
    if (!meal || meal.locked || !card) return false;
    const scale = slotScale(card, day, occasion);
    regenUndo = null;
    favUndo = null;
    swapUndo = { day: dayIndex, snapshot: cloneJson(meal) };
    const generated = !isCustomId(card.id) && !likeItems().some((item) => item.id === productId(card.id));
    const next = mealFromRemix(meal, card, scale, generated);
    trackReplaced(meal, next.pick, src);
    day.meals = orderMeals(day.meals.filter((row) => row.id !== occasion).concat(next));
    const moved = syncLeftovers();
    persist();
    scheduleWeekSave();
    render();
    showWeekToast(withLeftoverNote(toast, moved));
    return true;
  }

  // ---------- copy one meal to other days (meal prep, the same breakfast every day) ----------
  // Same recipe and the same portion on every target day (a prepped portion does not change size), locked so
  // remix leaves it alone. Targets: this week from today on and next week, whichever of them is planned.
  // Lunch and dinner are both mains, so a main can land in either.
  // Two switches ride along: "Schon vorgekocht" (prepped, applies to the whole batch = this recipe in the
  // target occasion from today on, both weeks, plus the original) and "Jede Woche so planen" (a Feste Mahlzeit
  // rule for the target occasion on the batch's weekdays). *0 = the state when the sheet opened.
  // The same sheet is "In Plan einfügen" for a recipe that is not in the week yet (copyPick.card set): any
  // occasion, each day gets its own portion (slotScale) and stays unlocked, like a swap.
  const copyPick = { card: null, day: 0, occasion: null, as: null, targets: new Set(), prepped: false, prepped0: false, repeat: false };
  const copySheet = () => funnel.querySelector('[data-vhp-copy-sheet]');
  const copyKey = (start, dayIndex) => `${start}|${dayIndex}`;
  const copySource = () => state.week?.[copyPick.day]?.meals?.find((row) => row.id === copyPick.occasion) || null;
  const copyRecipeId = () => (copyPick.card ? productId(copyPick.card.id) : mealProductId(copySource()));
  // Occasions the sheet offers: a new recipe goes anywhere, a copied main into lunch or dinner.
  const copyOccasions = () =>
    copyPick.card
      ? activeOccasions()
      : copyPick.occasion === LEFTOVER_FROM || copyPick.occasion === LEFTOVER_TO
        ? EXAMPLE_OCCASIONS.filter((row) => row.id === LEFTOVER_TO || row.id === LEFTOVER_FROM)
        : [];
  const repeatRuleFor = (occasion) => (state.repeat || []).find((rule) => rule.occasion === occasion) || null;

  // "Mo–Fr", "Mo, Mi, Fr", "Jeden Tag".
  const fmtDays = (days) => {
    const list = [...new Set(days)].sort((a, b) => a - b);
    if (list.length === WEEK_LEN) return tr('planner.every_day');
    const runs = [];
    list.forEach((day) => {
      const last = runs[runs.length - 1];
      if (last && day === last[1] + 1) last[1] = day;
      else runs.push([day, day]);
    });
    return runs
      .map(([a, b]) => (b - a >= 2 ? `${DAY_LABEL[a]}–${DAY_LABEL[b]}` : b > a ? `${DAY_LABEL[a]}, ${DAY_LABEL[b]}` : DAY_LABEL[a]))
      .join(', ');
  };

  // { start, week, onScreen, title } for this week and next week, oldest first; week is null when not planned.
  const copyWeeks = () => {
    const here = state.weekStart || mondayIso(0);
    const other = here === mondayIso(0) ? mondayIso(1) : mondayIso(0);
    const otherWeek = state.weekAlt?.start === other && weekHasPlan(state.weekAlt.week) ? state.weekAlt.week : null;
    return [
      { start: here, week: state.week, onScreen: true },
      { start: other, week: otherWeek, onScreen: false },
    ]
      .sort((a, b) => (a.start < b.start ? -1 : 1))
      .map((row) => ({ ...row, title: row.start === mondayIso(0) ? tr('planner.this_week') : tr('planner.next_week') }));
  };

  // Why a day cannot take the copy ('' = it can).
  const copyBlock = (row, dayIndex) => {
    if (row.start === mondayIso(0) && dayIndex < (new Date().getDay() + 6) % 7) return 'past';
    if (row.onScreen && dayIndex === copyPick.day && copyPick.as === copyPick.occasion) return 'source';
    const target = row.week?.[dayIndex]?.meals?.find((meal) => meal.id === copyPick.as);
    if (!target) return 'missing';
    if (mealProductId(target) && mealProductId(target) === copyRecipeId()) return 'same';
    if (target.locked) return 'locked';
    return '';
  };

  // The batch the switches apply to: { row, dayIndex, meal } for the original and every meal of this recipe in the
  // target occasion from today on.
  const copyBatch = () => {
    const id = copyRecipeId();
    const out = [];
    copyWeeks().forEach((row) => {
      (row.week || []).forEach((day, dayIndex) => {
        (day?.meals || []).forEach((meal) => {
          const original = row.onScreen && dayIndex === copyPick.day && meal.id === copyPick.occasion;
          if (original || (meal.id === copyPick.as && mealProductId(meal) === id && copyBlock(row, dayIndex) === 'same')) {
            out.push({ row, dayIndex, meal });
          }
        });
      });
    });
    return out;
  };

  // Weekdays a Feste Mahlzeit rule would cover: the batch in the target occasion + the chosen days.
  const copyRepeatDays = () => {
    const days = new Set();
    copyBatch().forEach(({ dayIndex, meal }) => {
      if (meal.id === copyPick.as) days.add(dayIndex);
    });
    copyPick.targets.forEach((key) => days.add(Number(key.split('|')[1])));
    return [...days].sort((a, b) => a - b);
  };

  // The rule as it would be saved (null = off or nothing to repeat).
  const copyRepeatRule = () => {
    const card = copyPick.card;
    const src = card ? null : copySource();
    const days = copyRepeatDays();
    if (!copyPick.repeat || !(card || src?.pick) || !days.length) return null;
    const scale = card ? capToShare(card, 1) : Number(src.scale) || 1;
    return { occasion: copyPick.as, id: copyRecipeId(), scale, days, pick: snapshot(card || src.pick) };
  };

  const sameRule = (a, b) =>
    Boolean(a) === Boolean(b) &&
    (!a || (a.occasion === b.occasion && a.id === b.id && a.scale === b.scale && a.days.join() === b.days.join()));

  // Something to save: new days, or a switch that changes what is stored.
  const copyDirty = () => {
    if (copyPick.targets.size) return true;
    if (copyPick.prepped !== copyPick.prepped0) return true;
    const current = repeatRuleFor(copyPick.as);
    const mine = current && current.id === copyRecipeId() ? current : null;
    return copyPick.repeat ? !sameRule(copyRepeatRule(), mine) : Boolean(mine);
  };

  const paintCopySheet = () => {
    const card = copyPick.card;
    const src = card ? null : copySource();
    if (!card && !src) return;
    const titleEl = $('[data-vhp-copy-title]');
    if (titleEl) titleEl.textContent = card ? tr('planner.add_to_plan') : tr('planner.copy_days');
    const recipeEl = $('[data-vhp-copy-recipe]');
    if (recipeEl) {
      const portion = card ? '' : fmtScaleShort(src.scale);
      const kcal = card ? 0 : src.kcal;
      recipeEl.textContent = [card ? card.title || tr('common.recipe') : src.pick?.title, portion && tr('planner.portion_x', { x: portion }), kcal ? `${Math.round(kcal)} kcal` : '']
        .filter(Boolean)
        .join(' · ');
    }
    const asBox = $('[data-vhp-copy-as]');
    const occasions = copyOccasions();
    if (asBox) asBox.hidden = occasions.length < 2;
    const asLabel = $('[data-vhp-copy-as-label]');
    if (asLabel) asLabel.textContent = card ? tr('planner.meal') : tr('planner.as');
    const seg = $('[data-vhp-copy-seg]');
    if (seg) {
      seg.classList.toggle('vhp-copy__seg--many', occasions.length > 2);
      seg.replaceChildren(...occasions.map((row) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vhp-copy__seg-btn';
        btn.setAttribute('role', 'radio');
        btn.dataset.vhpCopyOccasion = row.id;
        btn.textContent = row.label;
        const on = row.id === copyPick.as;
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
        return btn;
      }));
    }
    const hint = $('[data-vhp-copy-hint]');
    if (hint) {
      hint.textContent = card
        ? tr('planner.copy_hint_card')
        : tr('planner.copy_hint');
    }

    const weeksBox = $('[data-vhp-copy-weeks]');
    if (weeksBox) {
      const today = new Date();
      weeksBox.replaceChildren(...copyWeeks().map((row) => {
        const section = document.createElement('section');
        section.className = 'vhp-copy__week';
        const head = document.createElement('div');
        head.className = 'vhp-copy__week-head';
        const label = document.createElement('p');
        label.className = 'vhp-plan-pick__label';
        label.textContent = row.title;
        head.append(label);
        section.append(head);
        if (!weekHasPlan(row.week)) {
          const empty = document.createElement('p');
          empty.className = 'vhp-copy__empty';
          empty.textContent = tr('planner.copy_empty');
          section.append(empty);
          return section;
        }
        const open = [];
        const days = document.createElement('div');
        days.className = 'vhp-week-days vhp-copy__days';
        days.setAttribute('role', 'group');
        days.setAttribute('aria-label', row.title);
        const monday = dateOfIso(row.start);
        DAY_LABEL.forEach((dayLabel, index) => {
          const date = addDays(monday, index);
          const block = copyBlock(row, index);
          const key = copyKey(row.start, index);
          const on = !block && copyPick.targets.has(key);
          const btn = renderDayTab({ label: dayLabel, date: date.getDate(), selected: on, today: sameDay(date, today), past: block === 'past', on: true });
          btn.setAttribute('role', 'checkbox');
          btn.removeAttribute('aria-selected');
          btn.setAttribute('aria-checked', on ? 'true' : 'false');
          btn.classList.toggle('is-source', block === 'source');
          btn.classList.toggle('is-same', block === 'same');
          if (block) {
            btn.disabled = true;
            const why = block === 'source' ? tr('planner.why_source') : block ? tr(`picker.why_${block}`) : undefined;
            btn.setAttribute('aria-label', `${dayLabel} ${date.getDate()}, ${why}`);
          } else {
            btn.dataset.vhpCopyDay = key;
            open.push(key);
          }
          days.append(btn);
        });
        if (open.length) {
          const all = open.every((key) => copyPick.targets.has(key));
          const toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'vhp-text-btn vhp-copy__all';
          toggle.dataset.vhpCopyAll = row.start;
          toggle.textContent = all ? tr('planner.none') : tr('planner.all');
          head.append(toggle);
        }
        section.append(days);
        return section;
      }));
    }

    const setSwitch = (el, on) => {
      if (!el) return;
      el.classList.toggle('is-on', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    };
    setSwitch($('[data-vhp-copy-prepped]'), copyPick.prepped);
    setSwitch($('[data-vhp-copy-repeat]'), copyPick.repeat);
    const repeatNote = $('[data-vhp-copy-repeat-note]');
    if (repeatNote) {
      const days = copyRepeatDays();
      const other = repeatRuleFor(copyPick.as);
      const replaces = copyPick.repeat && other && other.id !== copyRecipeId();
      const occasionLabel = EXAMPLE_OCCASIONS.find((row) => row.id === copyPick.as)?.label || tr('planner.meal');
      repeatNote.textContent = !copyPick.repeat
        ? tr('planner.repeat_same_days')
        : !days.length
          ? tr('planner.pick_a_day')
          : tr('planner.repeat_days', { days: fmtDays(days) }) + (replaces ? tr('planner.replaces_fixed', { meal: occasionLabel }) : '');
    }

    const confirm = $('[data-vhp-copy-confirm]');
    if (confirm) {
      const n = copyPick.targets.size;
      confirm.disabled = !copyDirty() || (copyPick.repeat && !copyRepeatDays().length);
      if (card) confirm.textContent = n > 1 ? tr('picker.confirm_n', { n }) : tr('picker.confirm');
      else confirm.textContent = n ? tr('planner.copy_n', { n }) : tr('planner.save_btn');
    }
  };

  function openCopySheet(occasion) {
    const sheet = copySheet();
    if (!sheet || weekGenerating) return;
    copyPick.card = null;
    copyPick.day = state.weekDay;
    copyPick.occasion = occasion;
    copyPick.as = occasion;
    copyPick.targets = new Set();
    const src = copySource();
    if (!src?.pick) return;
    copyPick.prepped = Boolean(src.prepped);
    copyPick.prepped0 = copyPick.prepped;
    copyPick.repeat = repeatRuleFor(occasion)?.id === mealProductId(src);
    paintCopySheet();
    setDialogOpen(sheet, true);
    $('#vhp-copy-title')?.focus({ preventScroll: true });
  }

  // "In Plan einfügen" for a recipe card (reel, favorites, own recipes). opts.day: preselected day of the week on
  // screen (default today); the occasion that matches the recipe's slot is preselected.
  async function openPlanPicker(card, opts = {}) {
    const sheet = copySheet();
    if (!sheet || !card || weekGenerating) return;
    if (!weekHasPlan(state.week)) {
      await generateWeek({ keepLocks: false });
      scheduleWeekSave();
    }
    const occasions = activeOccasions();
    copyPick.card = card;
    copyPick.day = Number.isInteger(opts.day) && opts.day >= 0 && opts.day < WEEK_LEN ? opts.day : todayIndex();
    copyPick.occasion = null;
    copyPick.as = (occasions.find((row) => row.catalog === card.slot) || occasions[0])?.id || null;
    copyPick.targets = new Set();
    const here = copyWeeks().find((row) => row.onScreen);
    if (here && !copyBlock(here, copyPick.day)) copyPick.targets.add(copyKey(here.start, copyPick.day));
    copyPick.prepped = false;
    copyPick.prepped0 = false;
    copyPick.repeat = repeatRuleFor(copyPick.as)?.id === copyRecipeId();
    paintCopySheet();
    recipesMediaHeld = true;
    syncRecipesMedia();
    setDialogOpen(sheet, true);
    $('#vhp-copy-title')?.focus({ preventScroll: true });
  }

  function closeCopySheet() {
    const sheet = copySheet();
    if (sheet?.open) setDialogOpen(sheet, false);
  }

  // Targets that no longer fit (other occasion picked) drop out.
  const pruneCopyTargets = () => {
    const rows = new Map(copyWeeks().map((row) => [row.start, row]));
    copyPick.targets.forEach((key) => {
      const [start, day] = key.split('|');
      const row = rows.get(start);
      if (!row || copyBlock(row, Number(day))) copyPick.targets.delete(key);
    });
  };

  const confirmCopy = () => {
    const card = copyPick.card;
    const src = card ? null : copySource();
    if (!(card || src?.pick) || !copyDirty()) return;
    const as = copyPick.as;
    const label = EXAMPLE_OCCASIONS.find((row) => row.id === as)?.label || src?.label || '';
    const generated = Boolean(card) && !isCustomId(card.id) && !likeItems().some((item) => item.id === productId(card.id));
    const undo = {
      scope: 'copy',
      snapshot: cloneJson(state.week),
      alt: state.weekAlt ? { start: state.weekAlt.start, week: cloneJson(state.weekAlt.week) } : null,
      repeat: cloneJson(state.repeat || []),
    };
    const rule = copyRepeatRule();
    const batch = copyBatch();
    const notes = [];

    // Vorrat: the original and the rest of the batch (new copies get it below).
    const prepped = copyPick.prepped;
    let preppedChanged = 0;
    batch.forEach(({ row, meal }) => {
      if (Boolean(meal.prepped) === prepped) return;
      if (prepped) meal.prepped = true;
      else delete meal.prepped;
      if (!row.onScreen) state.weekAlt.pending = true;
      preppedChanged += 1;
    });

    let count = 0;
    let lastDay = 0;
    copyWeeks().forEach((row) => {
      if (!weekHasPlan(row.week)) return;
      row.week.forEach((day, dayIndex) => {
        if (!copyPick.targets.has(copyKey(row.start, dayIndex)) || copyBlock(row, dayIndex)) return;
        let copy;
        if (card) {
          // Portion fitted to that day (the other week is scored against the week on screen, close enough).
          const target = day.meals.find((meal) => meal.id === as);
          copy = mealFromRemix(target, card, slotScale(card, day, as), generated);
          if (row.onScreen) trackReplaced(target, copy.pick, 'reel');
        } else {
          copy = cloneJson(src);
          delete copy.leftover;
          delete copy.cook;
          delete copy.overShare;
          Object.assign(copy, { id: as, label, locked: true, generated: false });
        }
        if (prepped) copy.prepped = true;
        else delete copy.prepped;
        day.meals = orderMeals(day.meals.filter((meal) => meal.id !== as).concat(copy));
        // The other week has no syncLeftovers: a lunch that was the old dinner's leftovers becomes a normal meal.
        if (!row.onScreen) {
          [1, 2].forEach((back) => {
            const lunch = as === LEFTOVER_FROM ? findMeal(row.week, dayIndex + back, LEFTOVER_TO) : null;
            if (leftoverBackOf(lunch) === back && mealProductId(lunch) !== mealProductId(copy)) delete lunch.leftover;
          });
          state.weekAlt.pending = true;
        }
        count += 1;
        lastDay = dayIndex;
      });
    });

    // Feste Mahlzeit: on = this rule for the occasion (replaces another recipe's); off = drop this recipe's rule.
    const before = repeatRuleFor(as);
    let repeatChanged = false;
    if (rule && !sameRule(rule, before)) {
      state.repeat = (state.repeat || []).filter((row) => row.occasion !== as).concat(rule);
      repeatChanged = true;
    } else if (!rule && before && before.id === copyRecipeId()) {
      state.repeat = state.repeat.filter((row) => row.occasion !== as);
      repeatChanged = true;
    }

    closeCopySheet();
    if (!count && !preppedChanged && !repeatChanged) return;
    if (count && card) notes.push(count === 1 ? tr('planner.planned_at', { day: DAY_LABEL[lastDay], meal: label }) : tr('picker.planned_n', { n: count }));
    else if (count) notes.push(tr('planner.copied', { n: count }));
    if (preppedChanged) notes.push(prepped ? tr('planner.from_pantry') : tr('planner.back_on_list'));
    if (repeatChanged) notes.push(rule ? tr('planner.every_week', { days: fmtDays(rule.days) }) : tr('planner.not_every_week'));
    const moved = count ? syncLeftovers() : [];
    if (count && !card) usage('use_copy');
    regenUndo = undo;
    swapUndo = null;
    favUndo = null;
    persist();
    if (count || preppedChanged) scheduleWeekSave();
    if (repeatChanged) {
      state.pendingFlush = true;
      flushProfile();
    }
    render();
    showWeekToast(withLeftoverNote(notes.join(' · '), moved));
  };


  const openReelFromSet = (id) => {
    const set = activeSet();
    if (!set) return;
    const cards = setCards(set, hubCards());
    const index = Math.max(0, cards.findIndex((card) => productId(card.id) === productId(id)));
    openReel({ cards, index, title: set.kind === 'search' ? tr('planner.search_of', { q: set.title }) : set.title });
  };

  const openReelFromHero = () => {
    const source = heroSource(hubCards());
    const list = source?.cards || [];
    if (!list.length) return;
    const order = list.map((card) => productId(card.id));
    const ids = hubRules ? hubRules.rotateTo(order, hero.id) : order;
    const byId = new Map(list.map((card) => [productId(card.id), card]));
    openReel({ cards: ids.map((id) => byId.get(id)), index: 0, title: source.reelTitle });
  };

  // Dish grid (docs/DISH_PICKER.md, batch 1 2026-10-20): the mains in deck order (ranked like the deck: stats, taste,
  // exclusions, cook time) as one scrolling list, GRID_PAGE more as she nears the bottom (loading more from the pool
  // when the rendered cards run out; "Mehr Gerichte" is the end marker and the fallback while nothing scrolls). The
  // order is frozen for the visit of the slide (gridOrder): a like must not reshuffle the tiles under her finger.
  // Tap = like, ▶ = the reel zoomed out of that tile (openGridReel), the tray in the footer shows the LIKE_READY
  // slots filling up (the tile's photo flies into the slot). The button under it reads with the count: nothing
  // picked, one or two (the planner fills the rest, counted as deck_skipped), three or more (a plan from the likes).
  const GRID_PAGE = 9;
  const GRID_PLAY_SVG =
    '<svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13a1 1 0 0 0 1.5.9l10.4-6.5a1 1 0 0 0 0-1.8L9.5 4.6A1 1 0 0 0 8 5.5z"/></svg>';
  let gridOrder = null; // ids in deck order for this visit of the slide
  let gridShown = 0;
  let gridLoading = false;
  let gridRepaint = false; // next paint rebuilds the tiles (a chip change: staggered reveal)
  // Steering chips (batch 2): Alle, Schnell (mains up to GRID_QUICK_MIN), then the main ingredients and cuisine tags
  // of the real pool (assets/vhp-planner-hub-rules.js categories, biggest first), each with GRID_CHIP_MIN dishes at
  // least, GRID_CHIPS chips at most. A chip filters the list; the order inside stays the deck order.
  const GRID_QUICK_MIN = 25;
  const GRID_CHIP_MIN = 3;
  const GRID_CHIPS = 7;
  let gridChip = 'all';
  let gridChipsCache = { key: '', rules: [] };
  // Search (batch 3): the field under the question filters the list, local title / ingredient match at once and
  // the Algolia rank (assets/vhp-search-core.js, typo tolerant) as soon as it is in; ranked matches first.
  let gridQuery = '';
  let gridSearchOpen = false;
  const gridReset = () => {
    gridOrder = null;
    gridShown = 0;
    gridChip = 'all';
    gridQuery = '';
    gridRepaint = true;
    const scroll = $('[data-vhp-grid-scroll]');
    if (scroll) scroll.scrollTop = 0;
    gridSearchToggle(false, true);
  };
  const buzz = (ms) => {
    try {
      navigator.vibrate?.(ms);
    } catch (e) {
      /* not supported */
    }
  };
  const gridPool = () => {
    const rendered = new Map(poolFor('main').filter(withinTime).map((card) => [productId(card.id), card]));
    const ordered = [];
    try {
      startDeckIndex();
      deckOrderFor('main').forEach((item) => {
        const card = rendered.get(productId(item.id));
        if (card) {
          ordered.push(card);
          rendered.delete(productId(item.id));
        }
      });
    } catch (e) {
      /* no index yet: the rendered order */
    }
    return ordered.concat([...rendered.values()]);
  };
  // The pool in the frozen order; cards that arrived since (loadMore) go to the end, in deck order.
  const gridCards = () => {
    const pool = gridPool();
    const byId = new Map(pool.map((card) => [productId(card.id), card]));
    if (!gridOrder) gridOrder = [];
    const have = new Set(gridOrder);
    pool.forEach((card) => {
      const id = productId(card.id);
      if (!have.has(id)) {
        gridOrder.push(id);
        have.add(id);
      }
    });
    return gridOrder.map((id) => byId.get(id)).filter(Boolean);
  };
  // The whole catalog of mains (the planner index: ingredients, tags, time, collection position), minus the
  // exclusions and the cook-time cap. The loaded pool stands in while the index is still on its way (the deck
  // loads it too, startDeckIndex), with a repaint once it is in. Chips, the Beliebt pill and every filtered view
  // come from this, not from the pages loaded so far (Maxim 2026-10-20: chips for the loaded products only).
  let gridIndexWaited = false;
  const gridCatalog = () => {
    const items = deckIndex.main;
    if (Array.isArray(items) && items.length) return items.filter((item) => !isExcluded(item) && withinTime(item));
    if (!gridIndexWaited && planner.index) {
      gridIndexWaited = true;
      startDeckIndex();
      planner.index('main').then(
        (list) => {
          if (!deckIndex.main && Array.isArray(list)) deckIndex.main = list;
          if (state.screen === 'grid') {
            gridRepaint = true;
            renderGrid();
          }
        },
        () => {}
      );
    }
    return gridPool();
  };
  // The catalog in deck order (the same ranking the Alle view and the deck use).
  const gridCatalogOrdered = () => {
    const catalog = gridCatalog();
    if (!deckIndex.main) return catalog;
    const keep = new Set(catalog.map((item) => productId(item.id)));
    let ordered = [];
    try {
      ordered = deckOrderFor('main').filter((item) => keep.has(productId(item.id)));
    } catch (e) {
      ordered = [];
    }
    return ordered.length ? ordered : catalog;
  };
  const gridChipRules = () => {
    const catalog = gridCatalog();
    const key = catalog.map((item) => productId(item.id)).join('|');
    if (gridChipsCache.key === key) return gridChipsCache.rules;
    const rules = [];
    const quick = catalog.filter((item) => Number(item.time) > 0 && Number(item.time) <= GRID_QUICK_MIN);
    if (quick.length >= GRID_CHIP_MIN) {
      rules.push({ id: 'quick', label: tr('planner.grid_chip_quick', { n: GRID_QUICK_MIN }), ids: new Set(quick.map((item) => productId(item.id))) });
    }
    if (hubRules) {
      hubRules
        .categories(catalog, { min: GRID_CHIP_MIN })
        .themes.filter((row) => row.kind === 'ingredient' || row.kind === 'cuisine')
        .forEach((row) => rules.push({ id: row.id, label: row.label, kind: row.kind, ids: new Set(row.ids) }));
    }
    gridChipsCache = { key, rules: rules.slice(0, GRID_CHIPS - 1) };
    return gridChipsCache.rules;
  };
  // Dishes of a filtered view that are not in the loaded pool yet: their pool pages (from the index position, as
  // the deck does) load together, GRID_PAGE * 2 dishes a round, and the list repaints with them; a page that
  // brought nothing is not asked again. Without positions (index in pool mode) the rest of the mains load once.
  let gridFiltered = false;
  const gridPagesAsked = new Set();
  const gridEnsure = (items) => {
    if (!items.length || gridLoading || !planner.loadPage) return;
    const pages = new Set();
    let unplaced = false;
    items.slice(0, GRID_PAGE * 2).forEach((item) => {
      if (!Number.isFinite(item.pos)) {
        unplaced = true;
        return;
      }
      const page = Math.floor(item.pos / (planner.pageSize || 12)) + 1;
      if (!gridPagesAsked.has(page)) pages.add(page);
    });
    if (!pages.size) {
      if (unplaced) gridLoadAll();
      return;
    }
    gridLoading = true;
    Promise.all(
      [...pages].map((page) => {
        gridPagesAsked.add(page);
        return planner.loadPage('main', page).catch(() => 0);
      })
    ).finally(() => {
      gridLoading = false;
      if (state.screen === 'grid') {
        gridRepaint = true;
        renderGrid();
      }
    });
  };
  // The cards behind the active chip (all of them when the chip is gone, e.g. after an exclusion) and the query.
  const gridQueryActive = () => gridQuery.trim().length >= 2;
  const onGridRank = () => {
    if (state.screen !== 'grid') return;
    gridRepaint = true;
    renderGrid();
  };
  // The Algolia rank for the query (product id -> rank), null until it is in; the list repaints then, also when
  // the index answers with nothing or fails (so "Suche …" turns into "Nichts gefunden").
  const gridRankPending = new Set();
  const gridRank = (q) => {
    if (!searchCore || q.length < 2) return null;
    const known = searchCore.peekIds(q);
    if (known) return known;
    if (!gridRankPending.has(q)) {
      gridRankPending.add(q);
      searchCore
        .ids(q)
        .then(() => {}, () => {})
        .finally(() => {
          gridRankPending.delete(q);
          onGridRank();
        });
    }
    return null;
  };
  // A ranked dish that is not in the loaded pool yet (the pool comes in pages): the rest of the mains load once,
  // with skeleton tiles meanwhile. She came for that one dish; it must show.
  let gridLoadedAll = false;
  const gridLoadAll = () => {
    if (gridLoadedAll || gridLoading || !planner.hasMore('main')) return;
    gridLoadedAll = true;
    gridLoading = true;
    planner
      .loadAll('main')
      .catch(() => {})
      .finally(() => {
        gridLoading = false;
        if (state.screen === 'grid') {
          gridRepaint = true;
          renderGrid();
        }
      });
  };
  // The list behind the chip and the query. Alle: the frozen pool order. With a chip or a query: the whole catalog
  // in deck order, filtered (title / ingredient match at once, the Algolia rank first once it is in); the dishes
  // not loaded yet come through gridEnsure and appear with the repaint.
  const gridVisible = () => {
    const rule = gridChip === 'all' ? null : gridChipRules().find((row) => row.id === gridChip);
    const q = gridQueryActive() ? gridQuery.trim() : '';
    gridFiltered = Boolean(rule || q);
    if (!gridFiltered) return gridCards();
    let items = gridCatalogOrdered();
    if (rule) items = items.filter((item) => rule.ids.has(productId(item.id)));
    if (q) {
      const needle = foldSearch(q);
      const rank = gridRank(q);
      items = items.filter((item) => cardMatchesSearch(item, needle, rank));
      if (rank) {
        const at = (item) => (rank.has(productId(item.id)) ? rank.get(productId(item.id)) : Number.MAX_SAFE_INTEGER);
        items = items.slice().sort((a, b) => at(a) - at(b));
      }
    }
    const loaded = new Map(gridPool().map((card) => [productId(card.id), card]));
    const cards = [];
    const missing = [];
    items.forEach((item) => {
      const card = loaded.get(productId(item.id));
      if (card) cards.push(card);
      else if (deckIndex.main) missing.push(item);
    });
    gridEnsure(missing);
    return cards;
  };
  const gridSearchSet = (value) => {
    const next = String(value || '');
    if (next === gridQuery) return;
    const wasActive = gridQueryActive();
    gridQuery = next;
    if (!wasActive && !gridQueryActive()) return;
    gridShown = 0;
    gridRepaint = true;
    const scroll = $('[data-vhp-grid-scroll]');
    if (scroll) scroll.scrollTop = 0;
    if (gridQueryActive()) step('grid_search');
    renderGrid();
  };
  // silent: no repaint (gridReset paints right after).
  const gridSearchToggle = (open, silent) => {
    gridSearchOpen = Boolean(open);
    const form = $('[data-vhp-grid-search]');
    const btn = $('[data-vhp-grid-search-open]');
    const input = $('[data-vhp-grid-search-input]');
    if (form) form.hidden = !gridSearchOpen;
    btn?.setAttribute('aria-expanded', gridSearchOpen ? 'true' : 'false');
    if (gridSearchOpen) {
      input?.focus();
      return;
    }
    if (input) input.value = '';
    if (silent) gridQuery = '';
    else gridSearchSet('');
  };
  const gridSetChip = (id) => {
    if (id === gridChip) return;
    gridChip = id;
    gridShown = 0;
    gridRepaint = true;
    const scroll = $('[data-vhp-grid-scroll]');
    if (scroll) scroll.scrollTop = 0;
    step('grid_chip', /^cuisine-/.test(id) ? 'cuisine' : id);
    buzz(6);
    renderGrid();
  };
  const renderGridChips = () => {
    const box = $('[data-vhp-grid-chips]');
    if (!box) return;
    const rules = gridChipRules();
    box.hidden = !rules.length;
    if (!rules.some((row) => row.id === gridChip)) gridChip = 'all';
    const key = rules.map((row) => row.id).join('|');
    if (box.dataset.key !== key) {
      box.dataset.key = key;
      box.replaceChildren(
        ...[{ id: 'all', label: tr('planner.grid_chip_all') }, ...rules].map((row) => {
          const li = document.createElement('li');
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'vhp-grid__chip';
          btn.dataset.vhpGridChip = row.id;
          btn.textContent = row.label;
          li.append(btn);
          return li;
        })
      );
    }
    box.querySelectorAll('[data-vhp-grid-chip]').forEach((btn) => {
      const on = btn.dataset.vhpGridChip === gridChip;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) btn.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
    });
  };
  // "Beliebt" on the two best like rates of the catalog (recipe_stats row[6], above the average only).
  let gridPopularCache = { key: '', ids: new Set() };
  const gridPopular = () => {
    const stats = planner.config.recipeStats;
    const pool = gridCatalog();
    const key = pool.map((card) => productId(card.id)).join('|');
    if (gridPopularCache.key === key) return gridPopularCache.ids;
    const avg = Number(stats?.avg?.like) || 0;
    const top = pool
      .map((card) => ({ id: productId(card.id), rate: Number(stats?.r?.[productId(card.id)]?.[6]) || 0 }))
      .filter((row) => row.rate > avg)
      .sort((a, b) => b.rate - a.rate)
      .slice(0, 2)
      .map((row) => row.id);
    gridPopularCache = { key, ids: new Set(top) };
    return gridPopularCache.ids;
  };
  // The brand prefix is on nearly every title; on a 110 px tile it only eats the dish's name.
  const gridTitle = (card) => String(card?.title || '').replace(/^(vegan(e|es|er)?\s+)?high[- ]?protein\s+/i, '');
  const gridTile = (card, i) => {
    const id = productId(card.id);
    const li = document.createElement('li');
    li.dataset.vhpGridId = id;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vhp-grid__card';
    btn.dataset.vhpGridPick = id;
    btn.style.setProperty('--i', String(i));
    const img = document.createElement('img');
    img.src = posterUrl(card) || card.image || '';
    img.alt = '';
    img.loading = i < 6 ? 'eager' : 'lazy';
    img.decoding = 'async';
    const copy = document.createElement('span');
    copy.className = 'vhp-grid__copy';
    const title = document.createElement('strong');
    title.textContent = gridTitle(card);
    const meta = document.createElement('span');
    const bits = [];
    if (Number(card.protein) > 0) bits.push(`${Math.round(card.protein)} g`);
    if (Number(card.time) > 0) bits.push(`${Math.round(card.time)} Min`);
    meta.textContent = bits.join(' · ');
    copy.append(title, meta);
    const check = document.createElement('span');
    check.className = 'vhp-grid__check';
    check.setAttribute('aria-hidden', 'true');
    check.textContent = '✓';
    btn.append(img, copy, check);
    if (gridPopular().has(id)) {
      const pop = document.createElement('span');
      pop.className = 'vhp-grid__pop';
      pop.textContent = tr('planner.grid_popular');
      btn.append(pop);
    }
    const play = document.createElement('button');
    play.type = 'button';
    play.className = 'vhp-grid__play';
    play.dataset.vhpGridPlay = id;
    play.setAttribute('aria-label', tr('planner.grid_play', { title: gridTitle(card) }));
    play.innerHTML = GRID_PLAY_SVG;
    li.append(btn, play);
    return li;
  };
  // The tray: LIKE_READY slots (number while empty, the dish's photo once picked, a tap unpicks), "+n" past them,
  // and the line that counts down to the plan. A slot filled since the last paint lands with a pop (is-new).
  const renderGridTray = () => {
    const slots = $('[data-vhp-grid-slots]');
    const line = $('[data-vhp-grid-line]');
    if (!slots || !line) return;
    const items = likeItems();
    const n = items.length;
    const key = items.map((item) => item.id).join('|');
    if (slots.dataset.key !== key) {
      const was = new Set(Array.from(slots.querySelectorAll('[data-vhp-grid-slot]'), (el) => el.dataset.vhpGridSlot));
      slots.dataset.key = key;
      const nodes = [];
      for (let i = 0; i < LIKE_READY; i += 1) {
        const li = document.createElement('li');
        li.className = 'vhp-grid__slot';
        const item = items[i];
        if (item) {
          li.classList.add('is-filled');
          if (!was.has(item.id)) li.classList.add('is-new');
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'vhp-grid__slot-btn';
          btn.dataset.vhpGridSlot = item.id;
          btn.setAttribute('aria-label', tr('planner.grid_unpick', { title: gridTitle(item) }));
          const card = poolFor('main').find((row) => productId(row.id) === item.id);
          const img = document.createElement('img');
          img.src = (card && posterUrl(card)) || item.image || '';
          img.alt = '';
          img.decoding = 'async';
          const x = document.createElement('span');
          x.className = 'vhp-grid__slot-x';
          x.setAttribute('aria-hidden', 'true');
          x.textContent = '×';
          btn.append(img, x);
          li.append(btn);
        } else {
          li.textContent = String(i + 1);
          li.setAttribute('aria-hidden', 'true');
        }
        nodes.push(li);
      }
      if (n > LIKE_READY) {
        const li = document.createElement('li');
        li.className = 'vhp-grid__slot vhp-grid__slot--more';
        li.textContent = tr('planner.grid_tray_more', { n: n - LIKE_READY });
        nodes.push(li);
      }
      slots.replaceChildren(...nodes);
    }
    line.textContent =
      n === 0 ? tr('planner.grid_tray_none') : n < LIKE_READY ? tr('planner.grid_tray_left', { n: LIKE_READY - n }) : tr('planner.grid_tray_ready');
  };
  const renderGrid = () => {
    const list = $('[data-vhp-grid-cards]');
    if (!list) return;
    renderGridChips();
    const cards = gridVisible();
    if (!gridShown) gridShown = Math.min(cards.length, GRID_PAGE);
    const shown = cards.slice(0, gridShown);
    // Append only what is new: the list scrolls, so the tiles already there stay where they are. A changed prefix
    // (exclusions edited on the way back) or a chip change repaints everything (staggered reveal).
    list.querySelectorAll('.vhp-grid__skel').forEach((li) => li.remove());
    const same = !gridRepaint && Array.from(list.children).every((li, i) => shown[i] && li.dataset.vhpGridId === productId(shown[i].id));
    if (!same) list.replaceChildren();
    gridRepaint = false;
    const from = list.childElementCount;
    if (shown.length > from) list.append(...shown.slice(from).map((card, i) => gridTile(card, i)));
    // Skeleton tiles while more mains load from the pool.
    if (gridLoading) {
      for (let i = 0; i < 3; i += 1) {
        const li = document.createElement('li');
        li.className = 'vhp-grid__skel';
        li.setAttribute('aria-hidden', 'true');
        li.style.setProperty('--i', String(i));
        list.append(li);
      }
    }
    const liked = new Set(likeItems().map((item) => productId(item.id)));
    const skipped = new Set((state.skips?.items || []).map((item) => productId(item.id)));
    list.querySelectorAll('[data-vhp-grid-pick]').forEach((btn) => {
      const on = liked.has(btn.dataset.vhpGridPick);
      btn.classList.toggle('is-on', on);
      btn.classList.toggle('is-off', !on && skipped.has(btn.dataset.vhpGridPick)); // "Nicht für mich" in the reel
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    const empty = $('[data-vhp-grid-empty]');
    if (empty) {
      const q = gridQuery.trim();
      const none = !shown.length && !gridLoading && gridQueryActive();
      empty.hidden = !none;
      if (none) empty.textContent = gridRankPending.has(q) ? tr('planner.grid_searching') : tr('planner.grid_search_none', { q });
    }
    renderGridTray();
    const n = likeCount();
    const plan = $('[data-vhp-grid-plan]');
    if (plan) {
      plan.disabled = n === 0 || exampleBuilding || weekGenerating;
      plan.textContent = n === 0 ? tr('planner.grid_plan_none') : planReady() ? tr('planner.grid_plan_ready') : tr('planner.grid_plan_some');
    }
    const skip = $('[data-vhp-grid-skip]');
    if (skip) skip.hidden = n > 0;
    const more = $('[data-vhp-grid-more]');
    if (more) {
      if (!more.dataset.label) more.dataset.label = more.textContent;
      // A filtered view fetches what it misses by itself; the end marker only pages the rendered list then.
      more.hidden = gridShown >= cards.length && !gridLoading && (gridFiltered || !planner.hasMore('main'));
      more.disabled = gridLoading;
      more.textContent = gridLoading ? tr('planner.grid_loading') : more.dataset.label;
    }
    gridBind();
    gridFill();
  };
  // The list is the scroll container: near its end the next page comes by itself. The search field filters as
  // she types; Enter / the keyboard's Suchen closes the keyboard.
  const gridBind = () => {
    const scroll = $('[data-vhp-grid-scroll]');
    if (scroll && !scroll.dataset.bound) {
      scroll.dataset.bound = '1';
      scroll.addEventListener(
        'scroll',
        () => {
          if (scroll.scrollHeight - scroll.scrollTop - scroll.clientHeight < 260) gridMore();
        },
        { passive: true }
      );
    }
    const input = $('[data-vhp-grid-search-input]');
    if (input && !input.dataset.bound) {
      input.dataset.bound = '1';
      input.addEventListener('input', () => gridSearchSet(input.value));
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          input.blur();
        } else if (event.key === 'Escape') gridSearchToggle(false);
      });
    }
  };
  // A tall phone: nine tiles leave room, so the next rendered page comes without a scroll (pool only, no fetch).
  const gridFill = () => {
    const scroll = $('[data-vhp-grid-scroll]');
    if (!scroll || gridLoading || state.screen !== 'grid') return;
    window.requestAnimationFrame(() => {
      if (state.screen !== 'grid' || !scroll.isConnected || scroll.clientHeight <= 0) return;
      if (scroll.scrollHeight <= scroll.clientHeight + 40 && gridShown < gridVisible().length) gridMore();
    });
  };
  // The picked tile's photo flies into its slot; the slot's own image lands right after (CSS is-new).
  const gridFly = (id) => {
    if (reelIsOpen() || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    const img = $(`[data-vhp-grid-pick="${id}"] img`);
    const slot = $(`[data-vhp-grid-slot="${id}"]`) || $('.vhp-grid__slot--more');
    if (!img || !slot || !img.animate) return;
    const from = img.getBoundingClientRect();
    const to = slot.getBoundingClientRect();
    if (!from.width || !to.width) return;
    const fly = img.cloneNode(false);
    fly.className = 'vhp-grid__fly';
    fly.removeAttribute('loading');
    Object.assign(fly.style, { left: `${from.left}px`, top: `${from.top}px`, width: `${from.width}px`, height: `${from.height}px` });
    document.body.append(fly);
    const scale = to.width / from.width;
    const dx = to.left + to.width / 2 - (from.left + from.width / 2);
    const dy = to.top + to.height / 2 - (from.top + from.height / 2);
    const motion = fly.animate(
      [
        { transform: 'translate(0, 0) scale(1)', opacity: 1, borderRadius: '14px' },
        { transform: `translate(${dx}px, ${dy}px) scale(${scale})`, opacity: 0.9, borderRadius: `${12 / scale}px` },
      ],
      { duration: 320, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)', fill: 'forwards' }
    );
    motion.onfinish = () => fly.remove();
    window.setTimeout(() => fly.remove(), 600);
  };
  const gridPick = (id) => {
    const liked = likeItems().some((item) => item.id === id);
    if (liked) {
      state.likes.items = state.likes.items.filter((row) => row.id !== id);
      if (state.undo?.action === 'like' && state.undo.item?.id === id) state.undo = null;
      plannerEvents('retract', 'recipe_liked', id);
    } else {
      const card = poolFor('main').find((row) => productId(row.id) === id);
      const item = card && asLike(card);
      if (!item) return;
      state.likes.items = state.likes.items.filter((row) => row.id !== item.id);
      state.likes.items.push(item);
      state.skips.items = (state.skips?.items || []).filter((row) => row.id !== item.id);
      recipeEvent('recipe_liked', item, item.slot, 'funnel');
      buzz(10);
    }
    persist();
    renderGrid();
    if (!liked) gridFly(id);
  };
  // "Nicht für mich" in the reel (batch 3): a skip like a left swipe in the deck (taste ranking, out of the plan),
  // the tile dims; a tap on the tile or "Doch für mich" takes it back. Returns true when the dish is now skipped.
  const gridSkip = (id) => {
    const skipped = (state.skips?.items || []).some((row) => row.id === id);
    if (skipped) {
      state.skips.items = state.skips.items.filter((row) => row.id !== id);
      plannerEvents('retract', 'recipe_skipped', id);
    } else {
      const card = poolFor('main').find((row) => productId(row.id) === id);
      if (!card) return false;
      const item = { id, slot: card.slot, at: new Date().toISOString() };
      state.skips.items = (state.skips?.items || []).filter((row) => row.id !== id);
      state.skips.items.push(item);
      if (likeItems().some((row) => row.id === id)) {
        state.likes.items = state.likes.items.filter((row) => row.id !== id);
        plannerEvents('retract', 'recipe_liked', id);
      }
      recipeEvent('recipe_skipped', item, item.slot, 'funnel');
      buzz(6);
    }
    persist();
    renderGrid();
    return !skipped;
  };
  const gridMore = async () => {
    if (gridLoading) return;
    const cards = gridVisible();
    if (gridShown < cards.length) {
      gridShown = Math.min(cards.length, gridShown + GRID_PAGE);
      renderGrid();
      return;
    }
    if (gridFiltered || !planner.hasMore('main')) return;
    gridLoading = true;
    renderGrid();
    try {
      await planner.loadMore('main');
    } catch (e) {
      /* the pool stays as it is */
    }
    gridLoading = false;
    gridShown = Math.min(gridVisible().length, gridShown + GRID_PAGE);
    renderGrid();
  };
  // ▶ on a tile: the reel zoomed out of it, the rendered tiles in grid order, the heart is the same pick.
  const openGridReel = (id) => {
    const cards = gridVisible().slice(0, gridShown);
    const index = cards.findIndex((card) => productId(card.id) === id);
    if (index < 0) return;
    step('grid_preview');
    openReel({ cards, index, grid: true });
  };

  const renderSwipe = () => {
    const weekApi = window.vhpPlannerLikes;
    const weekUi = window.vhpSwipeWeek;
    const screenEl = $('[data-vhp-screen="swipe"]');
    if (weekApi && weekUi && screenEl && typeof weekApi.weekView === 'function') {
      try {
        weekUi.render(screenEl, weekApi.weekView({ likes: state.likes }), {
          swap: Boolean(state.swap),
          swapLabel: state.swap
            ? tr('planner.swap_of', { label: state.swap.label || SLOT_LABEL[state.swap.slot] || '' })
            : '',
          planBusy: exampleBuilding || weekGenerating,
          allowSuccess: !state.swap,
          onPlan: () => createPlan(),
          // Setup deck only: plan without (enough) likes; the core fills every meal.
          onSkip: planner.config.paid ? null : () => createPlan({ skip: true }),
          // Planner landers after the first like (docs/PLANNER_PAGE_FUNNEL.md 2.4): the same skip, said as "enough".
          skipLabel: plannerLander() && likeCount() >= 1 ? tr('planner.skip_enough') : '',
          // Setup deck: the head counts likes toward a ready plan (3), not the 5 weekday mains.
          readyCount: planner.config.paid || state.swap ? 0 : LIKE_READY,
        });
      } catch (e) {
        /* week chrome must not block the deck or the screen change */
      }
    }

    if (!state.swap) startDeckIndex();
    const cards = deckCards();
    const loading =
      !cards.length &&
      ((!state.swap && !deckMode) ||
        (!state.swap && deckMode === 'index'
          ? selectedSlots().some((slot) => deckItems(slot, (id) => !likeItems().some((item) => item.id === id)).length)
          : slotsToFill().some((slot) => planner.hasMore(slot) && !failed.has(slot))));

    if (!cards.length && !loading) {
      step('planner_error', 'deck_empty');
      state.screen = 'empty';
      persist();
      return false;
    }

    if (!deck || !swipeDeck) return true;

    deck.classList.toggle('is-loading', loading);
    $$('[data-vhp-swipe]').forEach((btn) => {
      btn.disabled = loading;
    });
    const undoBtn = $('[data-vhp-swipe="undo"]');
    if (undoBtn) undoBtn.disabled = loading || !state.undo;

    const hint = !loading && !state.swipeHintSeen && !state.swap && !deckHintActive;
    const hintEl = $('[data-vhp-swipe-hint]');
    if (hintEl) hintEl.hidden = !hint;
    cardEl.classList.toggle('is-hinting', hint);

    if (!loading) {
      const card = cards[0];
      if (swipeDeck.show(card) && !state.swap) plannerEvents('shown', { id: card.id, slot: card.slot, src: 'funnel' });
      swipeDeck.showNext(cards[1] || null);
    } else {
      swipeDeck.showNext(null);
    }
    if (weekUi?.holding?.(screenEl)) {
      screenEl.querySelectorAll('[data-vhp-swipe-media] video').forEach((video) => {
        try { video.pause(); } catch (e) { /* ignore */ }
      });
    }
    if (!swipeDeck.dragging) swipeDeck.reset();
    ensureDeck();
    return true;
  };

  // ---------- preview = the planner week, locked (docs/PREVIEW_PAYWALL.md P1) ----------
  // The preview renders the subscriber week band fed from state.preview: the free day open with real meal cards, the
  // locked days on the strip, tappable, opening in place with blurred photos. No titles or per-meal numbers of a
  // locked day in the DOM (as the tiles before; a liked dish keeps its name, it really is in that day); day totals
  // are fine (they are not meal-level).
  let pvView = 0; // 0 = the free day, 1.. = the locked days after it
  let pvKey = ''; // a rebuilt preview starts back on the free day
  let pvDmKey = '';
  let pvDir = 0; // day-change slide direction for the meal cards

  // Free swaps on the free day (docs/PREVIEW_PAYWALL.md, P2 addition): two taps really replace the meal and the
  // day recalculates (the core demo of "ein Tap, der Tag rechnet neu"); after that the disc sells (paywall "swap").
  // The count lives in state.preview, so a reload keeps it and a rebuilt preview (new likes, new week) resets it.
  const PV_FREE_SWAPS = 2;
  const pvSwapsLeft = () => Math.max(0, PV_FREE_SWAPS - (Number(state.preview?.swapsUsed) || 0));
  // The free day's second line answers the obstacle they picked first on 1.4 with something on this screen (their
  // portion, the day list, the free swaps), so the preview shows what 1.5 promised before the paywall promises it
  // again. Counting, or no story answer: the portion line everyone had before.
  const pvPainLine = () => {
    const pain = storyActive() ? state.pain : null;
    if (pain === 'taste') {
      const n = pvSwapsLeft();
      if (n > 0) return tr('planner.skin_pv_pain_taste', { n });
    }
    if (pain === 'cook' || pain === 'time' || pain === 'family') return tr(`planner.skin_pv_pain_${pain}`);
    return tr('planner.skin_pv_2');
  };
  // The whole free day rerolled, once; after that the row opens the paywall (regen).
  const PV_FREE_ROLLS = 1;
  const pvRollsLeft = () => Math.max(0, PV_FREE_ROLLS - (Number(state.preview?.rollsUsed) || 0));
  let pvSwapBusy = false;
  let pvSwapNonce = 0;
  let pvSwapFlash = ''; // occasion of the last swap, "reroll", or "none" (nothing found); picks the DM line once

  const pvTotalsOf = (day) =>
    (day?.meals || []).reduce(
      (acc, meal) => ({
        kcal: acc.kcal + (Number(meal.kcal) || 0),
        protein: acc.protein + (Number(meal.protein) || 0),
        carbs: acc.carbs + (Number(meal.carbs) || 0),
        fat: acc.fat + (Number(meal.fat) || 0),
      }),
      { kcal: 0, protein: 0, carbs: 0, fat: 0 }
    );

  // The strip's days: the free day and everything after it (into next week when the free day is tomorrow).
  const pvSpan = (preview) => {
    const monday = ISO_DAY_RE.test(String(preview?.start || '')) ? dateOfIso(preview.start) : weekMonday();
    const open = Number(preview?.open) || 0;
    const out = [];
    // Sörens Woche (docs/SOEREN_WEEK.md 3): his whole week, Monday to Sunday ("7 Tage, 28 Gerichte"), no next week.
    if (preview?.soeren) {
      for (let index = 0; index < WEEK_LEN; index += 1) {
        out.push({ index, date: addDays(monday, index), day: preview?.week?.[index] || null, totals: preview?.days?.[index] || null });
      }
      return out;
    }
    for (let index = open; index < WEEK_LEN; index += 1) {
      out.push({ index, date: addDays(monday, index), day: preview?.week?.[index] || null, totals: preview?.days?.[index] || null });
    }
    const nextWeek = preview?.next?.week;
    if (previewTomorrow() && Array.isArray(nextWeek)) {
      const nextMonday = addDays(monday, WEEK_LEN);
      for (let i = 0; i < Math.min(previewNextDays(open), WEEK_LEN); i += 1) {
        out.push({ index: i, date: addDays(nextMonday, i), day: nextWeek[i] || null, totals: pvTotalsOf(nextWeek[i]) });
      }
    }
    return out;
  };

  // The day scratched free on the old gift slide (story arm, gone since 2026-10-19): the strip's second tab opens
  // like the free day (photo cards, rings, total) instead of a list of its own under the shopping list.
  const pvGifted = (view, preview = state.preview) =>
    view === 1 && state.scratched && !state.reward && Boolean(bonusDay(preview));

  const pvGo = (next) => {
    const span = pvSpan(state.preview);
    const clamped = Math.max(0, Math.min(span.length - 1, Number(next) || 0));
    if (clamped === pvView) return;
    pvDir = clamped > pvView ? 1 : -1;
    pvView = clamped;
    pvSwapFlash = '';
    if (soerenWeekOn()) step('soeren', 'day');
    else if (clamped > 0 && !pvGifted(clamped)) step('preview_use', 'day_locked');
    render();
  };

  // The chosen day's circle glides along the preview strip (like placeWeekGlide on the paid strip).
  let pvGlide = null;
  let pvGlideRaf = 0;
  const placePvGlide = (instant) => {
    if (!pvGlide) return;
    cancelAnimationFrame(pvGlideRaf);
    pvGlideRaf = requestAnimationFrame(() => {
      const box = pvGlide.parentElement;
      const on = box?.querySelector('.vhp-week-day.is-on .vhp-week-day__date');
      const at = on?.getBoundingClientRect();
      const from = box?.getBoundingClientRect();
      if (!at?.width || !from?.width) {
        pvGlide.classList.remove('is-on');
        return;
      }
      const jump = instant || !pvGlide.classList.contains('is-on') || !motionOk();
      if (jump) pvGlide.style.transition = 'none';
      pvGlide.style.transform = `translate(${at.left - from.left}px, ${at.top - from.top}px)`;
      pvGlide.classList.add('is-on');
      if (jump) {
        void pvGlide.offsetWidth;
        pvGlide.style.transition = '';
      }
    });
  };
  window.addEventListener('resize', () => placePvGlide(true));

  // One photo card per meal, the paid week's look (buildWeekMealRow): the free day with the portion badge ("Die Zahl
  // am Foto ist deine Portion"), swap and the recipe one tap away; a locked day blurred, the meal chip only.
  const pvMealCard = (meal, { locked, liked, when, paidSwap = false }) => {
    const wrap = document.createElement('div');
    wrap.className = 'vhp-meal';
    wrap.dataset.meal = meal.id;
    const card = document.createElement(locked ? 'button' : 'div');
    card.className = 'vhp-pick vhp-mcard';
    const hasImg = Boolean(meal.image);
    card.classList.toggle('is-noimg', !hasImg);
    if (locked) {
      card.type = 'button';
      card.classList.add('is-pv-locked');
      card.dataset.vhpPaywall = 'day';
      card.setAttribute('aria-label', tr('planner.day_locked_preview', { day: when }));
    } else {
      const hit = pickHit({ handle: meal.handle, scale: meal.scale, title: meal.title, occasion: meal.id });
      if (hit) card.append(hit);
    }

    const media = document.createElement('div');
    media.className = 'vhp-mcard__media';
    if (hasImg) {
      const img = weekTileImg(meal.image);
      img.className = 'vhp-pick__img';
      if (img.complete && img.naturalWidth) media.classList.add('is-loaded');
      else img.addEventListener('load', () => img.parentElement?.classList.add('is-loaded'), { once: true });
      media.append(img, mcardThumb(meal.image));
      card.classList.add('has-thumb');
    } else {
      const mark = document.createElement('div');
      mark.className = 'vhp-pick__img vhp-mcard__mark';
      const ico = spriteIcon(slotIconName(meal.id) || slotIconName(meal.label), 'vhp-mcard__mark-ico');
      if (ico) mark.append(ico);
      media.append(mark);
    }

    const top = document.createElement('div');
    top.className = 'vhp-mcard__top';
    const chip = document.createElement('p');
    chip.className = 'vhp-mcard__meal';
    const slotIco = spriteIcon(slotIconName(meal.id) || slotIconName(meal.label), 'vhp-mcard__ico');
    if (slotIco) chip.append(slotIco);
    const slotName = document.createElement('span');
    slotName.textContent = occLabel(meal);
    chip.append(slotName);
    if (locked) {
      const lock = lockIcon(true);
      lock.classList.add('vhp-mcard__lock');
      chip.append(lock);
    }
    top.append(chip);
    if (!locked) {
      const side = document.createElement('div');
      side.className = 'vhp-mcard__side';
      const actions = document.createElement('div');
      actions.className = 'vhp-pick__actions';
      // While free swaps are left the disc really swaps (badge = how many); after that it opens the paywall. The
      // gifted day's discs always sell (the free swaps belong to the free day).
      const left = paidSwap ? 0 : pvSwapsLeft();
      const swapBtn = left > 0
        ? pickAction({ label: tr('planner.pv_swap_aria', { n: left }), icon: swapIcon(), dataset: { vhpPvSwapFree: meal.id } })
        : pickAction({ label: tr('planner.swap_paid'), icon: swapIcon(), dataset: { vhpPaywall: 'swap' } });
      if (left > 0) {
        const n = document.createElement('span');
        n.className = 'vhp-pv-swap__n';
        n.setAttribute('aria-hidden', 'true');
        n.textContent = String(left);
        swapBtn.append(n);
      } else {
        swapBtn.classList.add('is-paywall');
      }
      actions.append(swapBtn);
      side.append(actions);
      // The paid card's ... in its place: the paid meal sheet, live where one day allows it (paintPvSheet).
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'vhp-meal__more';
      more.dataset.vhpPvMore = meal.id;
      more.dataset.title = dishName(meal.title || '');
      more.setAttribute('aria-haspopup', 'dialog');
      more.setAttribute('aria-label', tr('planner.more_actions', { label: occLabel(meal) || tr('planner.meal') }));
      more.append(dotsIcon());
      side.append(more);
      top.append(side);
    }

    const body = document.createElement('div');
    body.className = 'vhp-mcard__body';
    if (!locked) {
      const titleEl = document.createElement('p');
      titleEl.className = 'vhp-pick__title';
      titleEl.textContent = dishName(meal.title || '');
      body.append(titleEl);
      const meta = document.createElement('p');
      meta.className = 'vhp-mcard__meta';
      const protein = Math.round(Number(meal.protein) || 0);
      if (protein > 0) {
        const p = document.createElement('span');
        p.className = 'is-protein';
        p.textContent = `${protein} g ${tr('planner.protein')}`;
        meta.append(p);
      }
      if (liked) {
        const note = document.createElement('span');
        note.className = 'vhp-mcard__note';
        // "Von dir gewählt", not "Dein Like": grid pickers never saw the word Like (docs/DISH_PICKER.md, wording).
        note.textContent = `♥ ${tr('planner.pv_picked_tag')}`;
        meta.append(note);
      }
      // Sörens Woche: his reel's Instagram views on the dish ("▶ 7,3 Mio."), cut to one decimal like Instagram shows it.
      const views = Number(meal.views) || 0;
      if (views >= 100000 && soerenWeekOn()) {
        const v = document.createElement('span');
        v.className = 'vhp-mcard__views';
        const mio = (Math.floor(views / 100000) / 10).toLocaleString(LOCALE, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        v.textContent = `▶ ${tr('planner.soeren_views_badge', { n: mio })}`;
        meta.append(v);
      }
      if (meta.childNodes.length) body.append(meta);
      const play = mealPlayBtn({ handle: meal.handle, title: dishName(meal.title || ''), image: meal.image, scale: meal.scale, protein, occasion: meal.id });
      if (play) card.append(play);
      const badge = fmtScaleShort(meal.scale);
      if (badge) {
        const portion = document.createElement('span');
        portion.className = 'vhp-mcard__portion';
        portion.textContent = badge;
        card.append(portion);
      }
    } else if (meal.title) {
      // A locked day names its dishes (docs/PERSONA_ATTACK_PLAN.md 2.3): she sees what Tuesday is; recipe, list and
      // swaps stay in the subscription.
      const titleEl = document.createElement('p');
      titleEl.className = 'vhp-pick__title is-liked';
      titleEl.textContent = liked ? `♥ ${dishName(meal.title)}` : dishName(meal.title);
      body.append(titleEl);
    }
    if (locked) {
      const big = document.createElement('span');
      big.className = 'vhp-mcard__lockbig';
      big.setAttribute('aria-hidden', 'true');
      big.append(lockIcon(true));
      card.append(big);
    }

    card.append(media, top, body);
    wrap.append(card);
    return wrap;
  };

  // One free swap: the same picker as the paid swipe-replace (surprise), on the previewed week's free day. The new
  // dish is portioned to the slot, the day's totals and rings glide to the new numbers, and the swapped week is the
  // one takePreviewWeek hands over after checkout.
  const pvSwapReplace = async (occasion) => {
    const preview = state.preview;
    const open = Number(preview?.open) || 0;
    const day = preview?.week?.[open];
    const meal = day?.meals?.find((row) => row.id === occasion);
    if (!meal || !plannerCore || pvSwapBusy || pvSwapsLeft() <= 0 || planner.config.paid) return false;
    pvSwapBusy = true;
    try {
      let catalog = null;
      try {
        catalog = await plannerCatalog(false);
      } catch (e) {
        catalog = null;
      }
      const tried = new Set([productId(meal.pick?.id)]);
      const pool = (catalog?.[meal.catalog] ||
        allCatalogCards()
          .filter((card) => card.slot === meal.catalog)
          .map((card) => ({ ...card, mi: mainIngredient(card) }))
      ).filter(hasPlannableMacros);
      pvSwapNonce += 1;
      const pick = plannerCore.surprise(plannerContext({}), {
        days: (preview.week || []).map((d) => (d?.meals || []).map(coreFixedMeal)),
        dayIndex: open,
        occasionId: meal.id,
        pool,
        tried,
        seed: plannerCore.seed(planSeed(), 'pvswap', open, meal.id, pvSwapNonce),
      });
      if (!pick) {
        pvSwapFlash = 'none';
        render();
        return false;
      }
      const liked = new Set(likeItems().map((item) => item.id));
      const card = hydrateSwapCard(pick.card);
      const next = mealFromRemix(meal, card, slotScale(card, day, meal.id), !liked.has(productId(card.id)));
      next.locked = false;
      day.meals = orderMeals((day.meals || []).filter((row) => row.id !== meal.id).concat(next));
      // The screen renders the normalized view: rebuild it from the swapped week. The stored week carries no day
      // totals (buildPreview keeps meals only), so the open day's are summed fresh and the others come from
      // preview.days as built.
      const planned = (preview.week || []).map((d, i) => ({
        meals: d?.meals || [],
        totals: i === open ? pvTotalsOf(d) : preview.days?.[i],
      }));
      const refreshed = weekPreviewFromPlan(planned, Number(preview.target) || state.kcal, liked, open);
      state.preview = {
        ...preview,
        day: refreshed.day,
        days: refreshed.days,
        swapsUsed: (Number(preview.swapsUsed) || 0) + 1,
      };
      pvSwapFlash = occasion;
      step('preview_use', 'swap_free');
      persist();
      render();
      // The new card pops like a paid swap result.
      if (motionOk()) {
        requestAnimationFrame(() => {
          funnel.querySelector(`[data-vhp-preview-meals] .vhp-meal[data-meal="${occasion}"]`)?.classList.add('is-swapped');
        });
      }
      return true;
    } finally {
      pvSwapBusy = false;
    }
  };

  // The whole free day rerolled (once): every meal replaced through the same picker, one after another so each
  // pick sees the day as it grows; portions fitted per slot, totals and rings follow. Liked dishes go too: the
  // visitor asked for a fresh day.
  const pvDayReroll = async () => {
    const preview = state.preview;
    const open = Number(preview?.open) || 0;
    const day = preview?.week?.[open];
    if (!day?.meals?.length || !plannerCore || pvSwapBusy || pvRollsLeft() <= 0 || planner.config.paid) return false;
    pvSwapBusy = true;
    try {
      let catalog = null;
      try {
        catalog = await plannerCatalog(false);
      } catch (e) {
        catalog = null;
      }
      const liked = new Set(likeItems().map((item) => item.id));
      const tried = new Set((day.meals || []).map((meal) => productId(meal.pick?.id)).filter(Boolean));
      let changed = 0;
      for (const meal of [...day.meals]) {
        // Her "♥ Von dir gewählt" dishes stay; the roll renews the rest (docs/PERSONA_ATTACK_PLAN.md 2.6).
        if (meal.generated === false && liked.has(productId(meal.pick?.id))) continue;
        const pool = (catalog?.[meal.catalog] ||
          allCatalogCards()
            .filter((card) => card.slot === meal.catalog)
            .map((card) => ({ ...card, mi: mainIngredient(card) }))
        ).filter(hasPlannableMacros);
        pvSwapNonce += 1;
        const pick = plannerCore.surprise(plannerContext({}), {
          days: (preview.week || []).map((d) => (d?.meals || []).map(coreFixedMeal)),
          dayIndex: open,
          occasionId: meal.id,
          pool,
          tried,
          seed: plannerCore.seed(planSeed(), 'pvroll', open, meal.id, pvSwapNonce),
        });
        if (!pick) continue;
        const card = hydrateSwapCard(pick.card);
        tried.add(productId(card.id));
        const next = mealFromRemix(meal, card, slotScale(card, day, meal.id), !liked.has(productId(card.id)));
        next.locked = false;
        day.meals = orderMeals((day.meals || []).filter((row) => row.id !== meal.id).concat(next));
        changed += 1;
      }
      if (!changed) {
        pvSwapFlash = 'none';
        pvSwapNonce += 1;
        render();
        return false;
      }
      const planned = (preview.week || []).map((d, i) => ({
        meals: d?.meals || [],
        totals: i === open ? pvTotalsOf(d) : preview.days?.[i],
      }));
      const refreshed = weekPreviewFromPlan(planned, Number(preview.target) || state.kcal, liked, open);
      state.preview = {
        ...preview,
        day: refreshed.day,
        days: refreshed.days,
        rollsUsed: (Number(preview.rollsUsed) || 0) + 1,
      };
      pvSwapFlash = 'reroll';
      step('preview_use', 'reroll_free');
      persist();
      render();
      return true;
    } finally {
      pvSwapBusy = false;
    }
  };

  // ---------- the open day's meal ⋯ sheet (docs/PREVIEW_PAYWALL.md round 7) ----------
  // The paid week's meal sheet itself, fed from state.preview: what works on one day works here (portion stepper,
  // the day it adds up to, "Rest des Tages anpassen", the recipe, the free swaps); every other row of the paid sheet
  // carries an "Im Abo" pill and opens the paywall answering that row. Portions persist in state.preview like the
  // swaps, so takePreviewWeek hands them over after checkout.
  let pvSheet = null; // { occasion, index, next, date, free, rebalanced }
  const pvSheetEl = () => funnel.querySelector('[data-vhp-pv-more-sheet]');
  const pvSheetDay = () => {
    if (!pvSheet) return null;
    const week = pvSheet.next ? state.preview?.next?.week : state.preview?.week;
    return Array.isArray(week) ? week[pvSheet.index] || null : null;
  };
  const pvSheetMeal = () => pvSheetDay()?.meals?.find((row) => row.id === pvSheet.occasion) || null;
  // Row → paywall_opened value (the ctx is the row itself, see PW_CTX).
  const PV_SHEET_PAYWALL = { lock: 'lock', swap: 'swap', prep: 'prep', own: 'own', copy: 'copy', family: 'family', pick: 'pick', away: 'away' };

  const searchIcon = () =>
    strokeIcon((svg) => {
      addStroke(svg, 'circle', { cx: '11', cy: '11', r: '6.5' });
      addStroke(svg, 'path', { d: 'm20 20-4.2-4.2' });
    });
  const plusIcon = () =>
    strokeIcon((svg) => {
      addStroke(svg, 'rect', { x: '3.5', y: '3.5', width: '17', height: '17', rx: '5' });
      addStroke(svg, 'path', { d: 'M12 8.5v7M8.5 12h7' });
    });
  const pvAboPill = () => sheetEl('span', 'vhp-pv-sheet__abo', tr('planner.pv_sheet_abo'));
  const pvSheetRow = ({ act, label, note, icon, abo, free }) => {
    const btn = mealSheetItem({ act, label, note, icon });
    delete btn.dataset.vhpMealAct;
    btn.dataset.vhpPvAct = act;
    if (abo) {
      btn.classList.add('is-abo');
      btn.append(pvAboPill());
    }
    if (free) btn.append(sheetEl('span', 'vhp-pv-reroll__free', free));
    return btn;
  };

  // Portion card and the day line, the rebalance (live). Who eats along and Meal-Prep are rows of the Abo list.
  const pvSheetPortion = (day, meal) => {
    const box = sheetEl('div', 'vhp-meal-sheet__portion-box');
    const scale = Number(meal.scale) || 1;
    const card = sheetEl('div', 'vhp-meal-sheet__portion');
    const copy = sheetEl('div', 'vhp-meal-sheet__portion-copy');
    copy.append(sheetEl('strong', null, tr('planner.your_portion')), sheetEl('small', null, mealMetaLine({ kcal: meal.kcal, protein: meal.protein })));
    const stepper = sheetEl('div', 'vhp-stepper');
    stepper.setAttribute('role', 'group');
    stepper.setAttribute('aria-label', tr('planner.portions_label'));
    const btn = (act, label, glyph, disabled) => {
      const b = sheetEl('button', 'vhp-stepper__btn', glyph);
      b.type = 'button';
      b.dataset.vhpPvAct = act;
      b.setAttribute('aria-label', label);
      b.disabled = disabled;
      return b;
    };
    const value = sheetEl('output', 'vhp-stepper__value', fmtPortion(scale));
    value.setAttribute('aria-live', 'polite');
    stepper.append(btn('less', tr('planner.smaller'), '−', scale <= PORTION_MIN), value, btn('more', tr('planner.bigger'), '+', scale >= PORTION_MAX));
    card.append(copy, stepper);

    const target = Number(state.preview?.target) || Number(state.kcal) || 0;
    const nodes = [card, sheetEl('p', 'vhp-meal-sheet__day', dayStatusText(dayKcal(day.meals || []), target))];
    if (pvSheet.rebalanced) {
      const done = sheetEl('p', 'vhp-meal-sheet__done', tr('planner.adjusted', { text: pvSheet.rebalanced.text }));
      const undo = sheetEl('button', 'vhp-meal-sheet__undo', tr('planner.undo'));
      undo.type = 'button';
      undo.dataset.vhpPvAct = 'unbalance';
      done.append(undo);
      nodes.push(done);
    } else {
      const plan = rebalancePlan(day, meal.id);
      if (plan) {
        const go = sheetEl('button', 'vhp-meal-sheet__balance');
        go.type = 'button';
        go.dataset.vhpPvAct = 'rebalance';
        const text = sheetEl('span', 'vhp-meal-sheet__label');
        text.append(
          tr('planner.rebalance'),
          sheetEl('small', null, plan.changes.map((c) => `${c.label} ${fmtPortion(c.from)} → ${fmtPortion(c.to)}`).join(' · '))
        );
        go.append(text, sheetEl('span', 'vhp-meal-sheet__balance-kcal', `≈ ${deInt(plan.kcal)} kcal`));
        nodes.push(go);
      }
    }
    box.append(...nodes);
    return box;
  };

  function paintPvSheet() {
    const sheet = pvSheetEl();
    if (!sheet || !pvSheet) return;
    const day = pvSheetDay();
    const meal = pvSheetMeal();
    if (!day || !meal?.pick) {
      closePvSheet();
      return;
    }
    const pick = meal.pick;
    const thumb = sheet.querySelector('[data-vhp-pv-sheet-thumb]');
    if (thumb) {
      const src = pick.image || '';
      if (thumb.dataset.src !== src) {
        thumb.dataset.src = src;
        thumb.replaceChildren();
        if (src) {
          const img = document.createElement('img');
          img.src = swapThumbUrl(src, SWAP_CARD);
          img.alt = '';
          thumb.append(img);
        }
      }
    }
    const title = sheet.querySelector('[data-vhp-pv-sheet-title]');
    if (title) title.textContent = (pick.title && dishName(pick.title)) || occLabel(meal) || tr('planner.meal');
    const when = sheet.querySelector('[data-vhp-pv-sheet-when]');
    if (when) {
      when.textContent = tr('planner.meal_when', { label: occLabel(meal) || tr('planner.meal'), weekday: PREVIEW_DAYS[pvSheet.index], date: dayMonth(pvSheet.date) });
    }
    const focused = sheet.contains(document.activeElement) ? document.activeElement.dataset?.vhpPvAct : null;
    // What works on this day stays in view (portion, rebalance, recipe, the free swap). Of the subscription rows the
    // three that sell best show (Maxim 2026-10-19: show off what convinces, fold the rest): choosing yourself and
    // your own dish (a plan that bends: "why people buy" #2 in vhp-planner docs/features.md), cooking for more. The
    // row that answers their 1.4 obstacle leads (family, time → Meal-Prep). The rest folds into "Mehr im Abo", which
    // opens in place.
    const pains = storyActive() ? state.pains : [];
    const live = [];
    if (pick.handle) live.push(pvSheetRow({ act: 'view', label: tr('common.view_recipe'), icon: bookIcon }));
    // Überrasch mich is the free swap while one is left (free day only), then the paid one. Sörens Woche: none, and no
    // portion stepper either (the day is his; changing it is the subscription).
    const soeren = soerenWeekOn();
    const swapsLeft = pvSheet.free && !soeren ? pvSwapsLeft() : 0;
    if (swapsLeft > 0) {
      live.push(pvSheetRow({ act: 'surprise', label: tr('planner.surprise'), icon: diceIcon, free: tr('planner.pv_reroll_free_n', { n: swapsLeft }) }));
    }
    const aboRows = {
      pick: () => pvSheetRow({ act: 'pick', label: tr('planner.pv_sheet_pick'), note: tr('planner.pv_sheet_pick_note'), icon: searchIcon, abo: true }),
      own: () => pvSheetRow({ act: 'own', label: tr('planner.own_here'), note: tr('planner.own_here_note'), icon: penIcon, abo: true }),
      family: () => pvSheetRow({ act: 'family', label: tr('planner.eats_with'), note: tr('planner.eats_with_note'), icon: peopleIcon, abo: true }),
      prep: () => pvSheetRow({ act: 'prep', label: tr('planner.meal_prep'), note: tr('planner.prep_note'), icon: potIcon, abo: true }),
      swap: () => pvSheetRow({ act: 'swap', label: tr('planner.surprise'), icon: diceIcon, abo: true }),
      lock: () => pvSheetRow({ act: 'lock', label: tr('planner.lock'), note: tr('planner.lock_note'), icon: () => lockIcon(false), abo: true }),
      copy: () => pvSheetRow({ act: 'copy', label: tr('planner.copy_days'), icon: copyIcon, abo: true }),
      away: () => pvSheetRow({ act: 'away', label: tr('planner.away'), note: tr('planner.away_note'), icon: awayIcon, abo: true }),
    };
    const lead = pains.includes('family') ? ['family'] : pains.includes('time') ? ['prep'] : [];
    const shown = [...new Set([...lead, 'pick', 'own', 'family'])].slice(0, 3);
    const folded = ['prep', 'family', ...(swapsLeft > 0 ? [] : ['swap']), 'lock', 'copy', 'away'].filter((key) => !shown.includes(key));
    // Always in the list, shown by the toggle in place (a repaint would play the groups' entrance again).
    const abo = folded.map((key) => {
      const row = aboRows[key]();
      row.classList.add('vhp-pv-sheet__abo-row');
      row.hidden = !pvSheet.aboOpen;
      return row;
    });
    const toggle = pvSheetRow({ act: 'abo_more', label: tr('planner.pv_sheet_more'), note: tr('planner.pv_sheet_more_note', { n: abo.length }), icon: plusIcon });
    toggle.classList.add('vhp-pv-sheet__more');
    toggle.setAttribute('aria-expanded', pvSheet.aboOpen ? 'true' : 'false');
    const chev = sheetEl('span', 'vhp-pv-sheet__chev');
    chev.setAttribute('aria-hidden', 'true');
    chev.append(chevronIcon());
    toggle.append(chev);
    const box = sheet.querySelector('[data-vhp-pv-sheet-groups]');
    if (!box) return;
    box.replaceChildren(
      ...(soeren ? [] : [pvSheetPortion(day, meal)]),
      ...[live, [...shown.map((key) => aboRows[key]()), toggle, ...abo]]
        .filter((items) => items.length)
        .map((items) => {
          const group = sheetEl('div', 'vhp-meal-sheet__group');
          group.append(...items);
          return group;
        })
    );
    if (focused) {
      const again = sheet.querySelector(`[data-vhp-pv-act="${focused}"]:not(:disabled)`) || sheet.querySelector('[data-vhp-pv-act="less"]:not(:disabled), [data-vhp-pv-act="more"]:not(:disabled)');
      again?.focus({ preventScroll: true });
    }
  }

  // The tapped ⋯ on the day on screen (the free day, or the gifted one).
  const openPvSheet = (occasion) => {
    const sheet = pvSheetEl();
    const preview = state.preview;
    const entry = pvSpan(preview)[pvView];
    if (!sheet || !entry?.day) return;
    pvSheet = {
      occasion,
      index: entry.index,
      next: entry.day !== preview?.week?.[entry.index],
      date: entry.date,
      free: pvView === 0,
      rebalanced: null,
      aboOpen: false,
    };
    if (!pvSheetMeal()) {
      pvSheet = null;
      return;
    }
    step('preview_use', 'more');
    paintPvSheet();
    setDialogOpen(sheet, true);
    sheet.querySelector('[data-vhp-pv-sheet-title]')?.focus({ preventScroll: true });
  };

  function closePvSheet() {
    const sheet = pvSheetEl();
    const occasion = pvSheet?.occasion;
    pvSheet = null;
    if (sheet?.open) setDialogOpen(sheet, false);
    if (occasion) funnel.querySelector(`[data-vhp-preview-meals] [data-vhp-pv-more="${occasion}"]`)?.focus({ preventScroll: true });
  }

  const afterPvSheet = (fn) => {
    const sheet = pvSheetEl();
    if (sheet?.open) sheet.addEventListener('close', fn, { once: true });
    else fn();
  };

  // A changed portion: the open day's view and totals rebuilt (as after a free swap), rings and cards follow.
  const pvSheetCommit = () => {
    const preview = state.preview;
    if (!preview || !pvSheet) return;
    if (!pvSheet.next) {
      const open = Number(preview.open) || 0;
      const planned = (preview.week || []).map((d, i) => ({
        meals: d?.meals || [],
        totals: i === open || i === pvSheet.index ? pvTotalsOf(d) : preview.days?.[i],
      }));
      const liked = new Set(likeItems().map((item) => item.id));
      const refreshed = weekPreviewFromPlan(planned, Number(preview.target) || state.kcal, liked, open);
      state.preview = { ...preview, day: refreshed.day, days: refreshed.days };
    }
    persist();
    render();
    paintPvSheet();
  };

  const pvStepPortion = (dir) => {
    const meal = pvSheetMeal();
    if (!meal?.pick) return;
    const scale = portionStep(meal.scale, dir);
    if (scale === meal.scale) return;
    scaleMeal(meal, scale);
    pvSheet.rebalanced = null;
    step('preview_use', 'portion');
    pvSheetCommit();
  };

  const pvRebalance = () => {
    const day = pvSheetDay();
    const meal = pvSheetMeal();
    const plan = day && meal ? rebalancePlan(day, meal.id) : null;
    if (!plan) return;
    const snapshot = new Map((day.meals || []).map((row) => [row.id, row.scale]));
    plan.changes.forEach((change) => {
      const row = day.meals.find((m) => m.id === change.id);
      if (row) scaleMeal(row, change.to);
    });
    pvSheet.rebalanced = { snapshot, text: plan.changes.map((c) => `${c.label} ${fmtPortion(c.to)}`).join(', ') };
    step('preview_use', 'rebalance');
    pvSheetCommit();
  };

  const pvUnbalance = () => {
    const day = pvSheetDay();
    const snap = pvSheet?.rebalanced?.snapshot;
    if (!day || !snap) return;
    (day.meals || []).forEach((row) => {
      if (snap.has(row.id) && snap.get(row.id) !== row.scale && row.pick) scaleMeal(row, snap.get(row.id));
    });
    pvSheet.rebalanced = null;
    pvSheetCommit();
  };

  const runPvSheetAct = (act) => {
    if (!pvSheet) return;
    if (act === 'less' || act === 'more') {
      pvStepPortion(act === 'more' ? 1 : -1);
      return;
    }
    if (act === 'rebalance') {
      pvRebalance();
      return;
    }
    if (act === 'unbalance') {
      pvUnbalance();
      return;
    }
    if (act === 'abo_more') {
      pvSheet.aboOpen = !pvSheet.aboOpen;
      if (pvSheet.aboOpen) step('preview_use', 'abo_more');
      const open = pvSheet.aboOpen;
      pvSheetEl()?.querySelectorAll('.vhp-pv-sheet__abo-row').forEach((el) => {
        el.hidden = !open;
      });
      pvSheetEl()?.querySelector('.vhp-pv-sheet__more')?.setAttribute('aria-expanded', open ? 'true' : 'false');
      // The opened rows into view, the toggle row at the top of the list (both rects move with the sheet).
      const list = pvSheetEl()?.querySelector('[data-vhp-pv-sheet-groups]');
      const row = list?.querySelector('.vhp-pv-sheet__more');
      if (pvSheet.aboOpen && list && row) {
        const top = list.scrollTop + row.getBoundingClientRect().top - list.getBoundingClientRect().top - 8;
        list.scrollTo({ top: Math.max(0, top), behavior: motionOk() ? 'smooth' : 'auto' });
      }
      return;
    }
    const { occasion } = pvSheet;
    closePvSheet();
    afterPvSheet(() => {
      if (act === 'view') {
        funnel.querySelector(`[data-vhp-preview-meals] .vhp-pick__hit[data-vhp-recipe-occasion="${occasion}"]`)?.click();
      } else if (act === 'surprise') {
        // The card's own free swap disc: same swap, same counter, same pop.
        const disc = funnel.querySelector(`[data-vhp-preview-meals] [data-vhp-pv-swap-free="${occasion}"]`);
        if (disc) disc.click();
        else continueToSubscribe('swap');
      } else if (PV_SHEET_PAYWALL[act]) {
        continueToSubscribe(PV_SHEET_PAYWALL[act], act);
      }
    });
  };

  // Sticky bar line above "Ganze Woche freischalten": only during an offer (the offer price with its tag and
  // countdown); without one the button stands alone.
  const renderPreviewOffer = (show) => {
    const offer = $('[data-vhp-preview-offer]');
    if (!offer) return;
    const low = lowestMonthly();
    offer.replaceChildren();
    if (!show || !low) {
      offer.hidden = true;
      return;
    }
    const deal = activeOffer();
    if (deal) {
      const tag = document.createElement('span');
      tag.className = 'vhp-preview__offer-tag';
      tag.textContent = `${deal.tag} −${deal.off} %`;
      if (deal.timer === false) offer.append(tag, tr('planner.from_month', { price: money(low) }));
      else offer.append(tag, tr('planner.from_month_left', { price: money(low) }), offerTimer());
    } else if (previewWeekFirst() && giftReady() && giftIsReward() && REWARD_CFG?.off) {
      // 3.3 fallback: the gift the tap grants, named before it (a "Geschenk" everyone gets, never "gewonnen").
      const tag = document.createElement('span');
      tag.className = 'vhp-preview__offer-tag';
      tag.textContent = tr('planner.pv_gift_tag', { off: REWARD_CFG.off });
      offer.append(tag, tr('planner.from_month', { price: money(low) }));
    } else if (planner.config.previewPrice !== false) {
      // No offer: the decision on the bar (docs/CR_AUDIT.md 6): the lowest monthly price and the guarantee, one line.
      // Theme setting "Vorschau: Preis und Garantie in der Leiste"; off = the button alone (Maxim, 2026-10-19).
      const days = Number(planner.config.guaranteeDays) || 0;
      offer.textContent = days > 0 ? tr('planner.pv_bar_line', { price: money(low), days }) : tr('planner.from_month', { price: money(low) });
    } else {
      offer.hidden = true;
      return;
    }
    offer.hidden = false;
  };

  // Food first: the open day's dishes (photo, portion, protein; swap and lock locked) and its totals in one line,
  // then the days after it as photo tiles. Days before the open day are left out (the week they will eat).
  // An exclusive recipe the visitor swiped right on in the feed (vhp_feed_ex_wants_v1, assets/vhp-collection-reels.js)
  // or came for (?src=exclusive&recipe=<handle>, the locked card's link): a locked row in the preview that opens the
  // paywall (docs/FEED_ORDER.md step 4). The link's recipe first, else the latest right swipe. Title and poster from
  // the feed's exclusives pool (templates/collection.feed-exclusives.liquid).
  const EX_WANT_KEY = 'vhp_feed_ex_wants_v1';
  const exWantHandle = (() => {
    const params = new URLSearchParams(location.search);
    return params.get('src') === 'exclusive' ? params.get('recipe') || '' : '';
  })();
  let exWant; // undefined: not looked up, null: none, else { id, handle, title, image }
  const loadExWant = () => {
    if (exWant !== undefined) return;
    exWant = null;
    if (planner.config.paid) return;
    let wants = {};
    try {
      wants = JSON.parse(localStorage.getItem(EX_WANT_KEY) || 'null') || {};
    } catch (e) {
      /* no storage: the link's recipe only */
    }
    if (!exWantHandle && !Object.keys(wants).length) return;
    const url = new URL('/collections/alle-rezepte', location.origin);
    url.searchParams.set('view', 'feed-exclusives');
    fetch(url, { headers: { Accept: 'text/html' } })
      .then((response) => (response.ok ? response.text() : Promise.reject(new Error(`exclusives ${response.status}`))))
      .then((html) => {
        const holder = new DOMParser().parseFromString(html, 'text/html').querySelector('#vhpFeedExclusives');
        const rows = JSON.parse(holder?.textContent || '[]').filter((row) => row?.id && row.title && row.image);
        exWant =
          (exWantHandle && rows.find((row) => row.handle === exWantHandle)) ||
          rows.filter((row) => wants[row.id]).sort((a, b) => wants[b.id] - wants[a.id])[0] ||
          null;
        if (exWant && state.screen === 'preview') render();
      })
      .catch(() => {});
  };

  const renderWeekPreview = (preview) => {
    const openDay = preview?.day;
    const meals = Array.isArray(openDay?.meals) ? openDay.meals : [];
    const kicker = $('[data-vhp-preview-kicker]');
    const band = $('[data-vhp-pv-band]');
    const card = $('[data-vhp-preview-card]');
    const note = $('[data-vhp-preview-note]');
    const mealsBox = $('[data-vhp-preview-meals]');
    if (!note || !mealsBox || !band) return;

    // A rebuilt preview (new week, new likes) starts back on the free day. Sörens Woche spans Monday to Sunday and
    // opens on the open day (today or tomorrow), so the strip index is the weekday.
    if (preview?.key && preview.key !== pvKey) {
      pvKey = preview.key;
      pvView = preview.soeren ? Number(preview.open) || 0 : 0;
      pvSwapFlash = '';
    }
    const extras = $$('[data-vhp-preview-locked-ui]');
    renderPreviewOffer(meals.length > 0);

    if (!meals.length) {
      mealsBox.replaceChildren();
      mealsBox.vhpSig = '';
      band.hidden = true;
      // No preview at all (an older one that rebuilds on load): planning, not "no week found".
      const planning = exampleBuilding || !preview;
      if (kicker) {
        kicker.textContent = tr('planner.planning');
        kicker.hidden = !planning;
      }
      if (card) card.hidden = true;
      extras.forEach((el) => {
        el.hidden = true;
      });
      note.hidden = planning;
      note.textContent = planning ? '' : tr('planner.no_week_exclusions');
      return;
    }

    if (kicker) kicker.hidden = true;
    band.hidden = false;
    if (card) card.hidden = false;
    extras.forEach((el) => {
      el.hidden = false;
    });
    note.hidden = true;
    note.textContent = '';

    // Sörens Woche (docs/SOEREN_WEEK.md 3): every day opens like the free day (clear photos, names, her portion, the
    // recipe one tap away); the swap disc, the list and next week sell. No free swaps, no reroll, no day list, no
    // "free day": each day renders from the stored week.
    const soeren = soerenWeekOn();
    const span = pvSpan(preview);
    if (pvView >= span.length) pvView = soeren ? Number(preview.open) || 0 : 0;
    const entry = span[pvView] || span[0];
    const free = !soeren && pvView === 0;
    const gifted = !soeren && pvGifted(pvView, preview);
    const today = new Date();
    const whenLabel = PREVIEW_DAYS[entry.index] || '';
    const bar = $('[data-vhp-subscribe]');
    if (bar) {
      if (!bar.dataset.label) bar.dataset.label = bar.textContent;
      const label = soeren ? tr('planner.soeren_unlock') : bar.dataset.label;
      if (bar.textContent !== label) bar.textContent = label;
    }
    const nextRow = $('[data-vhp-soeren-next]');
    if (nextRow) nextRow.hidden = !soeren;

    // Band head: Heute / Morgen / the weekday, the date under it; a day change slides the words in from its side.
    const title = $('[data-vhp-pv-title]');
    const sub = $('[data-vhp-pv-sub]');
    if (title) title.textContent = weekHeadLabel(entry.date);
    if (sub) {
      const when = weekHeadSub(entry.date);
      const pick = title?.closest('.vhp-wk__pick');
      if (pick && sub.textContent && sub.textContent !== when && motionOk()) {
        pick.style.setProperty('--turn', String(pvDir < 0 ? -1 : 1));
        pick.classList.remove('is-turn');
        void pick.offsetWidth;
        pick.classList.add('is-turn');
      }
      sub.textContent = when;
    }
    $$('[data-vhp-pv-step]').forEach((btn) => {
      const next = pvView + Number(btn.dataset.vhpPvStep);
      btn.disabled = next < 0 || next >= span.length;
    });

    // The strip: the free day open, every locked day tappable (it opens in place, blurred).
    const daysBox = $('[data-vhp-pv-days]');
    if (daysBox) {
      daysBox.replaceChildren(
        ...span.map((row, i) => {
          const btn = renderDayTab({
            label: (DAY_LABEL[row.index] || '')[0] || '',
            date: row.date.getDate(),
            selected: i === pvView,
            today: sameDay(row.date, today),
            on: true,
          });
          btn.dataset.vhpPvGo = String(i);
          if (i === 0 || soeren || pvGifted(i, preview)) btn.setAttribute('aria-label', `${PREVIEW_DAYS[row.index]}, ${dayNum(row.date)}`);
          else {
            btn.classList.add('is-locked');
            const lock = lockIcon(true);
            lock.classList.add('vhp-week-day__lock');
            btn.append(lock);
            btn.setAttribute('aria-label', tr('planner.day_locked_preview', { day: PREVIEW_DAYS[row.index] }));
          }
          return btn;
        })
      );
      pvGlide = pvGlide || $('[data-vhp-pv-glide]');
      if (pvGlide) daysBox.append(pvGlide);
      placePvGlide(false);
    }

    // The rings: the viewed day's totals against their target (every day is planned to it).
    fillWeekStats(
      $('[data-vhp-pv-stats]'),
      free ? openDay.totals : entry.totals,
      Number(preview.target) || state.kcal,
      `pv|${preview.key}|${pvView}`
    );

    // Sören in the band's foot, one message per day state; after a free swap or reroll one line on what happened.
    const dmEl = $('[data-vhp-pv-dm]');
    const want = Number(preview.target) || state.kcal || 0;
    const viewTotals = free ? openDay.totals : entry.totals;
    const soerenOff = soeren ? soerenDayOff(viewTotals, want) : '';
    const dmKey = `${preview.key}|${soeren ? `soeren|${pvView}|${soerenOff}` : free ? `free|${Number(preview.swapsUsed) || 0}|${Number(preview.rollsUsed) || 0}|${pvSwapFlash ? pvSwapNonce : ''}` : `${gifted ? 'gifted' : 'locked'}|${pvView}`}`;
    if (dmEl && storyActive() && !planner.config.paid && pvDmKey !== dmKey) {
      pvDmKey = dmKey;
      const name = storyName();
      if (soeren) {
        // Her dish (or a like) sits on one day of his week: say which. Then the day's honesty line when it misses.
        const pickAt = (preview.week || []).findIndex((d) => (d?.meals || []).some((m) => m?.generated === false));
        const lines = [
          pickAt >= 0
            ? tr('planner.soeren_week_dm_pick', { day: PREVIEW_DAYS[pickAt] || '', kcal: deInt(want) })
            : tr('planner.soeren_week_dm', { kcal: deInt(want) }),
        ];
        if (soerenOff) lines.push(tr(soerenOff === 'over' ? 'planner.soeren_day_over' : 'planner.soeren_day_under'));
        paintDm(dmEl, lines);
      } else if (free && pvSwapFlash === 'none') {
        paintDm(dmEl, [tr('planner.no_other_idea')]);
      } else if (free && pvSwapFlash === 'reroll') {
        paintDm(dmEl, [tr('planner.pv_reroll_done')]);
      } else if (free && pvSwapFlash) {
        const left = pvSwapsLeft();
        paintDm(dmEl, [left > 0 ? tr('planner.pv_swap_done_more', { n: left }) : tr('planner.pv_swap_done_last')]);
      } else if (free) {
        const first = previewTomorrow()
          ? name ? tr('planner.skin_pv_1_tomorrow_name', { name, day: whenLabel }) : tr('planner.skin_pv_1_tomorrow', { day: whenLabel })
          : name ? tr('planner.skin_pv_1_name', { name, day: whenLabel }) : tr('planner.skin_pv_1', { day: whenLabel });
        paintDm(dmEl, [first, pvPainLine()]);
      } else if (gifted) {
        paintDm(dmEl, [tr('planner.pv_gifted_day', { day: whenLabel })]);
      } else {
        paintDm(dmEl, [tr('planner.skin_pv_locked', { day: whenLabel })]);
      }
    }

    // The day's cards; on the free day the liked exclusive and the own-dish rows follow (markup in the section).
    const liked = new Set(likeItems().map((item) => item.id));
    // Sörens Woche: the viewed day's meals in the open look (the stored week's choices, normalized like the open day).
    const soerenMeals = soeren && !free
      ? (entry.day?.meals || [])
          .filter((meal) => meal?.pick)
          .map((meal) => ({
            id: meal.id,
            label: meal.label,
            title: meal.pick.title || '',
            image: meal.pick.image || '',
            handle: meal.pick.handle,
            scale: meal.scale,
            protein: meal.protein,
            generated: meal.generated,
            views: meal.pick.views || 0,
          }))
      : null;
    const rows = soerenMeals
      ? soerenMeals.map((meal) => pvMealCard(meal, { locked: false, liked: meal.generated === false, when: whenLabel, paidSwap: true }))
      : free
      ? meals.map((meal) => pvMealCard(meal, { locked: false, liked: meal.generated === false, when: whenLabel, paidSwap: soeren }))
      : (entry.day?.meals || [])
          .filter((meal) => meal?.pick)
          .map((meal) =>
            pvMealCard(
              gifted
                ? {
                    id: meal.id,
                    label: meal.label,
                    title: meal.pick.title || '',
                    image: meal.pick.image || '',
                    handle: meal.pick.handle,
                    scale: meal.scale,
                    protein: meal.protein,
                  }
                : { id: meal.id, label: meal.label, title: meal.pick?.title || '', image: meal.pick?.image || '' },
              { locked: !gifted, liked: liked.has(productId(meal.pick?.id)), when: whenLabel, paidSwap: gifted }
            )
          );
    if (free) {
      const exTpl = exWant && $('template[data-vhp-preview-ex]');
      if (exTpl) {
        const row = exTpl.content.cloneNode(true).firstElementChild;
        const img = row?.querySelector('[data-vhp-ex-img]');
        if (img) img.src = exWant.image;
        const exTitle = row?.querySelector('[data-vhp-ex-title]');
        if (exTitle) exTitle.textContent = exWant.title;
        if (row) rows.push(row);
      }
      // The "Dein Gericht" teaser (Foto / Sprache / Barcode) stays out of the preview (docs/CR_AUDIT.md 6): a paid
      // feature sold before the product has sold itself; its paywall opens were 2 of 56 in the first days. The
      // template stays for the meal sheet's "Eigenes Gericht eintragen" row.
    }
    const mealSig = soerenMeals
      ? soerenMeals.map((meal) => `${meal.id}:${meal.title}:${meal.scale}`).join('|')
      : free
      ? meals.map((meal) => `${meal.id}:${meal.title}:${meal.scale}`).join('|')
      : (entry.day?.meals || []).map((meal) => `${meal.id}:${productId(meal.pick?.id)}`).join('|');
    const sig = JSON.stringify([preview.key, pvView, Boolean(exWant), rows.length, liked.size, mealSig, pvSwapsLeft(), soeren]);
    if (pvDir && motionOk()) {
      queueWeekMeals(mealsBox, rows, { dir: pvDir, remix: false });
      mealsBox.vhpSig = sig;
    } else if (mealsBox.vhpSig !== sig) {
      mealsBox.replaceChildren(...rows);
      mealsBox.vhpSig = sig;
    }
    pvDir = 0;

    // Under a locked day's cards: the one quiet way to the price.
    const unlock = $('[data-vhp-pv-unlock]');
    if (unlock) {
      unlock.hidden = free || gifted || soeren;
      const label = unlock.querySelector('[data-vhp-pv-unlock-label]');
      if (label && !unlock.hidden) label.textContent = tr('planner.pv_unlock_day', { day: whenLabel });
    }

    // The whole day rerolled, free day only: once free, then the row sells (paywall "regen").
    const reroll = $('[data-vhp-pv-reroll]');
    if (reroll) {
      reroll.hidden = !free || soeren;
      if (free && !soeren) {
        const rolls = pvRollsLeft();
        const label = reroll.querySelector('[data-vhp-pv-reroll-label]');
        if (label) label.textContent = rolls > 0 ? tr('planner.pv_reroll') : tr('planner.pv_reroll_paid');
        const right = reroll.querySelector('[data-vhp-pv-reroll-right]');
        if (right) {
          right.replaceChildren();
          if (rolls > 0) {
            const n = document.createElement('span');
            n.className = 'vhp-pv-reroll__free';
            n.textContent = tr('planner.pv_reroll_free_n', { n: rolls });
            right.append(n);
          } else {
            const lock = lockIcon(true);
            lock.classList.add('vhp-pv-reroll__lock');
            right.append(lock);
          }
        }
        reroll.classList.toggle('is-paid', rolls <= 0);
      }
    }

    // "Zusammen 1.405 kcal · 107 g Protein ✓ dein Ziel" (the mark only when both are on target, never a shortfall here).
    const paintTotal = (el, totals) => {
      if (!el) return;
      const kcal = Number(totals?.kcal) || 0;
      const protein = Number(totals?.protein) || 0;
      const goalProtein = macroGrams(want, currentSplit()).protein;
      const onTarget =
        want > 0 && Math.abs(kcal - want) / want <= DAY_TOL && goalProtein > 0 && protein >= goalProtein * 0.95;
      el.replaceChildren(tr('planner.total', { kcal: deInt(kcal), protein: deInt(protein) }));
      if (onTarget) {
        const ok = document.createElement('span');
        ok.className = 'vhp-pv-total__ok';
        ok.textContent = tr('planner.your_goal_check');
        el.append(' ', ok);
      }
    };
    const totalEl = $('[data-vhp-preview-total]');
    if (totalEl) {
      totalEl.hidden = !free && !gifted && !soeren;
      if (free) paintTotal(totalEl, openDay.totals);
      else if (gifted || soeren) paintTotal(totalEl, entry.totals);
    }
    // The free day's shopping list and the extra rows below follow the free day only (Sörens Woche: the list sells).
    renderPreviewDayList(free && !soeren ? preview : null);
  };

  const weekMealNodes = (box) => Array.from(box.querySelectorAll(':scope > .vhp-pick, :scope > .vhp-meal'));

  const clearWeekMealAnim = (row) => {
    row.classList.remove('is-out-left', 'is-out-right', 'is-in-left', 'is-in-right', 'is-in', 'is-fading',
      'is-out-roll', 'is-in-roll');
    row.style.animationDelay = '';
    row.removeAttribute('aria-hidden');
  };

  const leavingWeekMeals = (rows, remix) =>
    remix ? rows.filter((row) => !row.classList.contains('is-locked')) : rows;

  const armWeekMealsOut = (rows, dir, remix) => {
    const outClass = remix ? 'is-out-roll' : dir > 0 ? 'is-out-left' : 'is-out-right';
    const stagger = remix ? MEALS_ROLL_STAGGER : MEALS_STAGGER;
    rows.forEach((row, i) => {
      clearWeekMealAnim(row);
      row.style.animationDelay = `${i * stagger}ms`;
      row.classList.add(outClass);
      row.setAttribute('aria-hidden', 'true');
    });
    return MEALS_ROW_MS + Math.max(0, rows.length - 1) * stagger;
  };

  // Neu würfeln / neu planen, the landing: each new card deals in after the one before, a glint runs once over its
  // photo; a locked card stayed where it was and its chip answers (Gesperrte bleiben). Meal rows only (the preview's
  // liked-exclusive and own-dish rows stay as they are).
  const armMealsRollIn = (rows) => {
    if (!motionOk()) return;
    let n = 0;
    rows.forEach((row) => {
      if (!row.dataset?.meal) return;
      if (row.classList.contains('is-locked')) {
        row.classList.add('is-lock-pop');
        return;
      }
      const delay = n * MEALS_ROLL_STAGGER;
      n += 1;
      row.style.animationDelay = `${delay}ms`;
      row.classList.add('is-in-roll');
      const done = (e) => {
        if (e.target !== row) return;
        row.removeEventListener('animationend', done);
        row.classList.remove('is-in-roll');
        row.style.animationDelay = '';
      };
      row.addEventListener('animationend', done);
      const card = row.querySelector('.vhp-mcard');
      if (card && !card.classList.contains('is-noimg') && !card.classList.contains('is-away')) {
        const glint = document.createElement('span');
        glint.className = 'vhp-mcard__glint';
        glint.setAttribute('aria-hidden', 'true');
        glint.style.animationDelay = `${delay + 240}ms`;
        glint.addEventListener('animationend', () => glint.remove(), { once: true });
        card.append(glint);
      }
    });
  };

  // The tap itself: one haptic tick and the arrows turn once with a little overshoot. Time-driven, not tied to the
  // work (which takes a few ms), so every tap gets the same full turn.
  const rollTap = (ico) => {
    window.vhpUi?.buzz(12);
    if (!ico || !motionOk()) return;
    ico.classList.remove('is-roll');
    void ico.offsetWidth;
    ico.classList.add('is-roll');
    window.clearTimeout(ico.vhpRollTimer);
    ico.vhpRollTimer = window.setTimeout(() => ico.classList.remove('is-roll'), 700);
  };

  const armWeekMealsIn = (rows, dir) => {
    const inClass = dir > 0 ? 'is-in-right' : 'is-in-left';
    rows.forEach((row, i) => {
      row.style.animationDelay = `${i * MEALS_STAGGER}ms`;
      row.classList.add(inClass);
      row.addEventListener(
        'animationend',
        () => {
          row.classList.remove(inClass);
          row.style.animationDelay = '';
        },
        { once: true }
      );
    });
  };

  const mealsFlyLayer = (box) => box.querySelector(':scope > .vhp-picks__fly');

  const pinWeekMealsBox = (box) => {
    box.style.minHeight = `${box.offsetHeight}px`;
    box.classList.add('is-swap');
  };

  const unpinWeekMealsBox = (box) => {
    if (!box) return;
    box.style.minHeight = '';
    box.classList.remove('is-swap');
  };

  const stopWeekMealsMotion = () => {
    if (!mealsMotion) return;
    window.clearTimeout(mealsMotion.timer);
    window.clearTimeout(mealsMotion.enterTimer);
    if (mealsMotion.raf) cancelAnimationFrame(mealsMotion.raf);
    mealsMotion.layer?.remove();
    unpinWeekMealsBox(mealsMotion.box);
    mealsMotion = null;
  };

  const liftLeavingMeals = (box, leaving) => {
    mealsFlyLayer(box)?.remove();
    leaving.forEach((row) => {
      row.style.transition = 'none';
    });
    pinWeekMealsBox(box);
    // Measured before moving: the week's tiles sit in a grid, so each keeps its column (left + width) too.
    const spots = leaving.map((row) => ({ top: row.offsetTop, left: row.offsetLeft, width: row.offsetWidth }));
    const layer = document.createElement('div');
    layer.className = 'vhp-picks__fly';
    layer.setAttribute('aria-hidden', 'true');
    leaving.forEach((row, i) => {
      row.style.top = `${spots[i].top}px`;
      row.style.left = `${spots[i].left}px`;
      row.style.width = `${spots[i].width}px`;
      layer.append(row);
    });
    box.append(layer);
    void layer.offsetWidth;
    return layer;
  };

  const settleIncomingMeals = (box, layer, nextRows, dir, remix, onEnter) => {
    Array.from(box.children).forEach((el) => {
      if (el !== layer) el.remove();
    });
    const incoming = remix ? nextRows.filter((row) => !row.classList.contains('is-locked')) : nextRows;
    if (remix) {
      armMealsRollIn(nextRows);
    } else if (motionOk()) {
      const inClass = dir > 0 ? 'is-in-right' : 'is-in-left';
      incoming.forEach((row, i) => {
        row.style.animationDelay = `${i * MEALS_STAGGER}ms`;
        row.classList.add(inClass);
        row.addEventListener(
          'animationend',
          () => {
            row.classList.remove(inClass);
            row.style.animationDelay = '';
          },
          { once: true }
        );
      });
    }
    nextRows.forEach((row) => {
      if (layer) box.insertBefore(row, layer);
      else box.append(row);
    });
    if (typeof onEnter === 'function') onEnter();
  };

  const commitWeekMeals = (box, nextRows, dir, remix, onEnter) => {
    stopWeekMealsMotion();
    box.replaceChildren(...nextRows);
    if (typeof onEnter === 'function') onEnter();
    if (!motionOk()) return;
    if (remix) armMealsRollIn(nextRows);
    else armWeekMealsIn(nextRows, dir);
  };

  const enterWeekMeals = () => {
    const job = mealsMotion;
    if (!job?.pending) {
      if (job) job.phase = 'wait';
      return;
    }
    const { box, layer, pending } = job;
    job.pending = null;
    job.phase = 'in';
    settleIncomingMeals(box, layer, pending.nextRows, pending.dir, pending.remix, pending.onEnter);
  };

  const playWeekMealsOut = (box, leaving, dir, pending) => {
    const layer = liftLeavingMeals(box, leaving);
    const roll = Boolean(pending.remix);
    const outMs = MEALS_ROW_MS + Math.max(0, leaving.length - 1) * (roll ? MEALS_ROLL_STAGGER : MEALS_STAGGER);
    mealsMotion = {
      phase: 'out',
      box,
      layer,
      pending,
      raf: 0,
      enterTimer: window.setTimeout(enterWeekMeals, roll ? MEALS_ROLL_OVERLAP_MS : MEALS_OVERLAP_MS),
      timer: window.setTimeout(() => {
        layer.remove();
        unpinWeekMealsBox(box);
        if (mealsMotion?.layer === layer) mealsMotion.layer = null;
        if (mealsMotion && mealsMotion.phase !== 'out' && !mealsMotion.pending) mealsMotion = null;
      }, outMs + 40),
    };
    mealsMotion.raf = requestAnimationFrame(() => {
      if (!mealsMotion || mealsMotion.layer !== layer) return;
      armWeekMealsOut(leaving, dir, roll);
    });
  };

  const queueWeekMeals = (box, nextRows, opts) => {
    if (!box) return;
    if (!motionOk()) {
      stopWeekMealsMotion();
      box.replaceChildren(...nextRows);
      if (typeof opts.onEnter === 'function') opts.onEnter();
      return;
    }
    const pending = { nextRows, dir: opts.dir, remix: opts.remix, onEnter: opts.onEnter };
    if (mealsMotion && (mealsMotion.phase === 'out' || mealsMotion.phase === 'wait')) {
      mealsMotion.pending = pending;
      if (mealsMotion.phase === 'wait') enterWeekMeals();
      return;
    }
    if (mealsMotion) stopWeekMealsMotion();
    const oldRows = weekMealNodes(box);
    const leaving = leavingWeekMeals(oldRows, opts.remix);
    if (!oldRows.length) {
      commitWeekMeals(box, nextRows, opts.dir, opts.remix, opts.onEnter);
      return;
    }
    if (!leaving.length) {
      box.replaceChildren(...nextRows);
      if (typeof opts.onEnter === 'function') opts.onEnter();
      if (opts.remix) armMealsRollIn(nextRows);
      return;
    }
    playWeekMealsOut(box, leaving, opts.dir, pending);
  };

  // Dish names without the shop's SEO prefix ("Vegan High Protein Tofu Rührei" → "Tofu Rührei"): in the planner every
  // dish is vegan and high protein, the words only push the part that tells dishes apart out of the line.
  // The prefix stays when it is the only vegan word in front of an animal-product name ("Vegan High Protein Käsekuchen",
  // "... Mozzarella"): a vegan reader must never wonder (docs/PERSONA_ATTACK_PLAN.md 1.1).
  const DISH_ANIMAL_WORD = /(k[äa]se|cheese|parmesan|mozzarella|feta|mayo|joghurt|skyr|quark|sahne|butter(?!bohne)|milch|hollandaise|chicken|h[äa]hnchen|schinken|speck|salami|hack|d[öo]ner|burger|schnitzel|steak|nuggets|carbonara|alfredo|gyros|zaziki|wurst|auster)/i;
  const DISH_VEGAN_WORD = /(vegan|tofu|seitan|tempeh|soja|erdnussbutter|"|„|“)/i;
  const dishName = (title) => {
    const full = String(title || '').trim();
    const short = full.replace(/^vegane?[rs]?\s+high[\s-]protein\s+/i, '').trim();
    if (short !== full && DISH_ANIMAL_WORD.test(short) && !DISH_VEGAN_WORD.test(short)) return full;
    return short.length >= 3 ? short.charAt(0).toUpperCase() + short.slice(1) : full;
  };

  // Week day view (planner skin v3): one photo card per meal, in eating order, like the story's deck cards. The dish
  // photo fills the card; top left the meal as a glass chip in its colour (Frühstück gold, Mittag green, Abend indigo,
  // Snack coral, as on the Mahlzeiten ring; a lock at its end when gesperrt), top right Austauschen and ⋯ in glass;
  // bottom left the dish name and its protein (kcal live in the rings above, the ⋯ sheet and the recipe), plus a note
  // (Vorrat / Reste / Eigenes). Tap opens the recipe, swipe right locks, left replaces.
  const buildWeekMealRow = (meal) => {
    const pick = meal.pick;
    const dayIndex = state.weekDay;
    const away = Boolean(meal.away);
    const customId = isCustomId(pick?.id) ? pick.id : '';
    const title = away ? tr('planner.away') : pick?.title || tr('planner.no_recipe_yet');
    const hasImg = Boolean(pick?.image) && !away;

    const wrap = document.createElement('div');
    wrap.className = 'vhp-meal';
    wrap.classList.toggle('is-locked', Boolean(meal.locked));
    wrap.dataset.meal = meal.id;
    const card = document.createElement('div');
    card.className = 'vhp-pick vhp-mcard';
    card.classList.toggle('is-away', away);
    card.classList.toggle('is-noimg', !hasImg);
    card.classList.toggle('is-locked', Boolean(meal.locked));
    card.classList.toggle('is-fading', weekGenerating && !keepsMeal(meal) && !motionOk());
    if (!away) card.dataset.vhpWeekSwipe = meal.id;
    const hit = pickHit({ customId, handle: pick?.handle, scale: meal.scale, title, occasion: meal.id });
    if (hit) card.append(hit);

    // Photo (fades in once loaded), or the brand frame with a mark for Unterwegs / a dish without a photo.
    const media = document.createElement('div');
    media.className = 'vhp-mcard__media';
    if (hasImg) {
      const img = weekTileImg(pick.image);
      img.className = 'vhp-pick__img';
      if (img.complete && img.naturalWidth) media.classList.add('is-loaded');
      else img.addEventListener('load', () => img.parentElement?.classList.add('is-loaded'), { once: true });
      media.append(img, mcardThumb(pick.image));
      card.classList.add('has-thumb');
    } else {
      const mark = document.createElement('div');
      mark.className = 'vhp-pick__img vhp-mcard__mark';
      if (away) mark.append(awayIcon());
      else {
        const ico = spriteIcon(slotIconName(meal.id) || slotIconName(meal.label), 'vhp-mcard__mark-ico');
        if (ico) mark.append(ico);
      }
      media.append(mark);
    }

    const top = document.createElement('div');
    top.className = 'vhp-mcard__top';
    const chip = document.createElement('p');
    chip.className = 'vhp-mcard__meal';
    const slotIco = spriteIcon(slotIconName(meal.id) || slotIconName(meal.label), 'vhp-mcard__ico');
    if (slotIco) chip.append(slotIco);
    const slotName = document.createElement('span');
    slotName.textContent = occLabel(meal);
    chip.append(slotName);
    if (meal.locked) {
      const lock = lockIcon(true);
      lock.classList.add('vhp-mcard__lock');
      chip.append(lock);
      chip.setAttribute('aria-label', tr('planner.label_locked_aria', { label: occLabel(meal) || tr('planner.meal') }));
    }
    const side = document.createElement('div');
    side.className = 'vhp-mcard__side';
    if (!meal.locked) {
      const actions = document.createElement('div');
      actions.className = 'vhp-pick__actions';
      actions.append(
        pickAction({
          label: tr('planner.swap_aria', { label: occLabel(meal) || tr('planner.meal') }),
          icon: swapIcon(),
          dataset: { vhpWeekSwap: meal.id },
        })
      );
      side.append(actions);
    }
    const moreBtn = document.createElement('button');
    moreBtn.type = 'button';
    moreBtn.className = 'vhp-meal__more';
    moreBtn.dataset.vhpMealMore = meal.id;
    moreBtn.setAttribute('aria-haspopup', 'dialog');
    moreBtn.setAttribute('aria-label', tr('planner.more_actions', { label: occLabel(meal) || tr('planner.meal') }));
    moreBtn.append(dotsIcon());
    side.append(moreBtn);
    top.append(chip, side);

    const body = document.createElement('div');
    body.className = 'vhp-mcard__body';
    const titleEl = document.createElement('p');
    titleEl.className = 'vhp-pick__title';
    titleEl.textContent = away ? title : dishName(title);
    const meta = document.createElement('p');
    meta.className = 'vhp-mcard__meta';
    const kcal = Math.round(Number(meal.kcal) || 0);
    const protein = Math.round(Number(meal.protein) || 0);
    if (away) {
      const free = document.createElement('span');
      free.textContent = kcal > 0 ? `≈ ${deInt(kcal)} ${tr('planner.kcal_free')}` : tr('planner.day_is_full');
      meta.append(free);
    } else if (protein > 0) {
      const p = document.createElement('span');
      p.className = 'is-protein';
      p.textContent = `${protein} g ${tr('planner.protein')}`;
      meta.append(p);
    }
    const fed = meal.id === LEFTOVER_FROM ? leftoverLunchDays(state.week, dayIndex) : [];
    const back = leftoverBackOf(meal);
    let noteText = '';
    const prepNote = prepMealNote(state.week, dayIndex, meal);
    if (meal.prepped) noteText = tr('planner.from_pantry');
    else if (prepNote) noteText = prepNote;
    else if (back && dayIndex >= back) noteText = tr('planner.leftovers_from', { day: DAY_LABEL[dayIndex - back] });
    else if (fed.length) noteText = tr('planner.leftovers_for', { days: dayList(fed) });
    else if (customId) noteText = pick?.archived ? tr('planner.own_archived') : tr('planner.own_recipe');
    if (noteText) {
      const note = document.createElement('span');
      note.className = 'vhp-mcard__note';
      note.textContent = noteText;
      meta.append(note);
    }
    body.append(titleEl);
    if (meta.childNodes.length) body.append(meta);

    card.append(media, top, body);
    const play = away || customId ? null : mealPlayBtn({ handle: pick?.handle, title: dishName(title), image: pick?.image, scale: meal.scale, protein, occasion: meal.id });
    if (play) card.append(play);
    wrap.append(card);
    return wrap;
  };

  // Week tile photos outlive render(). Every render rebuilds the rows, and a new <img> for a photo that is still
  // downloading starts it over (Safari drops the request of a removed image), so on mobile data the photos of a
  // freshly opened week kept restarting while the planner re-rendered around them and seemed to hang. A photo still
  // loading moves into the new row; a loaded one gets a fresh element (painted from cache) so a row sliding out
  // keeps its own. Eager: a day has at most five tiles, all on screen.
  // One element goes to one tile per render: the same photo twice in a day (a batch eaten at lunch and dinner) got the
  // same <img>, which the second tile then pulled out of the first, leaving it blank. The second gets its own element
  // (the browser shares the download).
  // The dish whole, as a portrait photo on the card's left: the photos are 9:16 video frames, and the wide card only
  // ever showed a strip of them. The card's own photo (weekTileImg) stays behind it, blurred, for the colour.
  const mcardThumb = (src) => {
    const thumb = document.createElement('div');
    thumb.className = 'vhp-mcard__thumb';
    const img = document.createElement('img');
    img.alt = '';
    img.decoding = 'async';
    img.src = src;
    if (img.complete && img.naturalWidth) thumb.classList.add('is-loaded');
    else img.addEventListener('load', () => thumb.classList.add('is-loaded'), { once: true });
    thumb.append(img);
    return thumb;
  };

  const weekImgs = new Map();
  const weekImgsClaimed = new Set();
  const weekTileImg = (src) => {
    if (!weekImgsClaimed.size) queueMicrotask(() => weekImgsClaimed.clear());
    const known = weekImgs.get(src);
    if (known && !weekImgsClaimed.has(known) && (!known.complete || !known.isConnected)) {
      weekImgsClaimed.add(known);
      return known;
    }
    const img = document.createElement('img');
    img.alt = '';
    img.src = src;
    weekImgsClaimed.add(img);
    if (known && weekImgsClaimed.has(known) && !known.complete) return img;
    weekImgs.delete(src);
    weekImgs.set(src, img);
    if (weekImgs.size > 60) weekImgs.delete(weekImgs.keys().next().value);
    return img;
  };

  // From Friday the planner nudges towards next week (people shop on the weekend), until it is planned.
  const nudgeNextWeek = () =>
    !viewingNextWeek() && [5, 6, 0].includes(new Date().getDay()) && !weekHasPlan(state.weekAlt?.week);

  // "5.–11. Oktober"; across a month "29. Sep – 5. Okt".
  const formatWeekTitle = (monday) => {
    const sunday = addDays(monday, 6);
    if (monday.getMonth() === sunday.getMonth()) {
      return tr('date.month_range', { from: String(monday.getDate()), to: String(sunday.getDate()), month: MONTH_LONG[sunday.getMonth()] });
    }
    return formatWeekRange(monday);
  };

  // Head title: Heute / Morgen / Gestern, else the weekday ("Donnerstag"); the date sits under it (weekHeadSub), so
  // the two weeks never read the same.
  const weekHeadLabel = (date) => {
    const today = new Date();
    if (sameDay(date, today)) return tr('date.today');
    if (sameDay(date, addDays(today, 1))) return tr('date.tomorrow');
    if (sameDay(date, addDays(today, -1))) return tr('date.yesterday');
    return PREVIEW_DAYS[(date.getDay() + 6) % 7];
  };
  // "Mittwoch, 15. Oktober" under Heute / Morgen / Gestern, "15. Oktober" under a weekday.
  const weekHeadSub = (date) => {
    const weekday = PREVIEW_DAYS[(date.getDay() + 6) % 7];
    const when = dayMonth(date, MONTH_LONG);
    return weekHeadLabel(date) === weekday ? when : `${weekday}, ${when}`;
  };

  // Compact head: "Heute 📅" on the left (opens the week strip), ‹ › on the right. No plan yet: the week's name.
  const renderWeekHead = (empty) => {
    const next = viewingNextWeek();
    const weekName = next ? tr('planner.next_week') : tr('planner.this_week');
    const title = $('[data-vhp-week-title]');
    if (title) {
      const day = addDays(shownMonday(), state.weekDay);
      const sub = $('[data-vhp-week-sub]');
      const words = empty ? weekName : weekHeadLabel(day);
      const when = empty ? formatWeekTitle(shownMonday()) : weekHeadSub(day);
      // Another day: the title slides in from the side the day came from.
      const pick = title.closest('[data-vhp-week-pick]');
      if (pick && sub && sub.textContent && sub.textContent !== when && motionOk()) {
        pick.style.setProperty('--turn', String(weekDayDir < 0 ? -1 : 1));
        pick.classList.remove('is-turn');
        void pick.offsetWidth;
        pick.classList.add('is-turn');
      }
      title.textContent = words;
      if (sub) sub.textContent = when;
    }
    $$('[data-vhp-week-step]').forEach((btn) => {
      btn.disabled = weekGenerating || !canStepWeekDay(Number(btn.dataset.vhpWeekStep));
    });
    const strip = $('[data-vhp-week-strip]');
    if (strip) strip.setAttribute('aria-label', `${weekName}: ${formatWeekTitle(shownMonday())}`);
    // Only two weeks exist: one arrow at a time, pointing to the other one.
    const back = $('[data-vhp-week-go="this"]');
    const fwd = $('[data-vhp-week-go="next"]');
    if (back) {
      back.hidden = !next;
      back.disabled = weekGenerating;
    }
    if (fwd) {
      fwd.hidden = next;
      fwd.disabled = weekGenerating;
      fwd.classList.toggle('is-calm', nextWeekSeen());
    }
    const dot = $('[data-vhp-week-next-dot]');
    if (dot) dot.hidden = !nudgeNextWeek();
  };

  // Next week before it is planned: one primary action, repeat as the quiet alternative.
  const renderWeekEmpty = (empty) => {
    const box = $('[data-vhp-week-empty]');
    if (box) box.hidden = !empty;
    const card = $('[data-vhp-week-daycard]');
    if (card) card.hidden = empty;
    const meals = $('[data-vhp-week-mealsbox]');
    if (meals) meals.hidden = empty;
    if (!empty || !box) return;
    const favN = favoriteItems().length;
    const text = $('[data-vhp-week-empty-text]');
    if (text) {
      text.textContent = favN
        ? tr('planner.week_from_favs', { n: favN })
        : tr('planner.week_fresh');
    }
    const plan = box.querySelector('[data-vhp-week-plan-next]');
    if (plan) {
      plan.disabled = weekGenerating;
      plan.textContent = weekGenerating ? tr('planner.creating') : tr('planner.create_week');
    }
    const repeat = box.querySelector('[data-vhp-week-repeat]');
    if (repeat) repeat.hidden = weekGenerating || !weekHasPlan(state.weekAlt?.week);
  };

  // "Meine Rezepte" row in the Favoriten sheet: invite with none, autoplan status with some.
  const renderOwnCard = () => {
    const box = $('[data-vhp-own-card]');
    const store = customRecipes();
    if (!box) return;
    box.hidden = !store;
    if (box.hidden) return;
    const loaded = store.isLoaded();
    const list = store.all().filter((recipe) => recipe.status === 'active');
    const n = list.length;
    const auto = list.filter((recipe) => recipe.use_in_autofill !== false).length;
    const fresh = loaded && !n;
    box.classList.toggle('is-empty', fresh);

    const title = $('[data-vhp-own-title]');
    if (title) title.textContent = fresh ? tr('planner.own_enter') : tr('planner.my_recipes');
    const text = $('[data-vhp-own-text]');
    if (text) {
      let line = tr('planner.own_invite');
      if (fresh) line = tr('planner.own_invite_fresh');
      else if (n) {
        const count = tr('common.recipes', { n });
        if (!auto) line = tr('planner.own_manual', { count });
        else if (auto === n) line = tr('planner.own_auto_all', { n, count });
        else line = tr('planner.own_auto_some', { count, auto });
      }
      text.textContent = line;
    }
    box.setAttribute('aria-label', fresh ? tr('planner.own_enter') : tr('planner.open_my_recipes', { n: n ? ` (${n})` : '' }));
  };

  // Opens the next sheet once the recipes sheet has finished closing (two modals never animate at once).
  const afterRecipesSheet = (fn) => {
    const sheet = document.querySelector('[data-vhp-recipes-sheet]');
    if (sheet?.open) sheet.addEventListener('close', fn, { once: true });
    else fn();
  };

  const planOwnRecipe = (recipe) => {
    const card = customRecipes()?.card(recipe?.id);
    if (!card) return;
    afterRecipesSheet(() => openPlanPicker(card, { day: state.weekDay }));
  };

  const openOwnFromWeek = () => {
    const store = customRecipes();
    if (!store) return;
    const fresh = store.isLoaded() && !store.count();
    if (fresh) newOwnFromWeek();
    else store.openManager({ onPlan: planOwnRecipe });
  };

  const newOwnFromWeek = () => {
    customRecipes()?.openForm({ quick: true, onSaved: planOwnRecipe });
  };

  // ---------- planner skin (docs/planner-skin.md, step 2) ----------

  let weekIntroDone = false;
  // Swipe hand-off to the next render (the swipe code near the end): the meal swiped away for a new dish, the meal
  // whose lock was swiped.
  let swipeIncoming = null;
  let swipeLockPop = '';
  // Sören's message once per week: on the first open of the planned current week, kept for that page view, gone
  // for good with ×. His face comes from the section (founder image).
  let weekDmKey = '';
  const renderWeekDm = (empty) => {
    const box = $('[data-vhp-week-dm]');
    const ui = window.vhpUi;
    if (!box || !ui) return;
    const key = `week_dm_${state.weekStart}`;
    const thisWeek = !empty && Boolean(state.weekStart) && state.weekStart === mondayIso(0);
    const show = thisWeek && (weekDmKey === key || !ui.seen(key));
    if (!show) {
      box.hidden = true;
      return;
    }
    if (weekDmKey !== key) {
      weekDmKey = key;
      ui.markSeen(key);
    }
    const close = box.querySelector('[data-vhp-week-dm-close]');
    if (close && !close.dataset.wired) {
      close.dataset.wired = '1';
      close.addEventListener('click', () => {
        weekDmKey = '';
        const board = box.parentElement;
        if (board) ui.morph(board, () => {
          box.hidden = true;
        }, { width: false });
        else box.hidden = true;
      });
    }
    const name = state.name || '';
    ui.dm(box.querySelector('[data-vhp-week-dm-thread]'), [
      name ? tr('planner.week_dm_1_name', { name }) : tr('planner.week_dm_1'),
      tr('planner.week_dm_2', { kcal: deInt(state.kcal) }),
    ], { face: box.querySelector('.vhp-ui-face') });
    box.hidden = false;
  };

  // The chosen day's circle glides from day to day (it lives in the strip, so a swipe drags it along). A week switch,
  // an empty week or the first paint put it in place without the glide. Measured after layout; a hidden screen
  // (0 × 0) waits for its next render.
  let weekGlide = null;
  let weekGlideRaf = 0;
  const placeWeekGlide = (instant) => {
    if (!weekGlide) return;
    cancelAnimationFrame(weekGlideRaf);
    weekGlideRaf = requestAnimationFrame(() => {
      const box = weekGlide.parentElement;
      const on = box?.querySelector('.vhp-week-day.is-on .vhp-week-day__date');
      const at = on?.getBoundingClientRect();
      const from = box?.getBoundingClientRect();
      if (!at?.width || !from?.width) {
        weekGlide.classList.remove('is-on');
        return;
      }
      const jump = instant || !weekGlide.classList.contains('is-on') || !motionOk();
      if (jump) weekGlide.style.transition = 'none';
      weekGlide.style.transform = `translate(${at.left - from.left}px, ${at.top - from.top}px)`;
      weekGlide.classList.add('is-on');
      if (jump) {
        void weekGlide.offsetWidth;
        weekGlide.style.transition = '';
      }
    });
  };
  window.addEventListener('resize', () => placeWeekGlide(true));

  const renderWeek = () => {
    // Another day (or week) on screen: an open meal sheet belongs to a card that is gone.
    if (mealSheet && (mealSheet.day !== state.weekDay || mealSheet.start !== state.weekStart)) closeMealSheet();
    syncAwayBudgets(state.week);
    const daysBox = $('[data-vhp-week-days]');
    const mealsBox = $('[data-vhp-week-meals]');
    if (!daysBox || !mealsBox) return;

    if (state.weekDay < 0 || state.weekDay >= WEEK_LEN) state.weekDay = 0;
    const mondayDate = shownMonday();
    const today = new Date();
    const empty = !weekHasPlan(state.week);
    renderWeekHead(empty);
    renderWeekEmpty(empty);
    renderWeekDm(empty);
    const nudge = $('[data-vhp-week-nudge]');
    if (nudge) {
      nudge.hidden = empty || !nudgeNextWeek();
      const text = $('[data-vhp-week-nudge-text]');
      if (text && !nudge.hidden) {
        const monday = addDays(weekMonday(), 7);
        text.textContent = tr('planner.next_week_nudge', { date: dayMonth(monday, MONTH_LONG) });
      }
    }
    // Own recipes load async; the Favoriten sheet's Meine Rezepte row follows along.
    renderOwnCard();

    daysBox.replaceChildren();
    DAY_LABEL.forEach((label, index) => {
      const date = addDays(mondayDate, index);
      const btn = renderDayTab({
        label: label[0],
        date: date.getDate(),
        selected: !empty && state.weekDay === index,
        today: sameDay(date, today),
        past: date < today && !sameDay(date, today),
        on: !empty,
      });
      btn.dataset.vhpWeekDay = String(index);
      btn.setAttribute('aria-label', `${PREVIEW_DAYS[index]}, ${dayNum(date)}`);
      daysBox.append(btn);
    });
    weekGlide = weekGlide || $('[data-vhp-week-glide]');
    if (weekGlide) daysBox.append(weekGlide);
    placeWeekGlide(Boolean(weekStripDir) || empty);
    // Switched weeks: the strip slides in from the side it came from.
    if (weekStripDir && motionOk()) {
      daysBox.classList.remove('is-from-next', 'is-from-prev');
      void daysBox.offsetWidth;
      daysBox.classList.add(weekStripDir > 0 ? 'is-from-next' : 'is-from-prev');
    }
    weekStripDir = 0;
    if (empty) {
      mealsBox.replaceChildren();
      renderPrepToday(true);
      weekDayDir = 0;
      weekReveal = null;
      return;
    }

    const day = state.week[state.weekDay] || emptyWeekDay();
    const meals = day.meals || [];
    const totals = meals.reduce(
      (acc, meal) => ({
        kcal: acc.kcal + (meal.kcal || 0),
        protein: acc.protein + (meal.protein || 0),
        carbs: acc.carbs + (meal.carbs || 0),
        fat: acc.fat + (meal.fat || 0),
      }),
      { kcal: 0, protein: 0, carbs: 0, fat: 0 }
    );
    const note = $('[data-vhp-week-note]');
    if (note) {
      note.hidden = true;
      note.textContent = '';
    }
    const paintDay = () => fillWeekStats($('[data-vhp-week-body]'), totals, state.kcal);

    // Everything a card shows, as one string: the planner renders several times while it loads (account, pools,
    // own recipes) and a rebuild of identical cards would restart their entrance, so the cards stay when it's equal.
    const weekSig = JSON.stringify([
      state.weekStart,
      state.weekDay,
      weekGenerating,
      (state.week || []).map((d) =>
        (d?.meals || []).map((m) => [m.id, m.pick?.id, m.pick?.title, m.pick?.image, m.pick?.archived, m.scale,
          m.kcal, m.protein, m.locked, m.away, m.prepped, m.leftover, m.cook])),
    ]);
    const keepRows = !weekDayDir && !weekGenerating && !weekReveal && !mealsMotion &&
      mealsBox.vhpSig === weekSig && weekMealNodes(mealsBox).length === meals.length;
    const nextRows = keepRows ? [] : meals.map(buildWeekMealRow);
    mealsBox.vhpSig = weekSig;
    if (keepRows) {
      paintDay();
    } else if (weekDayDir) {
      queueWeekMeals(mealsBox, nextRows, { dir: weekDayDir, remix: false, onEnter: paintDay });
    } else if (weekGenerating) {
      if (!motionOk()) {
        mealsBox.replaceChildren(...nextRows);
        paintDay();
      }
    } else if (weekReveal) {
      queueWeekMeals(mealsBox, nextRows, {
        dir: weekReveal === 'back' ? -1 : 1,
        remix: true,
        onEnter: paintDay,
      });
    } else if (!mealsMotion) {
      // Planner skin (docs/planner-skin.md): the first paint per page view brings the meals in one after another;
      // a change on the same day (swap, lock, portion) glides to the new height and the changed meal pops.
      const ui = window.vhpUi;
      const ids = meals.map((meal) => `${meal.id}:${productId(meal.pick?.id)}:${meal.scale}`);
      const prev = mealsBox.vhpIds;
      const sameDay = mealsBox.vhpDay === `${state.weekStart}|${state.weekDay}`;
      const changed = Boolean(ui && prev && sameDay && prev.length === ids.length && prev.some((id, i) => id !== ids[i]));
      if (changed) {
        ui.morph(mealsBox, () => mealsBox.replaceChildren(...nextRows), { width: false });
        // A meal swiped away: its successor slides in from the right where it left; other changes pop in place.
        const swiped = swipeIncoming && swipeIncoming.day === state.weekDay && swipeIncoming.start === state.weekStart
          ? swipeIncoming.occasion
          : '';
        swipeIncoming = null;
        nextRows.forEach((row, i) => {
          if (prev[i] === ids[i]) return;
          row.classList.add(row.dataset.meal === swiped ? 'is-swiped-in' : 'is-swapped');
        });
      } else {
        mealsBox.replaceChildren(...nextRows);
        // The entrance belongs to these first cards (not the box): a later rebuild shows its cards as they are.
        if (!weekIntroDone && ui?.motionOk()) {
          weekIntroDone = true;
          const head = $('[data-vhp-day-head]');
          head?.classList.add('is-intro');
          nextRows.forEach((row, i) => {
            row.style.animationDelay = `${0.05 + Math.min(i, 4) * 0.07}s`;
            row.classList.add('is-intro');
            row.addEventListener(
              'animationend',
              () => {
                row.classList.remove('is-intro');
                row.style.animationDelay = '';
              },
              { once: true }
            );
          });
          window.setTimeout(() => head?.classList.remove('is-intro'), 1400);
        }
      }
      paintDay();
    }
    mealsBox.vhpIds = meals.map((meal) => `${meal.id}:${productId(meal.pick?.id)}:${meal.scale}`);
    mealsBox.vhpDay = `${state.weekStart}|${state.weekDay}`;
    if (swipeLockPop) {
      mealsBox.querySelector(`.vhp-meal[data-meal="${swipeLockPop}"]`)?.classList.add('is-lock-pop');
      swipeLockPop = '';
    }
    weekReveal = null;
    weekDayDir = 0;

    const regen = $('[data-vhp-week-regen]');
    if (regen) {
      regen.disabled = weekGenerating || !dayHasUnlocked(day);
      const label = $('[data-vhp-week-regen-label]');
      if (label) label.textContent = weekGenerating ? tr('planner.replanning') : label.dataset.idle || tr('planner.replan_day');
    }
    const allBtn = $('[data-vhp-week-regen-all]');
    if (allBtn) allBtn.disabled = weekGenerating || !weekHasUnlocked(state.week);
    const regenHint = $('[data-vhp-week-regen-hint]');
    if (regenHint) regenHint.hidden = !meals.some((meal) => meal.locked);
    const shopRow = $('[data-vhp-week-shop]');
    if (shopRow) {
      shopRow.hidden = !weekHasPlan(state.week);
      shopRow.disabled = weekGenerating;
    }
    if (mealSheet) paintMealSheet();
    renderPrepToday(false);
    if (prep) paintPrepSheet();
    const err = $('[data-vhp-week-error]');
    if (err) err.hidden = !weekError;
  };

  const shopAmountText = (item) => {
    if (item.kind === 'taste') return '';
    return `${shopFmtQty(item.qty)} ${shopUnitLabel(item.unit)}`.trim();
  };
  const renderShopLine = (item, checked) => {
    if (shopEdit) {
      // Anpassen: no ticking, one button that moves the item between the list and Vorrat.
      const row = document.createElement('div');
      row.className = 'vhp-shop-line is-edit';
      const text = document.createElement('span');
      text.className = 'vhp-shop-line__text';
      text.textContent = item.name;
      const move = document.createElement('button');
      move.type = 'button';
      move.className = 'vhp-shop-move';
      move.dataset.vhpShopMove = item.key;
      const inPantry = shopList.pantry.includes(item);
      move.textContent = inPantry ? tr('planner.to_list') : tr('planner.have_it');
      row.append(text, move);
      return row;
    }
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vhp-shop-line';
    btn.classList.toggle('is-on', checked);
    btn.dataset.vhpShopKey = item.key;
    btn.setAttribute('aria-pressed', checked ? 'true' : 'false');
    const box = document.createElement('span');
    box.className = 'vhp-shop-line__check';
    box.setAttribute('aria-hidden', 'true');
    const text = document.createElement('span');
    text.className = 'vhp-shop-line__text';
    text.textContent = item.name;
    const amount = document.createElement('span');
    amount.className = 'vhp-shop-line__amount';
    amount.textContent = shopAmountText(item);
    btn.append(box, text, amount);
    return btn;
  };
  // One sticker per aisle, its name inside at the top (planner skin v2: the first one sits on the band's edge).
  const renderShopGroup = (title, items, checks) => {
    const group = document.createElement('div');
    group.className = 'vhp-shop-group';
    const card = document.createElement('div');
    card.className = 'vhp-shop-card';
    if (title) {
      const head = document.createElement('p');
      head.className = 'vhp-shop-head';
      head.textContent = title;
      card.append(head);
    }
    items.forEach((item) => card.append(renderShopLine(item, checks.has(item.key))));
    group.append(card);
    return group;
  };

  // Ring in the band: what's ticked of the list. The basket turns into ✓ when all is in the cart (confetti once per
  // completion); an aisle with everything ticked gets its ✓ and steps back.
  let shopWasDone = null;
  const fillShopProgress = (checks) => {
    const allItems = shopList.items;
    const doneN = allItems.filter((item) => checks.has(item.key)).length;
    const total = allItems.length;
    const progress = $('[data-vhp-shop-progress]');
    const countEl = $('[data-vhp-shop-count]');
    if (progress) progress.hidden = !total;
    if (countEl) countEl.textContent = total ? tr('planner.checked_of', { done: doneN, total }) : '';
    const ring = $('[data-vhp-shop-ring]');
    const arc = $('[data-vhp-shop-arc]');
    const done = total > 0 && doneN === total;
    if (ring && arc) {
      if (ring.hidden && total) {
        ring.hidden = false;
        void ring.offsetWidth;
      }
      ring.hidden = !total;
      arc.style.strokeDashoffset = String(100 - (total ? (doneN / total) * 100 : 0));
      arc.style.opacity = doneN ? '1' : '0';
      ring.classList.toggle('is-done', done);
      if (done && shopWasDone === false) {
        window.setTimeout(() => {
          window.vhpUi?.burst(ring, { count: 30, spread: 0.9 });
          window.vhpUi?.buzz(18);
        }, 380);
      }
    }
    shopWasDone = total ? done : null;
    markShopCards();
  };
  const markShopCards = () => {
    $$('[data-vhp-shop-list] .vhp-shop-card').forEach((card) => {
      const lines = card.querySelectorAll('.vhp-shop-line:not(.is-edit)');
      card.classList.toggle('is-done', lines.length > 0 && [...lines].every((line) => line.classList.contains('is-on')));
    });
  };

  const renderShop = () => {
    const list = $('[data-vhp-shop-list]');
    const missingEl = $('[data-vhp-shop-missing]');
    const copyBtn = $('[data-vhp-shop-copy]');
    if (!list) return;
    list.replaceChildren();
    if (shopLoading) {
      const wait = document.createElement('p');
      wait.className = 'vhp-hint';
      wait.textContent = tr('planner.ings_loading');
      list.append(wait);
      const progress = $('[data-vhp-shop-progress]');
      if (progress) progress.hidden = true;
      if (missingEl) missingEl.hidden = true;
      if (copyBtn) copyBtn.disabled = true;
      return;
    }
    const householdPill = $('[data-vhp-shop-household]');
    if (householdPill) householdPill.textContent = tr('planner.household_change', { label: householdLabel() });
    const rangeEl = $('[data-vhp-shop-range]');
    if (rangeEl) rangeEl.textContent = `${viewingNextWeek() ? tr('planner.next_week') : tr('planner.this_week')} · ${formatWeekRange(shownMonday())}`;
    renderShopDays();
    const checks = readShopChecks();
    fillShopProgress(checks);
    const aisles = shopRules ? shopRules.AISLES : [{ id: 'other', label: '' }];
    aisles.forEach((aisle) => {
      const rows = shopList.items.filter((item) => !shopRules || item.aisle === aisle.id);
      if (rows.length) list.append(renderShopGroup(aisle.label, rows, checks));
    });
    if (shopList.pantry.length) {
      const open = shopPantryOpen || shopEdit;
      const box = document.createElement('div');
      box.className = 'vhp-shop-pantry';
      const head = document.createElement('div');
      head.className = 'vhp-shop-pantry__head';
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'vhp-shop-pantry__toggle';
      toggle.dataset.vhpShopPantryToggle = '';
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = tr('planner.pantry_toggle', { n: String(shopList.pantry.length) });
      head.append(toggle);
      box.append(head);
      if (open) {
        const note = document.createElement('p');
        note.className = 'vhp-hint';
        note.textContent = tr('planner.pantry_note');
        box.append(note, renderShopGroup('', shopList.pantry, checks));
      }
      list.append(box);
    }
    if (shopList.items.length || shopList.pantry.length) {
      const edit = document.createElement('button');
      edit.type = 'button';
      edit.className = 'vhp-text-btn vhp-shop-edit';
      edit.dataset.vhpShopEdit = '';
      edit.textContent = shopEdit ? tr('planner.done') : tr('planner.pantry_edit');
      list.append(edit);
    }
    markShopCards();
    const preppedEl = $('[data-vhp-shop-prepped]');
    const prepped = Number(shopList.prepped) || 0;
    if (preppedEl) {
      preppedEl.hidden = !prepped;
      preppedEl.textContent = prepped
        ? tr('planner.prepped_list', { n: prepped })
        : '';
    }
    if (!shopList.items.length && !shopList.pantry.length && !shopList.missing.length && !prepped) {
      const empty = document.createElement('p');
      empty.className = 'vhp-hint';
      empty.textContent = shopList.days.length < WEEK_LEN
        ? tr('planner.no_ings_days')
        : tr('planner.no_ings_week');
      list.append(empty);
    }
    if (missingEl) {
      if (shopList.missing.length) {
        missingEl.hidden = false;
        missingEl.textContent = tr('planner.ings_missing', { titles: shopList.missing.map((row) => row.title).join(', ') });
      } else {
        missingEl.hidden = true;
        missingEl.textContent = '';
      }
    }
    if (copyBtn) {
      copyBtn.disabled = !shopList.items.length;
      const copyLabel = copyBtn.querySelector('[data-vhp-shop-copy-label]');
      const copyText = shopCopied ? tr('planner.copied') : canShareList() ? tr('planner.share_list') : tr('planner.copy_list');
      if (copyLabel) copyLabel.textContent = copyText;
      else copyBtn.textContent = copyText;
    }
  };

  // Share sheet on phones (WhatsApp, Notizen, …); desktop browsers mostly copy instead.
  const canShareList = () => typeof navigator.share === 'function' && window.matchMedia('(pointer: coarse)').matches;

  // Day chips above the list: which days of the shown week to shop for.
  const renderShopDays = () => {
    const box = $('[data-vhp-shop-days]');
    if (!box) return;
    const days = shopList.days?.length ? shopList.days : readShopDays();
    const monday = shownMonday();
    const today = new Date();
    box.replaceChildren(...DAY_LABEL.map((label, index) => {
      const date = addDays(monday, index);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vhp-shop-day';
      btn.dataset.vhpShopDay = String(index);
      const on = days.includes(index);
      btn.classList.toggle('is-on', on);
      btn.classList.toggle('is-past', date < today && !sameDay(date, today));
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.textContent = label;
      return btn;
    }));
    const label = $('[data-vhp-shop-days-label]');
    if (label) label.textContent = tr('planner.shop_for', { days: shopDaysLabel(days) });
  };

  const shopShareText = () => {
    const checks = readShopChecks();
    const open = shopList.items.filter((item) => !checks.has(item.key));
    const rows = open.length ? open : shopList.items;
    const aisles = shopRules ? shopRules.AISLES : [{ id: 'other', label: '' }];
    const blocks = aisles
      .map((aisle) => {
        const lines = rows.filter((item) => !shopRules || item.aisle === aisle.id).map((item) => `• ${shopLineText(item)}`);
        return lines.length ? [aisle.label, ...lines].filter(Boolean).join('\n') : '';
      })
      .filter(Boolean);
    const head = `${tr('planner.shopping_list')} · ${formatWeekRange(shownMonday())} · ${shopDaysLabel(shopList.days?.length ? shopList.days : readShopDays())}`;
    return [head, ...blocks].join('\n\n');
  };

  let pantryTimer = 0;
  const savePantry = () => {
    persist();
    if (!planner.config.paid) return;
    window.clearTimeout(pantryTimer);
    pantryTimer = window.setTimeout(() => {
      state.pendingFlush = true;
      flushProfile();
    }, 1200);
  };

  // Visits that started on the recipe side get "Die Rezepte hier bleiben kostenlos …" on the paywall
  // (docs/HOMEPAGE_FUNNEL.md): the landing page type this visit started on (sessionStorage vhp_visit, written by
  // assets/vhp-planner-events.js).
  const RECIPE_SIDE = new Set(['home', 'recipe', 'explore', 'collection', 'likes']);
  const visitLanding = () => {
    try {
      return JSON.parse(sessionStorage.getItem('vhp_visit') || 'null')?.l || '';
    } catch (e) {
      return '';
    }
  };
  // Visits that started on the planner page itself (docs/PLANNER_PAGE_FUNNEL.md: mostly Instagram links). The plan's
  // story changes (the "Fast geschafft" sheet on ×, one dish instead of the 1.3b montage, the poll that sends itself, the
  // deck line after one like, paywall first) stay with them until the homepage and recipe reads are done (~10-25), so
  // those visitors keep today's story as the control.
  const plannerLander = () => !planner.config.paid && storyActive() && visitLanding() === 'planner';
  // This visit's planner entry (vhp_visit.en: bio, story, dm, ig, tabbar …).
  const visitEntry = () => {
    try {
      return JSON.parse(sessionStorage.getItem('vhp_visit') || 'null')?.en || '';
    } catch (e) {
      return '';
    }
  };

  // "Deine Woche": up to three photos from the planned week and what it adds up to. Hidden without a preview.
  const renderSubscribeWeek = () => {
    const free = $('[data-vhp-pw-free]');
    if (free) free.hidden = !RECIPE_SIDE.has(visitLanding());
    const box = $('[data-vhp-pw-week]');
    if (!box) return;
    const preview = state.preview;
    const week = Array.isArray(preview?.week) ? preview.week : [];
    const meals = week.flatMap((day) => day.meals || []);
    const images = [];
    (preview?.day?.meals || []).forEach((meal) => meal.image && images.push(meal.image));
    meals.forEach((meal) => meal?.pick?.image && images.push(meal.pick.image));
    const photos = [...new Set(images)].slice(0, 4);
    if (!meals.length && !preview?.day?.meals?.length) {
      box.hidden = true;
      return;
    }
    box.hidden = false;
    const thumbs = $('[data-vhp-pw-thumbs]');
    if (thumbs) {
      thumbs.replaceChildren(...photos.map((src) => {
        const img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        return img;
      }));
      thumbs.hidden = !photos.length;
    }
    // Their targets, the same two numbers "Deine Zahlen" showed (the planned average differs a little day to day).
    const target = Number(preview.target) || state.kcal || 0;
    const protein = target ? macroGrams(target, currentSplit()).protein : 0;
    const title = $('[data-vhp-pw-week-title]');
    const sub = $('[data-vhp-pw-week-sub]');
    const count = meals.length || preview.day.meals.length;
    if (title) title.textContent = tr('planner.week_meals', { n: String(count) });
    if (sub) {
      const parts = [];
      if (target) parts.push(`${target.toLocaleString(LOCALE)} kcal`);
      if (protein) parts.push(tr('common.protein', { n: protein }));
      const from = likeCount() ? tr('planner.from_likes') : tr('planner.picked_for_you');
      // What the week does for her, not her numbers (PERSONA_ATTACK_PLAN.md 1.7); the numbers stay for Muskelaufbau and
      // the protein link, who came for them.
      if (state.goal !== 'gain' && !proteinSrc) sub.textContent = tr('planner.pw_week_sub_calm', { from });
      else sub.textContent = parts.length ? tr('planner.per_day_from', { parts: parts.join(' · '), from }) : `${from[0].toUpperCase()}${from.slice(1)}`;
    }
  };

  const renderSubscribe = () => {
    const box = $('[data-vhp-subscribe-plans]');
    if (!box) return;
    if (!state.subscribePlanId) state.subscribePlanId = defaultSubscribePlanId();
    const deal = activeOffer();
    const monthly = membershipPlans().find((p) => p.interval === 'month');
    box.replaceChildren();
    sortedPlans().forEach((plan) => {
      const { now, was, offer } = planPrice(plan);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vhp-choice vhp-plan';
      btn.dataset.vhpSubscribePlan = planKey(plan);
      btn.dataset.interval = plan.interval || '';
      const on = String(state.subscribePlanId) === planKey(plan);
      btn.classList.toggle('is-on', on);
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', on ? 'true' : 'false');

      const radio = document.createElement('span');
      radio.className = 'vhp-choice__radio';
      radio.setAttribute('aria-hidden', 'true');

      const copy = document.createElement('span');
      copy.className = 'vhp-choice__copy';
      const title = document.createElement('strong');
      title.textContent = planLabel(plan);
      const detail = document.createElement('small');
      const first = firstPaymentLabel(offer, plan);
      // Left: the yearly plan's total for the year (small, PAngV), monthly: cancel any month and nothing else (its
      // twelve-month total read as a decoy, docs/OFFER_DECISION.md 2). The renewal price sits in the line under the button.
      if (plan.interval === 'year') detail.textContent = first ? `${money(now)} ${first}` : tr('planner.per_year', { price: money(now) });
      else if (plan.interval === 'month') detail.textContent = tr('planner.monthly_cancel');
      else detail.textContent = money(now);
      copy.append(title, detail);

      // Right column, per month for both plans so yearly and monthly compare directly: the old price struck
      // through right next to the new one.
      const price = document.createElement('span');
      price.className = 'vhp-plan__price';
      if (plan.interval === 'year' || plan.interval === 'month') {
        const shown = monthlyShown(plan);
        const row = document.createElement('span');
        row.className = 'vhp-plan__amount';
        if (shown.was) {
          const old = document.createElement('s');
          old.textContent = money(shown.was);
          row.append(old);
        }
        const big = document.createElement('strong');
        big.textContent = money(shown.now);
        row.append(big);
        const per = document.createElement('small');
        per.textContent = (plan.interval === 'month' && first) || tr('planner.per_month');
        price.append(row, per);
      }

      btn.append(radio, copy, price);
      if (plan.interval === 'year') {
        // The saving against monthly. An offer on the first payment only (the story gift) is left out: the badge has
        // to hold for every year, not just the first (2026-10-17; it said 54 % for a saving of 49 % from year two).
        // The offer keeps its own chip and struck-through price.
        const monthlyNow = monthly ? planPrice(monthly).now : 0;
        const yearOffer = planPrice(plan).offer;
        const yearBase = yearOffer && yearOffer !== EARLY_ACCESS && yearOffer.firstPaymentOnly ? Number(plan.price) || now : now;
        const spare = monthlyNow > 0 ? Math.round((1 - yearBase / 12 / monthlyNow) * 100) : 0;
        const label = spare > 0 ? tr('planner.save_pct', { n: spare }) : tr('planner.best_price');
        const badge = document.createElement('span');
        badge.className = 'vhp-plan-badge';
        badge.textContent = label;
        btn.append(badge);
      }
      box.append(btn);
    });

    renderSubscribeWeek();

    const chip = $('[data-vhp-ea-chip]');
    if (chip) {
      chip.hidden = !deal;
      const text = $('[data-vhp-ea-chip-text]');
      // The offer and its countdown in one place at the top.
      if (text && deal) fillOfferHeadline(text, deal, deal !== EARLY_ACCESS);
    }
    const eaNote = $('[data-vhp-ea-note]');
    if (eaNote) {
      // Early access only (its price lasts the whole subscription); a sale's countdown sits in the chip.
      eaNote.hidden = deal !== EARLY_ACCESS;
      const text = $('[data-vhp-ea-note-text]');
      if (text && deal === EARLY_ACCESS) {
        text.textContent = tr('planner.early_text', { until: deal.untilLabel });
      }
    }

    const err = $('[data-vhp-checkout-error]');
    if (err) err.hidden = !checkoutError;
    // The consent line above the button, until it is given (the tap gives it: startCheckout).
    const consentLine = $('[data-vhp-pw-consent]');
    if (consentLine) consentLine.hidden = Boolean(state.consentPlanner || planner.config.paid);
    const terms = $('[data-vhp-subscribe-terms]');
    const picked = selectedSubscribePlan();
    const pickedDeal = picked ? planPrice(picked) : null;
    const pickedPrice = pickedDeal ? pickedDeal.now : 0;
    const firstPay = pickedDeal?.offer && pickedDeal.offer !== EARLY_ACCESS && pickedDeal.offer.firstPaymentOnly;
    const per = picked?.interval === 'year' ? 'year' : picked?.interval === 'month' ? 'month' : '';
    if (terms) {
      const trial = Number(planner.config.trialDays) || 0;
      if (!picked || !(pickedPrice > 0)) {
        terms.textContent = '';
      } else {
        let price = per ? tr(`planner.price_per_${per}`, { price: money(pickedPrice) }) : money(pickedPrice);
        if (firstPay) price = tr(`planner.price_first_${per}`, { now: money(pickedPrice), price: money(picked.price) });
        // Cancellation as the terms say it (subscription policy): the yearly plan runs its first year, then monthly.
        const renew = tr(per === 'year' ? 'planner.renew_year' : 'planner.renew');
        // The plan cards show the price; the line repeats it only when a first payment differs (the later price).
        if (trial > 0) terms.textContent = tr('planner.trial', { n: trial, price, renew });
        else terms.textContent = firstPay ? `${price} · ${renew}` : renew;
      }
      terms.hidden = !terms.textContent;
    }
    // The guarantee covers the first yearly subscription only (Maxim 2026-10-20; AGB § 15 to match): the line's
    // guarantee part shows while yearly is picked, the AGB link for every plan.
    $('[data-vhp-pw-guarantee]')?.classList.toggle('is-off', picked?.interval !== 'year');
    if (priceDrop) {
      priceDrop = false;
      dropPrices(box);
    }
    const pay = $('[data-vhp-checkout]');
    if (pay) {
      // Without consent the button stays solid and tappable: a tap opens the consent dialog. No aria-disabled: that paints .vhp-btn white and the paywall read as switched off.
      pay.disabled = !selectedSubscribePlan() || checkingOut;
      pay.removeAttribute('aria-disabled');
      // Price and renewal sit in the plan cards and the line under the button.
      // The progress shows once: on the dialog's button while it is open (docs/UX_REVIEW.md #19), else here.
      const dialogOpen = Boolean($('[data-vhp-consent-dialog]')?.open);
      paintCheckoutBtn(pay, tr('planner.start_plan'), { stage: dialogOpen ? '' : checkoutStage });
    }
    // Accepted in the dialog: it stays open and its button shows the progress (where the eye and finger are).
    const consentOk = $('[data-vhp-consent-ok]');
    if (consentOk) {
      consentOk.disabled = checkingOut;
      if (!consentOk.dataset.idle) consentOk.dataset.idle = consentOk.textContent.trim();
      paintCheckoutBtn(consentOk, consentOk.dataset.idle);
    }
    const consentCancel = $('[data-vhp-consent-cancel]');
    if (consentCancel) consentCancel.style.visibility = checkingOut ? 'hidden' : '';
  };

  // Story v2: right after "Geschenk einlösen" the old price is struck and the gifted one counts down to its value.
  let priceDrop = false;
  const dropPrices = (box) => {
    if (!box || !motionOk()) return;
    const pw = box.closest('.vhp-pw');
    box.classList.add('is-drop');
    pw?.classList.add('is-drop');
    box.querySelectorAll('.vhp-plan').forEach((btn) => {
      const plan = membershipPlans().find((p) => planKey(p) === btn.dataset.vhpSubscribePlan);
      const big = btn.querySelector('.vhp-plan__amount strong');
      if (!plan || !big || !(plan.interval === 'year' || plan.interval === 'month')) return;
      const { now, was } = monthlyShown(plan);
      if (!was) return;
      const from = was;
      const to = now;
      const t0 = performance.now() + 450;
      big.textContent = money(Math.round(from));
      const tick = (t) => {
        const p = Math.max(0, Math.min(1, (t - t0) / 600));
        big.textContent = money(Math.round(from + (to - from) * (1 - (1 - p) ** 3)));
        if (p < 1 && big.isConnected) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      // The price shown must end on the real one even when frames don't run (background tab).
      window.setTimeout(() => {
        if (big.isConnected) big.textContent = money(Math.round(to));
      }, 1150);
    });
    window.setTimeout(() => {
      box.classList.remove('is-drop');
      pw?.classList.remove('is-drop');
    }, 2200);
  };

  const stageIndexFor = (screen) => {
    const found = Object.keys(STAGE_SCREENS).find((key) => STAGE_SCREENS[key].includes(screen));
    return found == null ? -1 : Number(found);
  };

  const stageFillFor = (screen, index, active) => {
    if (index < active) return 100;
    if (index > active) return 0;
    if (screen === 'goal' || screen === 'body' || screen === 'macros' || screen === 'exclusions') {
      return FLOW_FILL[screen] || 100;
    }
    if (screen === 'swipe' || screen === 'empty') {
      return Math.min(100, Math.round(20 + (likeCount() / LIKE_VARIETY) * 80));
    }
    return 100;
  };

  const renderProgress = (screen) => {
    const root = $('[data-vhp-progress]');
    if (!root) return;
    const active = stageIndexFor(screen);
    $$('[data-vhp-stage]').forEach((el) => {
      const index = Number(el.dataset.vhpStage);
      const fill = el.querySelector('.vhp-funnel__stage-fill');
      const pct = active < 0 ? 0 : stageFillFor(screen, index, active);
      if (fill) fill.style.width = `${pct}%`;
      el.classList.toggle('is-on', active >= 0 && index <= active);
    });
    root.setAttribute('aria-valuenow', String(active < 0 ? 1 : active + 1));
    root.setAttribute('aria-valuemax', '3');
  };

  const rescaleWeekToKcal = (target) => {
    if (!Array.isArray(state.week) || !(target > 0)) return;
    const occasions = activeOccasions();
    const cap = capForOccasions(occasions);
    const shares = new Map(occasions.map((row) => [row.id, row.share]));
    state.week = state.week.map((day) => ({
      ...day,
      meals: (day.meals || []).map((meal) => {
        const share = shares.get(meal.id) || 0.25;
        const base = Number(meal.pick?.kcal) || 0;
        const scale = fitPortion(base, Math.round(target * share), target, cap) || meal.scale || 1;
        const pick = meal.pick || {};
        return {
          ...meal,
          scale,
          kcal: Math.round(base * scale),
          protein: Math.round((Number(pick.protein) || 0) * scale),
          carbs: pick.carbs == null ? null : Math.round(Number(pick.carbs) * scale),
          fat: pick.fat == null ? null : Math.round(Number(pick.fat) * scale),
        };
      }),
    }));
  };

  const flushSettingsProfile = () => {
    if (!planner.config.paid) return;
    state.pendingFlush = true;
    flushProfile();
  };

  const applyGoalKcal = (value) => {
    const next = Math.min(KCAL_MAX, Math.max(KCAL_MIN, Number(value)));
    if (!Number.isFinite(next) || next === state.kcal) return;
    state.kcal = next;
    state.kcalManual = true;
    rescaleWeekToKcal(next);
    persist();
    scheduleWeekSave();
    flushSettingsProfile();
    render();
  };

  const revertGoalKcal = () => {
    const next = computeKcal();
    if (next == null) return;
    state.kcalManual = false;
    if (next !== state.kcal) {
      state.kcal = next;
      rescaleWeekToKcal(next);
      scheduleWeekSave();
    }
    persist();
    flushSettingsProfile();
    render();
  };

  // ---------- Mahlzeiten (Einstellungen → its own screen) ----------
  // The same ring as the macros: the day from 12 o'clock clockwise, one arc per meal with a line out to its label
  // (name, kcal, % of the day). A knob between two neighbouring meals moves kcal from one to the other (1 % steps,
  // presets in 5s). The list under the ring takes a meal out (×) or puts it back (+). A meal that few recipes can be
  // portioned to says so in its label and row, with one line and a fix under the list (plannerCore.fitCount).
  // Changes apply when the screen closes: meals taken out leave the planned week and the portions follow the new
  // split; a meal put back waits for "Woche neu planen" (weekNeedsFill → plan foot).
  // A week's worth of different recipes: below that (and below half of what the balanced split offers) it warns.
  const MEAL_FIT_OK = 8;
  // Height of a ring label in viewBox units (400): labels on one side of the ring keep at least this apart.
  const MEAL_LABEL_GAP = 78;
  let mealsTouched = false;
  let mealNudge = null; // { id, key } after a refused remove, until the next action
  let mealDrag = null;
  let mealFitCatalog = null;
  let mealFitLoading = false;

  const mealLabel = (id) => EXAMPLE_OCCASIONS.find((row) => row.id === id)?.label || id;
  // Ring labels: Mittag / Abend (the full names don't fit beside the ring).
  const mealShortLabel = (id) => {
    const text = id === 'lunch' ? tr('planner.lunch_short') : id === 'dinner' ? tr('planner.dinner_short') : mealLabel(id);
    return text.charAt(0).toUpperCase() + text.slice(1);
  };
  const mealsOn = (shares) => MEAL_IDS.filter((id) => shares[id] > 0);
  const mealKcal = (shares, id) => (state.kcal > 0 ? Math.round((state.kcal * shares[id]) / 1000) * 10 : null);
  const mealPresetId = (shares) =>
    Object.keys(MEAL_PRESETS).find((key) => MEAL_IDS.every((id) => MEAL_PRESETS[key][id] === shares[id])) || null;

  // Any positive weights as whole percents that add up to 100 (largest remainder), at least MEAL_MIN each.
  const toMealPercents = (raw) => {
    const on = MEAL_IDS.filter((id) => raw[id] > 0);
    const total = on.reduce((sum, id) => sum + raw[id], 0) || 1;
    const rows = on.map((id) => {
      const exact = (raw[id] / total) * 100;
      return { id, n: Math.max(MEAL_MIN, Math.floor(exact)), rest: exact - Math.floor(exact) };
    });
    let left = 100 - rows.reduce((sum, row) => sum + row.n, 0);
    rows
      .slice()
      .sort((a, b) => b.rest - a.rest)
      .forEach((row) => {
        if (left <= 0) return;
        row.n += 1;
        left -= 1;
      });
    while (left < 0) {
      rows.reduce((a, b) => (b.n > a.n ? b : a)).n -= 1;
      left += 1;
    }
    const out = Object.fromEntries(MEAL_IDS.map((id) => [id, 0]));
    rows.forEach((row) => {
      out[row.id] = row.n;
    });
    return out;
  };

  // The split on screen: the saved one, or (not set yet) what slots + old sizes plan today.
  const mealSplit = () => {
    if (state.mealShares) return { ...state.mealShares };
    const raw = Object.fromEntries(MEAL_IDS.map((id) => [id, 0]));
    activeOccasions().forEach((row) => {
      raw[row.id] = row.share;
    });
    return normalizeMealShares(toMealPercents(raw)) || { ...MEAL_PRESETS.balanced };
  };

  // delta % to one meal, one at a time from / to the meal furthest above / below its balanced share.
  const shiftMeal = (shares, id, delta) => {
    const next = { ...shares };
    const others = mealsOn(next).filter((other) => other !== id);
    const ratio = (other) => next[other] / MEAL_PRESETS.balanced[other];
    let steps = Math.round(delta);
    while (steps > 0) {
      const from = others.filter((other) => next[other] > MEAL_MIN).sort((a, b) => ratio(b) - ratio(a))[0];
      if (!from) break;
      next[from] -= 1;
      next[id] += 1;
      steps -= 1;
    }
    while (steps < 0 && next[id] > MEAL_MIN && others.length) {
      const to = others.slice().sort((a, b) => ratio(a) - ratio(b))[0];
      next[to] += 1;
      next[id] -= 1;
      steps += 1;
    }
    return next;
  };

  // Taken out: its kcal spread over the others. Put back: its balanced share, the others make room.
  const withoutMeal = (shares, id) => toMealPercents({ ...shares, [id]: 0 });
  const withMeal = (shares, id) => {
    const add = MEAL_PRESETS.balanced[id];
    const rest = mealsOn(shares).reduce((sum, other) => sum + shares[other], 0) || 1;
    const raw = Object.fromEntries(MEAL_IDS.map((other) => [other, ((shares[other] || 0) * (100 - add)) / rest]));
    raw[id] = add;
    return toMealPercents(raw);
  };
  const mealRemoveBlock = (shares, id) => {
    const on = mealsOn(shares);
    if (on.length <= 2) return 'planner.meals_min_two';
    const other = id === 'lunch' ? 'dinner' : id === 'dinner' ? 'lunch' : null;
    if (other && !on.includes(other)) return 'planner.meals_need_main';
    return null;
  };

  const setMealShares = (next) => {
    const shares = normalizeMealShares(next);
    if (!shares) return;
    if (state.mealShares && MEAL_IDS.every((id) => state.mealShares[id] === shares[id])) return;
    state.mealShares = shares;
    state.mealSizes = {};
    state.slots = normalizePlanSlots([...(shares.breakfast ? ['breakfast'] : []), 'main', ...(shares.snack ? ['snack'] : [])]);
    mealsTouched = true;
    persist();
  };

  const applyMealsToWeek = () => {
    mealNudge = null;
    mealFitCatalog = null; // exclusions or own recipes may change before the screen opens again
    if (!mealsTouched) return;
    mealsTouched = false;
    const on = new Set(activeOccasions().map((row) => row.id));
    if (Array.isArray(state.week)) {
      state.week = state.week.map((day) => ({ ...day, meals: (day.meals || []).filter((meal) => on.has(meal.id)) }));
      rescaleWeekToKcal(state.kcal);
      if (state.weekApplied) state.weekApplied = { ...state.weekApplied, slots: planSlots() };
      scheduleWeekSave();
    }
  };

  // Recipe counts per meal (same catalog the generator plans from), loaded when the screen opens.
  const loadMealFit = () => {
    if (mealFitCatalog || mealFitLoading || !plannerCore?.fitCount) return;
    mealFitLoading = true;
    plannerCatalog(Boolean(planner.config.paid))
      .then((catalog) => {
        mealFitCatalog = catalog;
      })
      .catch(() => {})
      .finally(() => {
        mealFitLoading = false;
        if (state.screen === 'meals') renderMeals();
      });
  };
  const mealFitCounts = (shares) => {
    const out = {};
    if (!mealFitCatalog || !(state.kcal > 0)) return out;
    const occasions = EXAMPLE_OCCASIONS.filter((row) => shares[row.id] > 0).map((row) => ({ ...row, share: shares[row.id] / 100 }));
    const limit = Math.floor(state.kcal * capForOccasions(occasions));
    occasions.forEach((row) => {
      out[row.id] = plannerCore.fitCount(mealFitCatalog[row.catalog] || [], state.kcal * row.share, limit);
    });
    return out;
  };
  const mealFitLevel = (count, base) => {
    if (count == null) return null;
    if (count === 0) return 'none';
    return count < Math.min(MEAL_FIT_OK, Math.ceil((base || 0) / 2)) ? 'few' : null;
  };
  // The nearest split (this meal moved in steps of 5, toward its balanced share first) without the warning.
  const mealFix = (shares, id, base) => {
    const toward = Math.sign(MEAL_PRESETS.balanced[id] - shares[id]);
    const dirs = toward ? [toward, -toward] : [1, -1];
    for (const dir of dirs) {
      for (let pct = 5; pct <= 60; pct += 5) {
        const next = shiftMeal(shares, id, dir * pct);
        if (next[id] === shares[id]) break;
        if (!mealFitLevel(mealFitCounts(next)[id], base[id])) return next;
      }
    }
    return null;
  };

  const renderMeals = () => {
    const screen = $('[data-vhp-screen="meals"]');
    if (!screen || state.screen !== 'meals') return;
    loadMealFit();
    const shares = mealSplit();
    const on = mealsOn(shares);
    const q = (sel) => screen.querySelector(sel);

    const preset = mealPresetId(shares);
    screen.querySelectorAll('[data-vhp-meal-preset]').forEach((btn) => {
      const isOn = btn.dataset.vhpMealPreset === preset;
      btn.classList.toggle('is-on', isOn);
      btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
    });

    const counts = mealFitCounts(shares);
    const base = mealFitCounts(MEAL_PRESETS.balanced);
    const level = Object.fromEntries(on.map((id) => [id, mealFitLevel(counts[id], base[id])]));

    q('[data-vhp-meal-ring]')?.classList.toggle('is-dragging', mealDrag != null);

    // Where each meal starts; a meal out of the plan sits there with no length, so it grows from that spot.
    const starts = {};
    let at = 0;
    MEAL_IDS.forEach((id) => {
      starts[id] = at;
      at += shares[id] || 0;
    });

    // Labels: a line from the middle of the arc out to the side, like the macro ring. Labels on the same side are
    // pushed apart so neighbours (a small snack next to breakfast) don't overlap.
    const rows = on.map((id) => {
      const mid = starts[id] + shares[id] / 2;
      const [ax, ay] = macroPoint(mid, MACRO_R + 20);
      const [bx, by] = macroPoint(mid, MACRO_R + 44);
      return { id, ax, ay, bx, y: by, right: bx >= MACRO_CX };
    });
    [true, false].forEach((right) => {
      const side = rows.filter((row) => row.right === right).sort((a, b) => a.y - b.y);
      for (let i = 1; i < side.length; i += 1) side[i].y = Math.max(side[i].y, side[i - 1].y + MEAL_LABEL_GAP);
      const over = side.length ? side[side.length - 1].y - (400 - MEAL_LABEL_GAP / 2) : 0;
      if (over > 0) {
        side[side.length - 1].y -= over;
        for (let i = side.length - 2; i >= 0; i -= 1) side[i].y = Math.min(side[i].y, side[i + 1].y - MEAL_LABEL_GAP);
      }
    });

    MEAL_IDS.forEach((id) => {
      const p = shares[id] || 0;
      const isOn = p > 0;
      const arc = q(`[data-vhp-meal-arc="${id}"]`);
      if (arc) {
        arc.setAttribute('stroke-dasharray', `${(MACRO_C * p) / 100} ${(MACRO_C * (100 - p)) / 100}`);
        arc.setAttribute('stroke-dashoffset', String((-MACRO_C * starts[id]) / 100));
      }
      const cap = q(`[data-vhp-meal-cap="${id}"]`);
      if (cap) {
        const [cx, cy] = macroPoint(starts[id] + p, MACRO_R);
        cap.setAttribute('cx', String(cx));
        cap.setAttribute('cy', String(cy));
        cap.classList.toggle('is-off', !isOn);
      }
      const row = rows.find((r) => r.id === id);
      const lead = q(`[data-vhp-meal-lead="${id}"]`);
      const dot = q(`[data-vhp-meal-dot="${id}"]`);
      const label = q(`[data-vhp-meal-label="${id}"]`);
      [lead, dot, label].forEach((node) => node?.classList.toggle('is-off', !isOn));
      if (!row) return;
      const cx2 = row.bx + (row.right ? 14 : -14);
      lead?.setAttribute('points', `${row.ax},${row.ay} ${row.bx},${row.y} ${cx2},${row.y}`);
      dot?.setAttribute('cx', String(row.ax));
      dot?.setAttribute('cy', String(row.ay));
      if (label) {
        label.style.left = `${(cx2 + (row.right ? 6 : -6)) / 4}%`;
        label.style.top = `${row.y / 4}%`;
        // Under the ring the label hangs from its line, over the ring it stands on it (not across the arc).
        const ty = row.y > MACRO_CX + MACRO_R ? -20 : row.y < MACRO_CX - MACRO_R ? -80 : -50;
        label.style.transform = `translate(${row.right ? 0 : -100}%,${ty}%)`;
        label.style.textAlign = row.right ? 'left' : 'right';
        label.classList.toggle('is-few', level[id] === 'few');
        label.classList.toggle('is-none', level[id] === 'none');
        const name = label.querySelector('[data-vhp-meal-label-name]');
        if (name) name.textContent = mealShortLabel(id);
        const kcal = label.querySelector('[data-vhp-meal-label-kcal]');
        if (kcal) kcal.textContent = deInt(mealKcal(shares, id));
        const pct = label.querySelector('[data-vhp-meal-label-pct]');
        // Few recipes: the % turns gold / red here (no room for words beside the ring); the line under the card says it.
        if (pct) pct.textContent = `${p} %`;
      }
    });

    // Knob i sits where the i-th meal of the day ends (none after the last one: 12 o'clock stays the day's start).
    let end = 0;
    screen.querySelectorAll('[data-vhp-meal-handle]').forEach((handle) => {
      const i = Number(handle.dataset.vhpMealHandle);
      const a = on[i];
      const b = on[i + 1];
      const show = Boolean(a && b);
      handle.classList.toggle('is-off', !show);
      handle.setAttribute('tabindex', show ? '0' : '-1');
      handle.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (!show) return;
      end = on.slice(0, i + 1).reduce((sum, id) => sum + shares[id], 0);
      const [hx, hy] = macroPoint(end, MACRO_R);
      handle.querySelectorAll('circle').forEach((circle) => {
        circle.setAttribute('cx', String(hx));
        circle.setAttribute('cy', String(hy));
      });
      handle.setAttribute('aria-label', tr('planner.meals_handle', { a: mealLabel(a), b: mealLabel(b) }));
      handle.setAttribute('aria-valuemin', String(MEAL_MIN));
      handle.setAttribute('aria-valuemax', String(shares[a] + shares[b] - MEAL_MIN));
      handle.setAttribute('aria-valuenow', String(shares[a]));
      handle.setAttribute('aria-valuetext', `${mealLabel(a)} ${shares[a]} %, ${mealLabel(b)} ${shares[b]} %`);
    });

    const total = q('[data-vhp-meal-kcal]');
    if (total) total.textContent = deInt(state.kcal);

    // The card under the ring: preset name, the split as a bar, every meal with its kcal; × takes it out, + puts it
    // back (a meal out of the plan stays in the legend, greyed, with its +).
    const cardTitle = q('[data-vhp-meal-card-title]');
    if (cardTitle) cardTitle.textContent = preset ? tr(`planner.meals_preset_${preset}`) : tr('planner.meals_custom');
    const cardCount = q('[data-vhp-meal-card-count]');
    if (cardCount) cardCount.textContent = tr('planner.meals_count', { n: on.length });
    screen.querySelectorAll('[data-vhp-meal-part]').forEach((part) => {
      part.style.flexGrow = String(shares[part.dataset.vhpMealPart] || 0);
      part.classList.toggle('is-off', !(shares[part.dataset.vhpMealPart] > 0));
    });
    screen.querySelectorAll('[data-vhp-meal-row]').forEach((row) => {
      const id = row.dataset.vhpMealRow;
      const isOn = shares[id] > 0;
      row.classList.toggle('is-off', !isOn);
      row.classList.toggle('is-few', level[id] === 'few');
      row.classList.toggle('is-none', level[id] === 'none');
      const name = row.querySelector('[data-vhp-meal-row-name]');
      if (name) name.textContent = mealShortLabel(id);
      const meta = row.querySelector('[data-vhp-meal-row-kcal]');
      if (meta) {
        const kcal = mealKcal(shares, id);
        meta.textContent = isOn ? (kcal != null ? deInt(kcal) : `${shares[id]} %`) : '';
      }
      const remove = row.querySelector('[data-vhp-meal-remove]');
      const add = row.querySelector('[data-vhp-meal-add]');
      if (remove) {
        remove.hidden = !isOn;
        remove.setAttribute('aria-label', tr('planner.meals_remove_label', { label: mealLabel(id) }));
      }
      if (add) {
        add.hidden = isOn;
        add.setAttribute('aria-label', tr('planner.meals_add_label', { label: mealLabel(id) }));
      }
    });

    // One line under the list: why a meal stays, or the meal with the fewest fitting recipes and its fix.
    const note = q('[data-vhp-meal-note]');
    if (note) {
      note.replaceChildren();
      note.className = 'vhp-meal-note';
      const worst = on.filter((id) => level[id]).sort((a, b) => counts[a] - counts[b])[0];
      if (mealNudge) {
        const text = document.createElement('span');
        text.textContent = tr(mealNudge.key);
        note.append(text);
      } else if (worst) {
        const n = counts[worst];
        const vars = { label: mealLabel(worst), kcal: deInt(mealKcal(shares, worst)), n };
        note.classList.add(`is-${level[worst]}`);
        const text = document.createElement('span');
        text.textContent = tr(n === 0 ? 'planner.meals_fit_none' : n === 1 ? 'planner.meals_fit_one' : 'planner.meals_fit_few', vars);
        note.append(text);
        const fix = mealFix(shares, worst, base);
        if (fix) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'vhp-meal-note__fix';
          btn.textContent = tr(fix[worst] > shares[worst] ? 'planner.meals_fit_raise' : 'planner.meals_fit_lower', {
            kcal: deInt(mealKcal(fix, worst)),
          });
          btn.dataset.vhpMealFix = MEAL_IDS.map((id) => fix[id]).join(',');
          note.append(btn);
        }
      }
      note.hidden = !note.childNodes.length;
    }
  };

  const mealsAction = (fn) => {
    mealNudge = null;
    fn();
    renderMeals();
    renderSettings();
  };

  // Knob i sits between the i-th and the next meal of the day; pct = where the finger is on the ring (0–100).
  // Past the pair (over another meal) it snaps to the nearer end, like the macro ring.
  const moveMealKnob = (i, pct) => {
    const shares = mealSplit();
    const on = mealsOn(shares);
    const a = on[i];
    const b = on[i + 1];
    if (!a || !b) return;
    const before = on.slice(0, i).reduce((sum, id) => sum + shares[id], 0);
    const pool = shares[a] + shares[b];
    let v = (((pct - before) % 100) + 100) % 100;
    if (v > pool) v = v > pool + (100 - pool) / 2 ? MEAL_MIN : pool - MEAL_MIN;
    v = Math.round(Math.max(MEAL_MIN, Math.min(pool - MEAL_MIN, v)));
    if (v === shares[a]) return;
    setMealShares({ ...shares, [a]: v, [b]: pool - v });
  };

  // Settings card: the preset name and one row per meal (name, a bar the size of its share, kcal).
  const renderMealsSummary = () => {
    const card = $('[data-vhp-meals-sum]');
    if (!card) return;
    const shares = mealSplit();
    const on = mealsOn(shares);
    const preset = mealPresetId(shares);
    const title = card.querySelector('[data-vhp-meals-sum-title]');
    if (title) title.textContent = preset ? tr(`planner.meals_preset_${preset}`) : tr('planner.meals_custom');
    const count = card.querySelector('[data-vhp-meals-sum-count]');
    if (count) count.textContent = tr('planner.meals_count', { n: on.length });
    const list = card.querySelector('[data-vhp-meals-sum-rows]');
    if (!list) return;
    const max = Math.max(...on.map((id) => shares[id]));
    list.replaceChildren(
      ...on.map((id) => {
        const row = document.createElement('span');
        row.className = `vhp-meals-sum__row vhp-meal--${id}`;
        const name = document.createElement('span');
        name.className = 'vhp-meals-sum__name';
        name.textContent = mealLabel(id);
        const track = document.createElement('span');
        track.className = 'vhp-meals-sum__track';
        const fill = document.createElement('i');
        fill.style.width = `${(shares[id] / max) * 100}%`;
        track.append(fill);
        const kcal = document.createElement('span');
        kcal.className = 'vhp-meals-sum__kcal';
        const value = mealKcal(shares, id);
        kcal.textContent = value != null ? `${deInt(value)} kcal` : `${shares[id]} %`;
        row.append(name, track, kcal);
        return row;
      })
    );
  };

  const weekNeedsFill = () => {
    const want = activeOccasions().map((row) => row.id);
    return (state.week || []).some((day) => {
      const have = new Set((day.meals || []).map((meal) => meal.id));
      return want.some((id) => !have.has(id));
    });
  };

  const runSettingsRegen = async () => {
    if (weekGenerating || !weekHasPlan(state.week)) return;
    if (!weekNeedsFill()) {
      await runRemix('week');
      return;
    }
    weekGenerating = true;
    weekError = false;
    render();
    try {
      regenUndo = { scope: 'week', snapshot: cloneJson(state.week) };
      await generateWeek({ keepLocks: true });
      showRegenToast('week');
      persist();
      scheduleWeekSave();
    } catch (e) {
      console.error('[vhp-planner] settings regen failed', e);
      weekError = true;
      regenUndo = null;
      hideRegenToast();
    } finally {
      weekGenerating = false;
      render();
    }
  };

  const MACRO_PRESET_LABEL = Object.fromEntries(Object.keys(MACRO_PRESETS).map((id) => [id, tr(`planner.preset_${id}`)]));

  // Einstellungen tab of the Dein Plan sheet.
  const renderSettings = () => {
    const pane = $('[data-vhp-plan-pane="settings"]');
    if (!pane) return;

    const kcalValue = $('[data-vhp-goal-kcal-value]');
    if (kcalValue) kcalValue.textContent = state.kcal != null ? state.kcal.toLocaleString(LOCALE) : '—';
    $$('[data-vhp-goal-kcal]').forEach((btn) => {
      const delta = Number(btn.dataset.vhpGoalKcal);
      const current = Number(state.kcal);
      btn.disabled = !Number.isFinite(current) || (delta < 0 && current <= KCAL_MIN) || (delta > 0 && current >= KCAL_MAX);
    });
    const suggested = computeKcal();
    const revert = $('[data-vhp-goal-kcal-revert]');
    if (revert) {
      const show = Boolean(state.kcalManual && suggested != null && suggested !== state.kcal);
      revert.hidden = !show;
      revert.textContent = show ? tr('planner.back_to_suggestion', { n: suggested }) : '';
    }

    // Grams per day under the kcal: protein first, it's what the plan is built around.
    const macrosEl = $('[data-vhp-goal-macros]');
    if (macrosEl) {
      const grams = state.kcal != null ? macroGrams(state.kcal, currentSplit()) : null;
      macrosEl.replaceChildren(
        ...[
          ['protein', tr('planner.protein')],
          ['carbs', tr('planner.carbs_long')],
          ['fat', tr('planner.fat')],
        ].map(([key, label]) => {
          const cell = document.createElement('div');
          cell.className = `vhp-set-macros__cell vhp-set-macros__cell--${key}`;
          const dd = document.createElement('dd');
          dd.textContent = grams ? `${grams[key]} g` : '—';
          const dt = document.createElement('dt');
          dt.textContent = label;
          cell.append(dd, dt);
          return cell;
        })
      );
    }

    const setValue = (key, text) => {
      const el = $(`[data-vhp-set-value="${key}"]`);
      if (el) el.textContent = text;
    };
    setValue('goal', GOAL_LABEL[state.goal] || tr('planner.set'));
    setValue(
      'body',
      eckdatenValid() ? [`${state.weight} kg`, ACTIVITY_LABEL[state.activity]].filter(Boolean).join(' · ') : tr('planner.set')
    );
    const split = currentSplit();
    const preset = presetIdFor(split, state.macrosPreset);
    setValue('macros', MACRO_PRESET_LABEL[preset] || `${split.protein} / ${split.carbs} / ${split.fat} %`);

    renderMealsSummary();

    renderPlanFoot();
  };

  let dockBubbleTab = '';
  let dockBubbleGen = 0;

  const dockDesktop = () => window.matchMedia('(min-width: 960px)').matches;

  const syncDockBubble = (immediate) => {
    const dock = $('[data-vhp-dock]');
    const bubble = dock?.querySelector('[data-vhp-dock-bubble]');
    if (!dock || !bubble) return;
    if (dock.hidden) {
      bubble.classList.remove('is-on');
      dockBubbleTab = '';
      return;
    }
    const btn = dock.querySelector('.vhp-dock__btn.is-on');
    if (!btn) {
      bubble.classList.remove('is-on');
      dockBubbleTab = '';
      return;
    }

    const tab = btn.dataset.vhpTab || '';
    const ready = bubble.classList.contains('is-on');
    if (!immediate && ready && tab === dockBubbleTab) return;

    const desktop = dockDesktop();
    const target = desktop ? btn : btn.querySelector('.vhp-dock__ico') || btn;
    const dockBox = dock.getBoundingClientRect();
    const box = target.getBoundingClientRect();
    const x = box.left - dockBox.left;
    const y = box.top - dockBox.top;
    const w = box.width;
    const h = box.height;
    const snap = Boolean(immediate) || !ready;
    const gen = ++dockBubbleGen;

    const place = (px, py, pw, ph) => {
      bubble.style.setProperty('--dock-x', `${px}px`);
      bubble.style.setProperty('--dock-y', `${py}px`);
      bubble.style.setProperty('--dock-w', `${pw}px`);
      bubble.style.setProperty('--dock-h', `${ph}px`);
    };

    dock.classList.toggle('is-desk', desktop);
    dock.classList.toggle('is-snap', snap);

    if (!snap) {
      const oldX = Number(bubble.dataset.x);
      const oldY = Number(bubble.dataset.y);
      const oldW = Number(bubble.dataset.w) || w;
      const oldH = Number(bubble.dataset.h) || h;
      if (desktop) {
        place(x, Math.min(oldY, y), w, Math.max(oldY + oldH, y + h) - Math.min(oldY, y));
      } else {
        place(Math.min(oldX, x), y, Math.max(oldX + oldW, x + w) - Math.min(oldX, x), h);
      }
      void bubble.offsetWidth;
      window.requestAnimationFrame(() => {
        if (gen !== dockBubbleGen) return;
        dock.classList.remove('is-snap');
        place(x, y, w, h);
      });
    } else {
      place(x, y, w, h);
      window.requestAnimationFrame(() => {
        if (gen !== dockBubbleGen) return;
        dock.classList.remove('is-snap');
      });
    }

    bubble.dataset.x = String(x);
    bubble.dataset.y = String(y);
    bubble.dataset.w = String(w);
    bubble.dataset.h = String(h);
    bubble.classList.add('is-on');
    dockBubbleTab = tab;
  };

  const openTab = (id) => {
    // An unplanned next week only exists on the Wochenplan; every other tab works on this week.
    if (id !== 'week' && viewingNextWeek() && !weekHasPlan(state.week)) showWeekOf(mondayIso(0));
    if (id === 'week') openWeek();
    else if (id === 'shop') openShop();
    else if (id === 'settings') openSettings();
    else if (id === 'recipes') openRecipes();
  };

  // App shell (layout/theme.liquid): the planner is the Plan tab. Its views live in the shell bars:
  // Wochenplan / Einkaufsliste in the top bar, the Dein Plan sheet (Einstellungen · Favoriten) behind its button.
  const shell = document.querySelector('.app-shell');
  const SHELL_TITLES = { settings: tr('planner.your_plan'), recipes: tr('planner.recipes') };

  const renderShell = (screen) => {
    if (!shell) return;
    const paidApp = Boolean(planner.config.paid) && (screen === 'week' || screen === 'shop' || screen === 'settings' || inRecipes());
    const view = state.editFrom === 'settings' ? 'settings' : screen;
    const views = document.querySelector('[data-app-plan-views]');
    const title = document.querySelector('[data-app-plan-title]');
    const favBtn = document.querySelector('[data-app-plan-fav]');
    if (favBtn) favBtn.hidden = !(paidApp && view === 'week');
    if (views) {
      const segment = !paidApp || view === 'week' || view === 'shop';
      views.hidden = !segment;
      if (title) {
        title.hidden = segment;
        title.textContent = SHELL_TITLES[view] || '';
      }
      views.querySelectorAll('[data-app-plan-view]').forEach((btn) => {
        const on = btn.dataset.appPlanView === view;
        btn.classList.toggle('is-active', on);
        if (on) btn.setAttribute('aria-current', 'page');
        else btn.removeAttribute('aria-current');
        if (btn.dataset.appPlanView === 'shop') btn.disabled = weekGenerating || !weekHasPlan(state.week);
      });
    }
    const active = 'plan';
    shell.dataset.appTab = active;
    document.querySelectorAll('[data-app-tabbar] .app-tab').forEach((link) => {
      const on = link.dataset.tab === active;
      link.classList.toggle('is-active', on);
      if (on) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  };

  if (shell) {
    document.addEventListener('click', (event) => {
      const view = event.target.closest?.('[data-app-plan-view]');
      if (view) {
        if (!view.disabled) openTab(view.dataset.appPlanView);
        return;
      }
      if (event.target.closest?.('[data-app-plan-fav]')) {
        openFavSheet();
        return;
      }
      // Plan tab while already on the planner: back to the Wochenplan without a reload.
      const planTab = event.target.closest?.('[data-app-tabbar] [data-tab="plan"]');
      if (!planTab || !planner.config.paid || !funnel.querySelector('[data-vhp-screen="week"]')) return;
      event.preventDefault();
      try {
        sessionStorage.removeItem('app-shell-dir');
      } catch (e) {
        /* ignore */
      }
      openTab('week');
    });
  }

  const renderChrome = (screen) => {
    renderShell(screen);
    const isApp = screen === 'week' || screen === 'shop' || screen === 'settings' || inRecipes();
    const weekSwap = Boolean(state.swap?.from === 'week') && (screen === 'swipe' || screen === 'empty');
    const inFlow =
      FLOW.includes(screen) || screen === 'swipe' || screen === 'empty' || screen === 'preview' || screen === 'subscribe' ||
      (STORY_SCREENS.has(screen) && !planner.config.paid);
    // The story has its own bars; after it (preview, paywall) the old Ziele / Rezepte / Vorschau bar would be a
    // second progress system, so only the back button stays.
    const showBar = inFlow && !weekSwap && state.editFrom !== 'settings' && !storyActive();
    const hideTop = screen === 'waiting' || screen === 'building';
    funnel.classList.toggle('is-app', isApp);
    funnel.classList.toggle('is-building', screen === 'building');
    const top = funnel.querySelector('.vhp-funnel__top');
    if (top) top.hidden = hideTop;
    const nav = $('[data-vhp-nav]');
    if (nav) {
      nav.hidden = isApp || hideTop;
      nav.classList.toggle('is-slim', !showBar && !isApp);
    }
    const dock = $('[data-vhp-dock]');
    if (dock) dock.hidden = !isApp;
    $$('[data-vhp-tab]').forEach((btn) => {
      const id = btn.dataset.vhpTab;
      const on =
        id === screen ||
        (id === 'settings' && state.editFrom === 'settings') ||
        (id === 'recipes' && inRecipes());
      btn.classList.toggle('is-on', on);
      if (on) btn.setAttribute('aria-current', 'page');
      else btn.removeAttribute('aria-current');
      if (id === 'shop') btn.disabled = weekGenerating || !weekHasPlan(state.week);
    });
    syncDockBubble();
  };

  // The dish they tapped "Einplanen" on before coming here (assets/vhp-recipe-sheet.js, PICK_KEY): it comes first
  // in the hook's collage and onto the preview's open day.
  const PICK_KEY = 'vhp_planner_pick';
  const introPick = (() => {
    try {
      const raw = JSON.parse(sessionStorage.getItem(PICK_KEY) || 'null');
      return raw && raw.id ? String(raw.id) : '';
    } catch (e) {
      return '';
    }
  })();
  // That dish as saved with the like (title, slot, kcal and protein per portion as its page showed them).
  const introDish = () => (introPick ? likeItems().find((item) => productId(item.id) === productId(introPick)) || null : null);
  // ?src=portion: their portion of that dish for its meal (lunch share for mains, like 1.3b), with the planner's own
  // fitPortion, so the numbers are what a plan would give.
  const introPortion = () => {
    const dish = introDish();
    const kcal = Number(dish?.kcal) || 0;
    if (!dish || !kcal || !state.kcal) return null;
    const occasion = EXAMPLE_OCCASIONS.find((row) => row.catalog === dish.slot) || EXAMPLE_OCCASIONS[1];
    const scale = fitPortion(kcal, Math.round(state.kcal * occasion.share), state.kcal, capForOccasions(activeOccasions()));
    if (!scale) return null;
    return {
      title: dish.title || '',
      image: dish.image || '',
      scale,
      kcal: Math.round(kcal * scale),
      protein: Math.round((Number(dish.protein) || 0) * scale),
    };
  };

  // ---------- story setup (assets/vhp-planner-story.js) ----------

  const hasScreen = (id) => Boolean(funnel.querySelector(`[data-vhp-screen="${id}"]`));
  // Newest likes first, the dish they tapped "Einplanen" on before that.
  const likedImages = () => {
    const items = likeItems().filter((item) => item.image).slice().reverse();
    const picked = introPick ? items.find((item) => productId(item.id) === productId(introPick)) : null;
    return (picked ? [picked, ...items.filter((item) => item !== picked)] : items).map((item) => item.image);
  };
  // Dishes for backgrounds without a block: their likes, else the week (or the mains pool before there is one).
  const dishImages = (n) => {
    const liked = likedImages();
    if (liked.length >= n) return liked.slice(0, n);
    const week = (state.preview?.week || []).flatMap((day) => (day?.meals || []).map((meal) => meal?.pick?.image));
    const pool = poolFor('main').map((card) => card.image);
    return [...new Set([...liked, ...week, ...pool].filter(Boolean))].slice(0, n);
  };

  const storyView = (screen) => {
    const goal = state.goal || 'lose';
    const protein = state.kcal ? macroGrams(state.kcal, currentSplit()).protein : 0;
    // Chapter bars. "Deine Woche" is one bar when the gift is the discount; "Von mir" is one bar (gift or clip).
    const chapter = storyChapter(screen);
    // Geschlecht is part of the body slide since 2026-10-17; a body from the recipe calculator skips that slide.
    const bars = STORY_CHAPTERS[chapter].filter(
      (key) =>
        key !== 'sex' &&
        !(key === 'body' && state.bodyPreset) &&
        !(key === 'activity' && state.activityPreset) &&
        !(key === 'dishes' && montageSkipped()) &&
        !(trimmedStory() && ['why', 'dishes', 'pain', 'answer'].includes(key))
    );
    let slide = Math.max(0, bars.indexOf(screen));
    let count = bars.length;
    if (chapter === 2 && giftIsReward()) count = 1;
    if (chapter === 3) {
      count = 1;
      slide = 0;
    }
    const keys = {
      // One default 1.1 for everyone (with or without likes): the hook clip.
      goal: storySrc ? ['hook_story', 'hook'] : ['hook'],
      // A "1.2 Eckdaten" block covers all three Eckdaten slides unless one has its own.
      why: ['why', 'body'],
      sex: ['sex', 'body'],
      activity: ['activity', 'body'],
      numbers: [`numbers_${goal}`],
      answer: [`answer_${state.pain}`],
      building: ['planning'],
      gift: [],
      dishes: ownDishVideo()
        ? ['dishes_video']
        : $$('[data-vhp-story-fig="dishes"][data-recipe][data-kcal][data-protein]').length ? ['dishes'] : [],
    }[screen] || [screen];
    if (editorKey && !keys.includes(editorKey)) keys.unshift(editorKey);
    let images = null;
    let imageStyle = 'collage';
    if (screen === 'building') {
      images = dishImages(10);
      imageStyle = 'glide';
    } else if (screen === 'dishes' && !keys.length) {
      images = storyDishes().map((dish) => dish.card.image);
      imageStyle = 'parts';
    } else if (AMBIENT_SCREENS.includes(screen)) {
      // Question slides without their own block: one of their dishes, blurred and drifting, behind the sticker,
      // a different one per slide (until Sören's clips / photos are in).
      const pool = dishImages(8);
      const pic = pool[AMBIENT_SCREENS.indexOf(screen) % Math.max(1, pool.length)];
      if (pic) {
        images = [pic];
        imageStyle = 'ambient';
      }
    }
    let caption = '';
    if (screen === 'goal') {
      // After the first screen (docs/FIRST_SCREEN.md 9.8) no greeting: the goal as the first thing to give.
      if (state.mondayDoor) caption = tr('planner.story_hook_after');
      else if (storySrc) caption = tr('planner.story_hook_story');
      else if (srcParam === 'collection') caption = tr(collTheme ? `planner.story_hook_coll_${collTheme}` : 'planner.story_hook_coll', { name: planner.config.story?.name || 'Sören' });
      else if (proteinSrc) caption = tr('planner.story_hook_protein', { name: planner.config.story?.name || 'Sören' });
      else if (portionSrc) caption = tr('planner.story_hook_portion', { name: planner.config.story?.name || 'Sören' });
      else if (RECIPE_HOOKS.has(srcParam)) caption = tr(`planner.story_hook_${srcParam}`, { name: planner.config.story?.name || 'Sören' });
      // Planner page links (docs/PLANNER_PAGE_FUNNEL.md 1.2 / 1.3): the bio sits under "162 Rezepte kostenlos", a DM
      // answers a request; every other planner landing gets the two top pains (deciding, counting) in the line.
      else if (LANDER_HOOKS.has(srcParam)) caption = tr(`planner.story_hook_${srcParam}`, { name: planner.config.story?.name || 'Sören' });
      else if (plannerLander()) caption = tr('planner.story_hook_lander', { name: planner.config.story?.name || 'Sören' });
      else caption = tr('planner.story_hook', { name: planner.config.story?.name || 'Sören' });
    } else if (screen === 'numbers' && proteinSrc) {
      // The recipe they came from, per portion as its page showed it, as the first step towards the number.
      const fromProtein = Math.round(Number(introDish()?.protein) || 0);
      caption = fromProtein > 0 && fromProtein < protein
        ? tr('planner.story_numbers_protein_from', { n: deInt(fromProtein) })
        : tr('planner.story_numbers_protein');
    } else if (screen === 'numbers' && portionSrc) {
      // Their portion is the card on the slide (render); Sören says what that means for every meal.
      caption = tr('planner.story_numbers_portion');
    } else if (screen === 'numbers') {
      // Abnehmen with a slim body: a gentle deficit or none (LOSE), so the line doesn't promise one.
      const mode = goal === 'lose' && !state.kcalManual && state.weight && state.height ? loseMode() : 'lose';
      caption = tr(`planner.story_numbers_${goal}${mode === 'lose' ? '' : `_${mode}`}`, { protein: deInt(protein) });
    } else if (screen === 'answer' && state.pains.length > 1) {
      // Several obstacles: one opener, then a short answer to each, in their pick order (one bubble each).
      caption = [
        tr(`planner.story_answer_multi_${Math.min(state.pains.length, 3)}`),
        ...state.pains.map((key) => tr(`planner.story_answer_short_${key}`)),
      ].join('\n');
    } else if (screen === 'answer' && state.pain) {
      caption = tr(`planner.story_answer_${state.pain}`);
    } else if (screen === 'dishes') {
      if (proteinSrc) caption = tr('planner.story_dishes_cap_protein', { protein: deInt(protein) });
      else if (portionSrc) caption = tr('planner.story_dishes_cap_portion');
      else caption = tr('planner.story_dishes_cap', { kcal: deInt(state.kcal) });
    } else if (screen === 'grid') {
      caption = tr('planner.story_grid_cap');
    }
    const deck = screen === 'swipe' || screen === 'empty' || screen === 'grid';
    if (deck) {
      count = LIKE_READY;
      slide = 0;
    }
    return {
      screen,
      keys: deck ? [] : keys,
      images,
      imageStyle,
      deck,
      // Header back arrow: on every slide with a step before it (the deck always, it has no tap zones).
      canBack: deck || state.history.length > 0 || state.editFrom === 'summary',
      // short: the "Rezepte liken" chapter is skipped on this path (likes already plan, recipe express path), so the
      // label counts two steps instead of jumping from 1 to 3 (docs/PERSONA_ATTACK_PLAN.md 2.10).
      chapter: {
        index: chapter,
        slide,
        count: Math.max(1, count),
        fill: deck ? Math.min(LIKE_READY, likeCount()) : null,
        short: !planner.config.paid && !state.sawRecipes && (planReady() || expressPath() || recipeDoor()),
      },
      // 1.3b: a quick montage, one bar. With Story-Slide blocks a 1.5 s cut from each recipe video (the block's
      // "Clip-Start", else just after the start: the reels open on the finished dish, the middle shows cooking steps
      // with burned-in subtitles), without blocks their dish photos.
      // An own video ("1.3b So isst du · eigenes Video") plays in full instead, the slide moves on when it ends.
      parts: screen === 'dishes' && !keys.length ? Math.max(1, storyDishes().length) : 1,
      oneBar: screen === 'dishes',
      partsFollowMedia: false,
      maxClip: screen === 'dishes' && keys.length && !ownDishVideo() ? STORY_PASSIVE.dishes : 0,
      clipFrom: screen === 'dishes' && !ownDishVideo() ? 0.04 : 0,
      // 1.5 reads as a DM: their obstacle answers first (their words, one bubble each), then Sören's reply; a
      // reaction sticks to it.
      chat: screen === 'answer'
        ? {
            ask: $('[data-vhp-screen="pain"] .vhp-poll__q')?.textContent.trim() || '',
            me: state.pains
              .map((key) => $(`[data-vhp-pain="${key}"] [data-vhp-pain-label]`)?.textContent.trim() || '')
              .filter(Boolean),
          }
        : null,
      // "Deine Zahlen" waits for its button (2026-10-17): it moved on before most had read their numbers.
      passive: Object.prototype.hasOwnProperty.call(STORY_PASSIVE, screen) && screen !== 'numbers',
      // Each further obstacle adds a bubble to read.
      // The portion card (?src=portion) and the two-line protein reply (?src=protein) add something to read on 1.3.
      duration:
        (STORY_PASSIVE[screen] || 0) +
        (screen === 'answer' ? 3000 * Math.max(0, state.pains.length - 1) : 0) +
        (screen === 'numbers' && portionSrc && introPortion() ? 2500 : 0) +
        (screen === 'numbers' && proteinSrc ? 1500 : 0),
      caption,
      numbers: screen === 'numbers' ? { kcal: state.kcal || 0, protein } : null,
    };
  };

  // 1.3b: up to three mains from the top of the like ranking (the deck's order), by goal: Muskelaufbau the most
  // protein, Abnehmen the most protein per kcal, Halten as ranked. Not the recipes other slides already show
  // (obstacle background, "schmeckt nicht" montage), not what they excluded. Picked once per visit; the portions follow their kcal (±50 included) with the
  // planner's own fitPortion and the lunch share, so the numbers are what a plan would give.
  let dishPick = null;
  // A Story-Slide block "1.3b So isst du · eigenes Video" with media: that one clip instead of the recipe montage.
  const ownDishVideo = () => Boolean($('[data-vhp-story-fig="dishes_video"]'));
  const storyDishes = () => {
    if (!state.kcal) return [];
    // Pinned in the theme editor (Story-Slide "1.3b", one recipe each, optional own photo): those, in block order.
    const pinned = $$('[data-vhp-story-fig="dishes"][data-recipe][data-kcal][data-protein]');
    if (!dishPick && pinned.length) {
      dishPick = pinned.map((fig) => ({
        id: fig.dataset.recipe,
        handle: fig.dataset.recipe,
        title: fig.dataset.title || '',
        image: fig.querySelector('video')?.poster || fig.querySelector('img')?.currentSrc || fig.querySelector('img')?.src || '',
        kcal: Number(fig.dataset.kcal),
        protein: Number(fig.dataset.protein),
      }));
    }
    if (!dishPick) {
      const montage = new Set($$('[data-vhp-story-fig][data-recipe]:not([data-vhp-story-fig="dishes"])').map((el) => el.dataset.recipe));
      const pool = poolFor('main').filter(
        (card) => card.image && Number(card.kcal) > 0 && Number(card.protein) > 0 && !montage.has(card.handle)
      );
      let ranked = pool;
      try {
        if (plannerCore?.deckOrder) {
          ranked = plannerCore.deckOrder(
            { stats: planner.config.recipeStats },
            { cards: pool, seed: plannerCore.seed(state.seedKey || 'anon', 'deck'), now: Date.now(), kind: hubRules?.mainIngredient }
          ).cards;
        }
      } catch (e) {
        ranked = pool;
      }
      if (!Array.isArray(ranked) || !ranked.length) ranked = pool;
      // Prefer dishes that come out at ¾ portion or more: "½ Portion Lasagne" reads as eating half, not as the
      // promise "und trotzdem Lasagne".
      const lunchShare = EXAMPLE_OCCASIONS.find((row) => row.id === 'lunch')?.share || 0.35;
      const capNow = capForOccasions(activeOccasions());
      const big = (card) =>
        (fitPortion(card.kcal, Math.round(state.kcal * lunchShare), state.kcal, capNow) || 0) >= 0.75;
      const top10 = ranked.slice(0, 10);
      const roomy = ranked.slice(0, 30).filter(big).slice(0, 10);
      const top = roomy.length >= 3 ? roomy : top10;
      const by = {
        gain: (a, b) => Number(b.protein) - Number(a.protein),
        lose: (a, b) => Number(b.protein) / Number(b.kcal) - Number(a.protein) / Number(a.kcal),
      }[state.goal];
      const picked = by ? top.slice().sort(by) : top;
      // Different main ingredients where the rules know them.
      const seen = new Set();
      dishPick = [];
      picked.forEach((card) => {
        if (dishPick.length >= 3) return;
        const kind = hubRules?.mainIngredient ? hubRules.mainIngredient(card) : '';
        if (kind && seen.has(kind)) return;
        if (kind) seen.add(kind);
        dishPick.push(card);
      });
      if (dishPick.length && dishPick.length < 3) {
        picked.forEach((card) => {
          if (dishPick.length < 3 && !dishPick.includes(card)) dishPick.push(card);
        });
      }
    }
    const lunch = EXAMPLE_OCCASIONS.find((row) => row.id === 'lunch');
    const cap = capForOccasions(activeOccasions());
    return dishPick
      .map((card) => {
        const scale = fitPortion(card.kcal, Math.round(state.kcal * (lunch?.share || 0.35)), state.kcal, cap);
        return scale ? { card, scale, kcal: Math.round(card.kcal * scale), protein: Math.round(card.protein * scale) } : null;
      })
      .filter(Boolean);
  };

  // Planner landers (docs/PLANNER_PAGE_FUNNEL.md 2.2): no 1.3b montage (it lost 13 % of in-app visitors, five video
  // loads); one example dish sits on "Deine Zahlen" in their portion instead. One example, never "genau dieses Gericht".
  // Theme setting "Story: Folie „So isst du bei mir“ zeigen" off (2026-10-19): skipped for everyone.
  const montageSkipped = () =>
    planner.config.dishesMontage === false || (plannerLander() && !portionSrc && !proteinSrc);
  // A dish that comes out at ¾ portion or more ("½ Portion Lasagne" reads as eating half): the montage's first such
  // dish, else the best main of the deck's pool for their goal (the pinned montage dishes are big, so at low targets
  // they all land at ½), else the montage's biggest. Picked once per visit, the portion follows their kcal.
  let examplePick = null;
  const exampleDish = () => {
    if (!state.kcal) return null;
    const dishes = storyDishes();
    const lunch = EXAMPLE_OCCASIONS.find((row) => row.id === 'lunch');
    const cap = capForOccasions(activeOccasions());
    const portionOf = (card) => {
      const scale = fitPortion(Number(card.kcal), Math.round(state.kcal * (lunch?.share || 0.35)), state.kcal, cap);
      return scale ? { card, scale, kcal: Math.round(card.kcal * scale), protein: Math.round(card.protein * scale) } : null;
    };
    if (!examplePick) {
      examplePick = dishes.find((d) => d.scale >= 0.75)?.card || null;
      if (!examplePick) {
        const by = {
          gain: (a, b) => Number(b.protein) - Number(a.protein),
          lose: (a, b) => Number(b.protein) / Number(b.kcal) - Number(a.protein) / Number(a.kcal),
        }[state.goal];
        const roomy = poolFor('main')
          .filter((card) => card.image && Number(card.kcal) > 0 && Number(card.protein) > 0)
          .slice(0, 40)
          .filter((card) => (portionOf(card)?.scale || 0) >= 0.75);
        examplePick = (by ? roomy.sort(by) : roomy)[0] || null;
      }
    }
    const dish = (examplePick && portionOf(examplePick)) || dishes.slice().sort((a, b) => b.scale - a.scale)[0];
    if (!dish) return null;
    return {
      title: dish.card.title || '',
      image: dish.card.image || '',
      scale: dish.scale,
      kcal: dish.kcal,
      protein: dish.protein,
      example: true,
    };
  };

  const renderDishes = () => {
    const box = $('[data-vhp-dishes]');
    if (!box) return;
    const dishes = storyDishes();
    const key = dishes.map((d) => `${d.card.id}:${d.scale}:${d.kcal}`).join('|');
    if (box.dataset.key === key) return;
    box.dataset.key = key;
    box.replaceChildren(
      ...dishes.map((dish, i) => {
        const part = document.createElement('div');
        part.className = 'vhp-story-dish';
        part.dataset.vhpStoryPart = '';
        part.hidden = i !== 0;
        const title = document.createElement('p');
        title.className = 'vhp-story-dish__title';
        title.textContent = dish.card.title || '';
        const meta = document.createElement('p');
        meta.className = 'vhp-story-dish__meta';
        meta.textContent = tr('planner.story_dish_portion', {
          portion: fmtScale(dish.scale),
          kcal: deInt(dish.kcal),
          protein: deInt(dish.protein),
        });
        part.append(title, meta);
        return part;
      })
    );
  };

  // ---------- story v2 (docs/story-setup-v2.md) ----------

  // Deck progress: LIKE_READY slots fill with the liked dishes' photos; the line says what's left. More likes = "+n".
  const renderStoryLikes = (box) => {
    const items = likeItems();
    const n = items.length;
    const recent = items.slice(-LIKE_READY);
    const slots = box.querySelector('[data-vhp-story-likes-slots]');
    const text = box.querySelector('[data-vhp-story-likes-text]');
    const key = `${n}|${recent.map((item) => item.id).join(',')}`;
    if (slots && slots.dataset.key !== key) {
      const before = Number(slots.dataset.n || 0);
      slots.dataset.key = key;
      slots.dataset.n = String(n);
      slots.replaceChildren(
        ...Array.from({ length: LIKE_READY }, (_, i) => {
          const slot = document.createElement('span');
          slot.className = 'vhp-story-likes__slot';
          const item = recent[i];
          if (item) {
            slot.classList.add('is-on');
            if (item.image) {
              const img = document.createElement('img');
              img.src = swapThumbUrl(item.image, 96);
              img.alt = '';
              img.decoding = 'async';
              slot.append(img);
            }
            // The newest one pops in.
            if (n > before && i === recent.length - 1) slot.classList.add('is-new');
          }
          return slot;
        }),
        ...(n > LIKE_READY ? [Object.assign(document.createElement('b'), { className: 'vhp-story-likes__more', textContent: `+${n - LIKE_READY}` })] : [])
      );
    }
    if (text) {
      const ready = planReady();
      box.classList.toggle('is-ready', ready);
      text.textContent = n < LIKE_READY
        ? tr('planner.story_likes_left', { n: LIKE_READY - n })
        : ready ? tr('planner.story_likes_ready') : tr('planner.story_likes_main');
    }
  };

  // Their first name where Sören talks to them (story only), and its genitive: "Lisas" / "Max’" (de), "Lisa’s" (en).
  const storyName = () => (storyActive() ? state.name || '' : '');
  const nameGen = (name) => {
    if (!name) return '';
    if (/^de/i.test(LOCALE)) return /[sßxz]$/i.test(name) ? `${name}’` : `${name}s`;
    return /s$/i.test(name) ? `${name}’` : `${name}’s`;
  };
  const escHtml = (s) =>
    String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  // A Liquid-rendered line with a named variant: the plain text is kept in data-plain.
  const setNamed = (el, key, vars = {}) => {
    if (!el) return;
    if (el.dataset.plain == null) el.dataset.plain = el.textContent;
    const name = storyName();
    const text = name ? tr(key, { ...vars, name }) : el.dataset.plain;
    if (el.textContent !== text) el.textContent = text;
  };
  const setNamedHtml = (el, key) => {
    if (!el) return;
    if (el.dataset.plain == null) el.dataset.plain = el.innerHTML;
    const name = storyName();
    const html = name ? tr(key, { who: escHtml(nameGen(name)) }) : el.dataset.plain;
    if (el.dataset.html === html) return;
    el.dataset.html = html;
    el.innerHTML = html;
  };

  // Sören answers in the sticker of `screen` after a beat (the ✓ shows first), then the slide moves on. Without the
  // player (or off the story) it just moves on.
  let replyBeat = 0;
  const storyReply = (screen, text, { beat = 280, host = null, maxRead } = {}) => {
    window.clearTimeout(replyBeat);
    const next = () => {
      if (state.screen === screen) goNext();
    };
    if (!storyPlayer || !storyOn(screen)) {
      replyBeat = window.setTimeout(next, beat);
      return;
    }
    replyBeat = window.setTimeout(() => {
      if (state.screen !== screen) return;
      const el = host || funnel.querySelector(`[data-vhp-screen="${screen}"] .vhp-poll, [data-vhp-screen="${screen}"] .vhp-choices`);
      storyPlayer.reply(el, text, { onDone: next, maxRead });
    }, beat);
  };

  // 1.6 with something picked: "Notiert – …" in the card instead of the button, then on. "Nein, alles gut" goes
  // straight on (most pick nothing).
  const exclusionsReply = () => {
    if (state.screen !== 'exclusions' || !storyOn('exclusions') || !state.exclusions.length || !storyPlayer) return false;
    const el = funnel.querySelector('[data-vhp-screen="exclusions"]');
    if (!el) return false;
    if (el.classList.contains('is-replying')) return true;
    el.classList.add('is-replying');
    storyReply('exclusions', tr('planner.story_ex_reply'), { beat: 0, host: el.querySelector('.vhp-screen__body') });
    return true;
  };

  // Deck: Sören reacts to the first like and to the first like with 40 g protein or more per portion, twice at most.
  let likeReacts = 0;
  let likeReactProtein = false;
  const storyLikeReact = (card) => {
    if (!storyPlayer || !storyOn('swipe') || likeReacts >= 2) return;
    const protein = Math.round(Number(card?.protein) || 0);
    if (protein >= 40 && !likeReactProtein) {
      likeReactProtein = true;
      likeReacts += 1;
      storyPlayer.say(tr('planner.story_like_protein', { n: deInt(protein) }));
      return;
    }
    if (likeReacts === 0) {
      likeReacts += 1;
      storyPlayer.say(tr('planner.story_like_first'));
    }
  };

  // 3.1 summary rows (2026-10-19): a tap opens that answer while the summary is up; answering (or back) comes straight
  // back here with the week built anew (createPlan again). The running build is dropped (buildRun).
  const editFromSummary = (target) => {
    if (state.screen !== 'building' || !buildHolding || !target) return;
    step('summary_edit', target);
    clearBuildTimers();
    exampleBuilding = false;
    buildHolding = false;
    buildRelease = null;
    buildRun += 1;
    state.editFrom = 'summary';
    persist();
    show(target, null, 'fade');
  };
  const returnToSummary = () => {
    state.editFrom = null;
    persist();
    createPlan({ again: true });
  };

  // 3.1 summary: what the week is built from, their own data only.
  const exLabel = (key) => {
    const btn = $(`[data-vhp-toggle-ex="${key}"]`);
    return btn ? Array.from(btn.childNodes).filter((node) => node.nodeType === 3).map((node) => node.textContent).join('').trim() : '';
  };
  const renderHold = (box, fresh) => {
    const name = storyName();
    const title = box.querySelector('[data-vhp-hold-title]');
    if (title) title.textContent = name ? tr('planner.story_hold_title_name', { who: nameGen(name) }) : tr('planner.story_hold_title');
    // Their liked dishes as a small stack next to the title (the week is made of them).
    if (title) {
      let thumbs = box.querySelector('.vhp-hold__thumbs');
      if (!thumbs) {
        thumbs = document.createElement('div');
        thumbs.className = 'vhp-hold__thumbs';
        thumbs.setAttribute('aria-hidden', 'true');
        title.after(thumbs);
      }
      const pics = (likedImages().length ? likedImages() : dishImages(4)).slice(0, 4);
      const key = pics.join('|');
      if (thumbs.dataset.key !== key) {
        thumbs.dataset.key = key;
        thumbs.replaceChildren(
          ...pics.map((src, i) => {
            const img = document.createElement('img');
            img.src = swapThumbUrl(src, 120);
            img.alt = '';
            img.decoding = 'async';
            img.style.setProperty('--i', String(i));
            return img;
          })
        );
      }
    }
    const facts = box.querySelector('[data-vhp-hold-facts]');
    if (facts) {
      const goalBtn = goalWord() === 'easy' ? $('[data-vhp-goal-easy]') : $(`[data-vhp-set="goal:${state.goal}"]:not([data-vhp-goal-easy])`);
      const goalText = goalBtn?.querySelector('.vhp-choice__copy strong')?.textContent.trim() || '';
      const goalEmoji = goalBtn?.querySelector('.vhp-poll__emoji')?.textContent.trim() || '🎯';
      const why = state.why ? $(`[data-vhp-why="${state.why}"] [data-vhp-why-label]`)?.textContent.trim() : '';
      const protein = state.kcal ? macroGrams(state.kcal, currentSplit()).protein : 0;
      const likes = likeCount();
      const without = state.exclusions.map(exLabel).filter(Boolean);
      // Third item: the row's edit target (editFromSummary); the 30-min line has none (it lives on the answer slide).
      const rows = [
        goalText && [goalEmoji, goalText, 'goal'],
        why && ['💭', tr('planner.story_hold_why', { why }), 'why'],
        state.kcal && ['🎯', tr('planner.story_hold_numbers', { kcal: deInt(state.kcal), protein: deInt(protein) }), 'body'],
        ['❤️', likes ? tr('planner.story_hold_likes', { n: likes }) : tr('planner.story_hold_picked'), 'swipe'],
        without.length && ['🚫', tr('planner.story_hold_without', { list: without.join(', ') }), 'exclusions'],
        state.maxTime === 30 && ['⏱', tr('planner.story_hold_time'), ''],
      ].filter(Boolean);
      const key = JSON.stringify(rows);
      if (facts.dataset.key !== key) {
        facts.dataset.key = key;
        facts.replaceChildren(
          ...rows.map(([emoji, text, target], i) => {
            const li = document.createElement('li');
            li.style.setProperty('--i', String(i));
            const icon = document.createElement('span');
            icon.setAttribute('aria-hidden', 'true');
            icon.textContent = emoji;
            const copy = document.createElement('span');
            copy.textContent = text;
            if (!target) {
              li.append(icon, copy);
              return li;
            }
            // Quiet edit: the row itself is the button, a faint › at its end (2026-10-19).
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'vhp-hold__edit';
            btn.dataset.vhpHoldEdit = target;
            btn.setAttribute('aria-label', `${text}: ${tr('planner.story_hold_edit')}`);
            const chev = document.createElement('span');
            chev.className = 'vhp-hold__chev';
            chev.setAttribute('aria-hidden', 'true');
            chev.textContent = '›';
            btn.append(icon, copy, chev);
            li.append(btn);
            return li;
          })
        );
      }
    }
    const label = box.querySelector('[data-vhp-hold-label]');
    if (label && label.dataset.plain == null) label.dataset.plain = label.textContent;
    const ctl = storyPlayer?.holdToCommit(box.querySelector('[data-vhp-hold-btn]'), {
      // The card fades out, then the box shrinks smoothly to the checklist.
      onDone: () => {
        box.classList.add('is-leaving');
        window.setTimeout(() => {
          const build = $('[data-vhp-build]');
          if (storyPlayer && build) storyPlayer.morph(build, () => buildRelease?.(), { width: false, ms: 420 });
          else buildRelease?.();
          box.classList.remove('is-leaving');
        }, motionOk() ? 260 : 0);
      },
      onShort: () => {
        if (!label) return;
        label.textContent = tr('planner.story_hold_short');
        label.classList.remove('is-hint');
        void label.offsetWidth;
        label.classList.add('is-hint');
      },
    });
    if (fresh) {
      box.classList.remove('is-leaving');
      ctl?.reset();
      if (label) {
        label.textContent = label.dataset.plain;
        label.classList.remove('is-hint');
      }
    }
  };

  // The preview arrives once per page view: days stagger in, "✓ dein Ziel" stamps in. Never on the way back.
  let previewRevealed = false;
  const revealPreview = () => {
    if (previewRevealed || planner.config.paid || !state.preview?.day?.meals?.length) return;
    previewRevealed = true;
    const el = funnel.querySelector('[data-vhp-screen="preview"]');
    if (!el || !motionOk()) return;
    el.classList.add('is-reveal');
    window.setTimeout(() => el.classList.remove('is-reveal'), 2200);
  };

  // Right tap / end of a passive slide. Sören's clip opens from the paywall and goes back to it.
  const storyNext = () => {
    if (state.screen === 'numbers' || state.screen === 'dishes' || state.screen === 'answer') goNext();
    else if (state.screen === 'proof') toPlans();
  };

  // The free preview scrolled to its end (docs/PLANNER_PAGE_FUNNEL.md 0.4): a sentinel after its last block.
  let previewEndSeen = null;
  const watchPreviewEnd = () => {
    const end = funnel.querySelector('[data-vhp-pv-end]');
    if (!end || planner.config.paid || previewEndSeen || typeof IntersectionObserver !== 'function') return;
    previewEndSeen = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting) || state.screen !== 'preview') return;
      step('preview_use', 'end');
      previewEndSeen.disconnect();
    });
    previewEndSeen.observe(end);
  };
  funnel.addEventListener('vhp:render', (event) => {
    if (event.detail?.screen === 'preview') watchPreviewEnd();
  });

  // × after the first question: the "Fast geschafft" sheet first, once per page view (docs/PLANNER_PAGE_FUNNEL.md
  // 2.1; every entry since 2026-10-19, docs/UX_REVIEW.md #14: it says the answers stay). Stay keeps the slide; leave goes out as before. The first
  // question, the preview and the plans keep their plain ×.
  const EXIT_ASK_SCREENS = new Set(['why', 'body', 'activity', 'numbers', 'dishes', 'pain', 'answer', 'exclusions', 'swipe', 'empty', 'building']);
  let exitAsked = false;
  const askBeforeExit = () => {
    if (exitAsked || !EXIT_ASK_SCREENS.has(state.screen)) return false;
    const dlg = $('[data-vhp-exit-sheet]');
    if (!dlg || typeof dlg.showModal !== 'function' || dlg.open) return false;
    exitAsked = true;
    if (!dlg.dataset.wired) {
      dlg.dataset.wired = '1';
      // Esc / the phone's back on the sheet: they stay.
      dlg.addEventListener('cancel', () => step('story_exit', 'stay'));
    }
    dlg.showModal();
    return true;
  };

  // 1.4 for planner landers (docs/PLANNER_PAGE_FUNNEL.md 2.3): after a pick "Abschicken" fills like a ring and sends
  // 2.5 s later; another pick starts it again, a tap sends at once, no pick left stops it.
  // Off since 2026-10-19 (docs/UX_REVIEW.md #10): a multi-select never moves on by itself, "Abschicken" does.
  const PAIN_AUTO_SEND = false;
  const PAIN_AUTO_MS = 2500;
  let painTimer = 0;
  const schedulePainSend = () => {
    window.clearTimeout(painTimer);
    painTimer = 0;
    const btn = $('[data-vhp-pain-send]');
    btn?.classList.remove('is-auto');
    if (!PAIN_AUTO_SEND || !plannerLander() || state.screen !== 'pain' || !state.pains.length) return;
    if (btn) {
      btn.style.setProperty('--auto-ms', `${PAIN_AUTO_MS}ms`);
      void btn.offsetWidth; // restart the fill
      btn.classList.add('is-auto');
    }
    painTimer = window.setTimeout(() => {
      painTimer = 0;
      $('[data-vhp-pain-send]')?.classList.remove('is-auto');
      if (state.screen === 'pain' && state.pains.length) goNext();
    }, PAIN_AUTO_MS);
  };

  // The week-mail module is attached at boot, after the render helpers: null until then.
  const weekMailApi = () => {
    try {
      return weekMail;
    } catch (e) {
      return null;
    }
  };

  // ---------- "Weiter in Safari / Chrome" (docs/PLANNER_PAGE_FUNNEL.md 4.3; theme setting, off by default) ----------
  // Instagram's in-app browser often can't offer Apple Pay / Google Pay. On the plans, in-app visitors can move their
  // week to the phone's browser: a 2-day draft (the API's handoff route, no address), opened there with ?week=…&pay=1,
  // which plans the same week again and opens the plans. If nothing opens, the way by hand and the link to copy.
  const PAGE_UA = navigator.userAgent || '';
  const IN_APP_UA = /Instagram|FBAN|FBAV|FB_IAB|TikTok|musical_ly/i.test(PAGE_UA);
  const HANDOFF_OS = /iPhone|iPad|iPod/i.test(PAGE_UA) ? 'ios' : /Android/i.test(PAGE_UA) ? 'android' : '';
  const handoffArrival = new URLSearchParams(location.search).get('pay') === '1';
  const dropPayParam = () => {
    const url = new URL(location.href);
    if (!url.searchParams.has('pay')) return;
    url.searchParams.delete('pay');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  };
  const handoffOn = () =>
    planner.config.safariHandoff === true && IN_APP_UA && Boolean(HANDOFF_OS) && weekDraftReady();
  let handoffUrl = '';
  let handoffBusy = false;
  let handoffShown = false;
  const startHandoff = async () => {
    if (handoffBusy) return;
    step('pay_handoff', 'tap');
    const help = $('[data-vhp-handoff-help]');
    if (!handoffUrl) {
      const payload = weekMailPayload();
      if (!payload) return;
      handoffBusy = true;
      try {
        const res = await fetch(`${planner.config.apiBase}/api/week-draft/handoff`, {
          method: 'POST',
          credentials: 'omit',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify({ draft: payload.draft }),
        });
        const body = res.ok ? await res.json() : null;
        if (!body?.token) throw new Error(String(res.status));
        handoffUrl = `${location.origin}/pages/meal-planner?week=${encodeURIComponent(body.token)}&pay=1`;
      } catch (e) {
        weekMailApi()?.toast(tr('planner.handoff_err'));
        return;
      } finally {
        handoffBusy = false;
      }
    }
    const bare = handoffUrl.replace(/^https?:\/\//, '');
    const target =
      HANDOFF_OS === 'ios'
        ? `x-safari-https://${bare}`
        : `intent://${bare}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(handoffUrl)};end`;
    window.setTimeout(() => {
      if (help && document.visibilityState === 'visible') help.hidden = false;
    }, 1500);
    location.href = target;
  };
  const copyHandoff = async (btn) => {
    if (!handoffUrl) return;
    step('pay_handoff', 'copy');
    try {
      await navigator.clipboard.writeText(handoffUrl);
      if (btn) btn.textContent = tr('planner.handoff_copied');
    } catch (e) {
      window.prompt('', handoffUrl);
    }
  };

  // × in the story header: out of the planner (state stays; the Plan tab's dot brings them back).
  const closeStory = () => {
    step('story_closed', state.screen);
    // The discount gift and Sören's clip sit between the preview and the plans: × goes on to the plans, not out.
    if (state.screen === 'proof' || (state.screen === 'gift' && giftIsReward())) {
      toPlans();
      return;
    }
    if (askBeforeExit()) return;
    leavePlanner();
  };

  // Leaving the preview or the plans with a week that isn't saved yet: "Soll ich dir deine Woche schicken?" comes up
  // once (assets/vhp-planner-weekmail.js), then they leave as they wanted to.
  const leavePlanner = () => {
    if ((state.screen === 'preview' || state.screen === 'subscribe') && weekMail?.offerOnExit(leavePlannerNow)) return;
    leavePlannerNow();
  };

  // Out of the planner (state stays): back to the page they came from on this site, else the feed. Never back into
  // Shopify's login, which sits behind the planner after a left checkout (the referrer is then the planner itself).
  const leavePlannerNow = () => {
    window.vhpPlannerEvents?.flush?.();
    let sameSite = false;
    try {
      const from = document.referrer ? new URL(document.referrer) : null;
      sameSite = Boolean(from) && from.origin === location.origin && from.pathname !== location.pathname;
    } catch (e) {
      sameSite = false;
    }
    // Past the extra entry the story keeps for the back button (syncStoryBack) too.
    const steps = history.state?.vhpStoryBack ? 2 : 1;
    if (sameSite && history.length > steps) history.go(-steps);
    else location.href = '/';
  };

  // ---------- "Schick mir meine Woche" (assets/vhp-planner-weekmail.js, docs/HOMEPAGE_FUNNEL.md 5) ----------
  // A week can be saved once the free preview has its day: with the section setting on (week_mail), not with the
  // preview switched off, not for subscribers.
  // The preview's week as a draft (a goal, a target and the open day's meals): what the mail and the Safari handoff
  // (docs/PLANNER_PAGE_FUNNEL.md 4.3) store.
  const weekDraftReady = () =>
    !planner.config.paid &&
    !gated() &&
    Boolean(state.goal && state.kcal) &&
    Boolean(state.preview?.week?.[Number(state.preview.open) || 0]?.meals?.length);
  const weekSavable = () => planner.config.weekMail === true && weekDraftReady();

  // Likes and skips as ids (the newest 100 each): the device that opens the link takes title and photo from the catalog.
  const savedSwipes = (items) =>
    (items || [])
      .map((item) => ({
        id: productId(item?.id),
        slot: item?.slot,
        at: Number.isFinite(Date.parse(item?.at || '')) ? new Date(item.at).toISOString() : null,
      }))
      .filter((row) => /^\d+$/.test(row.id) && SLOT_ORDER.includes(row.slot))
      .slice(-100);

  // What the preview is planned from (never body data) and its open day for mail 1 (recipe ids + portions; the mail
  // takes titles, photos and numbers from Shopify).
  // The plan inputs as a draft (mail 1, the Safari handoff, the guest buy tap).
  const draftFields = () => ({
    goal: state.goal,
    kcal: Math.round(Number(state.kcal)),
    macros: currentSplit(),
    exclusions: [...new Set(state.exclusions)],
    maxTime: state.maxTime === 15 || state.maxTime === 30 ? state.maxTime : null,
    likes: savedSwipes(likeItems()),
    skips: savedSwipes(state.skips?.items),
    seed: state.seedKey,
    gift: Number.isFinite(Date.parse(state.reward?.at || '')) ? new Date(state.reward.at).toISOString() : null,
  });

  const weekMailPayload = () => {
    if (!weekDraftReady()) return null;
    const preview = state.preview;
    const open = Number(preview.open) || 0;
    const meals = (preview.week[open].meals || [])
      .filter((meal) => EXAMPLE_OCCASIONS.some((row) => row.id === meal?.id) && /^\d+$/.test(productId(meal?.pick?.id)))
      .map((meal) => ({ occasion: meal.id, id: productId(meal.pick.id), scale: Number(meal.scale) }));
    if (!meals.length || !ISO_DAY_RE.test(String(preview.start || ''))) return null;
    return {
      draft: draftFields(),
      day: { start: preview.start, open, meals: meals.slice(0, EXAMPLE_OCCASIONS.length) },
    };
  };

  // A saved draft on this browser: its plan inputs (the kcal as a set target: the body inputs behind it stayed on the
  // other device), likes and skips merged with this browser's, its seed and the gift's start. Likes come back by id,
  // with title and photo from the planner index (a like that left the catalog stays out). The preview is then planned
  // again (openPreview): same seed and inputs, same week. false = the catalog didn't load (the link stays for a reload).
  const applyWeekDraft = async (draft) => {
    const rows = Array.isArray(draft?.likes) ? draft.likes : [];
    const slots = [...new Set(['main', ...rows.map((row) => row.slot)])].filter((slot) => SLOT_ORDER.includes(slot));
    const lists = await Promise.allSettled(slots.map((slot) => planner.index(slot)));
    if (lists[0].status !== 'fulfilled') return false;
    const cards = new Map();
    lists.forEach((list) => {
      if (list.status === 'fulfilled') list.value.forEach((card) => cards.set(String(card.id), card));
    });
    const liked = rows
      .map((row) => (cards.has(row.id) ? normalizeLikeItem({ ...cards.get(row.id), slot: row.slot, at: row.at }) : null))
      .filter(Boolean);
    const own = likeItems().filter((item) => !liked.some((row) => row.id === item.id));
    const byAt = (a, b) => (Date.parse(a.at || '') || 0) - (Date.parse(b.at || '') || 0);
    state.likes = { v: LIKES_VERSION, items: [...liked, ...own].sort(byAt) };
    const likedIds = new Set(state.likes.items.map((item) => item.id));
    state.skips = { v: LIKES_VERSION, items: mergeSkips(draft.skips, state.skips?.items, likedIds) };
    state.goal = draft.goal;
    state.kcal = draft.kcal;
    state.kcalManual = true;
    state.macros = normalizeSplit(draft.macros);
    state.macrosPreset = presetIdFor(state.macros, 'custom');
    state.exclusions = (draft.exclusions || []).filter((key) => EXCLUSIONS[key]);
    state.maxTime = draft.maxTime === 15 || draft.maxTime === 30 ? draft.maxTime : null;
    if (SEED_RE.test(String(draft.seed || ''))) state.seedKey = draft.seed;
    if (!state.reward && Number.isFinite(Date.parse(draft.gift || ''))) {
      state.reward = { at: draft.gift };
      state.scratched = true;
      saveGiftBanner();
    }
    Object.assign(state, { screen: 'preview', slot: null, history: [], preview: null, editFrom: null, swap: null });
    persist();
    shareExclusions();
    return true;
  };

  // The link from mail 1 (?week=<token>): the preview says "planning" until the draft is applied (boot), then it is
  // planned like on the other device. An expired link puts back what this browser had and says so.
  const restoreWeek = async (token, before) => {
    const found = await weekMail.fetchDraft(token);
    let applied = false;
    if (found.draft) {
      try {
        applied = await applyWeekDraft(found.draft);
      } catch (e) {
        console.error('[vhp-planner] restoring the saved week failed', e);
      }
    }
    exampleBuilding = false;
    if (applied) {
      weekMail.dropLink();
      step('week_restored', 'ok');
      // Handed over from Instagram's browser to pay here (?pay=1, 4.3): the same week, then straight to the plans.
      if (handoffArrival) {
        dropPayParam();
        step('pay_handoff', 'ok');
        weekMail.toast(tr('planner.handoff_back'));
        await openPreview();
        if (state.screen === 'preview') continueToSubscribe('other');
        return;
      }
      weekMail.toast(tr('planner.weekmail_back'));
      openPreview();
      return;
    }
    Object.assign(state, before);
    if (found.gone) {
      weekMail.dropLink();
      step('week_restored', 'gone');
    }
    // Nothing came back and this browser starts the setup: the new start the boot left out for the link.
    if (state.screen === 'goal' && !state.goal && !state.editFrom) step('planner_new');
    weekMail.toast(tr(found.gone ? 'planner.weekmail_gone' : 'planner.weekmail_restore_err'));
    render();
    if (state.screen === 'preview') openPreview();
  };

  // The order mail's link after a guest checkout on another device (docs/GUEST_CHECKOUT.md): ?week=<the buy tap's
  // draft> in an account without a setup (none in this browser, none saved) sets it up from those answers (the
  // consent given in the checkout dialog included) and plans the week, as on the device they bought on.
  const restorePaidSetup = async (token) => {
    const found = await weekMail.fetchDraft(token);
    if (!found.draft) {
      if (found.gone) step('paid_restore', 'gone');
      return;
    }
    if (state.goal) return;
    let applied = false;
    try {
      applied = await applyWeekDraft(found.draft);
    } catch (e) {
      console.error('[vhp-planner] restoring the setup failed', e);
    }
    if (!applied) {
      render();
      return;
    }
    const at = Date.parse(found.draft.consentAt || '');
    state.consentPlanner = true;
    state.consentAt = Number.isFinite(at) ? new Date(at).toISOString() : new Date().toISOString();
    state.pendingFlush = true;
    Object.assign(state, { screen: 'week', history: [] });
    persist();
    step('paid_restore', 'ok');
    flushProfile();
    openWeek();
  };

  // Story v2: the gift as a pill on the other webapp pages (snippets/app-gift-banner.liquid) until its real deadline.
  // Only with a deadline; gone for subscribers.
  const GIFT_KEY = 'vhp_planner_gift';
  const saveGiftBanner = () => {
    const at = Date.parse(state.reward?.at || '');
    if (!REWARD_CFG?.hours || !Number.isFinite(at)) return;
    try {
      localStorage.setItem(GIFT_KEY, JSON.stringify({
        until: at + REWARD_CFG.hours * 3600000,
        off: REWARD_CFG.off,
        plan: REWARD_CFG.plans.length === 1 ? REWARD_CFG.plans[0] : 'any',
      }));
    } catch (e) {
      /* private mode: no pill */
    }
  };

  // The discount gift lands on the plans themselves (2026-10-17: the scratch card between the buy tap and the price
  // is gone, one screen and two price numbers less). The offer runs from here; the struck price drops to the gifted
  // one. scratch_done keeps counting the gift's start. The second-day gift (no discount set up) keeps its card.
  const grantGift = () => {
    if (!(giftReady() && giftIsReward())) return;
    state.reward = { at: new Date().toISOString() };
    saveGiftBanner();
    state.scratched = true;
    step('scratch_done');
    priceDrop = true;
    persist();
  };

  const scratchDone = () => {
    if (state.scratched) return;
    if (giftIsReward()) {
      state.reward = { at: new Date().toISOString() };
      saveGiftBanner();
    }
    state.scratched = true;
    step('scratch_done');
    persist();
    render();
  };

  // The discount ticket under the foil: "−20 %" + what it's on + how long it runs.
  const rewardWhat = () => {
    if (!REWARD_CFG.firstPaymentOnly) return tr('planner.story_reward_ongoing');
    if (REWARD_CFG.plans.length === 1) return tr(REWARD_CFG.plans[0] === 'year' ? 'planner.story_reward_year' : 'planner.story_reward_month');
    return tr('planner.story_reward_first');
  };
  const renderRewardGift = (box) => {
    if (box.dataset.key !== 'reward') {
      box.dataset.key = 'reward';
      const ticket = document.createElement('div');
      ticket.className = 'vhp-gift__ticket';
      const off = document.createElement('p');
      off.className = 'vhp-gift__off';
      off.textContent = `−${REWARD_CFG.off} %`;
      const what = document.createElement('p');
      what.className = 'vhp-gift__what';
      what.textContent = rewardWhat();
      // No code on the ticket: checkout applies it, and a visible code only gets shared.
      ticket.append(off, what);
      box.replaceChildren(ticket);
    }
    const line = $('[data-vhp-gift-line]');
    if (line) {
      const offer = rewardOffer();
      line.hidden = !state.scratched;
      // In euros, on the plan it covers (yearly first): the percent alone has no anchor before the prices.
      const plan = ['year', 'month']
        .filter((interval) => REWARD_CFG.plans.includes(interval))
        .map((interval) => membershipPlans().find((p) => p.interval === interval))
        .find((p) => Number(p?.price) > 0);
      const parts = [];
      if (plan) {
        const was = Number(plan.price);
        parts.push(
          tr('planner.story_reward_price', {
            plan: plan.interval === 'year' ? tr('planner.plan_year') : tr('planner.plan_month'),
            now: money(Math.round((was * (100 - REWARD_CFG.off)) / 100)),
            was: money(was),
            first: REWARD_CFG.firstPaymentOnly ? ` ${plan.interval === 'year' ? tr('planner.first_year') : tr('planner.first_month')}` : '',
          })
        );
      }
      if (offer && offer.timer) {
        const when = offer.until.toLocaleString(LOCALE, { weekday: 'short', day: 'numeric', month: 'numeric', hour: '2-digit', minute: '2-digit' });
        parts.push(tr('planner.story_reward_until', { when }));
      }
      line.textContent = parts.join(' · ');
    }
  };

  const renderGift = () => {
    const box = $('[data-vhp-gift-day]');
    const sub = $('[data-vhp-gift-sub]');
    if (box && giftIsReward()) {
      if (sub) {
        sub.textContent = REWARD_CFG.hours
          ? tr('planner.story_reward_sub_hours', { h: String(REWARD_CFG.hours) })
          : tr('planner.story_reward_sub');
      }
      renderRewardGift(box);
    }
    const bonus = bonusDay();
    if (!box || (!bonus && !giftIsReward())) return;
    if (giftIsReward()) {
      renderGiftChrome();
      return;
    }
    const monday = ISO_DAY_RE.test(String(state.preview?.start || '')) ? dateOfIso(state.preview.start) : weekMonday();
    const dayName = PREVIEW_DAYS[bonus.index];
    const key = `${state.preview?.key}|${bonus.index}`;
    if (box.dataset.key !== key) {
      box.dataset.key = key;
      const when = document.createElement('p');
      when.className = 'vhp-gift__when';
      when.textContent = `${dayName}, ${dayMonth(addDays(monday, bonus.index))}`;
      const grid = document.createElement('div');
      grid.className = 'vhp-gift__grid';
      bonus.meals.slice(0, 4).forEach((meal) => {
        const fig = document.createElement('figure');
        if (meal.pick.image) {
          const img = document.createElement('img');
          img.src = swapThumbUrl(meal.pick.image, 360);
          img.alt = '';
          img.decoding = 'async';
          fig.append(img);
        }
        const cap = document.createElement('figcaption');
        const title = document.createElement('strong');
        title.textContent = meal.pick.title || '';
        const portion = document.createElement('span');
        portion.textContent = `${fmtScaleShort(meal.scale)} · ${deInt(meal.protein)} g Protein`;
        cap.append(title, portion);
        fig.append(cap);
        grid.append(fig);
      });
      box.replaceChildren(when, grid);
    }
    const line = $('[data-vhp-gift-line]');
    if (line) {
      // ✓ only when the day is on target (same rule as the preview's total line).
      const want = Number(state.preview?.target) || state.kcal || 0;
      const kcal = Number(bonus.totals?.kcal) || 0;
      const protein = Number(bonus.totals?.protein) || 0;
      const goalProtein = macroGrams(want, currentSplit()).protein;
      const onTarget =
        want > 0 && Math.abs(kcal - want) / want <= DAY_TOL && goalProtein > 0 && protein >= goalProtein * 0.95;
      line.hidden = !state.scratched;
      line.textContent = `${tr('planner.story_gift_day', { day: dayName, kcal: deInt(kcal), protein: deInt(protein) })}${onTarget ? ' ✓' : ''}`;
    }
    renderGiftChrome();
  };

  // Reveal button, foil and "Zu meiner Woche" (both gift kinds).
  const renderGiftChrome = () => {
    const card = $('[data-vhp-gift]');
    if (card) {
      const holo = giftIsReward() && state.scratched;
      card.classList.toggle('is-holo', holo);
      if (holo) storyPlayer?.holo(card);
    }
    const done = $('[data-vhp-gift-done]');
    if (done) {
      done.hidden = !state.scratched;
      // The discount leads to the plans, the second day to the preview.
      if (giftIsReward()) done.textContent = `${tr('planner.story_reward_done')} →`;
    }
    const revealBtn = $('[data-vhp-gift-reveal]');
    if (revealBtn) revealBtn.hidden = state.scratched;
    const canvas = $('[data-vhp-gift-foil]');
    if (canvas) {
      canvas.classList.toggle('is-gone', state.scratched);
      if (!state.scratched && !canvas.dataset.ready && storyPlayer) {
        // Sized once the screen is laid out.
        requestAnimationFrame(() => {
          if (state.screen === 'gift' && !state.scratched) giftFoil = storyPlayer.foil(canvas, { onDone: scratchDone }) || giftFoil;
        });
      }
    }
  };

  // The skin paywall's second DM bubble (renderSkin): their obstacle's promise; the source's own on protein /
  // portion links; the counting one when a tapped lock already answers that obstacle in the first bubble.
  const pwPromiseKey = () => {
    if (portionSrc) return 'portion';
    if (proteinSrc && state.kcal && macroGrams(state.kcal, currentSplit()).protein) return 'protein';
    const ctx = PW_CTX[pwCtx?.key];
    if (!proteinSrc && ctx?.pain && ctx.pain === state.pain) return 'count';
    return PAINS.includes(state.pain) ? state.pain : 'count';
  };
  // The perk each promise already says (it is not listed again under the DM).
  const PROMISE_PERK = { count: 'goal', cook: 'week', time: 'list', taste: 'swap', family: 'family', protein: 'goal', portion: 'goal' };

  // Paywall in the story arm: their obstacle repeated, the line that answers it first.
  const renderPainPerks = () => {
    const list = $('[data-vhp-pw-perks]');
    if (!list) return;
    const pain = storyActive() ? state.pain : null;
    // Their obstacle's answer first, and always the new week every Monday (what makes it a subscription).
    let order = [...(PAIN_PERKS[pain] || PAIN_PERKS.count)];
    if (!order.includes('week')) order.push('week');
    // Came from a locked control: its perk first (marked once), still at most four lines, "Jeden Montag" kept last.
    const ctxPerk = PW_CTX[pwCtx?.key]?.perk || '';
    if (ctxPerk) {
      const rest = order.filter((key) => key !== ctxPerk && key !== 'week');
      order = ctxPerk === 'week'
        ? ['week', ...rest.slice(0, PERKS_MAX - 1)]
        : [ctxPerk, ...rest.slice(0, PERKS_MAX - 2), 'week'];
    }
    // Skin paywall: Sören's promise bubble already says one perk (2026-10-19: the first perk was always the
    // promise again); the list keeps the others, three at least.
    if (storyActive() && !planner.config.paid) {
      const said = PROMISE_PERK[pwPromiseKey()];
      if (said && said !== ctxPerk) {
        order = order.filter((key) => key !== said);
        ['goal', 'list', 'swap', 'week'].forEach((key) => {
          if (order.length < 3 && key !== said && !order.includes(key)) order.push(key);
        });
      }
    }
    const items = Array.from(list.querySelectorAll('[data-vhp-perk]'));
    items.forEach((li) => {
      li.hidden = !order.includes(li.dataset.vhpPerk);
      li.classList.toggle('is-ctx', li.dataset.vhpPerk === ctxPerk);
    });
    order.forEach((key) => {
      const li = items.find((el) => el.dataset.vhpPerk === key);
      if (li) list.append(li);
    });
    // Story v2: their reason in their own words, and the title with their name.
    const whyEl = $('[data-vhp-pw-why]');
    if (whyEl) {
      const why = storyActive() ? state.why : null;
      const label = why ? $(`[data-vhp-why="${why}"] [data-vhp-why-label]`)?.textContent.trim() : '';
      whyEl.hidden = !label;
      whyEl.textContent = label ? tr('planner.story_why_said', { why: label }) : '';
    }
    setNamedHtml($('[data-vhp-pw-title]'), 'planner.story_title_ready_html');
    const said = $('[data-vhp-pw-said]');
    if (said) {
      const label = pain ? $(`[data-vhp-pain="${pain}"] [data-vhp-pain-label]`)?.textContent.trim() : '';
      said.hidden = !label;
      // "Kalorien zählen." alone doesn't say it was the problem; the other answers read as a quote already.
      said.textContent = !label ? '' : pain === 'count' ? tr('planner.story_said_count') : tr('planner.story_said', { pain: label });
    }
  };

  let deckHintShown = false;
  // While the story's deck hint is up, the deck's own swipe hint (hand) waits, so the first card has one message.
  let deckHintActive = false;
  // Story polls with a default value (sex, activity) show it as picked only once tapped in this visit.
  const storyVoted = new Set();
  const renderStory = (screen) => {
    const on = storyOn(screen);
    if (on && screen !== 'empty') step('story_seen', screen);
    // Goal poll: no shares (Maxim 2026-10-15: seeing what others picked can put people off); the pick gets a ✓.
    const goalGroup = funnel.querySelector('[data-vhp-screen="goal"] .vhp-choices');
    if (goalGroup) goalGroup.classList.toggle('is-picked', on && Boolean(state.goal));
    // Deck: three slots for the likes towards a week (their dish photos), not the weekday strip.
    const likesBox = $('[data-vhp-story-likes]');
    if (likesBox) {
      const show = on && screen === 'swipe' && !state.swap;
      likesBox.hidden = !show;
      if (show) renderStoryLikes(likesBox);
    }
    // 1.3b clips load while the slides before it play.
    if (on && (screen === 'activity' || screen === 'numbers') && !montageSkipped()) storyPlayer?.warm(ownDishVideo() ? 'dishes_video' : 'dishes');
    const painFull = state.pains.length >= PAIN_MAX;
    $$('[data-vhp-pain]').forEach((btn) => {
      const isOn = state.pains.includes(btn.dataset.vhpPain);
      btn.classList.toggle('is-on', isOn);
      btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
      btn.setAttribute('aria-disabled', painFull && !isOn ? 'true' : 'false');
    });
    const painPoll = funnel.querySelector('[data-vhp-screen="pain"] .vhp-poll');
    painPoll?.classList.toggle('is-voted', Boolean(state.pain));
    painPoll?.classList.toggle('is-full', painFull);
    // There from the start, dimmed until a pick: the options don't move when it appears (docs/UX_REVIEW.md #12).
    const painSend = $('[data-vhp-pain-send]');
    if (painSend) {
      painSend.hidden = false;
      painSend.disabled = !state.pains.length;
    }
    ['sex', 'activity'].forEach((key) => {
      funnel.querySelector(`[data-vhp-screen="${key}"] .vhp-poll`)?.classList.toggle('is-voted', storyVoted.has(key));
    });
    $('[data-vhp-sex-tags]')?.classList.toggle('is-voted', storyVoted.has('sex'));
    const timeBtn = $('[data-vhp-story-time]');
    if (timeBtn) {
      timeBtn.hidden = !state.pains.includes('time');
      const timeOn = state.maxTime != null;
      timeBtn.classList.toggle('is-on', timeOn);
      timeBtn.setAttribute('aria-pressed', timeOn ? 'true' : 'false');
    }
    // 1.1 is the same for everyone now: no large Sören over a likes collage.
    const founder = $('[data-vhp-story-founder]');
    if (founder) founder.hidden = true;
    // 1.6 skips the cook-time row when 1.5 already asked it (obstacle "Zeit").
    if (on) funnel.dataset.storyPain = state.pains.join(' ');
    else delete funnel.dataset.storyPain;
    // 1.3 with protein first for those who came for it (assets/vhp-planner-story.css).
    funnel.classList.toggle('is-protein-src', on && proteinSrc);
    // Her numbers as one quiet line under "Passt. Deine Portionen sind gerechnet." (PERSONA_ATTACK_PLAN.md 1.5); big
    // only for Muskelaufbau, who wants them, and for the protein link, which came for the number.
    funnel.classList.toggle('is-calm-numbers', on && !proteinSrc && state.goal !== 'gain');
    // 3.1 in their numbers (and with their name, story v2).
    const buildKicker = $('[data-vhp-build-kicker]');
    if (buildKicker) {
      const name = storyName();
      const n = String(likeCount());
      // One like reads "aus deinem Lieblingsgericht", not "aus deinen 1 Lieblingsgerichten" (PERSONA_ATTACK_PLAN.md 2.10).
      const one = likeCount() === 1 ? '_one' : '';
      if (name) {
        buildKicker.textContent = likeCount()
          ? tr(`planner.story_planning_likes_name${one}`, { n, name })
          : tr('planner.story_planning_name', { name });
      } else {
        buildKicker.textContent = likeCount() ? tr(`planner.story_planning_likes${one}`, { n }) : tr('planner.story_planning');
      }
    }
    // Story v2, 1.1b: the reasons for their goal in that goal's order (moved only when the goal changes), ✓ on theirs.
    const whyPoll = $('[data-vhp-why-poll]');
    if (whyPoll) {
      const list = WHY_BY_GOAL[state.goal] || WHY_BY_GOAL.lose;
      if (whyPoll.dataset.goal !== String(state.goal)) {
        whyPoll.dataset.goal = String(state.goal);
        const tail = whyPoll.querySelector(':scope > .vhp-story-reply');
        list.forEach((key) => {
          const btn = whyPoll.querySelector(`[data-vhp-why="${key}"]`);
          if (btn) whyPoll.insertBefore(btn, tail);
        });
      }
      $$('[data-vhp-why]').forEach((btn) => {
        const key = btn.dataset.vhpWhy;
        btn.hidden = !list.includes(key);
        const isOn = state.why === key;
        btn.classList.toggle('is-on', isOn);
        btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
      });
      whyPoll.classList.toggle('is-voted', Boolean(state.why));
    }
    // Story v2: their first name (field, greeting, "Lisa, dein Tag:", the gift).
    const nameInput = $('[data-vhp-name]');
    if (nameInput && document.activeElement !== nameInput) nameInput.value = state.name || '';
    const bodyKicker = $('[data-vhp-body-kicker]');
    const greeted = bodyKicker?.dataset.plain != null && bodyKicker.textContent !== bodyKicker.dataset.plain;
    setNamed(bodyKicker, 'planner.story_body_kicker_name');
    if (bodyKicker && on && screen === 'body' && !greeted && storyName()) {
      bodyKicker.classList.remove('is-greeted');
      void bodyKicker.offsetWidth;
      bodyKicker.classList.add('is-greeted');
    }
    setNamed($('[data-vhp-num-kicker]'), 'planner.story_numbers_kicker_name');
    if (giftIsReward()) setNamed($('[data-vhp-gift-title]'), 'planner.story_gift_title_name');
    // 1.5: a real voice on the answer to their obstacle, when one names it.
    $$('[data-vhp-story-quote]').forEach((el) => {
      el.hidden = el.dataset.vhpStoryQuote !== state.pain;
    });
    // 1.6: the reply took the button's place; gone once they're elsewhere.
    if (screen !== 'exclusions') funnel.querySelector('[data-vhp-screen="exclusions"]')?.classList.remove('is-replying');
    // 3.1: summary + "Gedrückt halten" until it's held, then the checklist.
    const holdBox = $('[data-vhp-hold]');
    const buildBox = $('[data-vhp-build]');
    if (holdBox && buildBox) {
      const showHold = on && screen === 'building' && buildHolding;
      const fresh = showHold && holdBox.hidden;
      holdBox.hidden = !showHold;
      buildBox.classList.toggle('is-hold', showHold);
      buildBox.classList.toggle('is-built', on && screen === 'building' && !buildHolding);
      if (showHold) renderHold(holdBox, fresh);
    }
    // Ch. 2: the first deck card of a visit says what the swipes are for (3.5 s).
    const deckHint = $('[data-vhp-deck-hint]');
    if (deckHint && storyActive() && screen === 'swipe' && !deckHintShown && !planner.config.paid) {
      deckHintShown = true;
      deckHintActive = true;
      // Obstacle "cook" (deciding is the problem): point them to "Überspringen, ich wähle für dich aus".
      deckHint.textContent = tr(state.pains.includes('cook') ? 'planner.story_deck_hint_cook' : 'planner.story_deck_hint');
      deckHint.classList.remove('is-gone');
      $('[data-vhp-swipe-hint]')?.setAttribute('hidden', '');
      // After the chapter turn, so the 3.5 s aren't spent half off-screen; then the hand hint takes over.
      window.setTimeout(() => {
        deckHint.hidden = false;
        window.setTimeout(() => {
          deckHint.classList.add('is-gone');
          window.setTimeout(() => {
            deckHint.hidden = true;
            deckHintActive = false;
            if (state.screen === 'swipe') render();
          }, 400);
        }, 3500);
      }, CUBE_MS + 80);
    }
    // 1.3: where the number comes from (their burn, then the goal), so "ausgerechnet" is visible.
    const basis = $('[data-vhp-num-basis]');
    if (basis && screen === 'numbers') {
      const need = maintenanceKcal();
      const diff = need && state.kcal ? state.kcal - need : 0;
      basis.hidden = !need;
      if (need) {
        // Abnehmen says what keeps it safe: never under the basal rate (LOSE), or no deficit at all for a slim body.
        const lose = state.goal === 'lose' && !state.kcalManual;
        const bmr = basalKcal();
        if (Math.abs(diff) < 30) {
          const hold = lose && loseMode() === 'hold';
          basis.textContent = tr(hold ? 'planner.story_basis_hold' : 'planner.story_basis_same', { need: deInt(need) });
          // "Genau dein Bedarf" is already Sören's line under it (story_numbers_maintain): once is enough (Maxim 2026-10-30).
          if (!hold) basis.hidden = true;
        } else if (diff < 0 && lose && bmr && state.kcal >= bmr) {
          basis.textContent = tr('planner.story_basis_lose', { need: deInt(need), diff: deInt(-diff), bmr: deInt(Math.round(bmr / 10) * 10) });
        } else {
          basis.textContent = tr(diff < 0 ? 'planner.story_basis_less' : 'planner.story_basis_more', { need: deInt(need), diff: deInt(Math.abs(diff)) });
        }
      }
    }
    // ?src=bio (docs/PLANNER_PAGE_FUNNEL.md 1.3): the bio promises free recipes, so the Ziel slide offers them too.
    const recipesLink = $('[data-vhp-goal-recipes]');
    if (recipesLink) recipesLink.hidden = !(screen === 'goal' && srcParam === 'bio' && !planner.config.paid);
    // 1.3 for ?src=portion: their portion of the recipe they came from, under the day's numbers. Planner landers: one
    // example dish in their portion instead of the montage after it (docs/PLANNER_PAGE_FUNNEL.md 2.2).
    const portionBox = $('[data-vhp-num-portion]');
    if (portionBox && screen === 'numbers') {
      const portion = portionSrc ? introPortion() : montageSkipped() ? exampleDish() : null;
      portionBox.hidden = !portion;
      const kicker = portionBox.querySelector('[data-vhp-num-portion-kicker]');
      if (kicker) kicker.hidden = !portion?.example;
      if (portion) {
        portionBox.querySelector('[data-vhp-num-portion-title]').textContent = portion.title;
        portionBox.querySelector('[data-vhp-num-portion-amount]').textContent = fmtScale(portion.scale);
        portionBox.querySelector('[data-vhp-num-portion-kcal]').textContent = deInt(portion.kcal);
        portionBox.querySelector('[data-vhp-num-portion-protein]').textContent = `${deInt(portion.protein)} g`;
        const img = portionBox.querySelector('[data-vhp-num-portion-img]');
        if (img) {
          img.hidden = !portion.image;
          if (portion.image) img.src = portion.image;
        }
      }
    }
    if (screen === 'dishes') renderDishes();
    if (screen === 'monday') renderMonday();
    if (screen === 'soeren') renderSoeren();
    if (screen === 'gift') renderGift();
    if (screen === 'subscribe') renderPainPerks();
    storyPlayer?.render(on ? storyView(screen) : null);
    syncStoryBack(on);
    renderSkin(screen);
  };

  // ---------- story skin for the preview and the paywall (docs/story-setup-v2.md, round 3) ----------

  // Same frame as the story (dark, Sören's header instead of the app bar), his DM instead of headings and grey copy,
  // the content as white stickers that come in one after another (assets/vhp-planner-story.css). Not a story slide:
  // these screens scroll, the plans need clarity, every lock still opens the paywall.
  const SKIN_SCREENS = new Set(['preview', 'subscribe', 'monday', 'soeren']);
  // Sören's DM thread, shared with the planner (assets/vhp-ui-story.js dm), his face from the skin header.
  const paintDm = (el, lines) => window.vhpUi?.dm(el, lines, { face: $('.vhp-skin-head .vhp-story__avatar') });

  // ---------- the planner landers' first screen (docs/FIRST_SCREEN.md 9.8) ----------

  // Static: three dishes, two chips, seven ticked days, the headline, the button, the links row (the section renders it
  // all, the early paint shows it before the scripts). Here only the step.
  let mondaySeen = false;
  let mondayShownAt = 0;
  let mondayDwellSent = false;
  const renderMonday = () => {
    if (!$('[data-vhp-screen="monday"]')) return;
    if (!mondaySeen) {
      mondaySeen = true;
      mondayShownAt = performance.now();
      step('monday', 'seen');
    }

  };
  // How long the week screen stood (2026-11-03, the ~65 % first-screen loss: never read it or read it and left): from
  // monday seen to the button (go), the × (close), a link out of it (link) or the page hidden while still on it (left),
  // bucketed lt3 / 3_10 / 10_30 / 30p. Once per page view.
  const mondayDwell = (how) => {
    if (!mondayShownAt || mondayDwellSent) return;
    mondayDwellSent = true;
    const s = (performance.now() - mondayShownAt) / 1000;
    step('monday_dwell', `${how}_${s < 3 ? 'lt3' : s < 10 ? '3_10' : s < 30 ? '10_30' : '30p'}`);
  };
  const mondayLeave = () => {
    if (state.screen !== 'monday' || planner.config.paid) return;
    mondayDwell('left');
    window.vhpPlannerEvents?.flush?.();
  };
  window.addEventListener('pagehide', mondayLeave);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') mondayLeave();
  });
  document.addEventListener(
    'click',
    (e) => {
      if (state.screen === 'monday' && e.target.closest?.('[data-vhp-screen="monday"] a[href]')) mondayDwell('link');
    },
    true
  );

  // ---------- Sörens Woche: the one-question door (docs/SOEREN_WEEK.md, 2026-11-03) ----------
  // Her day's kcal (typed, or estimated in place from a goal and her weight with the rest assumed and named), then his
  // week: 28 fixed dishes from a collection, 4 per day in its manual order, each portioned to her number with the
  // planner's fitPortion; her dish or likes take the open day's slot of the same meal. Every day opens to look at,
  // recipes stay free, swap / list / next week sell (renderWeekPreview, soerenWeekOn).
  const SOEREN_ORDER = ['breakfast', 'lunch', 'snack', 'dinner'];
  const SOEREN_PER_DAY = 4;
  const SOEREN_MIN = 20; // fewer valid recipes than this: the old flow runs (step soeren missing)
  const SOEREN_ASSUMED = { sex: 'female', height: 166, age: 30, activity: 'light', weight: 70 }; // the recipe calculator's typical visitor
  const SOEREN_KCAL_MIN = 1000;
  const SOEREN_KCAL_MAX = 4000;
  const soerenKcalValid = (value) => Number.isFinite(value) && value >= SOEREN_KCAL_MIN && value <= SOEREN_KCAL_MAX;
  const soerenWeekOn = () => !planner.config.paid && Boolean(state.preview?.soeren);
  const soerenHandles = () => String(planner.config.soerenHandles || '').split(',').map((s) => s.trim()).filter(Boolean);
  const isoWeekNo = (date) => {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const day = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - day);
    const y0 = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil(((d - y0) / 86400000 + 1) / 7);
  };
  // Rotation by ISO week over the configured collections; one handle = the same week until someone changes it.
  const soerenHandle = () => {
    const list = soerenHandles();
    return list.length ? list[isoWeekNo(weekMonday()) % list.length] : '';
  };
  // A fixed day can miss her target: more than 10 % off gets no ✓ and one honest line in the DM.
  const soerenDayOff = (totals, want) => {
    const kcal = Number(totals?.kcal) || 0;
    if (!want || !kcal) return '';
    const diff = (kcal - want) / want;
    return diff > 0.1 ? 'over' : diff < -0.1 ? 'under' : '';
  };
  const soerenAssumeBody = () => {
    if (state.sex !== 'female' && state.sex !== 'male') state.sex = SOEREN_ASSUMED.sex;
    if (!(state.height >= HEIGHT_MIN && state.height <= HEIGHT_MAX)) state.height = SOEREN_ASSUMED.height;
    if (!(state.age >= AGE_MIN && state.age <= AGE_MAX)) state.age = SOEREN_ASSUMED.age;
    if (!(state.weight >= WEIGHT_MIN && state.weight <= WEIGHT_MAX)) state.weight = SOEREN_ASSUMED.weight;
    if (!Object.prototype.hasOwnProperty.call(PAL, state.activity)) state.activity = SOEREN_ASSUMED.activity;
  };
  // A goal tile in the calculator: the estimate for her weight and the assumed rest fills the field.
  const soerenPickGoal = (goal, easy, rerender = true) => {
    if (!Object.prototype.hasOwnProperty.call(GOAL_DELTA, goal)) return;
    state.goal = goal;
    state.goalEasy = goal === 'maintain' && Boolean(easy);
    soerenAssumeBody();
    state.kcalManual = false;
    state.soerenKcal = null;
    state.kcal = computeKcal();
    persist();
    if (rerender) render();
  };
  const soerenSetWeight = (value) => {
    const weight = Math.round(Number(value));
    if (!(weight >= WEIGHT_MIN && weight <= WEIGHT_MAX)) return;
    state.weight = weight;
    if (state.goal) {
      soerenAssumeBody();
      state.kcalManual = false;
      state.soerenKcal = null;
      state.kcal = computeKcal();
    }
    persist();
    renderSoeren();
  };
  let soerenSeen = false;
  const renderSoeren = () => {
    const screen = $('[data-vhp-screen="soeren"]');
    if (!screen) return;
    if (!soerenSeen) {
      soerenSeen = true;
      step('soeren', 'seen');
    }
    // Her dish is only pinned into his week when it is a main (likedForOpenDay): only then does the line say it is in.
    const lead = screen.querySelector('[data-vhp-soeren-lead]');
    if (lead && introDish()?.slot === 'main' && lead.dataset.tPick && !lead.dataset.pick) {
      lead.dataset.pick = '1';
      lead.textContent = lead.dataset.tPick;
    }
    // Story and DM links: Sören just told her about it, so the screen picks up his promise.
    const title = screen.querySelector('[data-vhp-soeren-title]');
    if (title && (srcParam === 'story' || srcParam === 'dm') && !title.dataset.story) {
      title.dataset.story = '1';
      title.textContent = tr('planner.soeren_title_story');
    }
    const input = screen.querySelector('[data-vhp-soeren-kcal]');
    const shown = state.soerenKcal != null ? state.soerenKcal : state.goal && state.kcal ? state.kcal : null;
    if (input && document.activeElement !== input) input.value = shown != null ? String(shown) : '';
    const go = screen.querySelector('[data-vhp-soeren-go]');
    if (go) go.disabled = !soerenKcalValid(Number(input?.value));
    const calc = screen.querySelector('[data-vhp-soeren-calc]');
    if (calc) calc.hidden = !state.soerenCalc;
    const toggle = screen.querySelector('[data-vhp-soeren-calc-toggle]');
    if (toggle) {
      toggle.hidden = Boolean(state.soerenCalc);
      toggle.setAttribute('aria-expanded', state.soerenCalc ? 'true' : 'false');
    }
    screen.querySelectorAll('[data-vhp-soeren-goal]').forEach((btn) => {
      const on = state.goal === btn.dataset.vhpSoerenGoal && btn.hasAttribute('data-vhp-goal-easy') === Boolean(state.goalEasy);
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    const weight = state.weight >= WEIGHT_MIN && state.weight <= WEIGHT_MAX ? state.weight : SOEREN_ASSUMED.weight;
    const slider = screen.querySelector('[data-vhp-soeren-weight]');
    if (slider && document.activeElement !== slider) slider.value = String(weight);
    const out = screen.querySelector('[data-vhp-soeren-weight-out]');
    if (out) out.textContent = `${weight} kg`;
    const assumed = screen.querySelector('[data-vhp-soeren-assumed]');
    if (assumed) {
      const sex = state.sex === 'male' ? 'male' : 'female';
      assumed.textContent = tr(`planner.soeren_assumed_${sex}`, {
        height: state.height >= HEIGHT_MIN ? state.height : SOEREN_ASSUMED.height,
        age: state.age >= AGE_MIN ? state.age : SOEREN_ASSUMED.age,
      });
    }
  };
  // "Woche ansehen": the field decides. A typed number that isn't the estimate is her number (manual, goal "Einfach gut
  // essen" when none was picked); otherwise the goal's estimate stands. known: her target came along (the recipe
  // calculator), the screen was skipped.
  const startSoerenWeek = async ({ known = false } = {}) => {
    if (exampleBuilding || planner.config.paid) return;
    if (!known) {
      const typed = Number($('[data-vhp-soeren-kcal]')?.value);
      if (!soerenKcalValid(typed)) return;
      const kcal = Math.round(typed);
      const computed = state.goal ? computeKcal() : null;
      if (computed == null || kcal !== computed) {
        state.kcal = kcal;
        state.kcalManual = true;
        state.soerenKcal = kcal;
        if (!state.goal) {
          state.goal = 'maintain';
          state.goalEasy = true;
        }
        step('soeren', 'typed');
      } else {
        state.kcalManual = false;
        state.soerenKcal = null;
        state.kcal = computed;
      }
    }
    if (!state.kcal) return;
    if (!validSplit(state.macros)) {
      state.macros = recommendedMacros();
      state.macrosPreset = 'recommended';
    }
    step('soeren', 'go');
    persist();
    await buildSoerenWeek();
  };
  let soerenRun = 0;
  const buildSoerenWeek = async () => {
    if (exampleBuilding || !state.kcal) return;
    const handle = soerenHandle();
    const key = `${exampleKey()}|soeren:${handle}`;
    if (state.preview?.key === key && state.preview.day?.meals?.length) {
      forward('preview', null);
      return;
    }
    clearBuildTimers();
    buildStep = 0;
    buildHolding = false;
    exampleBuilding = true;
    const started = Date.now();
    const run = ++soerenRun;
    forward('building', null);
    [1, 2, 3].forEach((i) => {
      buildTimers.push(window.setTimeout(() => {
        buildStep = i;
        render();
      }, BUILD_STEP_MS * i));
    });
    render();
    try {
      await buildSoerenPreview(handle, key);
      if (run !== soerenRun) return;
      persist();
    } catch (e) {
      if (run !== soerenRun) return;
      console.error('[vhp-planner] Sörens Woche failed', e);
      if (!(e && e.soerenMissing)) step('planner_error', 'no_plan');
      exampleBuilding = false;
      clearBuildTimers();
      // The old flow from the goal slide: this setup keeps her number.
      state.soerenDoor = false;
      state.history = [];
      if (state.screen === 'building') show('goal', null, 'fade');
      else render();
      return;
    }
    step('plan_ready');
    const wait = Math.max(0, BUILD_MIN_MS - (Date.now() - started));
    buildTimers.push(window.setTimeout(() => {
      exampleBuilding = false;
      if (state.screen === 'building') forward('preview', null);
      else render();
    }, wait));
  };
  const buildSoerenPreview = async (handle, key) => {
    const items = handle && planner.week ? await planner.week(handle) : [];
    const usable = items.filter(hasPlannableMacros);
    if (usable.length < SOEREN_MIN) {
      step('soeren', 'missing');
      const err = new Error(`soeren week missing (${usable.length} of ${items.length} usable)`);
      err.soerenMissing = true;
      throw err;
    }
    const start = previewStartIso();
    const open = previewOpenIndex();
    const kcal = Number(state.kcal) || 0;
    const occasions = activeOccasions();
    const cap = shareCap();
    const fixed = Array.from({ length: WEEK_LEN }, () => []);
    usable
      .filter((card) => !isExcluded(card))
      .forEach((card) => {
        const pos = Number(card.pos);
        if (!Number.isFinite(pos)) return;
        const day = Math.floor(pos / SOEREN_PER_DAY);
        const occasion = occasions.find((row) => row.id === SOEREN_ORDER[pos % SOEREN_PER_DAY]);
        if (day >= WEEK_LEN || !occasion || fixed[day].some((meal) => meal.id === occasion.id)) return;
        const scale = fitPortion(Number(card.kcal), Math.round(kcal * occasion.share), kcal, cap) || 0.5;
        fixed[day].push({ ...mealFromRemix(occasion, { ...card, mi: mainIngredient(card) }, scale, true), locked: true });
      });
    // Her dish (the recipe she came from) or her likes go into his week without pushing out one of his favourites (the
    // dishes with reel views: the "über 40 Mio. Aufrufe" line counts them). Already in his week: it stays where it is
    // (the ♥ comes from her like). Else the first main slot from the open day on that holds no favourite; none: left out.
    const keep = await likedForOpenDay(introPick);
    const inWeek = (id) => fixed.some((day) => day.some((row) => productId(row.pick?.id) === productId(id)));
    const mainOccasions = occasions.filter((row) => row.catalog === 'main');
    keep.forEach((meal) => {
      if (inWeek(meal.pick?.id)) return;
      for (let d = 0; d < WEEK_LEN; d += 1) {
        const day = (open + d) % WEEK_LEN;
        const occasion = mainOccasions.find((occ) => {
          const there = fixed[day].find((row) => row.id === occ.id);
          return !there || !(Number(there.pick?.views) > 0);
        });
        if (!occasion) continue;
        const scale = fitPortion(Number(meal.pick?.kcal), Math.round(kcal * occasion.share), kcal, cap) || meal.scale;
        const placed = { ...mealFromRemix(occasion, meal.pick, scale, false), locked: true };
        fixed[day] = fixed[day].filter((row) => row.id !== occasion.id).concat(placed);
        return;
      }
    });
    // The core fills what the collection left open (a missing or excluded recipe) and sums every day.
    const planned = await planWeek({ fixed });
    planned.forEach((day, index) => {
      day.meals = orderMeals((day.meals || []).concat(fixed[index].map((meal) => ({ ...meal, locked: false }))));
    });
    const favoriteIds = new Set(likeItems().map((item) => item.id));
    if (key !== `${exampleKey()}|soeren:${handle}`) return;
    state.preview = {
      key,
      basis: planBasisKey(),
      start,
      ...weekPreviewFromPlan(planned, state.kcal, favoriteIds, open),
      week: planned.map((day) => ({ meals: orderMeals(day.meals.map((meal) => mealFromChoice(meal, favoriteIds))) })),
      next: null,
      soeren: handle,
      // No free swaps, no free reroll: the week is his, changing it is the subscription.
      swapsUsed: PV_FREE_SWAPS,
      rollsUsed: PV_FREE_ROLLS,
    };
  };

  const renderSkin = (screen) => {
    const skin = storyActive() && !planner.config.paid && SKIN_SCREENS.has(screen);
    funnel.classList.toggle('is-skin', skin);
    document.documentElement.classList.toggle('vhp-skin-open', skin);
    const head = $('[data-vhp-skin-head]');
    if (head) {
      head.hidden = !skin;
      const back = head.querySelector('[data-vhp-skin-back]');
      if (back && !back.dataset.wired) {
        back.dataset.wired = '1';
        back.addEventListener('click', () => goBack());
      }
      // Her Monday (and Sörens Woche's question) is a first screen: nothing to go back to, but a × out (back to where
      // she came from, else home).
      const firstScreen = screen === 'monday' || screen === 'soeren';
      if (back) back.hidden = firstScreen;
      const close = head.querySelector('[data-vhp-skin-close]');
      if (close && !close.dataset.wired) {
        close.dataset.wired = '1';
        close.addEventListener('click', () => {
          step(state.screen === 'soeren' ? 'soeren' : 'monday', 'close');
          if (state.screen === 'monday') mondayDwell('close');
          leavePlanner();
        });
      }
      if (close) close.hidden = !firstScreen;
      const label = head.querySelector('[data-vhp-skin-label]');
      // Sörens Woche keeps its name over the week too (not "Schritt 3 von 3").
      if (label && skin) label.textContent = (screen === 'preview' && soerenWeekOn() ? label.dataset.soeren : label.dataset[screen]) || '';
    }
    if (!skin) return;
    if (screen === 'preview') {
      // Sören's message lives in the band's foot and follows the viewed day (renderWeekPreview).
    } else {
      // No chat on the paywall (Maxim 2026-10-20): the title "Deine Woche ist fertig." as a plain headline and one
      // quiet line under it instead of Sören's bubbles. The line, first match wins: what they tapped when a locked
      // control opened it (round 6); visits from the recipe side get "die Rezepte bleiben kostenlos …" (docs/
      // RECIPE_FUNNEL.md 0.1); everyone else the one promise that answers their obstacle (their protein number when
      // they came for it).
      const protein = state.kcal ? macroGrams(state.kcal, currentSplit()).protein : 0;
      const promiseKey = pwPromiseKey();
      const promise = promiseKey === 'protein' ? tr('planner.skin_promise_protein', { protein: deInt(protein) }) : tr(`planner.skin_promise_${promiseKey}`);
      const ctx = PW_CTX[pwCtx?.key];
      const recipeSide = RECIPE_SIDE.has(visitLanding()) || visitEntry() === 'bio';
      const lead = $('[data-vhp-pw-lead]');
      if (lead) {
        // Sörens Woche (docs/SOEREN_WEEK.md 3): what the subscription adds to the week she just saw.
        lead.textContent = ctx ? pwCtxLine(pwCtx) : soerenWeekOn() ? tr('planner.soeren_pw_dm') : recipeSide ? tr('planner.skin_pw_free') : promise;
        lead.hidden = false;
      }
    }
    // Paywall first (docs/PLANNER_PAGE_FUNNEL.md 3.1): the free day one tap away, named like the preview names it.
    const peek = $('[data-vhp-pw-peek]');
    if (peek) {
      const on = screen === 'subscribe' && state.pwFirst && pwFirstScope() && Boolean(state.preview?.day?.meals?.length);
      peek.hidden = !on;
      const label = peek.querySelector('[data-vhp-pw-peek-label]');
      if (on && label) label.textContent = tr('planner.pw_peek', { day: PREVIEW_DAYS[Number(state.preview?.open) || 0] || '' });
    }
    // "Noch nicht? Woche per Mail sichern" (3.2): planner landers, once the sender is set up and the week isn't saved.
    const later = $('[data-vhp-pw-later]');
    if (later) later.hidden = !(screen === 'subscribe' && pwFirstScope() && weekMailApi()?.canOffer?.());
    // 4.3: "Mit Apple Pay bezahlen? Weiter in Safari" for in-app visitors (theme setting, off by default).
    const handoff = $('[data-vhp-pw-handoff]');
    if (handoff) {
      const on = screen === 'subscribe' && handoffOn();
      handoff.hidden = !on;
      if (on) {
        const go = handoff.querySelector('[data-vhp-handoff-go]');
        if (go) go.textContent = tr(HANDOFF_OS === 'ios' ? 'planner.handoff_ios' : 'planner.handoff_android');
        if (!handoffShown) {
          handoffShown = true;
          step('pay_handoff', 'shown');
        }
      }
    }
  };

  // Phone back / iOS swipe-back in the story arm goes to the previous screen (slide, deck, preview …), not off the
  // page, like in an app: one extra history entry (vhpStoryBack) that stays once there. Pushed only after a tap
  // (browsers skip entries made without one). On the first slide back leaves as usual.
  const pushStoryBack = () => {
    if (history.state?.vhpStoryBack || navigator.userActivation?.hasBeenActive === false) return;
    try {
      history.pushState({ ...(history.state || {}), vhpStoryBack: true }, '');
    } catch (e) {
      /* sandboxed */
    }
  };
  const syncStoryBack = (on) => {
    if (on) pushStoryBack();
  };
  window.addEventListener('popstate', () => {
    // Only when our entry was just left (a reel or sheet closing lands back on it).
    if (!storyActive() || history.state?.vhpStoryBack) return;
    if (state.screen === 'goal' && !state.history.length) {
      history.back();
      return;
    }
    goBack();
    pushStoryBack();
  });

  // Theme editor: selecting a "Story-Slide" block opens its slide (story forced on in the editor), so position and
  // dimming can be judged on the real slide.
  let editorKey = null;
  if (window.Shopify?.designMode) {
    const EDITOR_SCREEN = {
      hook: 'goal',
      hook_story: 'goal',
      why: 'why',
      sex: 'sex',
      body: 'body',
      activity: 'activity',
      pain: 'pain',
      exclusions: 'exclusions',
      dishes: 'dishes',
      dishes_video: 'dishes',
      proof: 'proof',
    };
    document.addEventListener('shopify:block:select', (event) => {
      const key = event.target?.dataset?.vhpStoryFig || event.target?.dataset?.vhpStoryPlaceholder;
      if (!key || planner.config.paid) return;
      let screen = EDITOR_SCREEN[key];
      const [kind, variant] = key.split('_');
      if (kind === 'numbers' && GOAL_DELTA[variant] !== undefined) {
        state.goal = variant;
        if (!state.kcalManual) state.kcal = computeKcal();
        screen = 'numbers';
      } else if (kind === 'answer' && PAINS.includes(variant)) {
        state.pain = variant;
        state.pains = [variant];
        screen = 'answer';
      }
      if (!screen || !funnel.querySelector(`[data-vhp-screen="${screen}"]`)) return;
      editorKey = key;
      show(screen, null, 'fade');
    });
    document.addEventListener('shopify:block:deselect', () => {
      editorKey = null;
    });
  }

  const render = (motion) => {
    if (state.screen === 'building' && !exampleBuilding) {
      state.screen = state.preview?.day?.meals?.length ? (gated() ? 'subscribe' : 'preview') : 'swipe';
      persist();
    }
    if (state.screen === 'swipe') {
      try {
        renderSwipe();
      } catch (e) {
        /* still reveal the screen below */
      }
    }
    if (state.screen === 'grid') {
      if (visibleScreen !== 'grid') gridReset(); // a fresh order per visit of the slide
      try {
        renderGrid();
      } catch (e) {
        /* the slide still shows; its cards come with the next render */
      }
    }
    if (state.screen !== 'swipe') {
      swipeDeck?.showNext(null);
      $('[data-vhp-swipe-media]')?.querySelectorAll('video').forEach((video) => video.pause());
    }
    const screen = state.screen;
    applyScreens(screen, motion?.from ?? visibleScreen, motion?.dir);

    renderProgress(screen);
    renderChrome(screen);
    renderStory(screen);
    renderRecipes();
    $('[data-vhp-back]').disabled =
      screen === 'waiting' || screen === 'building' || (screen === 'goal' && state.editFrom !== 'settings');

    funnel.classList.toggle('is-calm-goal', calmGoal());
    $$('[data-vhp-set]').forEach((btn) => {
      const [key, value] = btn.dataset.vhpSet.split(':');
      const easyMatch = key !== 'goal' || btn.hasAttribute('data-vhp-goal-easy') === Boolean(state.goalEasy);
      btn.classList.toggle('is-on', state[key] === value && easyMatch);
    });
    $$('[data-vhp-toggle-ex]').forEach((btn) => {
      btn.classList.toggle('is-on', state.exclusions.includes(btn.dataset.vhpToggleEx));
    });
    $$('[data-vhp-set-time]').forEach((btn) => {
      const raw = btn.dataset.vhpSetTime;
      const value = raw === '15' || raw === '30' ? Number(raw) : null;
      btn.classList.toggle('is-on', state.maxTime === value);
    });
    // Meal-Prep: Aus · 2× essen · 3× essen, and what that means in one line.
    const span = state.leftovers ? (state.leftoverDays === 2 ? 2 : 1) : 0;
    $$('[data-vhp-leftovers-set]').forEach((btn) => {
      const on = Number(btn.dataset.vhpLeftoversSet) === span;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    const leftoversNote = $('[data-vhp-leftovers-note]');
    if (leftoversNote) {
      leftoversNote.textContent = tr(`planner.leftovers_${span}`);
    }
    // Feste Mahlzeiten: one row per rule (occasion · days, recipe or Freie Mahlzeit, remove).
    const repeatList = $('[data-vhp-repeat-list]');
    if (repeatList) {
      const rules = orderMeals([
        ...(state.repeat || []).map((rule) => ({ ...rule, id: rule.occasion, recipe: rule.id })),
        ...(state.awayRepeat || []).map((rule) => ({ ...rule, id: rule.occasion, away: true })),
      ]);
      const repeatCard = $('[data-vhp-repeat-card]');
      if (repeatCard) repeatCard.hidden = !rules.length;
      repeatList.replaceChildren(...rules.map((rule) => {
        const item = document.createElement('li');
        item.className = 'vhp-repeat-row';
        const copy = document.createElement('div');
        copy.className = 'vhp-repeat-row__copy';
        const when = document.createElement('p');
        when.className = 'vhp-repeat-row__when';
        const occasionLabel = EXAMPLE_OCCASIONS.find((row) => row.id === rule.occasion)?.label || '';
        when.textContent = `${occasionLabel} · ${fmtDays(rule.days)}`;
        const title = document.createElement('p');
        title.className = 'vhp-repeat-row__title';
        title.textContent = rule.away ? tr('planner.away') : rule.pick?.title || findCatalogCard(rule.recipe)?.title || tr('common.recipe');
        copy.append(when, title);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'vhp-repeat-row__remove';
        if (rule.away) remove.dataset.vhpAwayRemove = rule.occasion;
        else remove.dataset.vhpRepeatRemove = rule.occasion;
        remove.setAttribute('aria-label', rule.away ? tr('planner.plan_again', { label: occasionLabel }) : tr('planner.unfix', { label: occasionLabel }));
        remove.append(strokeIcon((svg) => {
          addStroke(svg, 'path', { d: 'M6 6l12 12' });
          addStroke(svg, 'path', { d: 'M18 6 6 18' });
        }));
        item.append(copy, remove);
        return item;
      }));
    }
    const household = normalizeHousehold(state.household);
    const householdValue = $('[data-vhp-household-value]');
    if (householdValue) householdValue.textContent = String(household.n);
    const householdUnit = $('[data-vhp-household-unit]');
    if (householdUnit) householdUnit.textContent = tr('planner.person', { n: household.n });
    const householdNote = $('[data-vhp-household-note]');
    if (householdNote) {
      householdNote.textContent =
        household.n === 1
          ? tr('planner.household_invite')
          : tr('planner.household_text', { n: String(household.n - 1) });
    }
    const householdDown = $('[data-vhp-household-n="-1"]');
    const householdUp = $('[data-vhp-household-n="1"]');
    if (householdDown) householdDown.disabled = household.n <= 1;
    if (householdUp) householdUp.disabled = household.n >= HOUSEHOLD_MAX;
    const householdShared = $('[data-vhp-household-shared]');
    if (householdShared) householdShared.hidden = household.n <= 1;
    $$('[data-vhp-household-meal]').forEach((btn) => {
      const on = household.shared.includes(btn.dataset.vhpHouseholdMeal);
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-vhp-household-size]').forEach((btn) => {
      const on = Number(btn.dataset.vhpHouseholdSize) === household.size;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    const ageValue = $('[data-vhp-age-value]');
    if (ageValue) ageValue.textContent = String(state.age);
    const ageDown = $('[data-vhp-age="-1"]');
    const ageUp = $('[data-vhp-age="1"]');
    if (ageDown) ageDown.disabled = state.age <= AGE_MIN;
    if (ageUp) ageUp.disabled = state.age >= AGE_MAX;

    ['height', 'weight'].forEach((key) => {
      const input = $(`[data-vhp-input="${key}"]`);
      if (input && document.activeElement !== input) input.value = state[key] ?? '';
    });
    const bodyError = $('[data-vhp-body-error]');
    if (bodyError) bodyError.hidden = bodyValid() || state.height == null || state.weight == null;

    const kcalValue = $('[data-vhp-kcal-value]');
    if (kcalValue) kcalValue.textContent = state.kcal != null ? state.kcal.toLocaleString(LOCALE) : '—';
    const kcalUnit = $('[data-vhp-kcal-unit]');
    if (kcalUnit) {
      kcalUnit.textContent =
        state.kcal != null ? tr('planner.kcal_protein_unit', { n: String(macroGrams(state.kcal, currentSplit()).protein) }) : 'kcal';
    }
    const kcalCard = $('[data-vhp-kcal-card]');
    if (kcalCard) kcalCard.classList.toggle('is-ready', state.kcal != null);
    $$('[data-vhp-kcal]').forEach((btn) => {
      btn.disabled = computeKcal() == null && state.kcal == null;
    });
    const actDesc = $('[data-vhp-activity-desc]');
    if (actDesc) actDesc.textContent = ACTIVITY_DESC[state.activity] || tr('planner.act_hint');

    $$('[data-vhp-build-step]').forEach((el) => {
      const index = Number(el.dataset.vhpBuildStep);
      el.classList.toggle('is-on', buildStep > index);
    });
    const build0 = $('[data-vhp-build-step="0"]');
    if (build0 && state.kcal != null) {
      const grams = macroGrams(state.kcal, currentSplit());
      build0.textContent = tr('planner.daily_target', { kcal: state.kcal, protein: String(grams.protein) });
    }
    const build1 = $('[data-vhp-build-step="1"]');
    if (build1) {
      const n = likeCount();
      build1.textContent = n
        ? tr('planner.build_favs', { n: String(n) })
        : tr('planner.build_fresh');
    }
    // Story 3.1: "✓ 28 Mahlzeiten aus deinen Likes · ✓ Jede Portion auf 1.410 kcal · ✓ Einkaufsliste sortiert".
    if (storyOn('building')) {
      const meals = String(WEEK_LEN * activeOccasions().length);
      const step0 = $('[data-vhp-build-step="0"]');
      const step1 = $('[data-vhp-build-step="1"]');
      const step2 = $('[data-vhp-build-step="2"]');
      if (step0) {
        step0.textContent = likeCount()
          ? tr('planner.story_build_likes', { n: meals })
          : tr('planner.story_build_picked', { n: meals });
      }
      if (step1 && state.kcal != null) step1.textContent = tr('planner.story_build_kcal', { kcal: deInt(state.kcal) });
      if (step2) step2.textContent = tr('planner.story_build_list');
    }

    renderMacros();
    renderMeals();
    renderSettings();

    const nextDisabled = {
      goal: !state.goal,
      body: !eckdatenValid(),
    };
    const nextLabel = (name) => {
      if (state.editFrom !== 'settings') {
        // Likes from the webapp that already make a plan skip the deck (goNext): the button says where it goes.
        if (name === 'exclusions') {
          if (!planner.config.paid && planReady()) return tr('common.create_plan');
          if (storyActive()) return `${tr(state.exclusions.length ? 'planner.story_ex_next' : 'planner.story_ex_none')} →`;
          return tr('planner.discover');
        }
        if (name === 'macros' || name === 'goal' || name === 'body') return tr('planner.next');
        return null;
      }
      return tr('planner.done');
    };
    $$('[data-vhp-next]').forEach((btn) => {
      const name = btn.closest('[data-vhp-screen]')?.dataset.vhpScreen;
      btn.disabled = Boolean(nextDisabled[name]);
      const label = nextLabel(name);
      if (label) btn.textContent = label;
    });

    if (screen === 'empty') {
      const note = $('[data-vhp-empty-copy]');
      const loaded = slotsToFill().some((slot) => deckPoolFor(slot).length);
      if (state.swap) {
        note.textContent = tr('planner.no_recipe_here');
      } else if (!loaded) {
        note.textContent = tr('planner.no_recipe_adjust');
      } else if (!hasLikedMain()) {
        note.textContent = tr('planner.need_main');
      } else if (likeCount() < LIKE_READY) {
        note.textContent = tr('planner.few_more');
      } else {
        note.textContent = tr('planner.all_swiped');
      }
      const edit = $('[data-vhp-edit-exclusions]');
      if (edit) edit.hidden = Boolean(state.swap);
      const emptyFooter = funnel.querySelector('[data-vhp-screen="empty"] .vhp-screen__footer');
      if (emptyFooter) emptyFooter.hidden = Boolean(state.swap);
    }

    const ctaLabel = planButtonLabel();
    const showPlan = likeCount() >= LIKE_READY && !state.swap;
    $$('[data-vhp-plan]').forEach((btn) => {
      btn.hidden = !showPlan;
      btn.disabled = exampleBuilding || weekGenerating || !planReady();
      btn.setAttribute('aria-disabled', planReady() ? 'false' : 'true');
      btn.textContent = ctaLabel;
    });

    if (screen === 'preview') {
      loadExWant();
      renderWeekPreview(state.preview);
      revealPreview();
    }
    if (screen === 'week') renderWeek();
    if (screen === 'shop') renderShop();
    if (screen === 'subscribe') renderSubscribe();
    if (screen === 'waiting') {
      const copy = $('[data-vhp-wait-copy]');
      const retry = $('[data-vhp-wait-retry]');
      const stuck = paidWaitTries() >= PAID_WAIT_MAX;
      if (copy) {
        copy.textContent = stuck
          ? tr('planner.wait_stuck')
          : tr('planner.wait');
      }
      if (retry) retry.hidden = !stuck || Boolean(paidClaim);
      const leave = $('[data-vhp-wait-leave]');
      if (leave) {
        leave.hidden = !stuck && paidClaim !== 'login';
        const label = paidClaim === 'login' ? leave.dataset.claim : leave.dataset.idle;
        if (label) leave.textContent = label;
      }
      // Guest checkout: the sign-in screen instead of the wait.
      const claim = paidClaim === 'login';
      $('[data-vhp-wait-spin]')?.toggleAttribute('hidden', claim);
      $('[data-vhp-wait-title]')?.toggleAttribute('hidden', claim);
      $('[data-vhp-claim-title]')?.toggleAttribute('hidden', !claim);
      paintClaim(claim);
      if (copy && claim) copy.textContent = tr('planner.claim_lead');
      const login = $('[data-vhp-wait-login]');
      if (login) {
        login.hidden = !claim;
        if (claim) login.href = claimLoginHref(login.dataset.base);
      }
    }
    // First render done: the boot frame (sections/meal-planner.liquid) gives way to the real screen.
    if (funnel.classList.contains('is-booting')) {
      funnel.classList.remove('is-booting');
      document.documentElement.classList.remove('vhp-story-boot', 'vhp-story-early');
      // A goal tapped on the first slide the section painted before the scripts (docs/PLANNER_PAGE_FUNNEL.md 1.1):
      // the same tap again, now with Sören's reply and the way on.
      const early = window.__vhpEarlyGoal;
      const earlyEasy = window.__vhpEarlyGoalEasy === true;
      window.__vhpEarlyGoal = '';
      window.__vhpEarlyGoalEasy = false;
      if (early && screen === 'goal' && !state.goal && Object.prototype.hasOwnProperty.call(GOAL_DELTA, early)) {
        // Two tiles carry maintain ("Einfach gut essen" and "Gewicht halten"): the same one again.
        const sel = `[data-vhp-set="goal:${early}"]${earlyEasy ? '[data-vhp-goal-easy]' : ':not([data-vhp-goal-easy])'}`;
        window.setTimeout(() => funnel.querySelector(sel)?.click(), 0);
      }
    }
    funnel.dispatchEvent(new CustomEvent('vhp:render', { detail: { screen } }));
  };

  // ---------- swipe on week meal rows ----------
  // Right = Sperren / Entsperren (same as the lock button). Left = Ersetzen: one new suggestion for this meal
  // (same picker as "Überrasch mich"), undoable from the week toast. The card slides over its action; it fires on
  // release past about a quarter of the card's width, or on a flick. A locked meal can only be unlocked (left
  // rubber-bands). Buttons stay.
  const SWIPE_HINT_KEY = 'vhp_planner_swipe_hint';
  let swipeDrag = null;
  let swipeClickGuard = 0;
  let swipeNonce = 0;

  const toggleWeekLock = (occasion) => {
    const meal = state.week?.[state.weekDay]?.meals?.find((row) => row.id === occasion);
    if (!meal) return false;
    meal.locked = !meal.locked;
    usage('use_lock');
    scheduleWeekSave();
    persist();
    render();
    return true;
  };

  // New suggestion for one meal without the sheet (true when it replaced the meal). Falls back to the sheet while the planner core is not loaded.
  const swipeReplace = async (occasion) => {
    const day = state.week?.[state.weekDay];
    const meal = day?.meals?.find((row) => row.id === occasion);
    if (!meal || meal.locked) return false;
    if (!plannerCore) {
      openSwapSheet(occasion);
      return false;
    }
    // The planner index (JSON, cached after the first plan) instead of every card page of every slot: that load
    // took seconds on mobile data with nothing on screen.
    let catalog = null;
    try {
      catalog = await plannerCatalog(true);
    } catch (e) {
      catalog = null;
    }
    const ctx = swapContext(occasion);
    if (!ctx) return false;
    const tried = new Set([ctx.excludeId]);
    const pool = (catalog?.[ctx.meal.catalog] ||
      allCatalogCards()
        .filter((card) => card.slot === ctx.meal.catalog)
        .map((card) => ({ ...card, mi: mainIngredient(card) }))
    ).filter(hasPlannableMacros);
    swipeNonce += 1;
    const pick = plannerCore.surprise(ctx.core, {
      days: ctx.days,
      dayIndex: ctx.dayIndex,
      occasionId: ctx.meal.id,
      pool,
      tried,
      seed: plannerCore.seed(planSeed(), 'swipe', ctx.dayIndex, ctx.meal.id, swipeNonce),
    });
    if (!pick) {
      showWeekToast(tr('planner.no_other_idea'), { action: 'OK', ms: 3000 });
      return false;
    }
    const liked = new Set(likeItems().map((item) => item.id));
    const card = hydrateSwapCard(pick.card);
    const next = mealFromRemix(ctx.meal, card, slotScale(card, ctx.day, ctx.meal.id), !liked.has(productId(card.id)));
    next.locked = false;
    regenUndo = null;
    swapUndo = { day: state.weekDay, snapshot: cloneJson(ctx.meal) };
    trackReplaced(ctx.meal, next.pick, 'week');
    ctx.day.meals = orderMeals((ctx.day.meals || []).filter((row) => row.id !== ctx.meal.id).concat(next));
    const moved = syncLeftovers();
    usage('use_swap');
    persist();
    scheduleWeekSave();
    render();
    showWeekToast(withLeftoverNote(tr('planner.recipe_replaced'), moved));
    return true;
  };

  const swipeBackdrop = (row, locked) => {
    const host = row.parentElement;
    if (!host) return null;
    const bg = document.createElement('div');
    bg.className = 'vhp-swipe-bg';
    bg.setAttribute('aria-hidden', 'true');
    const label = document.createElement('span');
    label.className = 'vhp-swipe-bg__label';
    bg.append(label);
    bg.style.top = `${row.offsetTop}px`;
    bg.style.height = `${row.offsetHeight}px`;
    bg._locked = locked;
    host.insertBefore(bg, row);
    return bg;
  };

  const swipeSetDir = (bg, dir) => {
    if (bg.dataset.dir === dir) return;
    bg.dataset.dir = dir;
    const right = dir === 'right';
    bg.dataset.act = right ? (bg._locked ? 'unlock' : 'lock') : 'replace';
    const label = bg.firstChild;
    const ico = document.createElement('span');
    ico.className = 'vhp-swipe-bg__ico';
    ico.append(right ? lockIcon(!bg._locked) : swapIcon());
    const text = document.createElement('span');
    text.textContent = right ? (bg._locked ? tr('planner.unlock') : tr('planner.lock')) : tr('planner.replace');
    label.replaceChildren(ico, text);
  };

  // Planner skin v3: the card follows the finger 1:1, then gives way like rubber; the action behind it grows with the
  // pull and fills its colour once a release would fire it (a flick fires it too). Let go short and the card springs
  // home. Replace: the card flies off with the finger's speed, the new dish slides in from the other side where it
  // was (or the old one comes back if there is nothing new). Lock: the card springs home, then its chip pops the lock.
  const SWIPE_FLICK = 0.55; // px per ms
  const SWIPE_HOME = 'transform 0.46s cubic-bezier(0.25, 1.2, 0.4, 1)';

  const swipeArmAt = (row) => Math.min(110, Math.max(72, row.offsetWidth * 0.28));
  const swipeRubber = (d, free) => {
    const a = Math.abs(d);
    return a <= free ? d : Math.sign(d) * (free + (a - free) * 0.32);
  };

  // keep: the action stays lit while the card returns (it fired).
  const swipeHome = (row, bg, then, keep = false) => {
    row.style.transition = SWIPE_HOME;
    row.style.transform = 'translate3d(0, 0, 0)';
    if (!keep) {
      bg?.style.setProperty('--p', '0');
      bg?.classList.remove('is-armed');
    }
    window.setTimeout(() => {
      row.style.transition = '';
      row.style.transform = '';
      bg?.remove();
      if (then) then();
    }, 460);
  };

  const swipeEnd = (event) => {
    const drag = swipeDrag;
    if (!drag || (event && event.pointerId !== drag.id)) return;
    swipeDrag = null;
    const { row, bg } = drag;
    if (!drag.horizontal) return;
    try {
      row.releasePointerCapture(drag.id);
    } catch (e) {
      /* already released */
    }
    swipeClickGuard = Date.now() + 350;
    row.classList.remove('is-swiping');
    const dir = drag.dx > 0 ? 'right' : 'left';
    const flick = Math.abs(drag.vx) >= SWIPE_FLICK && Math.sign(drag.vx) === Math.sign(drag.dx) && Math.abs(drag.dx) > 24;
    const armed = event && event.type === 'pointerup' && (Math.abs(drag.dx) >= drag.arm || flick);
    const act = armed && (dir === 'right' || !drag.locked);
    if (!act) {
      swipeHome(row, bg);
      return;
    }
    if (dir === 'right') {
      // Home first, then the lock changes (a re-render mid-spring would make the card jump).
      bg?.classList.add('is-armed');
      bg?.style.setProperty('--p', '1');
      swipeHome(row, bg, () => {
        swipeLockPop = drag.occasion;
        toggleWeekLock(drag.occasion);
      }, true);
      return;
    }
    if (!motionOk()) {
      row.style.transform = '';
      bg?.remove();
      swipeReplace(drag.occasion);
      return;
    }
    // Off with the finger's speed (160–300 ms), the slot stays until the new dish is there.
    const from = drag.shown;
    const to = -(row.offsetWidth + 40);
    const speed = Math.max(Math.abs(drag.vx), 1.4);
    const ms = Math.round(Math.min(300, Math.max(160, Math.abs(to - from) / speed)));
    row.style.transition = `transform ${ms}ms cubic-bezier(0.3, 0.6, 0.5, 1), opacity ${ms}ms ease`;
    row.style.transform = `translate3d(${to}px, 0, 0)`;
    row.style.opacity = '0.6';
    bg?.classList.add('is-armed');
    swipeIncoming = { occasion: drag.occasion, day: state.weekDay, start: state.weekStart };
    const gone = new Promise((resolve) => window.setTimeout(resolve, ms));
    Promise.all([swipeReplace(drag.occasion), gone]).then(([done]) => {
      if (done) return;
      // Nothing new: the meal comes back from where it left.
      swipeIncoming = null;
      row.style.opacity = '';
      swipeHome(row, bg);
    });
  };

  funnel.addEventListener('pointerdown', (event) => {
    if (swipeDrag || state.screen !== 'week' || weekGenerating) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    const row = event.target.closest?.('[data-vhp-week-meals] .vhp-pick');
    if (!row || event.target.closest('.vhp-pick__actions, .vhp-meal__more, .vhp-mcard__play')) return;
    if (document.querySelector('dialog[open]')) return;
    const occasion = row.dataset.vhpWeekSwipe;
    if (!occasion) return;
    swipeDrag = {
      id: event.pointerId,
      x: event.clientX,
      y: event.clientY,
      dx: 0,
      shown: 0,
      vx: 0,
      t: event.timeStamp,
      row,
      occasion,
      arm: swipeArmAt(row),
      locked: row.classList.contains('is-locked'),
      horizontal: false,
      bg: null,
      armed: false,
    };
  });

  funnel.addEventListener('pointermove', (event) => {
    const drag = swipeDrag;
    if (!drag || event.pointerId !== drag.id) return;
    const dx = event.clientX - drag.x;
    const dy = event.clientY - drag.y;
    if (!drag.horizontal) {
      if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) {
        swipeDrag = null;
        return;
      }
      if (Math.abs(dx) < 10 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      drag.horizontal = true;
      drag.bg = swipeBackdrop(drag.row, drag.locked);
      drag.row.classList.add('is-swiping');
      drag.row.style.transition = 'none';
      try {
        drag.row.setPointerCapture(drag.id);
      } catch (e) {
        /* no capture: moves outside the row are lost, release still ends the drag */
      }
    }
    // Finger speed, smoothed (a flick fires the action short of the threshold).
    const dt = Math.max(1, event.timeStamp - drag.t);
    drag.vx = drag.vx * 0.4 + ((dx - drag.dx) / dt) * 0.6;
    drag.t = event.timeStamp;
    drag.dx = dx;
    // A locked meal gives way only a little to the left (nothing to replace).
    const blocked = dx < 0 && drag.locked;
    const shown = blocked ? swipeRubber(dx, 0) * 0.5 : swipeRubber(dx, drag.arm * 1.35);
    drag.shown = shown;
    drag.row.style.transform = `translate3d(${shown.toFixed(1)}px, 0, 0)`;
    if (drag.bg) {
      swipeSetDir(drag.bg, dx > 0 ? 'right' : 'left');
      const armed = Math.abs(dx) >= drag.arm && !blocked;
      drag.bg.style.setProperty('--p', blocked ? '0' : Math.min(1, Math.abs(dx) / drag.arm).toFixed(3));
      drag.bg.classList.toggle('is-armed', armed);
      drag.bg.classList.toggle('is-blocked', blocked);
      if (armed && !drag.armed) window.vhpUi?.buzz(8);
      drag.armed = armed;
    }
  });

  funnel.addEventListener('pointerup', swipeEnd);
  funnel.addEventListener('pointercancel', swipeEnd);
  // A finished drag must not also open the recipe.
  funnel.addEventListener(
    'click',
    (event) => {
      if (Date.now() < swipeClickGuard && event.target.closest?.('[data-vhp-week-meals] .vhp-pick')) {
        event.stopPropagation();
        event.preventDefault();
      }
    },
    true,
  );

  // One-time hint: the first row slides a little to the left and back, showing "Ersetzen" behind it.
  const swipeHintSeen = () => {
    try {
      return window.localStorage.getItem(SWIPE_HINT_KEY) === '1';
    } catch (e) {
      return false;
    }
  };
  const swipePeek = (target) => {
    const row =
      target ||
      [...funnel.querySelectorAll('[data-vhp-week-meals] .vhp-pick:not(.is-locked)')].find((el) => el.offsetParent);
    if (!row || swipeDrag || !motionOk()) return false;
    const bg = swipeBackdrop(row, false);
    if (!bg) return false;
    try {
      window.localStorage.setItem(SWIPE_HINT_KEY, '1');
    } catch (e) {
      /* shows again next visit */
    }
    swipeSetDir(bg, 'left');
    bg.style.setProperty('--p', '0.6');
    row.classList.add('is-swiping');
    row.style.transition = 'transform 0.38s cubic-bezier(0.32, 0.72, 0, 1)';
    row.style.transform = 'translate3d(-64px, 0, 0)';
    window.setTimeout(() => {
      row.style.transform = 'translate3d(0, 0, 0)';
      window.setTimeout(() => {
        row.classList.remove('is-swiping');
        row.style.transition = '';
        row.style.transform = '';
        bg.remove();
      }, 420);
    }, 750);
    return true;
  };
  window.vhpPlannerSwipe = { peek: swipePeek };

  funnel.addEventListener('vhp:render', (event) => {
    if (event.detail?.screen !== 'week' || !planner.config.paid || swipeHintSeen()) return;
    window.setTimeout(() => {
      if (state.screen !== 'week' || document.documentElement.classList.contains('vhp-tour-on')) return;
      if (document.querySelector('dialog[open]') || swipeHintSeen()) return;
      swipePeek();
    }, 1800);
  });

  // ---------- events ----------

  funnel.addEventListener('click', (event) => {
    const t = event.target;
    if (t.closest('a[href]')) return;

    // What is done on the free preview (docs/PLANNER_PAGE_FUNNEL.md 0.4), once per kind and day; the actions themselves
    // run below as before.
    if (state.screen === 'preview' && !planner.config.paid) {
      if (t.closest('[data-vhp-recipe-open]')) step('preview_use', 'recipe');
      else if (t.closest('[data-vhp-daylist-more]') && !dayListOpen) step('preview_use', 'list_more');
      else if (t.closest('[data-vhp-daylist-item]')) step('preview_use', 'tick');
    }

    // Free day: a free swap really swaps (docs/PREVIEW_PAYWALL.md P2 addition); without the core loaded yet the
    // tap does nothing and the next one picks it up.
    const pvSwapBtn = t.closest('[data-vhp-pv-swap-free]');
    if (pvSwapBtn && state.screen === 'preview' && !planner.config.paid) {
      pvSwapBtn.classList.add('is-busy');
      pvSwapReplace(pvSwapBtn.dataset.vhpPvSwapFree).finally(() => pvSwapBtn.classList.remove('is-busy'));
      return;
    }

    // The whole day rerolled: once free, then the paywall.
    const pvRerollBtn = t.closest('[data-vhp-pv-reroll]');
    if (pvRerollBtn && state.screen === 'preview' && !planner.config.paid) {
      if (pvRerollBtn.classList.contains('is-busy')) return;
      if (pvRollsLeft() > 0) {
        // The cards fold away first, then the new day deals in (the same roll as the week's Neu planen).
        pvRerollBtn.classList.add('is-busy');
        rollTap(pvRerollBtn.querySelector('.vhp-pv-row__ico'));
        const box = $('[data-vhp-preview-meals]');
        const rowsOf = () => (box ? weekMealNodes(box).filter((row) => row.dataset.meal) : []);
        const leaving = motionOk() ? rowsOf() : [];
        const outMs = armWeekMealsOut(leaving, 1, true);
        new Promise((resolve) => window.setTimeout(resolve, leaving.length ? outMs : 0))
          .then(() => pvDayReroll())
          .finally(() => {
            // Rebuilt cards are new nodes; when nothing changed the old ones are still there, folded: both deal in.
            const rows = rowsOf();
            rows.forEach(clearWeekMealAnim);
            armMealsRollIn(rows);
            pvRerollBtn.classList.remove('is-busy');
          });
      } else {
        continueToSubscribe('regen');
      }
      return;
    }

    // A meal's ... on the open day: the paid meal sheet, live where one day allows it (paintPvSheet).
    const pvMoreBtn = t.closest('[data-vhp-pv-more]');
    if (pvMoreBtn && state.screen === 'preview' && !planner.config.paid) {
      openPvSheet(pvMoreBtn.dataset.vhpPvMore);
      return;
    }
    const pvActBtn = t.closest('[data-vhp-pv-act]');
    if (pvActBtn) {
      runPvSheetAct(pvActBtn.dataset.vhpPvAct);
      return;
    }
    if (t.closest('[data-vhp-pv-more-cta]')) {
      closePvSheet();
      afterPvSheet(() => continueToSubscribe('cta'));
      return;
    }

    // Preview week band (docs/PREVIEW_PAYWALL.md P1): ‹ › and the strip's pills step through the days; a locked day
    // opens in place (preview_use "day_locked" fires in pvGo).
    const pvStepBtn = t.closest('[data-vhp-pv-step]');
    if (pvStepBtn && state.screen === 'preview') {
      pvGo(pvView + Number(pvStepBtn.dataset.vhpPvStep));
      return;
    }
    const pvDayBtn = t.closest('[data-vhp-pv-go]');
    if (pvDayBtn && state.screen === 'preview') {
      pvGo(Number(pvDayBtn.dataset.vhpPvGo));
      return;
    }

    const planBtn = t.closest('[data-vhp-subscribe-plan]');
    if (planBtn) {
      state.subscribePlanId = planBtn.dataset.vhpSubscribePlan;
      checkoutError = false;
      persist();
      render();
      return;
    }

    // Story v2, 1.1b: the reason (one tap), Sören's reply, then on.
    const whyBtn = t.closest('[data-vhp-why]');
    if (whyBtn) {
      const why = whyBtn.dataset.vhpWhy;
      if (!WHYS.includes(why) || state.screen !== 'why') return;
      state.why = why;
      step('why_selected', why);
      persist();
      render();
      storyReply('why', tr(`planner.story_why_reply_${why}`));
      return;
    }

    const holdEdit = t.closest('[data-vhp-hold-edit]');
    if (holdEdit) {
      editFromSummary(holdEdit.dataset.vhpHoldEdit);
      return;
    }
    // Story setup: obstacle answers (a tap toggles one, up to PAIN_MAX; "Abschicken" moves on), the 30-min toggle
    // on its answer, gift, Sören's clip.
    const painBtn = t.closest('[data-vhp-pain]');
    if (painBtn) {
      const pain = painBtn.dataset.vhpPain;
      if (!PAINS.includes(pain) || state.screen !== 'pain') return;
      if (state.pains.includes(pain)) state.pains = state.pains.filter((key) => key !== pain);
      else if (state.pains.length < PAIN_MAX) {
        state.pains = [...state.pains, pain];
        step('pain_selected', pain);
      } else return;
      state.pain = state.pains[0] || null;
      persist();
      render();
      schedulePainSend();
      return;
    }
    if (t.closest('[data-vhp-pain-send]')) {
      if (state.screen !== 'pain' || !state.pains.length) return;
      window.clearTimeout(painTimer);
      goNext();
      return;
    }
    // "Fast geschafft" sheet (askBeforeExit): keep planning, or leave with the answers kept.
    if (t.closest('[data-vhp-exit-stay]')) {
      step('story_exit', 'stay');
      $('[data-vhp-exit-sheet]')?.close();
      return;
    }
    if (t.closest('[data-vhp-exit-leave]')) {
      step('story_exit', 'leave');
      $('[data-vhp-exit-sheet]')?.close();
      leavePlanner();
      return;
    }
    // Paywall first: the free preview from the plans (its back leaves the planner, its button comes back here).
    // The link names the free day, so the preview opens on it, not on a locked day viewed earlier.
    if (t.closest('[data-vhp-pw-peek]')) {
      pvView = 0;
      forward('preview', null);
      return;
    }
    // "Noch nicht? Woche per Mail sichern" under the plans (docs/PLANNER_PAGE_FUNNEL.md 3.2).
    if (t.closest('[data-vhp-pw-later]')) {
      weekMailApi()?.open('paywall', () => render());
      return;
    }
    // "Weiter in Safari / Chrome" (4.3) and its copy-the-link fallback.
    if (t.closest('[data-vhp-handoff-go]')) {
      startHandoff();
      return;
    }
    const copyBtn = t.closest('[data-vhp-handoff-copy]');
    if (copyBtn) {
      copyHandoff(copyBtn);
      return;
    }
    if (t.closest('[data-vhp-story-time]')) {
      state.maxTime = state.maxTime == null ? 30 : null;
      storyPlayer?.hold();
      persist();
      render();
      return;
    }
    if (t.closest('[data-vhp-gift-reveal]')) {
      if (giftFoil) giftFoil.reveal();
      else scratchDone();
      return;
    }
    if (t.closest('[data-vhp-gift-done]')) {
      if (state.reward) {
        // Story v2: the plans open with the price drop.
        priceDrop = true;
        toPlans();
      } else forward('preview', null);
      return;
    }
    if (t.closest('[data-vhp-proof-next]')) {
      toPlans();
      return;
    }
    // The week screen (docs/FIRST_SCREEN.md 9): the button starts the setup at the goal (short: goal, body, activity,
    // numbers, Ausschlüsse, dishes, the week).
    if (t.closest('[data-vhp-monday-go]')) {
      step('monday', 'go');
      mondayDwell('go');
      state.editFrom = null;
      forward('goal');
      return;
    }
    // Sörens Woche's question screen (docs/SOEREN_WEEK.md 2).
    if (t.closest('[data-vhp-soeren-calc-toggle]')) {
      state.soerenCalc = true;
      step('soeren', 'calc');
      persist();
      render();
      return;
    }
    const soerenGoalBtn = t.closest('[data-vhp-soeren-goal]');
    if (soerenGoalBtn) {
      soerenPickGoal(soerenGoalBtn.dataset.vhpSoerenGoal, soerenGoalBtn.hasAttribute('data-vhp-goal-easy'), true);
      return;
    }
    if (t.closest('[data-vhp-soeren-adjust]')) {
      step('soeren', 'calc_adjust');
      soerenAssumeBody();
      state.editFrom = null;
      persist();
      forward('body');
      return;
    }
    if (t.closest('[data-vhp-soeren-go]')) {
      startSoerenWeek();
      return;
    }
    // Paywall tile: Sören's clip as a story, back to the plans after it.
    if (t.closest('[data-vhp-proof-open]')) {
      forward('proof', null);
      return;
    }
    // "anpassen" on Deine Zahlen: ±50 shows, the slide stays.
    const adjustBtn = t.closest('[data-vhp-num-adjust]');
    if (adjustBtn) {
      const row = $('[data-vhp-num-adjust-row]');
      if (row) row.hidden = !row.hidden;
      adjustBtn.setAttribute('aria-expanded', row && !row.hidden ? 'true' : 'false');
      storyPlayer?.hold();
      return;
    }
    const reactBtn = t.closest('[data-vhp-react]');
    if (reactBtn) {
      if (state.pain) step('story_reaction', `${state.pain}_${reactBtn.dataset.vhpReact}`);
      storyPlayer?.react(reactBtn);
      return;
    }

    const setBtn = t.closest('[data-vhp-set]');
    if (setBtn) {
      const [key, value] = setBtn.dataset.vhpSet.split(':');
      state[key] = value;
      // "Einfach gut essen" is maintain under her words (docs/PERSONA_ATTACK_PLAN.md 1.4).
      if (key === 'goal') state.goalEasy = setBtn.hasAttribute('data-vhp-goal-easy');
      if (key === 'sex') storyVoted.add('sex');
      // A new goal has its own reasons (1.1b): one that isn't among them is asked again.
      if (key === 'goal' && state.why && !(WHY_BY_GOAL[value] || []).includes(state.why)) state.why = null;
      state.kcalManual = false;
      syncKcal();
      persist();
      render();
      // Counted at the tap: goal_selected waits for Sören's reply, so a visitor who taps and leaves during it is only
      // here (2026-10-21).
      if (key === 'goal' && state.screen === 'goal') step('goal_tap', value);
      // Goal tiles have no Weiter button: the tap is the answer. A short beat so the pick shows before the slide.
      // Story polls (sex, activity): the tap is the answer, like the goal.
      if ((key === 'sex' || key === 'activity') && state.screen === key && storyOn(key)) {
        storyVoted.add(key);
        render();
        // Activity gets Sören's reply (story v2); the sex poll already says why it's asked.
        if (key === 'activity') storyReply('activity', tr(`planner.story_act_reply_${value}`));
        else {
          window.setTimeout(() => {
            if (state.screen === key) goNext();
          }, 380);
        }
        return;
      }
      if (key === 'goal' && state.screen === 'goal' && storyOn('goal')) {
        // Story: the real shares fill first, then Sören's reply to the goal (story v2), then on. Read for 2.4 s at most:
        // the length-based time (up to 8 s since 10-19) kept the first answer waiting ~6.5 s (2026-10-21).
        storyReply('goal', tr(`planner.story_goal_reply_${goalWord()}`), { beat: 650, maxRead: 2400 });
        return;
      }
      if (key === 'goal' && state.screen === 'goal' && !goalAdvance) {
        goalAdvance = window.setTimeout(() => {
          goalAdvance = 0;
          if (state.screen === 'goal' && state.goal) goNext();
        }, 180);
      }
      return;
    }

    const timeBtn = t.closest('[data-vhp-set-time]');
    if (timeBtn) {
      const raw = timeBtn.dataset.vhpSetTime;
      state.maxTime = raw === '15' || raw === '30' ? Number(raw) : null;
      persist();
      if (planner.config.paid && (favSheet()?.open || state.editFrom === 'settings')) {
        state.pendingFlush = true;
        flushProfile();
      }
      render();
      return;
    }

    const ageBtn = t.closest('[data-vhp-age]');
    if (ageBtn) {
      state.age = Math.min(AGE_MAX, Math.max(AGE_MIN, state.age + Number(ageBtn.dataset.vhpAge)));
      state.kcalManual = false;
      syncKcal();
      persist();
      render();
      return;
    }

    const kcalBtn = t.closest('[data-vhp-kcal]');
    if (kcalBtn) {
      const base = state.kcal ?? computeKcal() ?? 2000;
      state.kcal = Math.min(KCAL_MAX, Math.max(KCAL_MIN, base + Number(kcalBtn.dataset.vhpKcal)));
      state.kcalManual = true;
      persist();
      render();
      return;
    }

    if (t.closest('[data-vhp-kcal-toggle]')) {
      const edit = $('[data-vhp-kcal-edit]');
      edit.hidden = !edit.hidden;
      return;
    }

    const presetBtn = t.closest('[data-vhp-macro-preset]');
    if (presetBtn) {
      applyMacroPreset(presetBtn.dataset.vhpMacroPreset);
      persist();
      render();
      return;
    }

    if (t.closest('[data-vhp-macro-reset]')) {
      applyMacroPreset('recommended');
      persist();
      render();
      return;
    }

    const goalKcal = t.closest('[data-vhp-goal-kcal]');
    if (goalKcal) {
      if (goalKcal.disabled) return;
      const base = state.kcal ?? computeKcal() ?? 2000;
      const delta = Number(goalKcal.dataset.vhpGoalKcal);
      // Snap to the step grid: the suggestion is rounded to 10 (1840), so +50 goes to 1850, not 1890.
      const step = Math.abs(delta);
      applyGoalKcal(delta > 0 ? Math.floor(base / step) * step + step : Math.ceil(base / step) * step - step);
      return;
    }

    if (t.closest('[data-vhp-goal-kcal-revert]')) {
      revertGoalKcal();
      return;
    }

    const mealPreset = t.closest('[data-vhp-meal-preset]');
    if (mealPreset) {
      mealsAction(() => setMealShares(MEAL_PRESETS[mealPreset.dataset.vhpMealPreset]));
      return;
    }

    const mealRemove = t.closest('[data-vhp-meal-remove]');
    if (mealRemove) {
      const id = mealRemove.dataset.vhpMealRemove;
      mealsAction(() => {
        const shares = mealSplit();
        const block = mealRemoveBlock(shares, id);
        if (block) mealNudge = { id, key: block };
        else setMealShares(withoutMeal(shares, id));
      });
      if (mealNudge) {
        // The row shakes (again on every refused tap) and the line under the list says why.
        const row = mealRemove.closest('[data-vhp-meal-row]');
        row?.classList.remove('is-shake');
        void row?.offsetWidth;
        row?.classList.add('is-shake');
        $('[data-vhp-meal-note]')?.scrollIntoView({ block: 'nearest', behavior: motionOk() ? 'smooth' : 'auto' });
      }
      return;
    }

    const mealAdd = t.closest('[data-vhp-meal-add]');
    if (mealAdd) {
      mealsAction(() => setMealShares(withMeal(mealSplit(), mealAdd.dataset.vhpMealAdd)));
      return;
    }

    const mealFixBtn = t.closest('[data-vhp-meal-fix]');
    if (mealFixBtn) {
      const values = mealFixBtn.dataset.vhpMealFix.split(',').map(Number);
      mealsAction(() => setMealShares(Object.fromEntries(MEAL_IDS.map((id, i) => [id, values[i]]))));
      return;
    }

    if (t.closest('[data-vhp-goal-regen-run]')) {
      runSettingsRegen();
      return;
    }

    const exBtn = t.closest('[data-vhp-toggle-ex]');
    if (exBtn) {
      const key = exBtn.dataset.vhpToggleEx;
      state.exclusions = state.exclusions.includes(key)
        ? state.exclusions.filter((k) => k !== key)
        : [...state.exclusions, key];
      failed.clear();
      state.likes.items = state.likes.items.filter((item) => {
        const card = planner.cards(item.slot).find((row) => productId(row.id) === item.id);
        return !(card && isExcluded(card));
      });
      if (state.undo?.action === 'like' && !state.likes.items.some((item) => item.id === state.undo.item.id)) {
        state.undo = null;
      }
      if (state.pin && !likeItems().some((item) => item.id === state.pin) && state.undo?.item?.id !== state.pin) {
        const stillInPool = selectedSlots().some((slot) => poolFor(slot).some((card) => productId(card.id) === state.pin));
        if (!stillInPool) state.pin = null;
      }
      persist();
      if (planner.config.paid && favSheet()?.open) {
        state.pendingFlush = true;
        flushProfile();
      }
      render();
      return;
    }

    const mealMore = t.closest('[data-vhp-meal-more]');
    if (mealMore) {
      openMealSheet(mealMore.dataset.vhpMealMore);
      return;
    }

    const mealAct = t.closest('[data-vhp-meal-act]');
    if (mealAct) {
      runMealAct(mealAct.dataset.vhpMealAct);
      return;
    }

    const copyAs = t.closest('[data-vhp-copy-occasion]');
    if (copyAs) {
      copyPick.as = copyAs.dataset.vhpCopyOccasion;
      pruneCopyTargets();
      paintCopySheet();
      return;
    }

    const copyDay = t.closest('[data-vhp-copy-day]');
    if (copyDay) {
      const key = copyDay.dataset.vhpCopyDay;
      if (copyPick.targets.has(key)) copyPick.targets.delete(key);
      else copyPick.targets.add(key);
      paintCopySheet();
      $(`[data-vhp-copy-day="${key}"]`)?.focus({ preventScroll: true });
      return;
    }

    const copyAll = t.closest('[data-vhp-copy-all]');
    if (copyAll) {
      const keys = [...funnel.querySelectorAll('[data-vhp-copy-day]')]
        .map((btn) => btn.dataset.vhpCopyDay)
        .filter((key) => key.startsWith(`${copyAll.dataset.vhpCopyAll}|`));
      const all = keys.every((key) => copyPick.targets.has(key));
      keys.forEach((key) => (all ? copyPick.targets.delete(key) : copyPick.targets.add(key)));
      paintCopySheet();
      $(`[data-vhp-copy-all="${copyAll.dataset.vhpCopyAll}"]`)?.focus({ preventScroll: true });
      return;
    }

    if (t.closest('[data-vhp-copy-prepped]')) {
      copyPick.prepped = !copyPick.prepped;
      paintCopySheet();
      return;
    }

    if (t.closest('[data-vhp-copy-repeat]')) {
      copyPick.repeat = !copyPick.repeat;
      paintCopySheet();
      return;
    }

    const awayRemove = t.closest('[data-vhp-away-remove]');
    if (awayRemove) {
      state.awayRepeat = (state.awayRepeat || []).filter((rule) => rule.occasion !== awayRemove.dataset.vhpAwayRemove);
      persist();
      state.pendingFlush = true;
      flushProfile();
      render();
      return;
    }

    const repeatRemove = t.closest('[data-vhp-repeat-remove]');
    if (repeatRemove) {
      state.repeat = (state.repeat || []).filter((rule) => rule.occasion !== repeatRemove.dataset.vhpRepeatRemove);
      persist();
      state.pendingFlush = true;
      flushProfile();
      render();
      return;
    }

    if (t.closest('[data-vhp-copy-confirm]')) {
      confirmCopy();
      return;
    }

    if (t.closest('[data-vhp-copy-cancel]')) {
      closeCopySheet();
      return;
    }

    const weekSwap = t.closest('[data-vhp-week-swap]');
    if (weekSwap) {
      if (weekSwap.disabled) return;
      openSwapSheet(weekSwap.dataset.vhpWeekSwap);
      return;
    }


    const customOpen = t.closest('[data-vhp-custom-open]');
    if (customOpen) {
      openCustomRecipeSheet({
        id: customOpen.dataset.vhpCustomOpen,
        scale: customOpen.dataset.vhpRecipeScale,
        occasion: customOpen.dataset.vhpRecipeOccasion,
      });
      return;
    }

    const ownEdit = t.closest('[data-vhp-recipes-edit-own]');
    if (ownEdit) {
      closeRecipeSheet();
      customRecipes()?.openForm({ id: ownEdit.dataset.vhpRecipesEditOwn });
      return;
    }

    if (t.closest('[data-vhp-recipes-manage]')) {
      customRecipes()?.openManager();
      return;
    }

    if (t.closest('[data-vhp-own-open]')) {
      openOwnFromWeek();
      return;
    }

    const swapOwn = t.closest('[data-vhp-swap-own]');
    if (swapOwn) {
      startOwnRecipe(swapOwn.dataset.vhpSwapOwn);
      return;
    }

    const mealPlay = t.closest('[data-vhp-meal-play]');
    if (mealPlay) {
      openDayReel(mealPlay);
      return;
    }

    const recipeOpen = t.closest('[data-vhp-recipe-open]');
    if (recipeOpen) {
      openRecipeSheet({
        handle: recipeOpen.dataset.vhpRecipeOpen,
        scale: recipeOpen.dataset.vhpRecipeScale,
        title: recipeOpen.dataset.vhpRecipeTitle,
        occasion: recipeOpen.dataset.vhpRecipeOccasion,
      });
      return;
    }

    if (t.closest('[data-vhp-recipe-why]')) {
      recipeWhyOpen = !recipeWhyOpen;
      paintRecipeWho();
      return;
    }

    const recipeWhoBtn = t.closest('[data-vhp-recipe-who-btn]');
    if (recipeWhoBtn) {
      recipeWho = recipeWhoBtn.dataset.vhpRecipeWhoBtn === 'me' ? 'me' : 'all';
      paintRecipeWho();
      const body = recipeSheet()?.body();
      if (body?.querySelector('.vhp-recipe-ings__amt')) scaleRecipeAmounts(body, recipeSheetPortions.n, recipeCookPortions());
      return;
    }

    // Meal-Prep setting: saved, then applied to the planned weeks right away (applyLeftoverSetting).
    const leftoversSet = t.closest('[data-vhp-leftovers-set]');
    if (leftoversSet) {
      setLeftoverSpan(Number(leftoversSet.dataset.vhpLeftoversSet));
      return;
    }

    // Meal-Prep sheet (a draft until Übernehmen) and the Vorkochen card on the cook day.
    const prepCook = t.closest('[data-vhp-prep-cook]');
    if (prepCook) {
      pickPrepCook(Number(prepCook.dataset.vhpPrepCook));
      return;
    }
    const prepSlotBtn = t.closest('[data-vhp-prep-slot]');
    if (prepSlotBtn) {
      togglePrepSlot(prepSlotBtn.dataset.vhpPrepSlot, prepSlotBtn.dataset.vhpPrepWhy || '');
      return;
    }
    if (t.closest('[data-vhp-prep-prepped]')) {
      togglePrepPrepped();
      return;
    }
    if (t.closest('[data-vhp-prep-apply]')) {
      applyPrep();
      return;
    }
    if (t.closest('[data-vhp-prep-cancel]')) {
      closePrepSheet();
      return;
    }
    const prepTodayRecipe = t.closest('[data-vhp-prep-today-recipe]');
    if (prepTodayRecipe) {
      openPrepTodayRecipe(Number(prepTodayRecipe.dataset.vhpPrepTodayRecipe));
      return;
    }
    const prepTodayOpen = t.closest('[data-vhp-prep-today-open]');
    if (prepTodayOpen) {
      openPrepToday(Number(prepTodayOpen.dataset.vhpPrepTodayOpen));
      return;
    }

    const householdBtn = t.closest('[data-vhp-household-n]');
    if (householdBtn) {
      const h = normalizeHousehold(state.household);
      state.household = { ...h, n: Math.min(HOUSEHOLD_MAX, Math.max(1, h.n + Number(householdBtn.dataset.vhpHouseholdN))) };
      saveHousehold();
      return;
    }

    const householdMeal = t.closest('[data-vhp-household-meal]');
    if (householdMeal) {
      const h = normalizeHousehold(state.household);
      const id = householdMeal.dataset.vhpHouseholdMeal;
      const shared = h.shared.includes(id) ? h.shared.filter((row) => row !== id) : [...h.shared, id];
      // At least one shared meal while cooking for more people.
      if (!shared.length) return;
      state.household = { ...h, shared: HOUSEHOLD_MEALS.filter((row) => shared.includes(row)) };
      saveHousehold();
      return;
    }

    const householdSize = t.closest('[data-vhp-household-size]');
    if (householdSize) {
      const size = Number(householdSize.dataset.vhpHouseholdSize);
      if (!HOUSEHOLD_SIZES.includes(size)) return;
      state.household = { ...normalizeHousehold(state.household), size };
      saveHousehold();
      return;
    }

    if (t.closest('[data-vhp-shop-household]')) {
      openSettingsAt('[data-vhp-household]');
      return;
    }

    // Like the feed: the ↑ button, the title and the macros open the recipe.
    const swipeRecipe = t.closest('[data-vhp-swipe-info], [data-vhp-swipe-recipe], [data-vhp-swipe-card] .vhp-swipe-card__title, [data-vhp-swipe-card] .vhp-swipe-card__macros');
    if (swipeRecipe) {
      event.preventDefault();
      const current = deckCard();
      if (!current?.handle) return;
      openRecipeSheet({ handle: current.handle, scale: 1, title: current.title });
      return;
    }

    const swapCardBtn = t.closest('[data-vhp-swap-card]');
    if (swapCardBtn && swapUi) {
      openSwapReel(Number(swapCardBtn.dataset.vhpSwapCard) || 0);
      return;
    }

    const swapChip = t.closest('[data-vhp-swap-chip]');
    if (swapChip && swapUi) {
      if (swapChip.dataset.vhpSwapChip === swapUi.chip) return;
      applySwapChip(swapChip.dataset.vhpSwapChip);
      const scroll = funnel.querySelector('[data-vhp-swap-scroll]');
      if (scroll) scroll.scrollTop = 0;
      renderSwapResults();
      // The new choice rises in (the first cards one after another), the chip itself centres in its row.
      const list = funnel.querySelector('[data-vhp-swap-results]');
      if (list && motionOk()) {
        list.classList.remove('is-enter');
        void list.offsetWidth;
        list.classList.add('is-enter');
        window.clearTimeout(list.vhpEnter);
        list.vhpEnter = window.setTimeout(() => list.classList.remove('is-enter'), 700);
      }
      funnel.querySelector(`[data-vhp-swap-chip="${swapUi.chip}"]`)?.scrollIntoView({ block: 'nearest', inline: 'center', behavior: motionOk() ? 'smooth' : 'auto' });
      return;
    }

    if (t.closest('[data-vhp-swap-all]') && swapUi) {
      applySwapChip('best');
      renderSwapResults();
      return;
    }

    if (t.closest('[data-vhp-swap-leftover]') && swapUi) {
      applyLeftoverPick();
      return;
    }

    const swapPick = t.closest('[data-vhp-swap-pick]');
    if (swapPick) {
      applySwapPick(swapPick.dataset.vhpSwapPick, swapPick.dataset.vhpSwapScale);
      return;
    }

    if (t.closest('[data-vhp-swap-discover]')) {
      startDiscoverFromSheet();
      return;
    }

    if (t.closest('[data-vhp-swap-browse]')) {
      closeSwapSheet();
      openRecipes();
      return;
    }

    // Lock / swap / Neu generieren / Einkaufsliste on the preview: locked until the subscription.
    const paywallBtn = t.closest('[data-vhp-paywall]');
    if (paywallBtn) {
      continueToSubscribe(paywallBtn.dataset.vhpPaywall);
      return;
    }

    const weekDay = t.closest('[data-vhp-week-day]');
    if (weekDay) {
      pickWeekDay(Number(weekDay.dataset.vhpWeekDay) || 0);
      return;
    }

    const weekStep = t.closest('[data-vhp-week-step]');
    if (weekStep) {
      if (!weekStep.disabled) stepWeekDay(Number(weekStep.dataset.vhpWeekStep) || 0);
      return;
    }


    if (t.closest('[data-vhp-week-undo]')) {
      applyRegenUndo();
      return;
    }

    const weekGo = t.closest('[data-vhp-week-go]');
    if (weekGo) {
      showWeekOf(mondayIso(weekGo.dataset.vhpWeekGo === 'next' ? 1 : 0));
      return;
    }

    if (t.closest('[data-vhp-week-plan-next]')) {
      planNextWeek();
      return;
    }

    if (t.closest('[data-vhp-week-repeat]')) {
      planNextWeek({ repeat: true });
      return;
    }

    if (t.closest('[data-vhp-week-regen-all]')) {
      if (weekGenerating || !weekHasUnlocked(state.week)) return;
      openRegenConfirm();
      return;
    }

    if (t.closest('[data-vhp-week-confirm-cancel]')) {
      closeRegenConfirm();
      return;
    }

    if (t.closest('[data-vhp-week-confirm-ok]')) {
      closeRegenConfirm();
      runRemix('week');
      return;
    }

    if (t.closest('[data-vhp-week-regen]')) {
      runRemix('day');
      return;
    }

    if (t.closest('[data-vhp-week-shop]')) {
      openTab('shop');
      return;
    }

    // ---------- Rezepte tab ----------
    if (t.closest('[data-vhp-rx-create]')) {
      customRecipes()?.openForm({});
      return;
    }

    const rxOpen = t.closest('[data-vhp-rx-open]');
    if (rxOpen && inRecipes()) {
      const kind = rxOpen.dataset.vhpRxOpen === 'own' ? 'own' : 'likes';
      openSet({ kind, id: kind, title: kind === 'own' ? tr('planner.own') : tr('planner.favorites') });
      return;
    }

    const rxCat = t.closest('[data-vhp-rx-cat]');
    if (rxCat && inRecipes()) {
      const cat = findCategory(hubCards(), rxCat.dataset.vhpRxCat);
      if (cat) openSet({ kind: 'category', id: cat.id, title: cat.label });
      return;
    }

    if (t.closest('[data-vhp-rx-back]')) {
      closeSet();
      return;
    }

    if (t.closest('[data-vhp-rx-hero]')) {
      openReelFromHero();
      return;
    }

    if (t.closest('[data-vhp-rx-reel]')) {
      const first = $('[data-vhp-hub-grid] [data-vhp-rx-card]');
      if (first) openReelFromSet(first.dataset.vhpRxCard);
      return;
    }

    const rxLike = t.closest('[data-vhp-rx-like]');
    if (rxLike) {
      toggleRecipeLike(rxLike.dataset.vhpRxLike);
      return;
    }

    const rxCard = t.closest('[data-vhp-rx-card]');
    if (rxCard) {
      openReelFromSet(rxCard.dataset.vhpRxCard);
      return;
    }

    const tab = t.closest('[data-vhp-tab]');
    if (tab) {
      openTab(tab.dataset.vhpTab);
      return;
    }

    const edit = t.closest('[data-vhp-edit]');
    if (edit) {
      startSettingsEdit(edit.dataset.vhpEdit);
      return;
    }

    if (t.closest('[data-vhp-shop-reset]')) {
      writeShopChecks(new Set());
      shopCopied = false;
      renderShop();
      return;
    }

    const shopDay = t.closest('[data-vhp-shop-day]');
    if (shopDay) {
      const day = Number(shopDay.dataset.vhpShopDay);
      const days = readShopDays();
      const next = days.includes(day) ? days.filter((row) => row !== day) : [...days, day].sort();
      if (!next.length) return;
      writeShopDays(next);
      shopCopied = false;
      shopList = buildShoppingList();
      renderShop();
      return;
    }

    if (t.closest('[data-vhp-shop-pantry-toggle]')) {
      shopPantryOpen = !shopPantryOpen;
      renderShop();
      return;
    }

    if (t.closest('[data-vhp-shop-edit]')) {
      shopEdit = !shopEdit;
      renderShop();
      return;
    }

    const shopMove = t.closest('[data-vhp-shop-move]');
    if (shopMove && shopRules) {
      const item = [...shopList.items, ...shopList.pantry].find((row) => row.key === shopMove.dataset.vhpShopMove);
      if (!item) return;
      const key = shopRules.canonical(item.name);
      const pantry = normalizePantry(state.pantry);
      const toPantry = !shopList.pantry.includes(item);
      pantry.have = pantry.have.filter((row) => row !== key);
      pantry.buy = pantry.buy.filter((row) => row !== key);
      const byDefault = shopRules.isPantryDefault(item.name, item.unit);
      if (toPantry && !byDefault) pantry.have.push(key);
      if (!toPantry && byDefault) pantry.buy.push(key);
      state.pantry = normalizePantry(pantry);
      savePantry();
      shopList = buildShoppingList();
      renderShop();
      return;
    }

    const shopLine = t.closest('[data-vhp-shop-key]');
    if (shopLine) {
      const checks = readShopChecks();
      const key = shopLine.dataset.vhpShopKey;
      if (checks.has(key)) checks.delete(key);
      else checks.add(key);
      writeShopChecks(checks);
      shopCopied = false;
      const on = checks.has(key);
      shopLine.classList.toggle('is-on', on);
      shopLine.setAttribute('aria-pressed', on ? 'true' : 'false');
      fillShopProgress(checks);
      const copyBtn = $('[data-vhp-shop-copy]');
      if (copyBtn) {
        const copyLabel = copyBtn.querySelector('[data-vhp-shop-copy-label]');
        if (copyLabel) copyLabel.textContent = canShareList() ? tr('planner.share_list') : tr('planner.copy_list');
      }
      return;
    }

    if (t.closest('[data-vhp-shop-copy]')) {
      const text = shopShareText();
      if (canShareList()) {
        navigator.share({ title: tr('planner.shopping_list'), text }).catch(() => {});
        return;
      }
      const done = () => {
        shopCopied = true;
        renderShop();
        window.setTimeout(() => {
          shopCopied = false;
          if (state.screen === 'shop') renderShop();
        }, 1500);
      };
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(() => {});
      } else {
        const area = document.createElement('textarea');
        area.value = text;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.left = '-9999px';
        document.body.append(area);
        area.select();
        try {
          document.execCommand('copy');
          done();
        } catch (e) { /* ignore */ }
        area.remove();
      }
      return;
    }

    const swipeBtn = t.closest('[data-vhp-swipe]');
    if (swipeBtn) {
      const act = swipeBtn.dataset.vhpSwipe;
      if (act === 'undo') undoSwipe();
      else swipeDeck?.flyOut(act);
      return;
    }

    if (t.closest('[data-vhp-back]')) goBack();
    else if (t.closest('[data-vhp-next]')) {
      if (!exclusionsReply()) goNext();
    } else if (t.closest('[data-vhp-plan]')) createPlan();
    else if (t.closest('[data-vhp-open-week]')) openWeek();
    else if (t.closest('[data-vhp-subscribe]')) continueToSubscribe('cta');
    else if (t.closest('[data-vhp-checkout]')) startCheckout();
    else if (t.closest('[data-vhp-consent-ok]')) {
      bridgePassed = true;
      state.consentPlanner = true;
      state.consentAt = state.consentAt || new Date().toISOString();
      persist();
      startCheckout();
      if (!checkingOut) $('[data-vhp-consent-dialog]')?.close();
    } else if (t.closest('[data-vhp-consent-cancel]')) $('[data-vhp-consent-dialog]')?.close();
    else if (t.closest('[data-vhp-grid-pick]')) gridPick(t.closest('[data-vhp-grid-pick]').dataset.vhpGridPick);
    else if (t.closest('[data-vhp-grid-play]')) openGridReel(t.closest('[data-vhp-grid-play]').dataset.vhpGridPlay);
    else if (t.closest('[data-vhp-grid-chip]')) gridSetChip(t.closest('[data-vhp-grid-chip]').dataset.vhpGridChip);
    else if (t.closest('[data-vhp-grid-search-open]')) gridSearchToggle(!gridSearchOpen);
    else if (t.closest('[data-vhp-grid-search-close]')) gridSearchToggle(false);
    else if (t.closest('[data-vhp-grid-slot]')) gridPick(t.closest('[data-vhp-grid-slot]').dataset.vhpGridSlot);
    else if (t.closest('[data-vhp-grid-more]')) gridMore();
    else if (t.closest('[data-vhp-grid-plan]')) {
      if (planReady()) createPlan();
      else if (likeCount() > 0) createPlan({ skip: true });
    } else if (t.closest('[data-vhp-grid-skip]')) createPlan({ skip: true });
    else if (t.closest('[data-vhp-daylist-more]')) {
      dayListOpen = !dayListOpen;
      renderPreviewDayList(state.preview);
    } else if (t.closest('[data-vhp-daylist-item]')) {
      const item = t.closest('[data-vhp-daylist-item]');
      const done = item.getAttribute('aria-pressed') !== 'true';
      item.setAttribute('aria-pressed', done ? 'true' : 'false');
      item.classList.toggle('is-done', done);
    } else if (t.closest('[data-vhp-wait-login]')) {
      step('paid_claim', 'login');
      window.vhpPlannerEvents?.flush?.();
    } else if (t.closest('[data-vhp-wait-leave]')) {
      if (paidClaim === 'login') step('paid_claim', 'leave');
      leaveCheckout();
      render();
    } else if (t.closest('[data-vhp-wait-retry]')) {
      try {
        sessionStorage.setItem(PAID_WAIT_KEY, '0');
      } catch (e) { /* ignore */ }
      location.reload();
    }
    else if (t.closest('[data-vhp-edit-exclusions]')) {
      const top = state.history[state.history.length - 1];
      if (top?.screen === 'exclusions') state.history.pop();
      show('exclusions', null, 'back');
    }
  });

  funnel.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    // The reel (assets/vhp-reel-viewer.js, a dialog inside the funnel) closes itself; the swap sheet under it stays.
    if (event.target.closest?.('.vhp-reel')) return;
    // The recipe sheet (and cook mode over it) close themselves.
    if (recipeSheetOpen() || window.vhpCook?.isOpen()) return;
    if (mealSheet) {
      event.preventDefault();
      closeMealSheet();
      return;
    }
    if (copySheet()?.open) {
      event.preventDefault();
      closeCopySheet();
      return;
    }
    if (prepSheetEl()?.open) {
      event.preventDefault();
      closePrepSheet();
      return;
    }
    if (favSheet()?.open) {
      event.preventDefault();
      if (fav.menu) closeFavMenu();
      else closeFavSheet();
      return;
    }
    if (swapUi) {
      event.preventDefault();
      closeSwapSheet();
    }
  });

  const mealSheetDialog = mealSheetEl();
  if (mealSheetDialog) {
    mealSheetDialog.addEventListener('click', (event) => {
      if (event.target === mealSheetDialog) closeMealSheet();
    });
    mealSheetDialog.addEventListener('close', () => {
      mealSheet = null;
      mealSheetDialog.classList.remove('is-dragging', 'is-open');
      const panel = mealSheetDialog.querySelector('.vhp-sheet__panel');
      if (panel) panel.style.transform = '';
    });
    window.vhpSheet?.bindDrag(mealSheetDialog, closeMealSheet);
  }
  const pvSheetDialog = pvSheetEl();
  if (pvSheetDialog) {
    pvSheetDialog.addEventListener('click', (event) => {
      if (event.target === pvSheetDialog) closePvSheet();
    });
    pvSheetDialog.addEventListener('close', () => {
      pvSheet = null;
      pvSheetDialog.classList.remove('is-dragging', 'is-open');
      const panel = pvSheetDialog.querySelector('.vhp-sheet__panel');
      if (panel) panel.style.transform = '';
    });
    window.vhpSheet?.bindDrag(pvSheetDialog, closePvSheet);
  }

  const swapSheet = funnel.querySelector('[data-vhp-swap-sheet]');
  const swapScroll = funnel.querySelector('[data-vhp-swap-scroll]');
  if (swapScroll) {
    swapScroll.addEventListener('scroll', onSwapResultsScroll, { passive: true });
  }
  if (swapSheet) {
    swapSheet.setAttribute('aria-modal', 'true');
    swapSheet.addEventListener('close', () => {
      window.clearTimeout(swapSearchTimer);
      swapSearchTimer = 0;
      swapUi = null;
      swapSheet.classList.remove('is-dragging', 'is-open');
      const panel = swapSheet.querySelector('.vhp-sheet__panel');
      if (panel) panel.style.transform = '';
      const q = funnel.querySelector('[data-vhp-swap-q]');
      if (q) {
        q.value = '';
        q.readOnly = true;
      }
    });
    const swapQ = swapSheet.querySelector('[data-vhp-swap-q]');
    if (swapQ) {
      swapQ.readOnly = true;
      swapQ.addEventListener('pointerdown', () => {
        swapQ.readOnly = false;
      });
    }
    swapSheet.addEventListener('click', (event) => {
      if (event.target === swapSheet) closeSwapSheet();
    });
    swapSheet.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || !swapSheet.open) return;
      const nodes = Array.from(
        swapSheet.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]')
      );
      if (nodes.length < 2) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }
  if (swapSheet) window.vhpSheet?.bindDrag(swapSheet, closeSwapSheet);
  // Planner skin v3: scrolling the cards folds the head (photo, kicker, "statt …", pills) into a compact bar, like a
  // large title; back at the top it opens again. A little hysteresis so it doesn't flicker at the edge.
  const swapScrollEl = swapSheet?.querySelector('[data-vhp-swap-scroll]');
  const swapPanelEl = swapSheet?.querySelector('[data-vhp-swap-panel]');
  if (swapScrollEl && swapPanelEl) {
    swapScrollEl.addEventListener('scroll', () => {
      const top = swapScrollEl.scrollTop;
      const folded = swapPanelEl.classList.contains('is-collapsed');
      if (!folded && top > 36) swapPanelEl.classList.add('is-collapsed');
      else if (folded && top < 6) swapPanelEl.classList.remove('is-collapsed');
    }, { passive: true });
    swapSheet.addEventListener('close', () => swapPanelEl.classList.remove('is-collapsed'));
  }


  // Horizontal swipe: the finger drags `target` along (rubber band where there is nothing to go to); a flick or
  // about a quarter of the width commits. Vertical scrolling stays with the page.
  const bindWeekSwipe = (el, { target, can, go }) => {
    let start = null;
    let axis = '';
    const settle = () => {
      target.style.transition = '';
      target.style.transform = '';
    };
    el.addEventListener('touchstart', (event) => {
      start = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY, t: event.timeStamp } : null;
      axis = '';
    }, { passive: true });
    el.addEventListener('touchmove', (event) => {
      if (!start) return;
      const dx = event.touches[0].clientX - start.x;
      const dy = event.touches[0].clientY - start.y;
      if (!axis && Math.hypot(dx, dy) > 8) axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (axis !== 'x' || !motionOk()) return;
      target.style.transition = 'none';
      target.style.transform = `translateX(${dx * (can(dx < 0 ? 1 : -1) ? 0.6 : 0.15)}px)`;
    }, { passive: true });
    el.addEventListener('touchend', (event) => {
      const from = start;
      start = null;
      settle();
      const touch = event.changedTouches[0];
      if (!from || !touch || axis !== 'x') return;
      const dx = touch.clientX - from.x;
      const flick = Math.abs(dx) > 30 && event.timeStamp - from.t < 250;
      const dir = dx < 0 ? 1 : -1;
      if ((flick || Math.abs(dx) > el.clientWidth * 0.22) && can(dir)) go(dir);
    });
    el.addEventListener('touchcancel', () => {
      start = null;
      settle();
    });
  };

  // Week head: the strip switches weeks (the › / ‹ arrow hints at it), the numbers step day by day.
  const weekStrip = $('[data-vhp-week-strip]');
  const weekStripDays = $('[data-vhp-week-days]');
  if (weekStrip && weekStripDays) {
    bindWeekSwipe(weekStrip, {
      target: weekStripDays,
      can: (dir) => planner.config.paid && (dir > 0 ? !viewingNextWeek() : viewingNextWeek()),
      go: (dir) => showWeekOf(mondayIso(dir > 0 ? 1 : 0)),
    });
  }
  const weekStats = $('[data-vhp-week-daycard]');
  const weekStatsBody = $('[data-vhp-week-body]');
  if (weekStats && weekStatsBody) {
    bindWeekSwipe(weekStats, {
      target: weekStatsBody,
      can: canStepWeekDay,
      go: (dir) => {
        stepWeekDay(dir);
        if (!motionOk()) return;
        weekStatsBody.classList.remove('is-from-next', 'is-from-prev');
        void weekStatsBody.offsetWidth;
        weekStatsBody.classList.add(dir > 0 ? 'is-from-next' : 'is-from-prev');
      },
    });
  }

  // Mahlzeiten ring: drag a knob (pointer) or move it with the arrow keys (1 % a step).
  funnel.addEventListener('pointerdown', (event) => {
    const handle = event.target.closest('[data-vhp-meal-handle]');
    if (!handle) return;
    event.preventDefault();
    const svg = $('[data-vhp-meal-svg]');
    if (!svg) return;
    mealDrag = Number(handle.dataset.vhpMealHandle);
    mealNudge = null;
    renderMeals();
    const move = (ev) => {
      const box = svg.getBoundingClientRect();
      const dx = ev.clientX - (box.left + box.width / 2);
      const dy = ev.clientY - (box.top + box.height / 2);
      let a = (Math.atan2(dx, -dy) * 180) / Math.PI;
      if (a < 0) a += 360;
      moveMealKnob(mealDrag, a / 3.6);
      renderMeals();
    };
    const up = () => {
      mealDrag = null;
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
      window.removeEventListener('pointercancel', up);
      renderMeals();
      renderSettings();
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);
  });

  funnel.addEventListener('keydown', (event) => {
    const handle = event.target.closest?.('[data-vhp-meal-handle]');
    if (!handle) return;
    const dir = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1 }[event.key];
    if (!dir) return;
    event.preventDefault();
    const i = Number(handle.dataset.vhpMealHandle);
    const shares = mealSplit();
    const on = mealsOn(shares);
    const end = on.slice(0, i + 1).reduce((sum, id) => sum + shares[id], 0);
    mealsAction(() => moveMealKnob(i, end + dir));
  });

  funnel.addEventListener('pointerdown', (event) => {
    const handle = event.target.closest('[data-vhp-macro-handle]');
    if (!handle) return;
    event.preventDefault();
    const svg = $('[data-vhp-macro-svg]');
    if (!svg) return;
    const h = Number(handle.dataset.vhpMacroHandle);
    macroDrag = h;
    renderMacros();
    const move = (ev) => {
      const box = svg.getBoundingClientRect();
      const dx = ev.clientX - (box.left + box.width / 2);
      const dy = ev.clientY - (box.top + box.height / 2);
      let a = (Math.atan2(dx, -dy) * 180) / Math.PI;
      if (a < 0) a += 360;
      applyRingDrag(h, a / 3.6);
      persist();
      renderMacros();
    };
    const up = () => {
      macroDrag = null;
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
      persist();
      renderMacros();
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  });

  funnel.addEventListener('change', (event) => {
    const box = event.target.closest('[data-vhp-consent]');
    if (!box) return;
    if (box.dataset.vhpConsent === 'planner') {
      state.consentPlanner = box.checked;
      if (box.checked) {
        state.consentAt = state.consentAt || new Date().toISOString();
      } else {
        state.consentAt = null;
        state.pendingFlush = false;
        state.profileSaved = false;
      }
    } else if (box.dataset.vhpConsent === 'marketing') {
      state.consentMarketing = box.checked;
      if (state.profileSaved) state.profileSaved = false;
    }
    persist();
    render();
  });

  funnel.addEventListener('input', (event) => {
    // Sörens Woche's question screen: the typed number arms the button; the weight slider recomputes the estimate.
    const soerenKcalIn = event.target.closest('[data-vhp-soeren-kcal]');
    if (soerenKcalIn) {
      const value = Number(soerenKcalIn.value);
      state.soerenKcal = soerenKcalValid(value) ? Math.round(value) : null;
      const go = $('[data-vhp-soeren-go]');
      if (go) go.disabled = !soerenKcalValid(value);
      return;
    }
    const soerenWeightIn = event.target.closest('[data-vhp-soeren-weight]');
    if (soerenWeightIn) {
      soerenSetWeight(soerenWeightIn.value);
      return;
    }
    const swapQ = event.target.closest('[data-vhp-swap-q]');
    if (swapQ) {
      if (!swapUi) return;
      swapUi.query = swapQ.value;
      window.clearTimeout(swapSearchTimer);
      if (!swapQ.value.trim()) {
        renderSwapResults();
        return;
      }
      swapSearchTimer = window.setTimeout(() => renderSwapResults(), SWAP_SEARCH_MS);
      return;
    }
    const input = event.target.closest('[data-vhp-input]');
    if (!input) return;
    const digits = input.value.replace(/\D/g, '');
    if (digits !== input.value) input.value = digits;
    const n = parseInt(digits, 10);
    state[input.dataset.vhpInput] = Number.isFinite(n) ? n : null;
    state.kcalManual = false;
    syncKcal();
    persist();
    render();
  });

  funnel.addEventListener('focusin', (event) => {
    const input = event.target.closest('[data-vhp-input]');
    if (input) window.requestAnimationFrame(() => input.select());
  });

  // Story v2: the first name (1.2b), cleaned when they leave the field; Enter goes on to the height. Device only.
  const saveName = (input) => {
    const name = cleanName(input.value);
    input.value = name;
    if (name === state.name) return;
    state.name = name;
    persist();
    render();
  };
  funnel.addEventListener('change', (event) => {
    const input = event.target.closest?.('[data-vhp-name]');
    if (input) saveName(input);
  });
  funnel.addEventListener('keydown', (event) => {
    const input = event.key === 'Enter' ? event.target.closest?.('[data-vhp-name]') : null;
    if (!input) return;
    event.preventDefault();
    saveName(input);
    $('[data-vhp-input="height"]')?.focus();
  });

  funnel.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && event.target.closest('[data-vhp-input]')) goNext();
  });

  const rxQuery = $('[data-vhp-rx-q]');
  if (rxQuery) {
    rxQuery.addEventListener('input', () => {
      const value = rxQuery.value;
      window.clearTimeout(hubSearchTimer);
      hubSearchTimer = window.setTimeout(() => {
        const wasSearching = Boolean(hub.query.trim());
        if (!wasSearching && value.trim() && !hub.set) hub.hubTop = recipesScroller()?.scrollTop || 0;
        hub.query = value;
        hubGridKey = '';
        if (!inRecipes()) return;
        render();
        if (wasSearching && !value.trim() && !hub.set) {
          const scroller = recipesScroller();
          if (scroller) scroller.scrollTop = hub.hubTop || 0;
        }
      }, 200);
    });
    rxQuery.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') rxQuery.blur();
    });
  }

  bindFavSheet();

  const copySheetEl = copySheet();
  if (copySheetEl) {
    copySheetEl.addEventListener('close', () => {
      if (copySheetEl.open) return;
      copySheetEl.classList.remove('is-dragging', 'is-open');
      const panel = copySheetEl.querySelector('.vhp-sheet__panel');
      if (panel) panel.style.transform = '';
      copyPick.targets = new Set();
      copyPick.card = null;
      if (recipesMediaHeld && !recipeSheetOpen()) {
        recipesMediaHeld = false;
        syncRecipesMedia();
      }
    });
    copySheetEl.addEventListener('click', (event) => {
      if (event.target === copySheetEl) closeCopySheet();
    });
    window.vhpSheet?.bindDrag(copySheetEl, closeCopySheet);
  }

  const prepSheetNode = prepSheetEl();
  if (prepSheetNode) {
    prepSheetNode.addEventListener('close', () => {
      if (prepSheetNode.open) return;
      prepSheetNode.classList.remove('is-dragging', 'is-open');
      const panel = prepSheetNode.querySelector('.vhp-sheet__panel');
      if (panel) panel.style.transform = '';
      prep = null;
    });
    prepSheetNode.addEventListener('click', (event) => {
      if (event.target === prepSheetNode) closePrepSheet();
    });
    window.vhpSheet?.bindDrag(prepSheetNode, closePrepSheet);
  }

  // After paying (2026-10-22): once per device, how to put the planner on the home screen, on a phone that doesn't run
  // it from there yet. Waits for the week and for no other sheet; in Instagram's browser it says to open the browser first.
  const APP_HINT_KEY = 'vhp_app_hint';
  const appHintEl = () => funnel.querySelector('[data-vhp-app-hint]');
  const closeAppHint = () => {
    const sheet = appHintEl();
    if (window.vhpSheet) window.vhpSheet.setOpen(sheet, false);
    else sheet?.close();
  };
  const maybeAppHint = (tries = 4) => {
    const sheet = appHintEl();
    if (!sheet || !planner.config.paid) return;
    const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    const touch = window.matchMedia('(pointer: coarse)').matches;
    let seen = false;
    try {
      seen = !!localStorage.getItem(APP_HINT_KEY);
      if (standalone) localStorage.setItem(APP_HINT_KEY, 'standalone');
    } catch (e) {
      return;
    }
    if (seen || standalone || !touch) return;
    if (state.screen !== 'week' || weekGenerating || document.querySelector('dialog[open]')) {
      if (tries > 0) window.setTimeout(() => maybeAppHint(tries - 1), 4000);
      return;
    }
    const kind = IN_APP_UA ? 'inapp' : HANDOFF_OS === 'ios' ? 'ios' : 'other';
    sheet.querySelectorAll('[data-vhp-app-hint-steps]').forEach((list) => {
      list.hidden = list.dataset.vhpAppHintSteps !== kind;
    });
    try {
      localStorage.setItem(APP_HINT_KEY, kind);
    } catch (e) {
      return;
    }
    if (window.vhpSheet) window.vhpSheet.setOpen(sheet, true);
    else sheet.showModal();
    usage('app_hint_shown');
  };
  const appHintNode = appHintEl();
  if (appHintNode) {
    appHintNode.addEventListener('close', () => {
      appHintNode.classList.remove('is-dragging', 'is-open');
      const panel = appHintNode.querySelector('.vhp-sheet__panel');
      if (panel) panel.style.transform = '';
    });
    appHintNode.addEventListener('click', (event) => {
      if (event.target === appHintNode) closeAppHint();
    });
    appHintNode.querySelector('[data-vhp-app-hint-ok]')?.addEventListener('click', () => {
      usage('app_hint_ok');
      closeAppHint();
    });
    window.vhpSheet?.bindDrag(appHintNode, closeAppHint);
  }

  // Instagram's in-app browser keeps playing hidden media unless we stop it.
  document.addEventListener('visibilitychange', () => {
    syncRecipesMedia();
    if (document.visibilityState === 'visible') checkWeekRollover();
    if (document.visibilityState === 'hidden' && reel.seenTimer) flushSeen();
  });
  window.addEventListener('pagehide', () => {
    stopHero();
    reelViewer()?.hold(true);
    if (reel.seenTimer) flushSeen();
  });
  const dockEl = $('[data-vhp-dock]');
  if (dockEl && typeof ResizeObserver === 'function') {
    new ResizeObserver(() => syncDockBubble(true)).observe(dockEl);
  }
  window.addEventListener('resize', () => syncDockBubble(true));
  window.matchMedia('(min-width: 960px)').addEventListener('change', () => syncDockBubble(true));

  if (state.swap && (state.screen !== 'swipe' && state.screen !== 'empty')) state.swap = null;
  if (state.screen === 'swipe' || state.screen === 'empty') {
    if (state.swap && !PLAN_SLOTS.includes(state.swap.slot)) {
      state.swap = null;
      state.screen = 'exclusions';
      state.slot = null;
    } else if (!state.swap) {
      state.slot = null;
    }
  }
  hydrateFromSaved();
  if (planner.config.paid) rollWeeks();
  if (customRecipes()) {
    document.addEventListener('vhp:recipes-changed', () => {
      refreshCustomMeals();
      stopWeekMealsMotion();
      hubGridKey = '';
      if (state.screen === 'week' || state.screen === 'settings' || state.screen === 'shop' || inRecipes()) render();
      if (swapUi) renderSwapResults();
      if (recipeSheetCustom) paintCustomRecipeSheet(recipeSheetCustom);
    });
    refreshCustomMeals();
  }
  if (planner.config.paid && (weekHasPlan(state.week) || state.prevWeek) && funnel.querySelector('[data-vhp-screen="week"]')) {
    state.screen = 'week';
  } else if (!planner.config.paid && (state.screen === 'week' || state.screen === 'day' || state.screen === 'settings' || state.screen === 'shop' || state.screen === 'recipes')) {
    state.screen = 'preview';
  } else if (planner.config.paid && (state.screen === 'subscribe' || state.screen === 'preview' || state.screen === 'day' || state.screen === 'waiting' || state.screen === 'shop' || state.screen === 'settings' || state.screen === 'recipes')) {
    state.screen = 'week';
  }
  if (state.screen === 'week' || state.screen === 'shop' || state.screen === 'settings' || state.screen === 'preview') {
    state.editFrom = null;
  }
  const waitingForPaid = settleAfterCheckout();
  if (new URLSearchParams(location.search).get('vhp') === '1') {
    history.replaceState({}, '', location.pathname);
    persist();
  }
  // Set when the deficit rule raised their target on this load: told once on the week (toast after the first render).
  let kcalRaised = null;
  if (state.goal && eckdatenValid()) {
    const before = state.kcal;
    syncKcal();
    // An Abnehmen target the 2026-10-19 deficit rule raises takes the planned week and the account along, as a
    // settings change would. Only that case: other mismatches (body entered on another device) keep their week.
    if (planner.config.paid && state.goal === 'lose' && before != null && state.kcal > before) {
      kcalRaised = { from: before, to: state.kcal };
      rescaleWeekToKcal(state.kcal);
      scheduleWeekSave();
      state.pendingFlush = true;
      persist();
    }
  }
  // Profil links to /pages/meal-planner#ziele (without keeping the hash): subscribers get the Dein Plan sheet,
  // everyone else the setup from its goal step (kcal and macros come from there).
  const openGoals = () => {
    if (planner.config.paid) openSettings();
    else if (state.screen !== 'goal' && state.screen !== 'building' && state.screen !== 'waiting') forward('goal', null);
  };
  // Likes and Profil link to #meine-rezepte: subscribers get the "Meine Rezepte" sheet (with "Einplanen"),
  // everyone else just the planner.
  const openOwnRecipes = () => customRecipes()?.openManager({ onPlan: planOwnRecipe });
  // A recipe from outside the planner (Likes, Search, recipe sheet) as a planner card. Catalog pages load lazily:
  // a recipe not in them yet, or without kcal, waits for them (portion scaling needs the full card).
  const cardForPlan = async (from) => {
    const sid = productId(from?.id);
    if (!sid) return null;
    const item = likeItems().find((row) => row.id === sid) || { ...from, id: sid };
    let card = hydrateSwapCard(item);
    if (!(Number(card?.kcal) > 0) || !findCatalogCard(sid)) {
      await loadHubCatalog();
      card = hydrateSwapCard(item);
    }
    return card?.slot ? card : null;
  };

  // Old "Einplanen" links (#einplanen=<id>) and "Einplanen" on this page (assets/vhp-plan-picker.js hands it
  // over): the planner's own day/meal picker for that recipe.
  const planFromItem = async (from) => {
    if (!planner.config.paid) return;
    const card = await cardForPlan(from);
    if (card) openPlanPicker(card, { day: state.weekDay });
  };
  const planFromHash = (raw) => planFromItem({ id: raw });

  // "Einplanen" on another tab (assets/vhp-plan-picker.js) queues day(s) + meal; they go in here through the
  // picker's own confirm (portion per day, leftovers, undo toast, account save), one entry after the other.
  const placeQueued = async (entry) => {
    const card = await cardForPlan(entry);
    if (!card) return false;
    if (!weekHasPlan(state.week)) {
      await generateWeek({ keepLocks: false });
      scheduleWeekSave();
    }
    const occasions = activeOccasions();
    const as = occasions.some((row) => row.id === entry.occasion)
      ? entry.occasion
      : (occasions.find((row) => row.catalog === card.slot) || occasions[0])?.id;
    if (!as) return false;
    copyPick.card = card;
    copyPick.day = state.weekDay;
    copyPick.occasion = null;
    copyPick.as = as;
    copyPick.targets = new Set(Array.isArray(entry.targets) ? entry.targets : []);
    copyPick.prepped = false;
    copyPick.prepped0 = false;
    copyPick.repeat = repeatRuleFor(as)?.id === copyRecipeId();
    // Days that went by (or got locked) since then drop out.
    pruneCopyTargets();
    if (!copyPick.targets.size) {
      copyPick.card = null;
      return false;
    }
    confirmCopy();
    return true;
  };
  let planQueueRunning = false;
  const drainPlanQueue = async () => {
    const picker = window.vhpPlanPicker;
    if (planQueueRunning || !planner.config.paid || waitingForPaid || !picker?.pending()) return;
    if (weekGenerating) {
      window.setTimeout(drainPlanQueue, 400);
      return;
    }
    planQueueRunning = true;
    let placed = 0;
    let missed = 0;
    try {
      for (const entry of picker.take()) {
        if (await placeQueued(entry)) placed += 1;
        else missed += 1;
      }
    } finally {
      planQueueRunning = false;
    }
    if (missed && !placed) {
      regenUndo = null;
      swapUndo = null;
      favUndo = null;
      showWeekToast(tr('planner.missed', { n: missed }), { action: 'OK' });
    }
  };
  const hashPlanId = () => {
    const m = /^#einplanen=([^&]+)$/.exec(location.hash);
    return m ? decodeURIComponent(m[1]) : '';
  };
  const wantsGoals = location.hash === '#ziele';
  const wantsOwn = location.hash === '#meine-rezepte';
  const wantsPlan = hashPlanId();
  if (wantsGoals || wantsOwn || wantsPlan) history.replaceState(history.state, '', location.pathname + location.search);
  // A second-day gift slide saved before it went (2026-10-19): the preview.
  if (!planner.config.paid && state.screen === 'gift' && !giftIsReward()) state.screen = 'preview';
  // A discount gift slide saved before it went (2026-10-17): the plans, with the gift on them.
  if (!planner.config.paid && state.screen === 'gift' && giftIsReward()) {
    grantGift();
    state.screen = 'subscribe';
  }
  // Back with a built week (Plan tab, "Zu meinem Plan", the bio link again): her week, not the price; the plans stay
  // one tap away (docs/PERSONA_ATTACK_PLAN.md 2.2). The Safari hand-off (?pay=1) still opens on the plans.
  if (!planner.config.paid && !gated() && !handoffArrival && state.screen === 'subscribe' && state.preview?.day?.meals?.length) {
    state.screen = 'preview';
    state.history = [];
  }
  // "Schick mir meine Woche": the save sheet and the restore link (assets/vhp-planner-weekmail.js). A visit through the
  // link from mail 1 (?week=<token>) is no new start (no planner_new); subscribers have their week in the account.
  const weekMail =
    window.vhpWeekMail?.attach({
      apiBase: planner.config.apiBase,
      locale: LOCALE === 'en' ? 'en' : 'de',
      enabled: planner.config.weekMail === true && !planner.config.paid,
      canSave: weekSavable,
      payload: weekMailPayload,
      step,
    }) || null;
  const weekLink = planner.config.paid || waitingForPaid ? null : weekMail?.linkToken() || null;
  const paidLink = planner.config.paid && !state.goal ? weekMail?.linkToken() || null : null;
  if (planner.config.paid) weekMail?.dropLink();
  storyPlayer =
    window.vhpPlannerStory?.create({
      funnel,
      next: storyNext,
      back: goBack,
      close: closeStory,
      sound: () => step('story_sound'),
    }) || null;
  // Back in a started setup (left by ×, a swipe or the app): Sören says the answers are kept (docs/UX_REVIEW.md #14).
  if (!planner.config.paid && storyActive() && state.screen !== 'goal' && STORY_SCREENS.has(state.screen)) {
    window.setTimeout(() => storyPlayer?.say(tr('planner.story_resume'), 3200), 900);
  }
  // The first screen for planner landers (docs/FIRST_SCREEN.md 9.8): a lander who hasn't started gets it instead of the
  // goal question.
  // A dish brought along skips it, except from the recipe page's planner line: there the week screen is the explanation
  // of what the line promised (docs/RECIPE_PAGE_REBUILD.md 2; the explainer replaces it later).
  // Sörens Woche (docs/SOEREN_WEEK.md): the one-question screen first, for every new start the setting covers. A
  // reload during its build lands back on the question (nothing else of the setup was answered).
  if (!planner.config.paid && state.soerenDoor && state.screen === 'building' && !state.preview?.soeren) state.screen = 'soeren';
  if (!planner.config.paid && storyActive() && soerenOn() && state.screen === 'goal' && !state.goal && !state.editFrom && !weekLink) {
    state.soerenDoor = true;
    state.screen = 'soeren';
    persist();
  } else if (!planner.config.paid && storyActive() && mondayFirst() && state.screen === 'goal' && !state.goal && !state.editFrom && !weekLink && (!introPick || (recipeDoor() && !RECIPE_HOOKS.has(srcParam)))) {
    state.mondayDoor = true;
    state.screen = 'monday';
    persist();
  }
  step('planner_opened');
  // The first screen in front of someone who hasn't started yet: the clean base for goal_selected (opens also
  // count returning visitors that resume further in). The week screen counts the same way.
  let soerenSkip = false;
  if (((state.screen === 'goal' && !state.goal) || (state.screen === 'monday' && !state.goal) || (state.screen === 'soeren' && !state.goal && state.soerenKcal == null)) && !state.editFrom && !weekLink) {
    step('planner_new');
    // Its first screen, for the start's chain in the dashboard (vhp-planner docs/dashboard.md, 2026-10-31).
    window.vhpPlannerEvents?.door?.(state.screen === 'monday' ? 'monday' : state.screen === 'soeren' ? 'soeren' : 'goal');
    // The slide 1 diagnostics (goal_touch, goal_dwell) belong to the goal slide as a first screen only.
    goalShownAt = state.screen === 'goal' ? performance.now() || 1 : 0;
    // Was anyone looking when the first screen booted (slide 1 drop diagnostics, 2026-10-22): hidden / prerender = a
    // load before the visit (in-app preloads), shown_later = it was opened afterwards.
    const bootHidden = document.prerendering || document.visibilityState === 'hidden';
    step('boot_vis', document.prerendering ? 'prerender' : bootHidden ? 'hidden' : 'visible');
    if (bootHidden) {
      const shown = () => {
        if (document.prerendering || document.visibilityState !== 'visible') return;
        step('boot_vis', 'shown_later');
        document.removeEventListener('visibilitychange', shown);
        document.removeEventListener('prerenderingchange', shown);
      };
      document.addEventListener('visibilitychange', shown);
      document.addEventListener('prerenderingchange', shown);
    }
    // How long the first screen took (navigation start, or activation of a prerendered Plan tab, to just before the
    // first render), bucketed (docs/PLANNER_PAGE_FUNNEL.md 0.4).
    try {
      const nav = performance.getEntriesByType?.('navigation')?.[0];
      const bootS = Math.max(0, performance.now() - (Number(nav?.activationStart) || 0)) / 1000;
      step('boot', bootS < 1 ? 'lt1' : bootS < 2 ? '1_2' : bootS < 4 ? '2_4' : bootS < 8 ? '4_8' : '8p');
    } catch (e) {
      /* no timing API: no bucket */
    }
    // A goal picked before the planner (recipe page / Explore goal chips, assets/vhp-plan-goal.js): the goal screen
    // is answered, the planner opens on Eckdaten and back leads to the goal screen. Counted as goal_preset, so
    // goal_selected stays the rate of the goal screen itself (vhp-planner docs/entry.md).
    let preset = '';
    let presetBody = null;
    let presetAssumed = false;
    let presetEasy = false;
    try {
      const raw = JSON.parse(sessionStorage.getItem('vhp_planner_goal') || 'null');
      preset = String(raw?.goal || '');
      presetBody = raw?.body && typeof raw.body === 'object' ? raw.body : null;
      presetAssumed = raw?.assumed === true;
      presetEasy = raw?.easy === true;
      sessionStorage.removeItem('vhp_planner_goal');
    } catch (e) {
      preset = '';
    }
    if (!planner.config.paid && Object.prototype.hasOwnProperty.call(GOAL_DELTA, preset)) {
      state.goal = preset;
      state.goalEasy = preset === 'maintain' && presetEasy;
      // The recipe calculator (assets/vhp-plan-goal.js) sends sex and measures along: taken when all are in range,
      // and the body slide is skipped; with her activity (the calculator's flow asks it) the activity slide too.
      const sex = presetBody?.sex;
      const weight = Number(presetBody?.weight);
      const height = Number(presetBody?.height);
      const age = Number(presetBody?.age);
      if (
        (sex === 'female' || sex === 'male') &&
        weight >= WEIGHT_MIN && weight <= WEIGHT_MAX &&
        height >= HEIGHT_MIN && height <= HEIGHT_MAX &&
        age >= AGE_MIN && age <= AGE_MAX
      ) {
        Object.assign(state, { sex, weight: Math.round(weight), height: Math.round(height), age: Math.round(age) });
        // Their own answers skip the body slide; the typical visitor's only fill it in (calcEntry, express path).
        if (presetAssumed) state.calcEntry = portionSrc;
        else {
          state.bodyPreset = true;
          storyVoted.add('sex');
          if (Object.prototype.hasOwnProperty.call(PAL, presetBody.activity)) {
            state.activity = presetBody.activity;
            state.activityPreset = true;
            storyVoted.add('activity');
          }
        }
      }
      if (!state.kcalManual) state.kcal = computeKcal();
      step('goal_preset', preset);
      window.vhpPlannerEvents?.door?.('preset');
      // Sörens Woche stays on its own screen here (the build pushes it once), so no second history entry.
      if (!state.soerenDoor) state.history.push(position());
      // Sörens Woche with a goal (and body) from the recipe calculator: her number is known, the question is skipped and
      // the week builds right after the first render (soerenSkip).
      if (state.soerenDoor && state.kcal) soerenSkip = true;
      state.screen = state.soerenDoor ? 'soeren' : storyActive() ? (portionSrc && state.bodyPreset ? eckdatenNext() : state.calcEntry ? 'body' : 'why') : 'body';
      persist();
    }
    // Collection door: the theme the tile was tapped in becomes a setting of this new setup (never of a started one).
    if (!planner.config.paid && collTheme) {
      if (collTheme === 'prep') {
        state.leftovers = true;
        state.leftoverDays = 2;
      }
      if (collTheme === 'fast') state.maxTime = 30;
      persist();
    }
  }
  // Story v2: the gift pill (#geschenk) opens the plans while the gift is valid and the preview is there.
  if (planner.config.paid) {
    try {
      localStorage.removeItem(GIFT_KEY);
    } catch (e) {
      /* ignore */
    }
  } else if (location.hash === '#geschenk') {
    history.replaceState(history.state, '', location.pathname + location.search);
    if (activeOffer()?.id === 'reward' && state.preview?.day?.meals?.length && state.screen !== 'subscribe') {
      state.history.push(position());
      state.screen = 'subscribe';
      step('paywall_opened', 'other');
      persist();
    }
  }
  usage('paid_opened');
  // Preview switched off while one waits (or the restores above landed on it): the paywall, no preview_viewed.
  if (gated() && state.screen === 'preview') {
    if (!state.subscribePlanId) state.subscribePlanId = defaultSubscribePlanId();
    state.screen = 'subscribe';
    persist();
  }
  // Restore link: the preview's "planning" state until restoreWeek has the draft, not the slide this browser was on.
  const weekBefore = weekLink
    ? { screen: state.screen, slot: state.slot, history: state.history, preview: state.preview }
    : null;
  if (weekLink) {
    Object.assign(state, { screen: 'preview', slot: null, preview: null });
    exampleBuilding = true;
  }
  render();
  if (soerenSkip && state.screen === 'soeren') {
    step('soeren', 'skip');
    startSoerenWeek({ known: true });
  }
  // A bigger portion without a word reads as a bug: say why the target moved and that the week follows it.
  if (kcalRaised && state.screen === 'week') {
    showWeekToast(tr('planner.kcal_raised', { from: deInt(kcalRaised.from), to: deInt(kcalRaised.to) }), { action: tr('planner.toast_ok'), ms: 12000 });
  }
  // The pools' first pages arrive after the page (assets/vhp-planner.js): show what depends on them.
  planner.poolsReady?.then(() => render());
  flushProfile();
  // Week edits that didn't reach the account last time (closed tab, offline).
  if (planner.config.paid && (state.pendingWeekFlush || state.weekAlt?.pending)) flushWeek();
  if (waitingForPaid) {
    /* reload scheduled while Flow stamps subscriber-active */
  } else if (state.screen === 'preview') openPreview();
  else if (
    planner.config.paid &&
    state.screen === 'week' &&
    funnel.querySelector('[data-vhp-screen="week"]') &&
    !weekHasPlan(state.week)
  ) {
    openWeek();
  }
  if (wantsGoals && !waitingForPaid) openGoals();
  if (wantsOwn && !waitingForPaid) openOwnRecipes();
  if (wantsPlan && !waitingForPaid) planFromHash(wantsPlan);
  if (weekLink) restoreWeek(weekLink, weekBefore);
  if (paidLink) restorePaidSetup(paidLink);
  if (planner.config.paid && !waitingForPaid) window.setTimeout(() => maybeAppHint(), 2500);
  if (planner.config.paid && !waitingForPaid && window.vhpPlanPicker) {
    window.vhpPlanPicker.setHandler(planFromItem);
    drainPlanQueue();
    // Queued in another browser tab, or this page back from the back/forward cache.
    window.addEventListener('storage', (event) => {
      if (event.key === null || event.key === window.vhpPlanPicker.QUEUE_KEY) drainPlanQueue();
    });
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) drainPlanQueue();
    });
  }
  window.addEventListener('hashchange', () => {
    const hash = location.hash;
    const planId = hashPlanId();
    if (hash !== '#ziele' && hash !== '#meine-rezepte' && !planId) return;
    history.replaceState(history.state, '', location.pathname + location.search);
    if (hash === '#ziele') openGoals();
    else if (planId) planFromHash(planId);
    else openOwnRecipes();
  });
  if (!waitingForPaid) {
    if (window.requestIdleCallback) window.requestIdleCallback(warmPlannerIndex, { timeout: 2000 });
    else window.setTimeout(warmPlannerIndex, 1000);
  }
  // Warm the Rezepte catalog once the week is on screen, so the tab usually opens with tiles ready.
  if (!waitingForPaid && planner.config.paid && funnel.querySelector('[data-vhp-screen="recipes"]')) {
    window.setTimeout(loadHubCatalog, 2500);
  }
})();
